import { getImgUrl } from "../Utility/Utility";

// start live shows
// export const ShowsPostsData = [

// 	{
// 		id:1,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tom Jones \n Tel Aviv ",
//         smltitle: "The one and only Tom Jones returns to Tel Aviv for one live performance",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tomjones.com/">
// 												www.tomjones.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/1/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
// 						</p>

// 						<p>
// 							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
// 						</p>
// 						<p>
// 							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
// 						</p>

// 						<p>
// 							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//       id:2,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Britney Spears \n  Live in Concert",
//         smltitle: "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											03.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.britneyspears.com">
// 												www.britneyspears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/2/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>

// 						<p>
// 							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
// 						</p>

// 						<p>
// 							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
// 						</p>

// 						<p>
// 							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:3,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tears for Fears",
//         smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											05.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tearsforfears.com">
// 												www.tearsforfears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<p>
// 							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
// 						</p>

// 						<p>
// 							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
// 						</p>
// 						<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
// 						</p>
// 						<p>
// 						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
// 						</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:4,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: " Guns N' Roses  \"Not in this Lifetime\"",
//         smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											15.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.gunsnroses.com">
// 											www.gunsnroses.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
// 							</p>

// 							<p>
// 								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
// 							</p>
// 							<p>
// 								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/2.jpg"} class="img-responsive" />
// 							</div>

// 							<h3>
// 							"Not in this Lifetime"
// 							</h3>
// 							<p>
// 							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
// 							</p>
// 							<p>
// 								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
// 							</p>
// 							<p>
// 								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
// 							</p>
// 						`
// 			}
// 		}

// 	},

// 	{
//         id:5,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: " RADIOHEAD  \n Tel Aviv",
//         smltitle: "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.radiohead.com">
// 											www.radiohead.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/5/1.jpeg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
// 							</p>

// 							<p>
// 								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
// 							</p>

// 							<p>
// 								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
// 							</p>

// 							<p>
// 								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
// 							</p>
// 							<p>
// 							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:6,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											25-26.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<h2>I Pixies - ritornano con un concerto live che sconvolgerà Tel Aviv!</h2>

// 										<p>L’estate israeliana è sempre calda, ma i Pixies ritornano a Tel Aviv dopo 3 anni per renderla ancora più infuocata!</p>
// 										<p>La famosa band americana, conosciuta per il suo stile inconfondibile di punk rock e pop aggressivo è autrice di alcune delle canzoni più iconiche nella storia della musica, ivi compresa quella in assoluto preferita dal pubblico “where is my mind”. I Pixies tornano a Tel Aviv per la terza volta nel corso del loro tour promozionale per il nuovo album “Beneath the Eyrie”. </p>
// 										<p>I Pixies offriranno un’unica performance nella città di Tel Aviv che non si ferma mai: un modo perfetto per rallegrare la vostra vacanza a Tel Aviv fatta di mare, sole e divertimento.  Il concerto si terrà a luglio, un periodo ideale per godere al meglio della famosa estate di Tel Aviv: feste, deliziosa gastronomia e spiagge fantastiche. </p>
// 										<p>I biglietti si stanno vendendo velocemente, quindi affrettatevi e prenotate il vostro viaggio oggi!  </p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:7,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Regina Spektor – Back in Israel",
//         smltitle: "Regina Spektor – Back in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											19.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reginaspektor.com">
// 											www.reginaspektor.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
// 							</p>

// 							<p>
// 								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
// 							</p>
// 							<p>
// 								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
// 							</p>
// 							<p>
// 								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
// 							</p>

// 							<p>
// 								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
// 							</p>
// 							<p>
// 								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:8,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Nick Cave & The Bad Seeds",
//         smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											19-20.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.nick-cave.com">
// 											www.nick-cave.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
// 							</p>

// 							<p>
// 								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
// 							</p>

// 							<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
// 							</p>
// 							<p>
// 								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
// 							</p>
// 							<p>
// 								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
// 							</p>
// 							<p>
// 								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
// 							</p>

// 							<p>
// 								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:9,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Justin Bieber",
//         smltitle: "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											03.05.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.justinbiebermusic.com">
// 											www.justinbiebermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/9/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The artist with the most followers on Twitter 90,149,014
// 								The artist with the most watched official music channel online 13,518,849,954
// 								The artist with the most mentions on Youtube music channel
// 							</p>

// 							<p>
// 							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
// 							</p>
// 							<p>
// 								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
// 							</p>

// 							<p>
// 								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
// 							</p>

// 							<p>
// 								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
// 							</p>
// 							<p>
// 								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
// 							</p>
// 							<p>
// 								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
// 							</p>

// 							<p>
// 								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
// 							</p>

// 							<p>
// 								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
// 							</p>

// 							<p>
// 								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:10,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "AEROSMITH \n \"AERO-VEDERCI BABY\" ",
//         smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.aerosmith.com">
// 											www.aerosmith.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
// 							</p>
// 							<p>
// 								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/2.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
// 							</p>

// 							<p>
// 								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
// 							</p>

// 							<p>
// 							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:11,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Frankie Valli & The Four Seasons  ",
//         smltitle: " An American Legend in the heart of Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											4.007.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.frankievallifourseasons.com/">
// 											www.frankievallifourseasons.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/11/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
// 							</p>
// 							<p>
// 								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
// 							</p>

// 							<p>
// 								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
// 							</p>

// 							<p>
// 								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:12,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Unite With Tomorrowland",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											29.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
// 											www.tomorrowland.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/12/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
// 							</p>
// 							<p>
// 								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
// 							</p>

// 							<p>
// 								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
// 							</p>

// 							<p>
// 								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:13,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Chainsmokers",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											NEAR Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											3.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thechainsmokers.com/">
// 											www.thechainsmokers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/13/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
// 							</p>
// 							<p>
// 								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
// 							</p>

// 							<p>
// 								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:14,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Dire Straits Experience",
//         smltitle: "Get a shiver in the dark in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											14.09.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.direstraitsexperience.com/">
// 											www.direstraitsexperience.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/14/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
// 							</p>
// 							<p>
// 								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
// 							</p>

// 							<p>
// 								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
// 							</p>

// 							<p>
// 							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
// 							</p>

// 							<p>
// 							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
// 							</p>

// 							<p>
// 							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:15,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alan Parsons",
//         smltitle: "The man that said no to Pink Floyd, live in TA",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											11.11.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.alanparsonsmusic.com/">
// 											 www.alanparsonsmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/15/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
// 							</p>

// 							<p>
// 								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
// 							</p>

// 							<p>
// 							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
// 							</p>

// 							<p>
// 							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
// 							</p>

// 							<p>
// 							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:16,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Bryan Adams",
//         smltitle: "Bryan Adams to warm our winter with 3 shows",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv & Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											4+5+6.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bryanadams.co.il/">
// 											 www.bryanadams.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/16/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
// 							</p>
// 							<p>
// 								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
// 							</p>

// 							<p>
// 								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
// 							</p>

// 							<p>
// 							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   Make sure you don’t miss this time-defying legend.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {
//         id:17,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Chris Rock",
//         smltitle: "Coming to Tel Aviv to rock your world ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											8+9.01.18
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.chrisrock.com/">
// 											 www.chrisrock.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/17/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
// 							</p>
// 							<p>
// 								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
// 							</p>

// 							<p>
// 								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
// 							</p>

// 							<p>
// 							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
//                               Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).

// 							</p>

// 							<p>
// 							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
// 							</p>

// 							<p>
// 							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
// 							</p>

// 							<p>
// 							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
// 							</p>

// 							<p>
// 							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:18,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Patricia Kaas",
//         smltitle: "The great French singer returns to the white city once again",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											28.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.patriciakaas.net/">
// 											  www.patriciakaas.net
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/18/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
// 							</p>
// 							<p>
// 								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
// 							</p>

// 							<p>
// 								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
// 							</p>

// 							<p>

//                                    Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:19,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blue Man Group",
//         smltitle: "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											 7-23.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.blueman.com/">
// 											  www.blueman.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/19/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
// 							</p>
// 							<p>
// 								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
// 							</p>

// 							<p>
// 								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
// 							</p>

// 							<p>

//                                  Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:20,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Sean Paul",
//         smltitle: "The international mega star is coming to make our summer sizzle!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv Outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											22.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.allseanpaul.com/">
// 											  www.allseanpaul.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/20/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
// 							</p>
// 							<p>
// 								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
// 							</p>
// 							<p>
// 							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
// 							</p>

// 							<p>
// 							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
// 							</p>
// 							<p>
// 							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
// 							</p>

// 							<p>

//                                   His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.

// 							</p>

// 							<p>
//                                 Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
// 							</p>

// 							<p>
//                                Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
// 							</p>

// 							<p>
//                                Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
// 							</p>

// 							<p>
//                                His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:21,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "The Pretenders",
//         smltitle: "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											23.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thepretenders.com/">
// 											  www.thepretenders.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/21/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
// 							</p>
// 							<p>
// 								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
// 							</p>

// 							<p>
// 								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
// 							</p>

// 							<p>

//                                   The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:22,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Cliff Richard",
//         smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											10.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.cliffrichard.org/">
// 											  www.cliffrichard.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/22/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
// 							</p>
// 							<p>
// 								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
// 							</p>

// 							<p>
// 								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
// 							</p>

// 							<p>

//                                  Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.

// 							</p>

// 							<p>
// 							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
// 							</p>

// 							<p>
// 							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
// 							</p>

// 							<p>
// 							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel-Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:23,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "DGTL Festival",
//         smltitle: "An awesome digital celebration in the one of the world’s Digital Capitals",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											05.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
// 											  www.tlv-digital.nl
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/23/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
// 							</p>
// 							<p>
// 								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
// 							</p>

// 							<p>
// 								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
// 							</p>

// 							<p>

//                                The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.

// 							</p>

// 							<p>
// 							   The festival will include three stages featuring excellent music at any given moment.
// 							</p>

// 							<p>
// 							   The fantastic international line up is set to include:
// 							</p>

// 							<p>
// 							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
// 							</p>

// 							<p>
// 							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:24,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Richard Clayderman",
//         smltitle: "The famous pianist returns to perform in Israel with all his unforgettable hits!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											17.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.clayderman.co.uk/">
// 											  www.clayderman.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/24/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
// 							</p>
// 							<p>
// 								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
// 							</p>

// 							<p>
// 								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
// 							</p>

// 							<p>

//                                His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:25,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Smokie",
//         smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv + Jerusalim
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											28+31.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//smokie.co.uk/Band">
// 											  www.smokie.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/25/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
// 							</p>
// 							<p>
// 								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
// 							</p>

// 							<p>
// 								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
// 							</p>

// 							<p>

//                               Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."

// 							</p>

// 							<p>
// 							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
// 							</p>

// 							<p>
// 							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
// 							</p>

// 							<p>

// 							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:26,
//         bgImage :"/posts/bank/15/1.jpg",
//         mobBgImage :"/posts/bank/15/M.jpg",
//         title: "Foreigner",
//         smltitle: "The 80's are back to rock Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											  www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/26/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
// 							</p>
// 							<p>
// 								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
// 							</p>

// 							<p>
// 								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
// 							</p>

// 							<p>

//                               The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".

// 							</p>

// 							<p>
// 							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:27,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Carcass",
//         smltitle: "The British metal legends are coming <br>to rock the city that never sleeps!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											09.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
// 											  facebook.com/OfficialCarcass
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/27/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
// 							</p>
// 							<p>
// 								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
// 							</p>

// 							<p>
// 								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
// 							</p>

// 							<p>

//                               In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.

// 							</p>
// 							<p>
// 							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:28,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Kygo",
//         smltitle: "The Norwegian house phenomena for the first time ever in Tal Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.kygomusic.com/">
// 											  www.kygomusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/28/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
// 							</p>
// 							<p>
// 								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
// 							</p>

// 							<p>
// 								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
// 							</p>

// 							<p>

//                               His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.

// 							</p>
// 							<p>
// 							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:29,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Led Zeppelin 2",
//         smltitle: "Don’t Miss the Zeps in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv, Haifa and Be'er Sheva
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											07-10.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//zep2.com/">
// 											  www.zep2.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/29/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
// 							</p>
// 							<p>
// 								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
// 							</p>

// 							<p>
// 								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
// 							</p>

// 							<p>

//                              Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:30,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Oh Wonder",
//         smltitle: "Live in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											16.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ohwondermusic.com/">
// 											  www.ohwondermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/30/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
// 							</p>
// 							<p>
// 								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
// 							</p>

// 							<p>
// 								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:31,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Ott & The All Seeing I",
//         smltitle: "Electro explosion in the city that never sleeps",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											15.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ottsonic.com/">
// 											  www.ottsonic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/31/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
// 							</p>
// 							<p>
// 								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
// 							</p>

// 							<p>
// 								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
// 							</p>

// 							<p>
// 							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
// 							</p>

// 							 <p>
// 							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:32,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Take That",
//         smltitle: "Take That – Taking Tel Aviv By Storm!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											27.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//takethat.com/">
// 											  www.takethat.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/32/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
// 							</p>
// 							<p>
// 								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
// 							</p>

// 							<p>
// 								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
// 							</p>

// 							<p>
// 							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
// 							</p>

// 							 <p>
// 							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:33,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Kooks",
//         smltitle: "Getting it on with the Kooks in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											27-28.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thekooks.com/">
// 											  www.thekooks.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/33/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
// 							</p>
// 							<p>
// 								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
// 							</p>

// 							<p>
// 								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
// 							</p>

// 							<p>
// 							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
// 							</p>

// 							 <p>
// 							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:34,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Willy William and Farruko",
//         smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											  Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											28.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reggaetontelaviv.co.il/indexEN.php">
// 											  www.reggaetontelaviv.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/34/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The reggaetón superstars coming to get you movin’ in Tel Aviv!
// 							</p>
// 							<p>
// 								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
// 							</p>

// 							<p>
// 								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
// 							</p>

// 							<p>
// 							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
// 							</p>

// 							 <p>
// 							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:35,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Buena Vista",
//         smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											21-26.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pasion-de-buena-vista.com/">
// 											  www.pasion-de-buena-vista.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/35/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
// 							</p>
// 							<p>
// 								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
// 							</p>
// 							<p>
// 								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
// 							</p>

// 							<p>
// 								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:36,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Jerry Seinfeld",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											30.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jerryseinfeld.com/">
// 											  www.jerryseinfeld.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/36/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Comedy King Closing 2017 in Tel Aviv!
// 							</p>
// 							<p>
// 								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
// 							</p>
// 							<p>
// 								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
// 							</p>

// 							<p>
// 								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
// 							</p>

// 							<p>
// 							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
// 							</p>

// 							<p>
// 							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
// 							</p>

// 							<p>
// 							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:37,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alt-J",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											29.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.altjband.com/">
// 											  www.altjband.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/37/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
// 							</p>
// 							<p>
// 								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:38,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ozzy Osbourne",
//         smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											08.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ozzy.com/">
// 											  www.ozzy.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/38/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Ozzy O -  coming to say goodbye to Tel Aviv!
// 							</p>
// 							<p>
// 								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
// 							</p>

// 							<p>
// 							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
// 							</p>

// 							<p>
// 							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:39,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jim Jefferies",
//         smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											16.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//jimjefferies.com/">
// 											  www.jimjefferies.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/39/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
// 							</p>
// 							<p>
// 								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
// 							</p>

// 							<p>
// 							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
// 							</p>

// 							<p>
// 							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
// 							</p>

// 							<p>
// 							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:40,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Gerard Depardieu & Isabelle Adjani",
//         smltitle: "“Love Letters” Coming to Tel Aviv from France!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											05.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/40/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 “Love Letters” Coming to Tel Aviv from France!
// 							</p>
// 							<p>
// 								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
// 							</p>

// 							<p>
// 							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
// 							</p>

// 							<p>
// 							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
// 							</p>

// 							<p>
// 							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:41,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "A-HA",
//         smltitle: "An Electric Summer with A-HA!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											21.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://a-ha.com/">
// 											  www.a-ha.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/41/1.gif"} class="img-responsive" />
// 							</div>

// 							<p>
// 							 An Electric Summer with A-HA!
// 							</p>
// 							<p>
// 								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
// 							</p>

// 							<p>
// 							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
// 							</p>

// 							<p>
// 							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
// 							</p>

// 							<p>
// 							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:42,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ringo Starr",
//         smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											23-24.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ringostarr.com/">
// 											 www.ringostarr.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/42/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Ringo’s All Starr Band Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
// 							</p>

// 							<p>
// 							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
// 							</p>

// 							<p>
// 							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
// 							</p>

// 							<p>
// 							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:43,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Scorpions",
//         smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.the-scorpions.com/">
// 											 www.the-scorpions.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/43/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Go Crazy in July with The Scorpions!
// 							</p>
// 							<p>
// 								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
// 							</p>

// 							<p>
// 							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:44,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Natalia Oreiro",
//         smltitle: "Natalia to Wow Tel Aviv in March",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											20.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.nataliaoreiro.com/">
// 											 www.nataliaoreiro.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/44/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							Natalia to Wow Tel Aviv in March
// 							</p>
// 							<p>
// 								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
// 							</p>

// 							<p>
// 							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
// 							</p>

// 							<p>
// 							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
// 							</p>

// 							<p>
// 							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:45,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "André Rieu",
//         smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											04-05.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.andrerieu.com/">
// 											 www.andrerieu.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/45/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Be Treated to Rieu in 2018
// 							</p>
// 							<p>
// 								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
// 							</p>

// 							<p>
// 							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
// 							</p>

// 							<p>
// 							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
// 							</p>

// 							<p>
// 							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:46,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Foreigner",
//         smltitle: "Foreigner Returning to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											05.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											 www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/46/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Foreigner Returning to Israel in May!
// 							</p>
// 							<p>
// 								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
// 							</p>

// 							<p>
// 							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
// 							</p>

// 							<p>
// 							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
// 							</p>

// 							<p>
// 							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:47,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Don Mclean",
//         smltitle: "Enjoy a Piece of “American Pie” in June!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											16.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://don-mclean.com/">
// 											 www.don-mclean.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/47/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Enjoy a Piece of “American Pie” in June!
// 							</p>
// 							<p>
// 								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
// 							</p>

// 							<p>
// 							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
// 							</p>

// 							<p>
// 							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:48,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Enrique Iglesias",
//         smltitle: "Tel Aviv to Host Spanish Pop Legend!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											28.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://enriqueiglesias.com/">
// 											 www.enriqueiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/48/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Tel Aviv to Host Spanish Pop Legend!
// 							</p>
// 							<p>
// 								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
// 							</p>

// 							<p>
// 							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
// 							</p>

// 							<p>
// 							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
// 							</p>

// 							<p>
// 							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:49,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blood Sweat and Tears",
//         smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											22.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//bloodsweatandtears.com/">
// 											 www.bloodsweatandtears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/49/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Blood, Sweat & Tears Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
// 							</p>

// 							<p>
// 							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
// 							</p>

// 							<p>
// 							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
// 							</p>
//                             <p>
//                                 Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
//                             </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:50,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jamiroquai",
//         smltitle: "Jamiroquai Heads to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											02.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jamiroquai.com/">
// 											 www.jamiroquai.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/50/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jamiroquai Heads to Israel in May!
// 							</p>
// 							<p>
// 								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
// 							</p>

// 							<p>
// 							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
// 							</p>

// 							<p>
// 							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:51,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Backstreet Boys",
//         smltitle: "The Backstreet Boys are Back and Larger Than Life",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											22.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.backstreetboys.com/">
// 												www.backstreetboys.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/51/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    The Backstreet Boys are Back and Larger Than Life
// 							</p>
// 							<p>
// 									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
// 							</p>

// 							<p>
// 									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
// 							</p>

// 							<p>
// 									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
// 							</p>
// 							<p>
// 									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:52,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alice in Chains",
//         smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											17.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.aliceinchains.com/">
// 												www.aliceinchains.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/52/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Alice in Chains Announces Debut Show in Tel Aviv
// 							</p>
// 							<p>
// 									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
// 							</p>

// 							<p>
// 									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
// 							</p>

// 							<p>
// 									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
// 							</p>
// 							<p>
// 									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:53,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Hardwell",
//         smltitle: "Hardwell Headed to Israel in April",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											06.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.djhardwell.com/">
// 												www.djhardwell.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/53/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Hardwell Headed to Israel in April
// 							</p>
// 							<p>
// 									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
// 							</p>

// 							<p>
// 									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
// 							</p>

// 							<p>
// 									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:54,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jethro Tull",
//         smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											27-28.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jethrotull.com/">
// 												jethrotull.com/
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/54/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
// 							</p>
// 							<p>
// 									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
// 							</p>

// 							<p>
// 									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
// 							</p>

// 							<p>
// 									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:55,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Israel Calling",
//         smltitle: "Good Evening Europe, This is Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											08-10.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<!--	<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h2>
// 							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
// 							</h2>
// 							<p>
// 								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/55/1.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
// 							</p>

// 							<p>
// 								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.

// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/2.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
// 						</p>

// 						<p>
// 						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.

// 						</p>

// 						<p>
// 						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/3.jpg"} class="img-responsive" />
// 						</div>

// 						`
// 			}
// 		}

//     },

//     {

//       id:56,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Clean Bandit",
//         smltitle: "Clean Bandit Announces First Visit to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											26.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//cleanbandit.co.uk/">
// 												cleanbandit.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/56/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Clean Bandit Announces First Visit to Israel
// 							</p>
// 							<p>
// 									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
// 							</p>

// 							<p>
// 									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015.
// 							</p>

// 							<p>
// 									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
// 						    </p>

// 						    <p>
// 									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
// 						    </p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:57,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alanis Morissette",
//         smltitle: "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											30.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//alanis.com/">
// 												alanis.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/57/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
// 							</p>
// 							<p>
// 									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
// 							</p>

// 							<p>
// 									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
// 							</p>

// 							<p>
// 									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:58,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Marc Almond",
//         smltitle: "Marc Almond’s Amazing Summer Concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											14.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
// 												marcalmond.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/58/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Marc Almond’s Amazing Summer Concert
// 							</p>
// 							<p>
// 									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August.
// 							</p>

// 							<p>
// 									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion.
// 							</p>

// 							<p>
// 									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
// 							</p>

// 						    <p>
// 									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert.
// 							</p>

// 						`
// 			}
// 		}

//     },
//     {

//         id:59,
//         bgImage:"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title : "Shakira",
//         smlTitle : "Shakira to heat up the summer in sizzling Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											09.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.shakira.com/">
// 												shakira.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Shakira to heat up the summer in sizzling Tel Aviv
// 							</p>
// 							<p>
// 									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv.
// 							</p>

// 							<p>
// 									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views.
// 							</p>

// 							<p>
// 									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue.
// 							</p>
// 							<p>
// 							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv.
// 							</p>

// 	                    `
// 			}
// 		}
//       },
//   //     {

//   //     id: 60,
//   //     bgImage:"/posts/bank/16/1.jpg",
//   //     mobBgImage:"/posts/bank/16/M.jpg",
//   //     title: "White Night TLV",
//   //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
//   //     html: function(){
// 		// 	return {
// 		// 		__html: `

// 		// 					<h2>
// 		// 					   16.05.2019
// 		// 					</h2>
// 		// 					<h3>
// 		// 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
// 		// 					</h3>
// 		// 					<div class="responisve-iframe">
// 		// 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 		// 					</div>
// 		// 					<p>
// 		// 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
// 		// 					</p>

// 		// 					<p>
// 		// 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Adam Primer
// 		// 					</small>
// 		// 					<p>
// 		// 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
// 		// 					</p>
// 		// 					<p>
// 		// 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Kfir Sivan
// 		// 					</small>
// 		// 					<p>
// 		// 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by Moshik Lindenbaum
// 		// 					</small>
// 		// 					<p>
// 		// 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by: Guy Yechiely‎.
// 		// 					</small>

// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//       {
//       id: 60,
//       bgImage:"/posts/bank/16/1.jpg",
//       mobBgImage:"/posts/bank/16/M.jpg",
//       title: "White Night TLV",
//       smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
//       html: function(){
// 			return {
// 				__html: `

// 							<h2>
// 							   16.05.2019
// 							</h2>
// 							<h3>
// 							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
// 							</h3>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>
// 								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
// 							</p>

// 							<p>
// 								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.
// 							</p>
// 							<p>
// 								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
// 							</p>
// 							<p>
// 								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>
// 								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>
// 								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>

// 					               `
// 			}
// 		}
//     },
//     {

//         id:61,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Brian Wilson",
// 	    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											07.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.brianwilson.com/">
// 												brianwilson.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 The legendary Brian Wilson returning to rock Tel Aviv!
// 							</p>
// 							<p>
// 									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
// 							</p>

// 							<p>
// 									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards.
// 							</p>

// 							<p>
// 									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city.

//                             </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 62,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Jason Derulo and Rita Ora",
// 	    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											The outskirts of Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jasonderulo.com/">
// 												jasonderulo.com
// 											</a><br>
// 											<a target="_blank" href="//ritaora.com/">
// 												ritaora.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
// 							</p>
// 							<p>
// 									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
// 							</p>

// 							<p>
// 									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 63,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Julio Iglesias",
// 	    smlTitle: "The Latin legend returning to wow Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											06.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.julioiglesias.com/">
// 												julioiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						             The Latin legend returning to wow Tel Aviv!
// 							</p>
// 							<p>
// 									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital.
// 							</p>

// 							<p>
// 									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year.
// 							</p>
// 							<p>
// 							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
// 							</p>

// 							<p>
// 							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 64,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Maluma",
// 	    smlTitle: "The Reggaeton sensation returns to the white city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fame.malumaofficial.com/">
// 												fame.malumaofficial.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The Reggaeton sensation returns to the white city!
// 							</p>
// 							<p>
// 									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
// 							</p>

// 							<p>
// 									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
// 							</p>
// 							<p>
// 							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
// 						    </p>

// 							<p>
// 							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
// 						    </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 65,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Martin Garrix",
// 	    smlTitle: "The 1# DJ comes to the nonstop city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											10.09.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.martingarrix.com/">
// 												martingarrix.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The 1# DJ comes to the nonstop city!
// 							</p>
// 							<p>
// 									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene.
// 							</p>

// 							<p>
// 									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
// 							</p>
// 							<p>
// 							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
// 							</p>

// 							<p>
// 							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
// 						    </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 66,
// 	    bgImage:"/posts/bank/59/1.jpg",
// 	    mobBgImage:"/posts/bank/59/M.jpg",
// 	    title: "Eurovision Tel Aviv",
// 	    smlTitle: "Epic song contest in the Non-Stop City",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											14-18.05.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<!--<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h3>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h3>
// 							<p>
// 						     Epic song contest in the Non-Stop City
// 							</p>
// 							<p>Semi-final 1: 14 May 2019</p>
//                             <p>Semi-final 2: 16 May 2019</p>
//                             <p>Grand Final: 18 May 2019</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />

// 							</div>
//                             <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
//                             <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
//                             <div class="img-wrapper">

// 							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>

//                             <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p>

// 					               `
// 			}
// 		}
//     },

//    {

//         id: 68,
// 	    bgImage:"/posts/bank/68/1.jpg",
// 	    mobBgImage:"/posts/bank/68/M.jpg",
// 	    title: "",
// 	    smlTitle: "36 Years of Cinema Magic!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											25.07-04.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jff.org.il/en">

// 												www.jff.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h2>Jerusalem Film Festival (JFF)</h2>
// 							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
//                             <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 69,
// 	    bgImage:"/posts/bank/69/1.jpg",
// 	    mobBgImage:"/posts/bank/69/M.jpg",
// 	    title: "",
// 	    smlTitle: "Jerusalem Wine Festival (JWF)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											01-31.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Wine Festival (JWF)</h2>
// 							<p>
// 								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
// 							</p>
//                            <p>
// 								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: 70,
// 	    bgImage:"/posts/bank/70/1.jpg",
// 	    mobBgImage:"/posts/bank/70/M.jpg",
// 	    title: "OPEN RESTAURANTS TLV",
// 	    smlTitle: "Feed Your Curiosity!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											2019 y.
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Feed Your Curiosity!</h2>
// 							<p>
// 								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
// 							</p>
// 							<p>
// 								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
// 							</p>
//                            <p>
// 								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
// 							</p>
//                            <p>
// 								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 71,
// 	    bgImage:"/posts/bank/71/1.jpg",
// 	    mobBgImage:"/posts/bank/71/M.jpg",
// 	    title: "CULINARY FESTIVAL",
// 	    smlTitle: "Round Tables Culinary Festival",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											09-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Round Tables Culinary Festival</h2>
// 							<p>
// 								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
// 							</p>
// 							<p>
// 								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
// 							</p>
//                            <p>
// 								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 72,
// 	    bgImage:"/posts/bank/72/1.jpg",
// 	    mobBgImage:"/posts/bank/72/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "Tel Aviv Fashion Week (TAFW)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Tel Aviv Fashion Week (TAFW)</h2>
// 							<p>
// 								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
// 							</p>
//                            <p>
// 								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 73,
// 	    bgImage:"/posts/bank/73/1.jpg",
// 	    mobBgImage:"/posts/bank/73/M.jpg",
// 	    title: "DGTL FESTIVAL",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 												tlv.dgtl.nl/en
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
//                             <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                             <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
//                             <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                             <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
//                             <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 74,
// 	    bgImage:"/posts/bank/74/1.jpg",
// 	    mobBgImage:"/posts/bank/74/M.jpg",
// 	    title: "Tel Aviv Marathon",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											22.02.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>

// 											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">
// 												www.tlvmarathon.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Run and fun in the city that doesn’t stop</h2><br/>
//                             <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
//                             <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                             <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                             <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 75,
// 	    bgImage:"/posts/bank/75/1.jpg",
// 	    mobBgImage:"/posts/bank/75/M.jpg",
// 	    title: "Jerusalem Marathon",
// 	    smlTitle: "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											15.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">

// 												jerusalem-marathon.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
//                             <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
//                             <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
//                             <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p>
//                             <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 76,
// 	    bgImage:"/posts/bank/76/1.jpg",
// 	    mobBgImage:"/posts/bank/76/M.jpg",
// 	    title: "Bon Jovi",
// 	    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, TLV
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											25.07.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">

// 												bonjovi.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>

//                             <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city.
//                             <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide.
//                             <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric .
//                             <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop!

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 77,
// 	    bgImage:"/posts/bank/77/1.jpg",
// 	    mobBgImage:"/posts/bank/77/M.jpg",
// 	    title: "TAG 2019",
// 	    smlTitle: "Tel Aviv Games are Back!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											TAG 2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											27-30.3.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												www.telavivgames.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <h2>
//                             	Tel Aviv Games are Back!
//                           	 </h2>

//                             <p>
// 								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience.
//                             </p>
//                             <p>
// 								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
//                             </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>
// 								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
//                             </p>
//                             <p>
// 								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
//                             </p>
//                             <p>
// 								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
// 							 </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 78,
// 	    bgImage:"/posts/bank/100/1.jpg",
// 	    mobBgImage:"/posts/bank/100/M.jpg",
// 	    title: "Purim 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											20-22.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
// 												Tel Aviv Purim 2019
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
// 							</div>

//                             <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
// 							</div>
//                             <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
// 							</div>
//                             <p>So choose your costume and come celebrate with us!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
// 							</div>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "J_Lo",
// 	    bgImage:"/posts/bank/J_Lo/1.jpg",
// 	    mobBgImage:"/posts/bank/J_Lo/M.jpg",
// 	    title: "J.LO",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Hayarkon Park
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
// 							</h3>
// 							<p>
// 								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
// 							</p>
//                          <p>
// 								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
// 							</p>
// 							<p>
// 								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Parade_2019",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Parade 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											14.6.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								The  most fabulous event of the Year
// 							</h3>
// 							<p>
// 								<strong>
// 									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
// 								</strong>
// 							</p>
// 							<p>
// 								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade.
// 							</p>
//                          <p>
// 								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
// 							</p>
// 							<p>
// 								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more.
// 							</p>
// 							<p>
// 								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress.
// 							</p>
// 							<p>
// 								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.
// 							</p>
// 							<p>
// 								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Open_Restaurants_Jerusalem",
// 	    bgImage:"/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
// 	    mobBgImage:"/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
// 	    title: "Open Restaurants Jerusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											19-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												www.open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h3>
// 								Open Restaurants Jerusalem
// 							</h3>
// 							<p>
// 								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem.
// 							</p>
// 							<p>
// 								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
// 							</p>
//                          <p>
// 								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens.
// 							</p>
// 							<p>
// 								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
// 							</p>
// 							<p>
// 								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
// 							</p>
// 							<p>
// 								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													28 - 29.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 	                                <p>The city of Jerusalem is proud to host, for the 15th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’.</p>
// 	                                <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>

// 	                                <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an incomparable atmosphere, guaranteeing an unforgettable experience. </p>

// 	                                <p>The iconic festival has become over the years, a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe, to enjoy a delicious variety of cold beers, food and people in open air of Jerusalem.</p>

// 	                                <p>During the festival you will have the opportunity to taste any (or all) of the variety special flavors of beers from around the country and the world (and we have over 120 of them), served in pop up bars, built specifically for the festival. </p>
// 	                                <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local breweries. </p>

// 	                                <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>
//                                     <a href="https://www.jerusalembeer.com/en" target="_blank" class="jerusalem-link">www.jerusalembeer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Luogo</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													14.10.19
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>MaggiOri informazioni</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to the Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                                    <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now, Tel Aviv. DGTL brings together the worlds of music, technology and art, as well as the latest discoveries in production and sound.</p>
//                                    <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which, will operate simultaneously at any given moment.</p>
//                                    <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for reducing electricity consumption, vegetarian food only, a recycling plan and more. </p>
//                                    <p>The Festival will be held in the fabulous Yarkon Park,  situated in the heart of the buzzing city of Tel Aviv. As a hub of innovation, trendiness and exciting nightlife scene, it is the perfect host for DGTL festival. </p>
//                                    <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 	                            `
// 			}
// 		}
//     },

//     {
// 	              id: "The_International_Arts",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "The International Arts",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Luogo</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													12 - 24.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

//                                     <h2>The International Arts and Crafts Festival 2019<br>
//                                     <small>Hutzot Hayotzer Jerusalem<small></h2>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer. One of the most celebrated events is the colorful “Hutzot Hayotzer -International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer lane and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years. It has long since became a hugely popular tourist and artistic attraction for visitors from around the world. Visitors will enjoy more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more, as well as an international exhibition, showcasing the work of overseas artists.  They will be able to engage in fascinating art conversations and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music, all wrapped up in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not least, don’t miss the “Food around the world” - an Israeli and international food fair, which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>
//                                     <a href="https://artfair-jer.com/english/" target="_blank" class="artfair-link">www.artfair-jer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Jerusalem_Marathon",
// 	              bgImage:"/posts/bank/jer-marathon2019/1.jpg",
// 	              mobBgImage:"/posts/bank/jer-marathon2019/M.jpg",
// 	              title: "La maratona di Gerusalemme",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Luogo</h2>
// 											<div class="text">
// 												<p>
// 													Gerusalemme
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													20.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>MaggiOri informazioni</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">

// 														jerusalem-marathon.com
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                    <p>La Maratona di Gerusalemme si svolge a ottobre ed è uno degli eventi più variopinti ed eccitanti del paese, che riunisce decine di migliaia di maratoneti da tutto il mondo.
// 							<p>La Maratona di Gerusalemme comprende tre eventi - una maratona mattutina di percorsi naturalistici, un evento a Sacher Park e una parata gioiosa che si svolge nelle strade del centro di Gerusalemme.
// 							<p>Per assicurare la partecipazione a tutti coloro che lo desiderano, la maratona offre una varietà di percorsi di diversa lunghezza e grado di difficoltà.
// 							<p><strong>Percorsi mattutini</strong><br/>
//                                 Percorso A - Per coloro che possono camminare, circa 12 km (dalle 07:00 alle 09:00)</p>
//                              <p><strong>Da Ammunition Hill a Sacher Park.</strong><br/>
//                                 Percorso B - Livello di difficoltà media, circa 9 km (dalle 07:30 alle 09:30))</p>
//                              <p><strong>Da Mount Scopus a Sacher Park.</strong><br/>
//                                  Percorso C - Livello di difficoltà facile/per famiglie, circa 4 km (dalle 08:00 alle 10:00)</p>
//                              <p>Da Safra Square a Sacher Park.<br/>
//                              Sacher Park Festival </p>
//                              <p>Tra le 10:00 e le 16:00 presso il Sacher Park si svolgerà un gioioso evento caratterizzato da show, musica dal vivo e spettacoli per bambini e comprenderà anche un’area dedicata ai bambini. </p>
// 							<p>L’allegra parata comincerà alle 15:00, seguendo il percorso nelle vie Bezalel, Hillel e King David, terminando nei pressi di Bell Park e includerà veicoli da collezionisti, gruppi rappresentativi dello stato di Israele e di tutto il mondo, orchestre, corpi di ballo, soldati delle Forze di Difesa Israeliane, artisti di strada, squadre sportive e molto altro ancora.</p>
// 							<p>Non perdete l’occasione di partecipare a questa bella e vivace celebrazione a Gerusalemme! </p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Luogo</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													19 - 21.09.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>MaggiOri informazioni</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2>An amazing experience for design lovers everywhere</h2>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>

//                                     <p>The ‘Open Houses’ opens a one-time door to allow a glimpse into the forms of design, style of living, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical as well as urban buildings. The Festival will also include special guided tours and attractions in unusual places -  from tours of residential apartments to tours of  new buildings. </p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel-Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                      <p>"Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "TelAviv_Marathon",
// 	              bgImage:"/posts/bank/tlv-marathon2020/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-marathon2020/M.jpg",
// 	              title: "Tel Aviv Marathon",
// 	              smlTitle: "",
// 	              html: function(){
// 			              return {
// 				              __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Luogo</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													28.02.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>MaggiOri informazioni</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">

// 														www.tlvmarathon.co.il
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                     <h2>I 10 km più esaltanti che abbiate mai percorso</h2>
//                                     <p>Tanto è stato detto a proposito della città di Tel Aviv. Inserita da Lonely Planet nella lista delle 10 città più travolgenti e dinamiche, Tel Aviv è una metropoli sempre in fermento che può competere tranquillamente con NYC per il titolo di città che non dorme mai. </p>
//                                     <p>Tutto ciò risulta particolarmente vero quando si parla della fantastica maratona annuale notturna di Tel Aviv. </p>
//                                     <p>Con i suoi oltre 25.000 runner e le decine di migliaia di spettatori festanti, questa vivace e adrenalinica gara è anche una festa in piena regola, per la gioia di partecipanti e spettatori che giungono fin qui da tutto il mondo.</p>
//                                     <p>Questa maratona da 10 km si tiene in autunno, ha inizio dopo il tramonto e si snoda lungo le strade di Tel Aviv, partendo da Rabin Square in centro città, dirigendosi verso sud, lungo Rothschild Boulevard, Dizengoff Street, Nordau Boulevard e attraversando Park Hayarkon, per concludersi con la linea del traguardo lungo il fiume. </p>
//                                     <p>I runner avranno la possibilità di ammirare tutti i luoghi di interesse e l’architettura Bauhaus della “città bianca” di Tel Aviv, proclamata patrimonio dell’umanità dall’UNESCO.</p>
//                                     <p>La maratona notturna di Tel Aviv si conclude con una speciale manifestazione all’Hayarkon park nel cuore della città a cui partecipano migliaia di persone oltre ai runner e agli spettatori in un tripudio di musica, danza e divertimento senza fine.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Night_Run_TelAviv",
// 	              bgImage:"/posts/bank/tlv-nightrun2019/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-nightrun2019/M.jpg",
// 	              title: "Night Run Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											30.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvnightrun.co.il/MenuDefault.aspx?id=6571">

// 												www.tlvnightrun.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>The most exhilarating 10km you will ever experience</h2>
//                                     <p>A lot has been said about the world-renowned city of Tel Aviv. Named among Lonely Planet’s 'Top 10 Action-Packed Cities’, this city is a truly trendy buzzing metropolis that doesn’t rest. While its official slogan is the Non Stop City, it truly gives NYC a run for its money for the title the City that doesn’t sleep. </p>
//                                     <p>This is especially the case when it comes to the amazing Night Run Tel Aviv annual race. </p>
//                                     <p>With around 25,000 runners and tens of thousands of cheering spectators, this upbeat adrenaline-charged race is more of a full-blown night time party for the scores of participants and spectators who come from all around the world to take part.</p>
//                                     <p>Taking place during the autumn, the 10KM night run begins well after sundown and follows a fantastic urban route along the streets of Tel Aviv, starting at  Rabin Square in the center of town, and south along Rothschild Boulevard, before continuing along Dizengoff Street, Nordau Boulevard, and into Park Hayarkon, reaching the finish line alongside the river. </p>
//                                     <p>You will be passing all the trendy,, fascinating attractions and renowned Bauhaus architecture the "White City" of Tel Aviv has been declared a UNESCO World Heritage Site for. </p>
//                                     <p>Best of all, The TLV Night Run ends with a celebratory finish line festival at Hayarkon park in the heart of the city where thousands more come to join the runners and spectators in an all-night rager of music, dancing and nonstop fun.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Celine_Dion",
// 	              bgImage:"/posts/bank/Celine_Dion/1.jpg",
// 	              mobBgImage:"/posts/bank/Celine_Dion/M.jpg",
// 	              title: "Celine Dion",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											04.08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">

// 												www.celinedion.com

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Our Heart Goes On – for Celine Dion in Tel Aviv!</h2>
// 										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>

//                                         <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>

//                                         <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>

//                                         <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Nickcave_Badseeds",
// 	              bgImage:"/Concerts/bank/nickcave_badseeds/1.jpg",
// 	              mobBgImage:"/Concerts/bank/nickcave_badseeds/M.jpg",
// 	              title: "NICK CAVE & BAD SEEDS",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Bloomfield Stadium, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											17.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 												Update Soon

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h2>
//                                     <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>

//                                     <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>

//                                     <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>

//                                     <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>

//                                     <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Louis_CK",
// 	              bgImage:"/posts/bank/Louis_CK/1.jpg",
// 	              mobBgImage:"/posts/bank/Louis_CK/M.jpg",
// 	              title: "He’s coming back! Louis CK in Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Hangar 11, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/events/%D7%A4%D7%99%D7%A1-%D7%90%D7%A8%D7%A0%D7%94-%D7%9E%D7%9C%D7%97%D7%94-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%9C%D7%95%D7%90%D7%99%D7%A1-%D7%A1%D7%99-%D7%A7%D7%99%D7%99-%D7%91%D7%94%D7%95%D7%A4%D7%A2%D7%94-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-louis-ck-live-in-israel/554683431359536/">

// 												Louis CK

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>Back for the second time, Louis CK will preform at the Hangar 11 in Tel Aviv, this upcoming November.</p>

//                                     <p>After his tremendous success in Jerusalem in 2016, Louis CK is about to return for another exclusive show; this time, right here in Tel Aviv, one of the hottest cities for live shows.</p>

//                                     <p>The talented, hilarious comedian is back in action after a two-year break making this show, bigger, better and funnier than ever. Having a wide following audience in Tel Aviv alone, the sharp comedian is sure to light up the stage.</p>

//                                     <p>Tel Aviv has hosted dozens of comedians from all over the world, including Jerry Seinfeld and Chris Rock, Jim Jefferies and many others, is the ultimate city for having a good time. The city is known for its art and culture as well as its exciting club scene and trendy bars and restaurants.</p>

//                                     <p>So book your trip now and get ready for an unforgettable time in the city that doesn’t stop!</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Cycle_Tel_Aviv",
// 	              bgImage:"/Concerts/bank/cycle-tlv-2019/1.jpg",
// 	              mobBgImage:"/Concerts/bank/cycle-tlv-2019/M.jpg",
// 	              title: "Cycle Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											All Around Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											18.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>The mild to warm October weather, combined with the energetic vibe of Tel Aviv, provide the perfect setting for the biggest cycling event in the country.</p>

//                                     <p>Thousands of cycling enthusiasts flock to Tel Aviv to ride through the vibrant city, on a scenic course showing you everything Tel Aviv has to offer:</p>

//                                     <p>From the beautiful Yarkon Park, along the coast, past the city’s many dazzling beaches and back up to the park through the city center, you’ll get a glimpse of every characteristic place, the “Mediterranean capital” has to offer.</p>

//                                     <p>Everyone can experience the thrill and excitement of the event, from the 60 km course for professional riders to the 8 km course for families and beginners, there is even a rollerblades course for those who prefer to make their way through the city on foot.</p>

//                                     <p>With the locals coming out in droves to cheer on the event, you’ll see a colorful and diverse crowd, adding to the fun and excitement in the air.</p>

//                                     <p>Whether you’re looking for a personal challenge to compete against some of the top riders in the country, or you’re hoping to enjoy a family day out with the crowds, you’re sure to experience the beauty and energy that makes up the unique atmosphere of Tel Aviv.</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival_2020",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Luogo</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>MaggiOri informazioni</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							         <p>Il DGTL Festival è tornato!  </p>
//                                     <p>Con il suo eccellente programma musicale nello Yarkon Park, accompagnato dalle più recenti innovazioni tecnologiche e sostenibili e da progetti di fresh art.</p>

//                                     <p>Il DGTL Festival è un evento globale, protagonista della scena musicale e festivaliera, che si tiene in una serie di città in tutto il mondo: Amsterdam, San Paolo, Barcellona, Santiago e ora Tel Aviv. Il festival avvicina il mondo della musica alla tecnologia e all’arte con sound e produzioni all’avanguardia. </p>
//                                     <p>Il DGTL Festival quest’anno sarà in versione ampliata con un fantastico lineup e comprenderà quattro palcoscenici su cui si alterneranno simultaneamente tutti gli artisti.</p>
//                                     <p>Oltre ad essere un festival musicale innovativo, DGTL promuove la tutela ambientale e la sostenibilità ed è stato premiato come il festival più green d’Europa. Il festival ha un programma rivoluzionario per il risparmio di corrente, solo cibo vegetariano, un piano di riciclaggio e molto altro ancora. </p>
//                                     <p>Il festival si svolgerà nel fantastico Yarkon Park nel cuore dell’animata città di Tel Aviv, un luogo dalla vita notturna eccitante, innovativa e di tendenza, che la rendono ideale per ospitare il DGTL Festival.</p>
//                                     <p>Non perderti il festival più innovativo al mondo nella città più entusiasmante del pianeta! </p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Week_2020",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Week 2020",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											12.6.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<div class="responisve-iframe">
// 					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				             </div>
// 				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
// 							<span class="ac-cradit-text">Credits:</span>

// 								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
// 							</div>
// 							<p></p>
// 							</div>
// 							<h2>L'evento piu' cool dell'anno</h2>
//                             <p><strong>Celebrazioni Pride Tel Aviv 2020 – un evento che saprà sbalordire!</strong></p>
//                             <p>Tel Aviv, una delle capitali gay più celebrate al mondo, è famosa per l’energia che sprigiona 24 ore su 24 e per gli stravaganti party senza sosta. Uno degli eventi di gran lunga più imponenti e infuocati della città è rappresentato dalla settimana che celebra il Gay Pride e il venerdì culmina nella straordinaria Pride Parade. </p>
// 							<p>La parata, una tradizione iniziata sin dal 1998, attrae un’enorme folla della gente più cool proveniente da tutto il mondo, che si riunisce per celebrare e supportare la libertà e l’accettazione di tutti gli stili di vita e i generi in una celebrazione esagerata e lungimirante.</p>
// 							<p>La parata è il clou di una settimana di eventi per il gay pride che avranno luogo in tutta la città, tra i quali interminabili feste a tema pride, mostre, festival cinematografici, concerti e molto altro. </p>
// 							<p>La parata di per sé si svolge tra le animate strade principali della stupefacente Tel Aviv ed è caratterizzata, nella migliore tradizione delle sfilate pride in tutto il mondo, da carri impressionanti, musica dal vivo, esibizioni di ballo e gli sfavillanti outfit dei partecipanti. </p>
// 							<p>La parata termina sulla splendida passeggiata a mare, che corre lungo le spiagge della costa mozzafiato, dove si trasforma in una festa in spiaggia epica e carica di adrenalina con DJ di spicco e spettacoli dal vivo fino all’alba. </p>
// 							<p>La parata quest’anno avrà luogo il 12 giugno 2020 e la partecipazione sarà, come sempre, completamente gratuita. </p>

// 					               `
// 			}
// 		}
//     },

//     {
// 	              id: "Hutzot_Hayotzer_Jerusalem_2020",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "Festival della birra di Gerusalemme",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Luogo</h2>
// 											<div class="text">
// 												<p>
// 													La Piscina del Sultano, Gerusalemme
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <div class="clear"></div>
//                                      <h2>Festival internazionale delle arti e dell’artigianato </h2>
//                                     <p>Gerusalemme è ricca di straordinari eventi durante tutta l’estate. Uno dei più pittoreschi e celebrati è “Hutzot Hayotzer - il Festival internazionale delle arti e dell’artigianato”. </p>
// 									<p>Questo festival su larga scala si svolge tutti gli anni nella zona di Hutzot Hayotzer e della Piscina del Sultano, di fronte alla Torre di David e ai piedi delle mura della Città Vecchia. </p>
// 									<p>L’iconico festival Hutzot Hayotzer si svolge da oltre 35 anni senza interruzioni ed è diventato un’attrazione turistica ed artistica molto popolare, i cui visitatori vengono da tutto il mondo.</p>
// 									<p>Il festival ospita più di 150 artisti locali che mettono in mostra la loro arte: dipinti, stampe, ceramiche, gioielli e molto altro. Il festival comprende inoltre un’esposizione internazionale che mostra le opere di artisti di paesi esteri.</p>
// 									<p>I visitatori avranno la possibilità di prendere parte ad affascinanti conversazioni sull’arte nonché a workshop unici nel loro genere, accedere a un pub irlandese, ammirare sculture gigantesche, assistere a performance e musica jazz dal vivo, il tutto avvolto in un’autentica atmosfera di carnevale europea. </p>
// 									<p>Il festival è aperto tutte le sere (eccetto il venerdì) tra le 18 e le 23 e al sabato sera dalle 21 a mezzanotte, a Hutzot Hayotzer, nel Parco Mitchell e nell’Anfiteatro Merril Haasenfeld presso la Piscina del Sultano.</p>
// 									<p>E per ultimo ma decisamente non meno importante ricordiamo il “Cibo da tutto il mondo” - una fiera culinaria israeliana e internazionale dove saranno presenti stand gastronomici dalle varie cucine del mondo: thailandese, israeliana, cinese, coreana e molto altro.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival_2020",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Festival della birra di Gerusalemme",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							         <p>La città di Gerusalemme è orgogliosa di ospitare, per il sedicesimo (!) anno di fila, il mitico e super-popolare Festival della birra. </p>
//                                     <p>Il Festival della birra di Gerusalemme è una festa riconosciuta a livello internazionale all’insegna della buona musica, del buon cibo e ovviamente, avete indovinato, dell’ottima birra. </p>

//                                     <p>Il festival si svolge nella cornice della magica e millenaria città di Gerusalemme e può vantare un’atmosfera senza paragoni che garantisce un’esperienza indimenticabile. </p>

//                                     <p>L’iconico festival negli anni è diventato simbolo della cultura dell’intrattenimento di Gerusalemme e offre ai visitatori di tutto il mondo un’occasione unica di godersi all’aperto un’allettante varietà di birre fresche, cibi tipici e persone.</p>

//                                     <p>Durante il festival sarà possibile assaggiare e degustare una vastissima gamma di birre speciali da tutto il paese e dal mondo (ce ne sono oltre 120!) servite in appositi bar pop-up costruiti per l’occasione. </p>
//                                     <p>Il Festival della birra di Gerusalemme è l’unico nel suo genere in Israele e ogni anno ospita un’enorme varietà di grandi marchi internazionali di birra accanto alla presenza di illustri eccellenze locali. </p>

//                                     <p>Quindi unitevi agli oltre quindicimila visitatori che ogni anno vengono ad apprezzare l’atmosfera unica, i concerti imperdibili, il cibo eccellente e la gente fantastica, e per celebrare l’amore universale per la Birra.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Jerusalem_Wine_Festival_2020",
// 	    bgImage:"/Concerts/bank/jer-wine-festival-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jer-wine-festival-2020/M.jpg",
// 	    title: "Jerusalem Wine Festival",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							 <h2>   Cena con un calice di vino nella Città Santa!</h2>
// 							<p>Le sere rilassanti d’estate sono ideali per uno squisito bicchiere di vino! Per quattro giorni ad agosto al sedicesimo JWF annuale potete degustare selezioni di prim’ordine a livello internazionale e premiate specialità gastronomiche. Ospitato nel bellissimo Giardino d’arte giapponese presso il Museo israeliano, questo è da molti considerato l’evento sociale top di Gerusalemme. Si tratta di un festival enologico diverso da tutti gli altri: l’atmosfera e la strabiliante vista della città storica sono una combinazione perfetta che rende il JWF un’esperienza imperdibile.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p> Centinaia di vini saranno serviti da dozzine di rinomate boutique winery. Ci sarà la possibilità di sorseggiare gratuitamente il vino, il tutto accompagnato da oasi di stand culinari con formaggi, cioccolato, olio di oliva, eccellenti salse e gustose marmellate. Il festival animerà le feste ogni sera con due diversi concerti di musica dal vivo.</p>
// 							<p>Ogni anno, il JWF ospita a Gerusalemme oltre 20.000 raffinati amanti del vino e della cultura di varia provenienza. Molti partecipano per diverse serate soltanto per il gusto di immergersi in quest’atmosfera. Potreste anche organizzare il vostro soggiorno nella città avendo come punto di riferimento il festival! Potrete certamente completare le vostre giornate con giri turistici, shopping e lunghissime passeggiate. Il modo migliore per rilassarsi al termine di faticose giornate potrebbe proprio essere quello di passare delle serate ricche di divertimento al Jerusalem Wine Festival!</p>

// 					     `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival_2020",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Luogo</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, in tutta la città
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													09.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>MaggiOri informazioni</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                    <h2>Un’esperienza eccezionale per gli appassionati di design di tutto il mondo</h2>
//                                     <p>Tel Aviv, la città che non si ferma mai, ospiterà a settembre, per il quattordicesimo anno di fila, lo straordinario festival di architettura e design ‘Open Houses’. </p>
// 									<p>In questa speciale occasione sarà possibile visitare alcuni degli edifici più belli della città, tra cui case private, appartamenti, edifici storici e contemporanei. ? Il festival prevede inoltre speciali visite guidate ad alcuni luoghi di interesse inconsueti.</p>
// 									<p>L’evento ‘Open Houses’ consentirà ai suoi partecipanti di conoscere più da vicino il design, lo stile di vita, la storia, la cultura, la tecnologia, l’ecologia della città e i suoi edifici di alto valore così affascinanti e unici</p>
// 									<p>Ci sarà la possibilità di visitare numerosi edifici e tra questi anche alcuni mai aperti prima d’ora al pubblico:  il velodromo di Tel-Aviv, aperto per la prima volta, l’interno di una nave, una sinagoga del 1840 a Old Jaffa e altre speciali strutture tra cui l’elisuperficie sul tetto dell’Azrieli e il rifugio antiatomico del Dizengoff Center. </p>
// 									<p> L’evento "Open Houses” rientra tra le attività promosse dall’organizzazione internazionale Open House World Wide che opera a New York, Londra, Chicago, Roma, Barcellona, Melbourne, Dublino, Helsinki e in molte altre città. </p>
// 									<p>Non perderti questo eccezionale e indimenticabile evento nella meravigliosa città di Tel Aviv!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Purim_2020",
// 	              bgImage:"/Concerts/bank/purim2020/1.jpg",
// 	              mobBgImage:"/Concerts/bank/purim2020/M.jpg",
// 	              title: "Purim 2020",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Luogo</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv and Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Data</h2>
// 											<div class="text">
// 												<p>
// 													09-10.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									</div><div class="clear"></div>
//                                      <p>Ogni anno nel mese di marzo, gli abitanti di Tel Aviv e Gerusalemme indossano dei costumi e le città diventano la location per una grande festa: tutto a causa del Purim, la festività più vivace e divertente per tutti loro!</p>
// 									<div class="img-wrapper">
// 												<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
// 											</div>
// 									<p>La capitale del divertimento non delude le aspettative, dal momento che sono programmati decine di eventi tra cui scegliere. L’annuale street party è l’evento più imponente di Tel Aviv. Migliaia di persone vestite in maschera si raccolgono nel Kikar Hamedina per assistere a spettacoli di musicisti e ballerini di straordinaria bravura! La parte migliore? È gratuito! Se non siete troppo stanchi, potete partecipare anche alla Zombie Walk di Tel Aviv. Il nome è abbastanza intuitivo: si tratta di una passeggiata in cui centinaia di zombi attraversano le strade della città che non dorme mai. Altri eventi comprendono lo street party di Tel Aviv nel Rothschild Boulevard e molto altro ancora.</p>
// 									<div class="img-wrapper">
// 												<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
// 											</div>
// 									<p>Se preferite trascorrere le vacanze nella città dell’oro, non abbiate paura perché ci sono tantissimi eventi programmati per tutta Gerusalemme - dal carnevale alle feste ce n’è per tutti i gusti: Gli eventi ufficiali del Purim di Gerusalemme si tengono in Safra Square e prevedono attività e spettacoli per bambini. Un’altra alternativa è rappresentata dall’evento presso il Museo israeliano che è dedicato a tutta la famiglia. Ci sono inoltre il Purim Rave Party presso la Torre di David, la tradizionale parata di Nachlaot Street, una festa in un edificio della downtown di Gerusalemme, un Purim party a Shuka e molti altri eventi ancora da confermare!</p>
// 									<div class="img-wrapper">
// 												<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
// 											</div>
// 									<p>Iniziate a scegliere il vostro costume e venite a celebrare insieme a noi!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "TelAviv_Fashion_Week_2020",
// 	    bgImage:"/Concerts/bank/fashion-week-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/fashion-week-2020/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											03.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>C'est chic, magnifique!</h2>
//                             <p>Gli eventi di moda sono sempre una celebrazione di eleganza, immaginazione, creatività e stile. Il TAFW si sta facendo un nome nell’industria della moda a livello internazionale con l’attenzione che recentemente ha dedicato al cambiamento degli ideali di bellezza, rappresentati da modelli, uomini e donne, di diverse età, taglie, altezze, colore e religione. L’evento distribuito in 4 giornate presenta insolite mostre provenienti da tutto il mondo e allo stesso tempo esposizioni della vibrante scena del design di Tel Aviv e dei suoi dintorni. </p>
// 							<!--<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>-->
// 							<p>Il TAFW segue anche concetti di moda all’avanguardia presentando utilizzi innovativi di tecnologia e tessuti. È particolarmente orgoglioso di dare supporto a giovani designer. Come nelle precedenti edizioni, questo settimo evento annuale presenterà lo spettacolo Upcoming Designers, nel quale i nuovi talenti avranno l’opportunità di condividere i loro articoli/prodotti con voi!</p>
// 							<p>Nel 2020 la settimana della moda di Tel Aviv avrà nuovamente luogo nello storico complesso Tachana. In passato è stata l’ultima fermata del treno che da Old Jaffa portava a Gerusalemme, la stazione è stata ora trasformata in uno degli spazi pubblici più vivaci e di tendenza di Tel Aviv. Situato in un quartiere alla moda con case dai colori pastello, boutique uniche nel loro genere e numerosi bar, avrete voglia di esplorare l’intera zona mentre entrerete nel mondo della moda del TAFW!</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "The_Jerusalem_March_2020",
// 	    bgImage:"/Concerts/bank/jerusalem-march/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jerusalem-march/M.jpg",
// 	    title: "The Jerusalem March",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											30.09.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<p>Taking place in October, the Jerusalem Walk is one of the most colorful and exciting events in the country, bringing together tens of thousands of marchers from around the world.</p>
//                              <p>The Jerusalem march includes three events - a morning walk on nature trails, a happening in Sacher Park and a festive parade that takes place in the streets of central Jerusalem.</p>
//                              <p>To ensure the inclusion of all those who want to join, the march offers a variety of routes with different lengths and difficulty levels. </p>
//                              <p><strong>Morning Tracks</strong><br/>
//                              	<u>Track A</u> - for those who can walk, about 12 km (07:00 to 09:00)</p>
//                              <p><strong>Ammunition Hill to Sacher Park.</strong><br/>
//                              	<u>Track B</u> - Medium difficulty level, about 9 km (07:30 to 09:30)</p>
//                              <p><strong>Mount Scopus to Sacher Park.</strong><br/>
//                                 <u>Track C </u>- easy / family difficulty level, about 4 km (08:00 to 10:00)</p>
//                              <p>Safra Square to Sacher Park.<br/>
//                              Sacher Park Festival </p>
//                              <p>Between 10:00 and 16:00 a festive happening will take place in Sacher Park that will include performances, live music and children’s shows, and a designated area dedicated for kids. </p>
//                              <p>The festive parade will begin at 15:00 and will follow the route of Bezalel, Hillel and King David streets and will end next to the bell park and will include collector vehicles, representative groups from Israel and around the world, orchestras, dance groups, IDF soldiers, street artists, sports teams and more.</p>
//                              <p>Don’t miss your chance to take part in this beautiful and lively Jerusalem celebration! </p>

// 				`
// 			}
// 		}
//     },

//     {

//         id:"The_Pixies_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											14.07.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">The Pixies - coming back to rock it live Tel Aviv!</h2>

// 										<p>The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!</p>
// 			                            <p>The famous American band, well known for its signature style of aggressive punk rock and pop, is responsible for some of the most iconic tunes in music history, including their all-time audience favorite ‘where is my mind’. The pixies are returning to Tel Aviv for the third time as part of their promotional tour for their new album, ‘Beneath the Eyrie’. </p>
// 			                            <p>The pixies will be giving a single performance in the nonstop city of Tel Aviv, the perfect way to rock your beach, sun and fun Tel Aviv holiday.  The concert is set to be held in July, a fabulous time to enjoy the famous Tel Aviv summer, the parties, the amazing cuisine, and the stunning beaches. </p>
// 			                            <p>Tickets are selling fast so hurry up and book your trip today!  </p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"White_Night_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Notte Bianca",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h3>
// 											   Una “Notte Bianca” nella città che non si ferma mai!
// 											</h3>
// 				        					<div class="responisve-iframe">
// 												<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 											</div>
//                                             <p>Quando una città famosa in tutto il mondo come la “città che non dorme mai” organizza un evento come la “Notte Bianca”, sai che sei qui per divertirti. La “Notte Bianca” è uno dei maggiori eventi dell’anno di Tel Aviv, una festa annuale che coinvolge e tiene sveglia tutta la città per una notte intera. Tutti i negozi e i locali sono aperti e ci sono un sacco di eventi che si tengono in contemporanea ovunque...</p>
//                                              <p>Dalle prime ore della sera all’alba, la città si riempie all’inverosimile di turisti e gente del posto, che hanno voglia di divertirsi e di godersi tutto ciò che Tel Aviv ha da offrire: dai negozi ai ristoranti, ai cinema fino agli spazi che ospitano eventi culturali, il tutto disponibile gratuitamente o a prezzi scontati e naturalmente tutta la notte!</p>

// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Foto di: Adam Primer
// 											</small>

// 											<p>L’origine di questo evento ormai famoso in tutto il mondo risale al 2003, quando l’UNESCO ha dichiarato la “Città Bianca”, il complesso architettonico più grande di Tel Aviv con i suoi edifici in stile Bauhaus, patrimonio culturale dell’umanità conferendogli uno status unico nel patrimonio architettonico dell’era moderna.</p>

//                                              <p>Da allora, questa dichiarazione storica è stata celebrata ogni anno presso il quartiere di Jaffa a Tel Aviv con una serie di eventi notturni che hanno preso il nome dalla “Città Bianca” e dall’altra notoria caratteristica di Tel Aviv, quella di essere la “città che non si ferma mai”.</p>

// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Foto di: Kfir Sivan
// 											</small>

// 											<p>La Notte Bianca è una celebrazione di numerosi eventi che si svolgono in tutta la città, che sembra espandersi ogni anno sempre più. In anni recenti, le celebrazioni hanno incluso (giusto per citarne alcuni) uno straordinario picnic pubblico di mezzanotte, un silent party epico nella piazza principale della città, innumerevoli concerti di musica dal vivo, strabilianti spettacoli teatrali all’interno e per strada, affascinanti escursioni notturne, lezioni sportive notturne, lezioni di yoga all’alba, e ovviamente numerose e leggendarie feste organizzate contemporaneamente per tutta la città durante la notte. </p>
// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Foto di Moshik Lindenbaum
// 											</small>
// 											<p>Ti consigliamo di riposarti a dovere, perché avrai bisogno di tutta la tua energia per stare al passo con la “Notte Bianca” nella meravigliosa città di Tel Aviv! </p>
// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Foto di: Guy Yechiely‎.
// 											</small>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Piano_Competition_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Rubinstein International Piano Competition 2020",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											05-21.05.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://arims.org.il/">
// 											www.arims.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>There is no shortage of fantastic arts and culture events in Tel Aviv, but the Rubinstein International Competition is the pride of the city. </p>

// 							<p>39 extremely talented pianists have been nominated to participate in the 16th Arthur Rubinstein International Piano Master Competition. 15 competitors are coming from Asia, 10 from Eastern Europe, 7 from Europe, 3 local talents, 2 from Georgia, and 2 from the USA. Tel Aviv, the cultural hub, is happy to welcome all of them. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/piano-competition-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>The first two stages of this prestigious competition will be held at the Tel Aviv Museum of Art, one of the country’s leading artistic and cultural institutions. The lively Sarona Market is only a 10-minute stroll from there. </p>
// 							<p>The final stages will be hosted at the Charles Bronfman Auditorium, also known as the Culture Palace (Heichal HaTarbut), located in Habima Square, next to the national theater. Some of the best cafés and restaurants of Tel Aviv are located nearby, as well as the beautiful Rothschild Boulevard. </p>
// 							<p>Early tickets sale for friends of the society and newcomers has already started. The regular sale will commence on 16 February 2020. </p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Red_Hot_Chili_Peppers_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Red Hot Chili Peppers",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Luogo</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Data</h2>
// 									<div class="text">
// 										<p>
// 											10.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>MaggiOri informazioni</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://redhotchilipeppers.com/">
// 											www.redhotchilipeppers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2  class="ac-align-center ac-margin-top-20">Red Hot Chili Peppers are coming to Funkyard Tel Aviv!</h2>
// 							<p  class="ac-align-center ac-margin-bottom-20 "><b>They’re hot, they’re sexy, they’re Red Hot Chili Peppers,<br class="hide-on-mobile"> and they’re coming back to Tel Aviv for the first time since 2012!</b></p>
// 							<p>With 11 albums, 16 Grammy nominations and six awards, this mega-successful band will make your heart, body, and soul dance at the new Funkyard Festival to be held at the green heart of Tel Aviv - Hayarkon Park. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/red-hot-chili-peppers-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>last December, the band announced the return of the legendary guitarist John Frusciante to the band for the second time, and we’re sure the LA funk-rock icons will rock the park once again.</p>
// 							<p>Red Hot Chili Peppers will give a single concert in the city that doesn’t stop, where you can start the day tanning at the beach with ice-cold beers and end up at one of the lively bars open till morning. The Peppers’ will perform at the beginning of summer when the temperatures are not too hot, but the parties across the city are sizzling. </p>
// 							<p>Tickets are on sale now and the concert is expected to be sold out, so book your trip before it’s gone!</p>

// 						`
// 			}
// 		}
// 	},

// ];

// End live shows
export const ShowsPostsData = [];

export const newPostdata = [
  {
    id: "eurovision",
    bgImage: "/posts/bank/eurovision/1.jpg",
    mobBgImage: "/posts/bank/eurovision/M/1.jpg",
    title: "EUROVISION TEL AVIV",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/logo.png"} class="img-responsive" />
					</div>
					<h3>
						A ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST
					</h3>
					<p>					
						Epic song contest in the Non-Stop City
					</p>
					<p>
						Semi-final 1: 14 May 2019
					</p>
					<p>
						Semi-final 2: 16 May 2019
					</p>
					<p>
						Grand Final: 18 May 2019
					</p>
					<p>
						It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.
					</p>					
					<p>
						Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.
					</p>            
                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv.
					</p>
					<p>
						The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!
					</p>

            	`,
      };
    },
  },

  {
    id: "Get_ready_to_party",
    bgImage: "/posts/bank/Get_ready_to_party/1.jpg",
    mobBgImage: "/posts/bank/Get_ready_to_party/M/1.jpg",
    title: "The best Eurovision parties to be at",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

               <h3>
               	Your Total Guide to Tel Aviv Eurovision parties
               </h3>
               <p>
					From the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv…
				</p>
				<h3>
					CHARLES CLORE PARTY VENUE
				</h3>
				<h3>
					Charles Clore Park: home to the largest Eurovision Village to have ever been made.
				</h3>
				<p>
					Charles Clore Park is located on the sea-front in the south-west of Tel Aviv. It’s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv. 
					During Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea! 
				</p>
				<p>
					Also, some of Israel’s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.
				</p>
				<p>
					Charles Clore is easy to get to: It’s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you’ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there. 
					It’s a big park and will be having a Eurovision makeover, so you won’t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!
				</p>
				<h3>
					TEL AVIV PORT VENUE (“The Namal”)
				</h3>
				<h3>
					Home to 2019’s official Eurovision Euro Club
				</h3>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					The club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:
					<a href="https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0" target="_blank">https://www.eventer.co.il</a>
				</p>
				<h3>
					EUROVISION VENUE
				</h3>
				<h3>
					Expo Tel Aviv: home to the Eurovision Song Contest itself
				</h3>
				<p>
					The 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you’ve got tickets, this is the place you’ll need to get to.
					It’s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes’ away from the convention centre.
				</p>
				<p>
					Don’t forget about the White Night, all the details are in the next article.
				</p>

         	`,
      };
    },
  },

  {
    id: "Tourist_info",
    bgImage: "/posts/bank/Tourist_info/1.jpg",
    mobBgImage: "/posts/bank/Tourist_info/M/1.jpg",
    title: "Tourist info",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

					<h3>
					How to get to Tel Aviv from the airport:
					</h3>
					<p>
					The cheapest way to get into central Tel Aviv from Ben Gurion airport is by train. Follow the signs to the train station that’s attached to the airport (it’s clearly sign-posted) and look for a train that’s going to Tel Aviv-HaHagana (for south Tel Aviv), Tel Aviv-HaShalom (for Central Tel Aviv), Tel Aviv-Savidor Center (for the Old North area of Tel Aviv), or Tel Aviv-University (for the Eurovision Song Contest venue itself). Please note that Tel Aviv HaShalom is closed on Fridays until September 2019. 
					A one-way single ride ticket will cost 13 shekels 50, and the journey takes around 25 minutes. When you get off the train, you might want to take a taxi to your accommodation. Whenever you get in a taxi, ask the driver to use the meter (“monet”) and have cash ready to pay. Or see below for details of taxi apps. For more information and to plan your journey, visit <a href="https://www.rail.co.il/en" target="_blank">https://www.rail.co.il/en</a>: - it’s in English!
					</p>
					<p>
					If you’d prefer to take a taxi all the way to Tel Aviv from the airport, then join the registered taxi queue outside the arrivals hall. A member of staff will ask you where you’re going and how many passengers and cases you have, then will give you a ticket to hand to your driver. You can either use a meter or accept a fixed price. Journeys usually cost around 150-170 shekels for one person. 
					</p>
					<h3>
					How to get from Tel Aviv to Jerusalem:
					</h3>
					<h3>
					By Bus
					</h3>
					<p>
					Head to the Tel Aviv Savidor train central station take bus no.480. The journey time is around 45 minutes. The bus route finishes at the Jerusalem Central Bus Station on Jaffa Road. From there you can take the tram or any other means of transportation available to you, to get to your final destination. 
					</p>
					<h3>
					By Train
					</h3>            
					<p>
					You can also take the brand new train! If you want to go to Jerusalem directly from Ben Gurion Airport, take the train to Navon Station in Jerusalem. The journey from the airport takes around 25 minutes. If you’re connecting from other Tel Aviv stations, just take a train to Ben Gurion Airport station and change there for a connection to Navon.  
					</p>            
					<h3>
					How to get around Tel Aviv
					</h3>
					<p>
					The municipality of Tel Aviv will offer free public transport throughout the city over the weekend of the Eurovision Song Contest. 
					Free buses will run on Friday and Saturday May 17-18.
					However Usually on Saturday there is no public transport in Tel Aviv (aside from taxies).
					</p>
					<p>
					For the other days of Eurovision week, you’ll need a Rav Kav card: Similar to the “Oyster Card” in London, a Rav Kav is a smart card that can be loaded with credit to allow you to ride on buses without needing to worry about cash. In fact, bus drivers no longer let you pay in cash, so it’s super important to get a Rav Kav as soon as you arrive in Tel Aviv.
					To get a card, just jump on a bus at any bus stop, and ask the driver for a Rav-Kav card - it costs 5 shekels (You will need exact change). Then, when you get off the bus, take the card anywhere with you. Some local 7/11s (Kiosk) provide top up serives, ask to add some credit. 50 shekels is probably enough for a one-week visit, as it will cover the cost of around 10 local journeys (each journey is 5 shekels 90). 
					You can also buy a Rav Kav at the official Rav Kav office at 35 Iban Gabirol Street, which is open Sunday to Thursday 8:00 - 20:00 and Friday and holiday eves 8:00 - 13:00 ,or in the Tel Aviv Savidor train station and Carmelit central. You can also add credit at any train station. 
					</p>
					<h3>
					Cycling
					</h3>
					<p>
					Tel Aviv is a cycling hot-spot and there are bike lanes all around the city, including one that runs all the way along the beach promenade from Jaffa in the south  the north of Tel Aviv and beyond, which are gorgeous locations to take a bike ride while soaking up the atmosphere and architecture of Tel Aviv. If you have a bicycle helmet, bring it with you. 
					</p>
					<h3>
					Electric Scooters
					</h3>
					<p>
					Scooters have become super popular in Tel Aviv! They offer a convenient and fun way to get round the city. There are a few brands around – all you have to do is download the relevant app, follow instructions and off you go. Swap your handbag for a rucksack as this will help with balance and remember to keep an eye on the traffic and not to listen to music while scooting. If you have a helmet, it’s a good idea to wear it while you scoot
					</p>
					<h3>
					Walking
					</h3>
					<p>
					Walking is also a great option too - your step-count will soar after a few days in the non-stop city! Equip yourself with a map, a sun-hat and a bottle fo water, and hit the pavements!
					</p>
					<h3>
					Transportation Apps 
					</h3>
					<p>
					There are various transportation apps you can download before arrival to help you plan your way around. Search for one from each category: there are taxi apps, bicycle rental apps, scooter rental apps and journey planning apps. You can also ask your hotel concierge or apartment host for advice on how to get around Tel Aviv - they will be happy to help! 
					</p>
					<h3>
					WIFI
					</h3>
					<p>
					Tel Aviv has a free Wifi network throughout the city. Look for the ‘Free TLV’ network in your smartphone - it works in 80 locations around the city. Most cafes and bars have free public Wifi networks you can use too; just ask for the password when you make your order. Hotels also have free Wifi so just ask for the password information when you check-in.
					</p>

         	`,
      };
    },
  },

  {
    id: "White_night",
    bgImage: "/posts/bank/White_night/1.jpg",
    mobBgImage: "/posts/bank/White_night/M/1.jpg",
    title: "White night",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<h3>
							  White Night Lights Up Tel Aviv on 16th May 
							</h3>
        					<div class="responisve-iframe">
								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
							</div>

							<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>
                            <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv’s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>
                            <p>And for 2019, it’s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/1.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Adam Primer
							</small>

							<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it’s definitely worth stocking up on sleep so you’re ready to party all night long!</p>
                            <p>And at the Eurovision Village in Charles Clore Park, there’ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>
                            <p>Last year’s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv’s own Neta Barzilai with her smash-hit song “Fuego”, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, “Rise Like a Phoenix” while showcasing his new-look for 2019!</p>
                            <p>They’ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola Häggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition’s official lighting partner OSRAM.</p>
                            <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/2.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Kfir Sivan
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/3.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by Moshik Lindenbaum
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/4.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by: Guy Yechiely‎.
							</small>

         	`,
      };
    },
  },

  {
    id: "Tel_Aviv_Street_Food",
    bgImage: "/posts/bank/street-food/1.jpg",
    mobBgImage: "/posts/bank/street-food/M/1.jpg",
    title: "TEL AVIV STREET FOOD",
    ctg: "telaviv",
    isVid: true,
    vidId: "JQD9JpMaw9g",
    smlTitle: "",
    html: function() {
      return {
        __html: `

                     <h3>It is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations</h3>

                        <p>Tel Aviv, home to sandy beaches, non-stop action and a raging nightlife, is also chock-full of unique restaurants and bars, making the seaside city a trendy foodie destination. The Tel Aviv food industry is truly the city’s heart and soul and while plenty of high-end eateries can be found throughout Tel Aviv, it is fresh local street food that has taken the city by storm.</p>

                        <h3>Taking traditional street food to a whole new level</h3>

                        <p>Say goodbye to the days where Tel Aviv street food was mostly limited to the scrumptious, yet singular concept of crisply fried falafel stuffed into a freshly baked pita. Today, the Tel Aviv street food scene is just that - a scene, with gourmet and specialty treats being served to the masses on local street corners. Take a walk down Ibn Gvirol, Ben Yehuda or Carmel streets and choose from a myriad of high-end meats, fish, prepared vegetables and sauces, all artfully inserted inside pita bread, between slices of toast or other casings. Nibble on the succulent delicacies inspired by the four corners of the world - sabich and tahini in laffa bread, unique herring sandwiches and more, as you continue to wander throughout the city, a taste of Israeli culture on your tongue and a pleasant sense of satisfaction in your belly.</p>


                        <h3>Restaurant quality meals for the foodie on the go</h3>

                        <p>What more could a bustling city full of hurried business professionals and excited tourists want than easy access to flavorful and trendy dishes that can be eaten on the go? With more and more unique streetside quick-stop eateries popping up throughout the city and serving dishes like entrecote-stuffed ciabatta bread and cornflour arepas, it is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations.” </p>

                        <p>Foodies delight: Tel Aviv and its hip street food scene, with countless delectable choices on every corner, is the ultimate culinary travel destination and a must-visit stop on your next Israel trip.</p>

         	`,
      };
    },
  },

  {
    id: "Jerusalem_Old_City",
    bgImage: "/posts/bank/jerusalem-old-city/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-old-city/M/1.jpg",
    title: "Gerusalemme ti chiama",
    ctg: "jerusalem",
    isVid: true,
    vidId: "1Yx2Uht4rms",
    smlTitle: "",
    html: function() {
      return {
        __html: `
         
                             <p>
						Cos’altro si può dire della città più esclusiva del mondo? Benvenuti a Gerusalemme, il luogo dove una storia senza eguali si intreccia con un’atmosfera moderna e dinamica.
					</p>

					<p>
						Gerusalemme ospita molti affascinanti siti storici, magici viali, vedute mozzafiato al tramonto, innumerevoli possibilità di svago, ristoranti che offrono piatti squisiti, una vivace vita notturna e un’offerta formidabile di centri artistici e culturali.
					</p>

					<h3>
					   La Città Vecchia
					</h3>
					<p>
						Non esiste altro luogo al mondo che offra una concentrazione simile di affascinanti attrazioni e siti turistici in un solo chilometro quadrato. La Città Vecchia di Gerusalemme pullula di opportunità per scoprire il fulgido passato, la storia, la cultura e la spiritualità della città. Nella Città Vecchia troverai tesori archeologici risalenti a migliaia di anni fa, arte contemporanea e mercati brulicanti di persone dove assaggiare deliziosi manicaretti.
					</p>


					<h3>
					  Il Muro occidentale:
					</h3>
					<p>
						il Muro occidentale, considerato l’unica sezione rimasta del Secondo Tempio, è diventato l’emblema di Gerusalemme. Con le sue migliaia di anni di età, è il luogo di preghiera più importante al mondo per l’ebraismo; è qui che i tredicenni vengono a celebrare il loro bar mitzvah, il momento di confermazione della propria fede e l’ingresso ufficiale nella comunità degli adulti, ed è alle sue crepe che milioni di visitatori e turisti provenienti da tutto il mondo affidano richieste e preghiere.
					</p>
					<h3>
					   La Città di Davide:
					</h3>
					<p>
						situato nei pressi della Porta delle immondizie, questo sito presenta la storia di Gerusalemme durante i regni di Re Davide, Re Salomone e Re Ezechia. Durante gli scavi sono stati riportati alla luce molti tesori archeologici, tra cui un orecchino d’oro risalente a duemila anni fa.
					</p>
					<p>
					   In questo sito avrai la possibilità di prendere in mano una torcia e farti strada tra le acque del tunnel di Siloam, edificato durante il regno del Re Ezechia.
					</p>

					<h3>
					 La Basilica del Santo Sepolcro:
					</h3>
					<p>
						i cristiani di tutte le confessioni ripercorrono i passi di Gesù sulla Via Dolorosa e le 14 stazioni della Via Crucis, ricostruendo il fatidico percorso che rivoluzionò il corso della storia.
					</p>

					<h3>
					  Church of the Holy Sepulchre:
					</h3>
					<p>
						secondo la tradizione cristiana, la Basilica è il luogo in cui Gesù fu crocifisso, sepolto e dove poi risuscitò. È stato per lungo tempo e continua a essere un’importante meta di pellegrinaggio per i cristiani di tutto il mondo.
					</p>

					<h3>
					 Il mercato della Città Vecchia:
					</h3>
					<p>
						questa attrazione imperdibile è costituita da una serie di stradine in cui si ammassano locali che offrono una varietà incredibile di souvenir, articoli d’abbigliamento, cibo (prodotti da forno, spezie, dolciumi, tahini e molto altro), bancarelle che vendono succhi di frutta di ogni genere, ceramiche armene, tamburi e altri strumenti musicali, recipienti di terracotta e tanto altro ancora. Questo colorato mercato regala un’esperienza autentica ed estremamente piacevole: da non perdere.
					</p>

					<div class="img-wrapper">
								<img src=${getImgUrl() +
                  "/posts/jerusalem-old-city/1.jpg"} class="img-responsive" />
							 </div>

					<h3>
						Attrazioni
					</h3>

					<h3>
						Tour in segway:
					</h3>
					<p>
						la visita della città in segway è un’esperienza di pura adrenalina che consente di cogliere lo splendore di Gerusalemme da un punto di vista completamente nuovo. I tour in segway partono da vari punti centrali, tra cui la Passeggiata Armon HaNatziv (East Talpiot), Yemin Moshe e la Città Vecchia, nei pressi del Knesset (parlamento) e della zona dei musei.
					</p>

					<h3>
                        La prima stazione (Hatachana)
					</h3>

					<p>
					   la Prima stazione si trova proprio nel cuore di Gerusalemme, tra la Città Vecchia e il centro città e tra i quartieri storici della Colonia tedesca e di Yemin Moshe. Qui, nel 1892, fu edificata la prima stazione ferroviaria di Gerusalemme. In seguito a importanti interventi di ristrutturazione e salvaguardia, la Prima stazione è stata riaperta e trasformata in un vivace luogo di intrattenimento.
					</p>

					<h3>
                        L’Ascensore del tempo
					</h3>

					<p>
					   gli amanti dei parchi divertimento impazziranno per le sensazioni che regala l’Ascensore del tempo. È un’esperienza interattiva che porta i visitatori in luoghi affascinanti, con le straordinarie sedute in movimento in una sala piena di effetti speciali.
					</p>

					<h3>
					   Il Mercato Machane Yehuda
					</h3>

					<p>
					   per conoscere la città nella maniera più autentica possibile, non si può prescindere da una sosta al Mercato Machane Yehuda. Rappresenta la Gerusalemme del presente e del futuro. Machane Yehuda fonde in maniera straordinaria antico e moderno, con il mercato ortofrutticolo, prodotti alimentari eccellenti e una vivace zona di intrattenimento.
					</p>

					<h3>
					   I musei
					</h3>

					<p>
					   In una città così piena di musei, ci sono innumerevoli opportunità di scoprire e toccare con mano gli avvenimenti del passato e visitare mostre d’arte moderna e contemporanea.


					</p>

					<h3>
					   Il Museo d’Israele
					</h3>

					<p>
					   il Museo d’Israele è la più importante istituzione culturale del Paese. È caratterizzato da numerose gallerie e vaste collezioni di opere d’arte, archeologia e oggetti ebraici. Una delle punte di diamante del museo è il Santuario del Libro, edificio che con il suo design straordinario è stato paragonato alla città stessa.
					</p>

					<h3>
					   Il Museo della Torre di Davide:
					</h3>

					<p>
					 migliaia di anni fa, Gerusalemme era una cittadina tra i cui vicoli re e profeti passeggiavano a piedi o a cavallo. Da allora la Torre di Davide è diventata uno dei simboli più celebri della città, con la torretta che si erge in tutta la sua magnificenza al di sopra dell’antica fortezza, che è ormai diventata uno dei musei più importanti della città.
					</p>

					

					<h3>
					   I ristoranti
					</h3>

					<p>
					  Gerusalemme vanta moltissimi ristoranti, dove si può gustare una vasta scelta di squisitezze locali e internazionali, comuni ed esotiche. Un consiglio per i buongustai: prenota il tuo tavolo in uno dei ristoranti degli chef più esclusivi.
Di seguito sono indicati cinque tra i locali più eleganti e popolari di Gerusalemme, che attirano folle di persone da mattino a sera:
					</p>

					<h3>
					   Café Kadosh
					</h3>

					<p>
					 Questo caffè molto popolare serve piatti kosher, tutti fatti in casa e tutti da leccarsi i baffi!
					</p>

					<h3>
					   Tmol Shilshom
					</h3>

					<p>
					 Un caffè libreria nel centro città dall’atmosfera accogliente, che offre piatti deliziosi e un servizio cordiale. Non lasciartii sfuggire la shakshuka o il filetto di salmone con salsa ai fichi!
					</p>

					<h3>
					   The Eucalyptus
					</h3>

					<p>
					  Questo ristorante kosher, situato nel Quartiere degli artisti, serve piatti che rappresentano l’interpretazione della cucina biblica dello Chef Moshe Basson. Ogni piatto trae ispirazione da scene bibliche e tutte le spezie e le erbe utilizzate crescono, come nei tempi antichi, sulle colline che circondano Gerusalemme e la Giudea. Un’esperienza davvero indimenticabile.
					 </p>

					<h3>
					   Darna
					</h3>

					<p>
					 Un vero ristorante marocchino glatt kosher (solo di carne) nel cuore della città. Scopri l’accoglienza e il vero significato dell’ospitalità marocchina, gustando l’eccellenza culinaria del Maghreb
					</p>

					<h3>
					   Ristorante Ima
					</h3>

					<p>
					  Situato in fondo alla strada del mercato Machane Yehuda, Ima offre eccellenti piatti kosher mediorientali, serviti in un’atmosfera familiare e rilassata.
E non si può andare via da Gerusalemme senza avere assaggiato dell’humus accompagnato da una pita appena sfornata. Ecco alcuni locali in centro dove vivere questa vera esperienza culinaria:
					</p>


					<div class="cradit">
							<p>
							<strong>Azura,</strong><small> nella parte irachena del Mercato Machane Yehuda  </small><br>
							<strong>Lina,</strong><small> nel Quartiere cristiano della Città Vecchia</small><br>
							<strong>Hummus Acramawi,</strong><small>nel Quartiere mussulmano della Città Vecchia</small><br>
							<strong>Hummus Ben Sira</strong><small> nel centro città vicino al Mamilla Hotel</small><br>
							<strong>Abu Shukri,</strong><small>nel Quartiere mussulmano della Città Vecchia di Gerusalemme</small><br>
							</p>
				    </div>

				    <h3>
				        La vita notturna
				    </h3>

				    <p>
				        Gerusalemme è ricca di ristoranti e locali aperti anche di venerdì sera (lo Shabbat). Le zone più dense di locali di Gerusalemme hanno alternative per tutti i gusti di venerdì e di sabato sera, da chi vuole sorseggiare una buona birra in compagnia a chi ama scatenarsi in pista.
Di seguito è presentata una selezione di bar e locali notturni che il venerdì sera pullulano di vita: non vorrai più tornare a casa…
				    </p>

				    <h3>
				       Mantra
				    </h3>

				    <p>
				       Un ristorante e wine bar molto intimo, dove un’atmosfera cordiale si fonde con una cucina strepitosa.
				    </p>

				    <h3>
				       Gatsby Cocktail Room
				    </h3>

				    <p>
				       Questo cocktail lounge e bar richiama l’atmosfera magica dei ruggenti anni ’20 e degli spettacoli di cabaret.
				    </p>

				    <h3>
				        HaTaklit
				    </h3>

				    <p>
				       Questo bar di tendenza, il cui nome in ebraico significa “il disco”, è decorato con le copertine interne dei vinili. Ti aspetta per farti scoprire i suoi drink, la musica live, i DJ e i performer indipendenti che ospita.
				    </p>

				    <h3>
				       Toy Bar (HaTza’atzua)
				    </h3>

				    <p>
				      Questo straordinario locale notturno situato in posizione centrale offre squisiti drink e l’ottima musica di alcuni dei migliori DJ locali.
				    </p>

				    <h3>
                        Sira
				    </h3>

				    <p>
                       Uno dei locali underground più eclettici della città, con una sala giochi e una pista da ballo. Il pub ospita anche eventi e spettacoli.
				    </p>

				    <h3>
                        Even / Juke
				    </h3>

				    <p>
				       Un club di musica che ospita le band più creative di Israele, soprattutto nell’ambito del jazz, del blues e del funk.
				    </p>

				    <h3>
                       Video Pub
				    </h3>

				    <p>
				       Jerusalem’s only “official” gay bar is home to some of the wildest parties in the city.
				    </p>

				    <p>
				       L’unico gay bar “ufficiale” di Gerusalemme detiene il record delle feste più scatenate della città.

JGerusalemme è il non plus ultra delle destinazioni di vacanza! C’è così tanto da vedere e da fare, così tanto per stimolare i sensi e risvegliare la curiosità… un viaggio a Gerusalemme è la promessa di un’esperienza indimenticabile. Prenota subito il tuo soggiorno!
				    </p>

				   


					<h3>
					   Appuntamenti annuali
					</h3>

					<p>
					   Gerusalemme ospita moltissimi eventi annuali straordinari. Per ulteriori informazioni e date, fai una ricerca su Internet.
					</p>

					<h3>
					   Festival delle luci:
					</h3>

					<p>
					   ha luogo nella Città Vecchia ogni anno tra la fine di maggio e l’inizio del mese di giugno. Sarà una esperienza indimenticabile lasciarsitrasportare dagli incantevoli giochi di luci e colori delle decine di opere di artisti israeliani e internazionali. Segui all’interno della Città Vecchia i percorsi che ti guideranno da una straordinaria installazione all’altra.
					</p>

					<h3>
					   Fiera internazionale di Arti e Mestieri (Khutsot Hayotser):
					</h3>

					<p>
					  Ha sempre luogo nel mese di agosto. Le mura della Città Vecchia faranno da cornice a questa fiera, in cui i visitatori avranno l’opportunità di trascorrere serate in un’atmosfera speciale con musica dal vivo. Concedeti una passeggiata nei giardini e qualche sosta presso gli stand in cui artisti israeliani e internazionali di fama mondiale esporranno dipinti, stampe, ceramiche, oggetti in metallo, gioielli, tessuti e filati, oggetti della cultura ebraica, giocattoli, oggetti artigianali realizzati con le tecniche più disparate, oggetti in legno e tanto altro ancora.
					</p>

					<h3>
					   Festival di Israele
					</h3>

					<p>
					   Ogni anno, tra la fine di maggio e l’inizio di giugno. È il primo festival internazionale tenuto in Israele. Ha luogo ogni anno in primavera e presenta straordinarie performance teatrali, di danza contemporanea, musica classica e spettacoli provenienti da tutto il mondo, insieme a innovative opere israeliane. Il festival prevede numerosi eventi organizzati in luoghi della città carichi di una storia lunga centinaia, se non migliaia, di anni. Vengono allestiti anche spettacoli di strada aperti a tutti.
					</p>

					<h3>
					  Festival del cinema di Gerusalemme
					</h3>

					<p>
					  Appuntamento estivo che ha luogo ogni anno nel mese di luglio. Il festival cosparge la città di polvere di stelle con il grande cinema e l’arrivo di attori e scrittori di fama mondiale. Molte celebrità vi hanno presenziato nel corso degli anni. Oltre 200 film israeliani e stranieri dei generi più disparati saranno proiettati e candidati per l’assegnazione dei premi. Il festival offre l’opportunità di incontrare gli artisti e partecipare a laboratori, feste ed eventi musicali.
					</p>

					


         	`,
      };
    },
  },

  {
    id: 13,
    bgImage: "/posts/bank/25/1.jpg",
    mobBgImage: "/posts/bank/25/M.jpg",
    vidId: "k4OwoEk5wMw",
    ctg: "jerusalem",
    isVid: true,
    title: "Jerusalem’s Calling",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>The most magical and radiant city on Earth </h3>

					<p>
						What else can you say about the world’s most unique city? Simply put: Welcome to Jerusalem – where a glorious history is intertwined with modern and dynamic life.
					</p>

					<p>
						Jerusalem is home to innumerable fascinating historic sites, magical walkways, breathtaking views at sunset, a wide variety of entertainment options, restaurants that offer culinary excitement, spirited nightlife and a tremendous offering of centers for the arts and culture.
					</p>

					<h3>
					   The Old City
					</h3>
					<p>
						No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. The Old City of Jerusalem brims with opportunities for you to connect with the city’s resplendent past, history, culture and spirituality. In the Old City, you’ll find archaeological treasures that are thousands of years old, contemporary art and bustling markets where you can purchase delectable delights.
					</p>

					<h3>
					  The Western Wall:
					</h3>
					<p>
						Believed to be the only remaining segment of the Second Temple, the Western Wall has become truly synonymous with Jerusalem. Thousands of years old, it is the most important Jewish prayer site in the world, where thirteen-year-old boys come to celebrate their bar mitzvahs, and where millions of visitors and tourists from around the world place notes with requests and prayers into its cracks.
					</p>
					<h3>
					  Western Wall Tunnels:
					</h3>
					<p>
						Visiting the tunnels is like entering a time machine. Located beneath the Western Wall and the Muslim Quarter, provides visitors with a glimpse of the various periods in the history of Jerusalem.
					</p>
					<h3>
					   City of David:
					</h3>
					<p>
						Located next to the Dung Gate, this site presents the story of Jerusalem during the reigns of King David, King Solomon and King Hezekiah. Many archeological treasures were unearthed in the excavation, including a two-thousand year-old gold earring.
					</p>
					<p>
					   A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was built during the reign of King Hezekiah.
					</p>

					<h3>
					 Via Dolorosa
					</h3>
					<p>
						Christian faithful follow in the footsteps of Jesus down the Via Dolorosa and the 14 Stations of the Cross, reenacting the fateful path that had an unprecedented impact on the course of history.
					</p>

					<h3>
					  Church of the Holy Sepulchre:
					</h3>
					<p>
						According to Christian tradition, the Church is the site where Jesus was crucified, buried and where he resurrected from the dead. It has long been and continues to be a major pilgrimage center for Christians world over.
					</p>

					<h3>
					 The market in the Old City:
					</h3>
					<p>
						This must-see attraction is made up of a series of alleyways, with numerous stalls offering a staggering variety of souvenirs, clothing, foods (baked goods, spices, sweets, tehini and more); stands hawking juices of all kinds, Armenian ceramics, drums and other musical instruments, earthenware jugs and much more. The colorful market delivers an authentic and extremely enjoyable experience that simply cannot be missed.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/2.jpg"} class="img-responsive" />
					</div>

					<h3>
						Attractions
					</h3>

					<h3>
						Segway tours:
					</h3>
					<p>
						This adrenaline-packed method of seeing the city will allow you to take in the beauty of Jerusalem from an entirely different perspective. The Segway tours leave from various central spots, including the Armon HaNatziv Promenade (East Talpiot), Yemin Moshe, and the Old City, as well as near the Knesset and the museum area.
					</p>

					<h3>
                        First Station (Hatachana):
					</h3>

					<p>
					   If you like amusement park rides, you love having your senses scintillated by the Time Elevator. It’s an interactive experience that takes visitors on fabulous voyages to fascinating places, with motion-based seating in a unique hall that is filled with special effects.
					</p>

					<h3>
                        Time Elevator:
					</h3>

					<p>
					   The First Station is right in the heart of Jerusalem, between the Old City and the city center, and between the historical neighborhoods of the German Colony and Yemin Moshe. It is the site of the first train station in Jerusalem, which was built in 1892. After undergoing renovation and preservation, the First Station was reopened as a lively entertainment spot.
					</p>

					<h3>
					   Machane Yehuda Market:
					</h3>

					<p>
					   To experience the city as authentically as possible, your itinerary must include a stop at Machane Yehuda Market. It represents Jerusalem of the present and the future. Machane Yehuda uniquely brings together old and new, with its fruit and vegetable market, along with an excellent food and a vibrant entertainment area.
					</p>

					<h3>
					   Museums
					</h3>

					<p>
					   In a city filled with a large number of museums, you have every opportunity to experience and learn about the events of the past and to visit modern and contemporary exhibits.
					</p>

					<h3>
					   Israel Museum
					</h3>

					<p>
					   The Israel Museum is the largest cultural institution in the country. It has many wings and very large collections of art, archeology and Judaica. One of the highlights of any visit to the museum is the Shrine of the Book, with its unique design that has come to be closely associated with the city itself.
					</p>

					<h3>
					   Tower of David Museum:
					</h3>

					<p>
					  Thousands of years ago, Jerusalem was a small city, where kings and prophets walked or rode their horses down the alleys. Since that time, one of the best-known symbols of the city is David’s Tower, with its turret standing proudly above the ancient fortress that has also become one of the city’s important museums.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					   Restaurants
					</h3>

					<p>
					  Jerusalem boasts many restaurants, where you can dine on a wide array of delicacies –local and international, standard and exotic. And if you are looking for the gourmet experience, you can reserve a spot at exclusive chef restaurants. The following are five of Jerusalem’s finest and most popular spots, which attract crowds all day long:
					</p>

					<h3>
					   Café Kadosh
					</h3>

					<p>
					 Highly popular, the café serves kosher dairy cuisine – all made in house, and all delicious!
					</p>

					<h3>
					   Tmol Shilshom
					</h3>

					<p>
					  A dairy bookstore café in the city center, favored for its warmth, delicious food and friendly service. Don’t miss the shakshuka or salmon fillet in fig sauce!
					</p>

					<h3>
					   The Eucalyptus
					</h3>

					<p>
					  The kosher restaurant, located in the Artist’s Quarter, serves Chef Moshe Basson’s interpretation of biblical cuisine. Every dish has its origins in biblical scenes and all the spices and herbs used grow, as in ancient times, in the surrounding hills of Jerusalem and Judea. An unforgettable experience.					</p>

					<h3>
					   Darna
					</h3>

					<p>
					  An authentic, glatt kosher, Moroccan restaurant, located in the heart of the city. Experience the warm welcome and the true meaning of Moroccan hospitality, while enjoying the culinary excellence of the Maghreb.
					</p>

					<h3>
					   Ima Restaurant
					</h3>

					<p>
					  Right down the street from Machane Yehuda market, Ima offers excellent kosher Middle Eastern food, served in a relaxed family atmosphere
					</p>

					<h3>
					   And no visit to Jerusalem is complete without scooping up some hummus with a pita right out of the oven. The following are a few centrally located hummus spots:
					</h3>

					<div class="cradit">
							<p>
							<strong>Azura,</strong><small> in the Iraqi section of the Mahane Yehuda Market </small><br>
							<strong>Lina,</strong><small> in the Christian Quarter of the Old City</small><br>
							<strong>Hummus Acramawi,</strong><small>  in the Muslim Quarter of the Old City </small><br>
							<strong>Hummus</strong><small> Ben Sira, in the city center next to the Mamilla Hotel</small><br>
							<strong>Abu Shukri,</strong><small> in the Muslim Quarter in the Old City of Jerusalem </small><br>
							</p>
				    </div>

				    <h3>
				        Nightlife
				    </h3>

				    <p>
				         Jerusalem is filled with scores of restaurants and entertainment spots that are also open on Friday nights (the Jewish Sabbath). All of Jerusalem’s entertainment areas have excellent options for weekend fun on Friday nights as well as Saturdays, and you can most definitely enjoy a delightful evening over a cold beer or dance to great music.
                         Below is a small selection of bars and clubs that are hopping on Friday nights and will leave you wanting more…
				    </p>

				    <h3>
				       Mantra
				    </h3>

				    <p>
				       An intimate restaurant and wine bar, where a friendly atmosphere meets superb cuisine.
				    </p>

				    <h3>
				       Gatsby Cocktail Room
				    </h3>

				    <p>
				       The cocktail lounge and bar evokes the magic of the Roaring 20’s and the days of cabarets.
				    </p>

				    <h3>
				        HaTaklit
				    </h3>

				    <p>
				       With a name means “the record” in Hebrew, the trendy bar is decorated with record sleeves. Enjoy full bar, live music, DJs and even independent performers.
				    </p>

				    <h3>
				       Toy Bar (HaTza’atzua)
				    </h3>

				    <p>
				      Centrally located, Toy Bar offers great drinks, great music by some of the best local DJs and great dance bar experience.
				    </p>

				    <h3>
                        Sira
				    </h3>

				    <p>
                       One of the city’s most eclectic underground clubs, with an arcade room and dance floor. The pub also hosts events and performances.
				    </p>

				    <h3>
                        Even / Juke
				    </h3>

				    <p>
				       A music club that showcases the most creative bands in Israel, with an emphasis on jazz, blues and funk.
				    </p>

				    <h3>
                       Video Pub
				    </h3>

				    <p>
				       Jerusalem’s only “official” gay bar is home to some of the wildest parties in the city.
				    </p>

				    <p>
				       Jerusalem is the ultimate vacation destination! With so much to see and do, so much to stimulate your senses and pique your curiosity, your trip to Jerusalem promises us an unforgettable experience. Book your vacation now!
				    </p>

				    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/4.jpg"} class="img-responsive" />
					</div>

					<h3>Box:</h3>
					<h3>
					   Annual events
					</h3>

					<p>
					   Jerusalem plays host to a variety of unique annual events. Check the Internet for dates and further information.
					</p>

					<h3>
					   Festival of Light
					</h3>

					<p>
					   Held in the Old City – May 25, 2016 to June 2, 2016. Come and be part of the enchanting games of light and color, with dozens of displays by Israeli and international artists. Follow the paths set up throughout the Old City, guiding visitors from one mesmerizing work to another.
					</p>

					<h3>
					   International Arts and Crafts Fair (Khutsot Hayotser):
					</h3>

					<p>
					  August 15, 2016 – August 29, 2016. Held against the backdrop of the Old City walls, visitors enjoy a very special nighttime atmosphere and happening with musical performances. Walk through the gardens and stop at the various stands, where artists from Israel and the world exhibit paintings, prints, ceramics, metalwork and jewelry, weaving and textiles, Judaica, toys, crafts in various techniques, woodwork and more.
					</p>

					<h3>
					   The Israel Festival
					</h3>

					<p>
					   May 24, 2016 – June 11, 2016. The festival is Israel’s premiere multi-disciplinary international festival. It takes place annually in the spring, presenting outstanding theater performances, contemporary dance, classical music and performances from around the world, along with ground breaking Israeli works. Numerous festival events are held at unique Jerusalem locations that have historic significance of hundreds, if not thousands, of years. There are also many street performances that are open to the public.
					</p>

					<h3>
					  Jerusalem Film Festival
					</h3>

					<p>
					   July 7, 2016 – July 17, 2016. The festival sprinkles star dust across the city, with quality cinema, actors and writers that are guests. Many famous stars have come to the festival of the years. Over 200 Israeli and foreign films will be screened during the festival, highlighting various genres and competing for prizes. The festival offers opportunities for meetings with artists, workshops, parties and musical events.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/5.jpg"} class="img-responsive" />
					</div>


         `,
      };
    },
  },

  {
    id: "Outdoor_Adventures",
    bgImage: "/posts/bank/40/1.jpg",
    mobBgImage: "/posts/bank/40/M.jpg",
    title: "Outdoor Adventures",
    ctg: "telaviv",
    vidId: "88OV6xU0vPI",
    isVid: true,
    smltitle: "",
    html: function() {
      return {
        __html: `
                <h3>An action-packed city that’s perfect for active people</h3>
			<p>
				People in Tel Aviv live life to the fullest – and they do it outside. This city is chock-full with outdoor activities, and you can pick and choose your favorites. It’s an action packed city – perfect for active people.
			</p>
			<h3>
				Hayarkon Park
			</h3>
			<p>
				Known as the “Central Park” of Tel Aviv, Hayarkon Park is visited by approximately sixteen million people annually. Attractions range from picnics on the huge lawns, pedal boating on its beautiful manmade lake to cycle tracks and tours of the many amazing gardens, portraying nature at the heart of the city.
			</p>
			<h3>
				The Cycling Scene
			</h3>
			<p>
				One of the ultimate ways to discover Tel Aviv is via its 100km of dedicated bike lanes, where you can enjoy the Tel-O-Fun public bike hire system that lets residents and visitors pick up and drop off sleek green bicycles in 150 stations citywide. If you enjoy spending your time on wheels, you should also check out the many dedicated skating parks, where you can watch the local daredevils do their thing, or get your own skateboard or rollerblades and join the action.
			</p>

         `,
      };
    },
  },

  {
    id: "Port_Pleasures",
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    ctg: "telaviv",
    isVid: true,
    //  vidId : "xz05_8hA4q4",
    vidId: "tgF0zMUYY2g",
    title: "I piaceri del porto",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <br/>
        			<h3>I porti di Tel Aviv e Jaffa – diversi ed inaspettati</h3>
        			<p>
						Il porto di Giaffa offre una storia antica, edifici in pietra e strade lastricate, mentre il porto di Tel Aviv è un moderno sito di cultura, svago e commercio.
					</p>

					<h3>
					    Il porto di Giaffa
					</h3>
					<p>
						La moderna citta di Tel Aviv ha visto i propri umili inizi col porto di Giaffa dove immigrati, eserciti e mercanti hanno fatto approdare le loro navi. Il porto ha la fama di essere uno tra i più antichi nel mondo ed oggi viene ancora usato dai pescatori locali, mentre l’area che lo circonda è divenuta una popolare destinazione turistica
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

					<p>
						Le rimesse per le imbarcazioni sono state riconvertite in gallerie e spazi culturali, come il Centro Na laga’at, gestito da una comunita di sordi e ciechi, e la galleria Dvir. Dal lungomare, antichi vicoli si snodano attraverso edifici in pietra che ricordano la città vecchia di Gerusalemme. Tra gli edifici storici troverete gallerie d’arte, negozi di souvenir ed eccellenti ristoranti. Arrivando nella zona più elevata del vecchio porto troverete la chiesa di S. Pietro, il ponte dei desideri, il museo della vecchia Giaffa ed il museo Ilana Goor.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<h3>
						Il porto di Tel Aviv
					</h3>
					<p>
						In contrasto col porto di Giaffa, quello di Tel Aviv ha un piglio maggiormente moderno e commerciale. Il porto è stato operativo dal 1938 al 1965, venendo poi sottoposto a rinnovi e restauri che lo hanno trasformato in un sito di shopping e tempo libero. L’area del porto consiste in capannoni di rimessaggio riconvertiti ed una lunga ed ampia passeggiata lungomare. E’ amato dalle famiglie, che si recano al Dyada Center per attività coi bambini, e da chi va al centro per lo yoga, al centro femminile ed alla sala per conferenze dell’Istituto Cavim per il design e l’architettura( Cavim Institute of Design and Architecture). Il lungomare è anche frequentato da artisti di strada, eventi musicali e mercatini all’aperto. Il porto rappresenta un’area moderna e dinamica per la creativià e la cultura. Al tramonto del sole, il porto di Tel Aviv, coi suoi bar e club, diviene una location molto gradita per chi ama la vita notturna.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

         `,
      };
    },
  },

  {
    id: 14,
    bgImage: "/posts/videos/deadsea/1/1.jpg",
    mobBgImage: "/posts/videos/deadsea/1/M.jpg",
    title: "The Dead Sea",
    vidId: "ixFocykfYHo",
    ctg: "deadsea",
    isVid: true,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
			<p>
					A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			</p>
           <p>
					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
           </p>
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    vidId: "LLOUxE-K_9Y",
    player_id_post: "3",
    title: "Port Pleasures",
    isVid: true,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>The different charms of Tel Aviv and Jaffa Ports</h3>
					<p>
						Jaffa Port offers an ancient history, stone buildings and cobbled lanes while Tel Aviv Port is a contemporary cultural, recreational and commercial hub.
					</p>

					<h3>
					    Jaffa Port
					</h3>
					<p>
						The modern city of Tel Aviv had its humble beginnings in the port of Jaffa where immigrants, armies and traders docked their ships. The port is famed as one of the oldest in the world and today it is still used by local fishermen while the historic surrounding area has become a popular tourist destination.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

					<p>
						The waterside hangers have been converted into galleries and cultural spaces like the Nalaga’at Center operated by the deaf and blind community and the Dvir Gallery. From the waterfront the ancient cobbled alleyways wend their way up through stone buildings reminiscent of old Jerusalem. In among the historic buildings are galleries, specialty stores and excellent restaurants. As you reach the upper levels of the Old Port area you can see St. Peter’s Church, the Wishing Bridge, the Old Jaffa Museum and the Ilana Goor Museum.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<h3>
						Tel Aviv Port
					</h3>
					<p>
						In contrast to Jaffa Port Tel Aviv has a more commercial and contemporary feel. The port operated from 1938 to 1965 and has undergone renewal and restoration to convert it into a shopping and entertainment district. The port area consists of converted hangers and a long wide waterfront promenade. It is popular with families visiting the Dyada Center for children’s activities and others visiting the yoga center, center for women, conference venue and the Cavim Institute of Design and Architecture. The promenade is always alive with street performers, musical events and outdoor markets. The port is a contemporary and dynamic area for creative and cultural expression. When the sun goes down the Tel Aviv Port becomes a popular nightlife destination with bars and clubs.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>


         `,
      };
    },
  },

  {
    id: "TelAviv_By_The_Sea",
    bgImage: "posts/bank/17/1.jpg",
    mobBgImage: "posts/bank/17/M.jpg",
    title: "TEL AVIV SUL MARE",
    vidId: "BEmvshdB1ao",
    isVid: true,
    ctg: "telaviv",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			
			            <h3>Le spiagge di Tel Aviv</h3>
						<p>“Una delle 10 più belle città di mare del mondo” <br>secondo il National Geographic Magazine<br/>
						    Perché a Tel Aviv la vita è una spiaggia. Preparati a divertirti alla grande sotto il sole
						</p>
						<p>
						    Con le sue acque trasparenti e le sue spiagge ricche di divertimento, ciascuno dei 16 lidi di Tel Aviv ha il suo unico stile e attrae certi tipi di persone – dagli hippie casual ai Riviera chic. Giorno o notte che sia, divertirsi sulla spiaggia resta uno dei modi migliori per trascorrere del tempo a Tel Aviv.
						</p>
						<h3>Tel-aviv una delle 10 migliori città balneari del mondo</h3>
						<p>Nominata “Capitale mediterranea del divertimento” dal New York Times e inserita tra le “prime 10 città più movimentate” da Lonely Planet, Tel Aviv è sicuramente la città da visitare per eccellenza nel Mediterraneo.</p>
							<p>Nominata “Capitale mediterranea del divertimento” dal&nbsp;<em>New York Times</em>,&nbsp;<strong>Tel Aviv</strong>&nbsp;è una metropoli moderna e vivace. Fervente palcoscenico artistico, architettura Bauhaus riconosciuta dall’UNESCO, cucina premiata, tantissima vita notturna, atmosfera amichevole e rilassata e spiagge stupende hanno fatto della città una delle principali mete turistiche al mondo.&nbsp;</p>
							<p>Ma anche nella città che ha tutto c’è un solo luogo dove cominciare:&nbsp;<strong>la spiaggia</strong>.</p>
							<h3>Scopri il cuore di una città frenetica</h3>
							<p>Cosa.&nbsp;Il cuore della città che il&nbsp;<em>National Geographic</em>&nbsp;ha definito “La Miami Beach del Mediterraneo" e incluso nell’elenco delle migliori 10 città balneari del mondo, è la linea costiera.</p>
							<p><strong>Perché.</strong>&nbsp;Spiagge sabbiose, acque calde, tantissime opportunità per fare sport acquatici e tempo stupendo. Cos’altro dobbiamo aggiungere? La costa di Tel Aviv è costituita da 13 spiagge uniche nel loro genere, ciascuna con un panorama e un’esperienza diversa. Alcune spiagge sono affollate e alla moda, altre tranquille e rilassanti. Insieme, fanno da sfondo variopinto a questa città entusiasmante e originale.</p>
							<p><strong>Dove.</strong>&nbsp;A ovest di Tel-Aviv, la spiaggia è sempre a pochi passi. Non c’è bisogno di resistere alla tentazione. Non devi far altro che attraversare la strada, toglierti le scarpe e iniziare a divertirti.&nbsp;</p>
							<h3>Scegli la tua avventura in spiaggia</h3>
							<p>Fai attività fisica.&nbsp;</strong>A Tel-Aviv la spiaggia e gli sport acquatici sono molto popolari. Surf, vela, canoa, nuoto, sup, tuffi, pallavolo: e l’elenco potrebbe continuare.</p>
							<p>Scegli la tua attività preferita e divertiti. Dopodiché, quando sentirai il ticchettio delle&nbsp;<em>matkot</em>&nbsp;sulla spiaggia, unisciti alla gente per partecipare anche tu al gioco dei racchettoni, molto praticato in Israele. Non ci sono né vincitori né vinti, ma il gioco è molto divertente… e molto coinvolgente.</p>
							<p><strong>Iscriviti</strong>&nbsp;alla regata di vela SAIL TLV che si svolge in primavera e al quale partecipano imbarcazioni provenienti da ogni parte del mondo. Divertiti a fare sport e a socializzare.</p>
							<p>Vuoi di più? Unisciti alla gente del posto e vai in bicicletta, cammina o fai jogging lungo il litorale.</p>
							<p><strong>Socializza.&nbsp;</strong>Costruisci castelli di sabbia con la tua famiglia, porta a spasso il cane e fai amicizia con gli altri.</p>
							<p><strong>Rilassati.&nbsp;</strong>&nbsp;Desideri rallentare e rilassarti? Nessun problema! Trova un luogo tranquillo in una delle spiagge meno affollate, guarda i gruppi di percussionisti (se vuoi, puoi unirti a loro) e siediti in uno del ristoranti lungo la costa. Il pomeriggio, avvicinati all’acqua, prendi una sedia, siediti comodamente e guarda uno degli stupendi tramonti di Tel Aviv. Non c’è nulla di meglio.</p>

			`,
      };
    },
  },

  {
    id: "Sarona_TelAviv",
    bgImage: "posts/bank/36/1.jpg",
    mobBgImage: "posts/bank/36/M.jpg",
    title: "Sarona, Tel Aviv",
    isVid: true,
    ctg: "telaviv",
    // vidId: "XFgR0acFwF4",
    vidId: "MJ-gsGs1tqA",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<br/>
			
			<h3>Il mercato di sarona il cuore e l’anima del gusto israeliano</h3>
			<p>Un’incredibile oasi urbana. Una fantastica  scelta di attrazioni in una colonia templare incredibilmente rinnovata.</p>
			<h3>Al mercato di Sarona, a Tel Aviv, le opzioni culinarie sono infinite</h3>
			<p>Costruito attorno alle strutture templari di 50 anni fa nel cuore di Tel Aviv, costituisce il “melting pot” culinario di Tel Aviv. Il mercato di Sarona riflette la tipica atmosfera culinaria di Tel Aviv e conferisce un tocco di modernità ai mercati più tradizionali della città. È il luogo ideale da visitare per togliersi tutti gli sfizi e avvicinare le diverse culture che si muovono nella vitale città di mare.</p>
			
			<h3>Visita il mercato culinario coperto più grande di Israele</h3>
			<p>Dalle creazioni gourmet ai piatti tradizionali locali, il mercato di Sarona offre tutto il necessario per soddisfare anche i palati più raffinati. Con oltre 90 ristoranti, bancarelle di generi alimentari, pub e trattorie aperti sette giorni alla settimana, non devi far altro che decidere se mangiare un piatto di squisito ramen, di empanadas piccanti, un tramezzino speziato o una confettura cotta dolce. Non sai cosa scegliere? I ristoranti si trovano l’uno accanto all’altro e possono servire senza problemi un primo di pesce seguito da pad thai piccante o un succulento hamburger.</p>
			<p>Desideri fare una pausa tra una portata e l’altra? Al mercato di Sarona si trovano anche negozi specializzati, musei, un centro accoglienza per visitatori e altre attrazioni divertenti e da non perdere.&nbsp;</p>
			<h3>Viva la genuinità</h3>
			<p>Finalmente venerdì! I venerdì di Sarona sono affascinanti e si possono acquistare prodotti freschi e genuini, che rendono l’esperienza culinaria molto più interattiva e accattivante. Dopo che avrai scelto il prodotto, continua la tua avventura al mercato urbano, aggiungendo alla tua lista della spesa formaggi saporiti di importazione, aceto balsamico italiano di alta qualità, birre artigianali e dolci confetture per rendere più gustoso il pasto del fine settimana cucinato in casa.</p>
			<p>Prova la massima espressione della cucina israeliana moderna al mercato di Sarona. Con un numero praticamente illimitato di opzioni culinarie disponibili che riflettono l’atmosfera unica di Tel Aviv, non devi perdere l’occasione di visitare il mercato di Sarona, il quale soddisferà sicuramente le esigenze di ogni palato.</p>
					
			`,
      };
    },
  },

  {
    id: "Neve_Tzedek",
    bgImage: "posts/bank/4/1.jpg",
    mobBgImage: "posts/bank/4/M.jpg",
    title: "Neve Tzedek",
    // vidId: "R0QsWBZfIpU",
    vidId: "5jl13Z-38eE",
    smlTitle: "",
    isVid: true,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
                    <br/>
                      	<h3>Un’oasi artistica nel cuore frenetico di Tel Aviv</h3>
				<!--<p>
						Tesori antichi e lusso moderno. Un’entusiasmante avventura a Gerusalemme, una città incredibile.<br/>
						Prenditi una pausa dal ritmo frenetico di Tel Aviv: questo quartiere è un autentico gioiello nascosto, ricco di meravigliose architetture in stile orientale e affascinanti stradine. Tutto ciò rende Neve Tzedek, che significa letteralmente Oasi di giustizia, una vera e propria oasi nel cuore di questa vivacissima città.
				</p>
				<p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>-->
                <h3>Prova l’atmosfera magica nei cortili ombreggiati dei ristoranti e dei caffè di Neve Tzedek</h3>
				<p>Nascosto all’interno di una delle zone più antiche di Tel Aviv si trova una gemma architettonica con un cuore giovane. Fondato nel 1887, Neve Tzedek, il primo quartiere ebraico al di fuori della vecchia città portuale di Jaffa, negli ultimi tempi è diventato il luogo di ritrovo alla moda di artisti di ogni genere, che si inserisce a perfezione nella caratteristica architettura orientale rappresentata dagli edifici restaurati del quartiere.</p>

				<h3>Una vera oasi all’interno della frenetica Tel Aviv</h3>
				<p>Sia per la ricerca di un piatto di ceramica decorato a mano, un capo di abbigliamento esclusivo o un gioiello realizzato con tecniche di saldatura tradizionali, le innumerevoli boutique, gallerie, atelier di design e negozi alla moda all’interno degli edifici in stile orientale che costellano le strette vie laterali fino a via Shabazi forniscono un’esperienza di shopping unica e personale. E con la fresca brezza di mare che ti rinfresca mentre giri per il quartiere, inizierai a sentirti vivo e allegro, come lo spirito eccentrico del quartiere.</p>
				<p>Prova l’atmosfera magica nei cortili ombreggiati dei ristoranti e dei caffè di Neve Tzedek degustando un piatto leggero e al tempo stesso appagante. I numerosi ristoranti, all’interno di pittoreschi edifici storici costruiti per le vie strette del quartiere offrono delle vere e proprie specialità culinarie. I piatti squisiti, insieme all’aria pacifica che si respira camminando per le vie del quartiere ti trasportano in una realtà tipicamente bohémienne.</p>
				<h3>Dove la creatività non conosce limiti</h3>
				<p>Una visita a Neve Tzedek non sarebbe completa senza rendere omaggio alle principali espressioni di creatività, presso il Museo d’arte Nachum, dove le installazioni e le attività interattive contribuiscono all’atmosfera artistica esemplificata dal quartiere tranquillo, che ti induce a visitare altre gallerie locali e laboratori di ceramica.</p>
				<p>Visita il Centro di danza e teatro Suzanne Dellal di Tel Aviv, dove potrai assistere alle numerose performance o ai festival organizzati dal centro culturale, tra cui danze e canzoni etniche che coniugano le arti sceniche israeliane con la cultura internazionale.</p>
				<p>Percorri via Shabazi fino in cima e guardate come lo spirito creativo del quartiere continua a scorrere fino ad HaTachan, la vecchia stazione ferroviaria di Jaffa che è stata recentemente trasformata in un centro di boutique, dove negozi e caffè spiccano in un contesto dalle profonde radici storiche.</p>
				              
			`,
      };
    },
  },

  {
    id: "New_And_OLd_Jerusalem",
    bgImage: "/posts/bank/39/1.jpg",
    mobBgImage: "/posts/bank/39/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "3g9T1HMP39Q",
    title: "Gerusalemme vecchia e nuova",
    smltitle: "",
    html: function() {
      return {
        __html: `
                            
					<br/>
					<h3>La vecchia e nuova Gerusalemme</h3>
							<p>
							Tesori antichi e lusso moderno. Un’entusiasmante avventura a Gerusalemme, una città incredibile<br/>
							Benvenuti a Gerusalemme, dove una gloriosa storia si intreccia con una vita moderna e dinamica.
			        Gerusalemme è una città dagli innumerevoli e affascinanti siti storici, sentieri magici, viste di tramonti mozzafiato offre una grande varietà di passatempi, sorprendenti ristoranti, una vivace vita notturna e un’incredibile offerta di luoghi dedicati all’arte e alla cultura.
			        </p>
			        <h3>Gerusalemme avventure nel tempo</h3>
			        <h3>Una città di magia e splendore al di là di ogni immaginazione</h3>
					<p>Gerusalemme è la capitale di Israele e di gran lunga una delle città più famose e affascinanti del mondo, dove migliaia di anni di storia gloriosa si intrecciano con la vita moderna.</p>
					<p>Scopri l’enorme energia di questa città di 3.000 anni, i suoi innumerevoli siti storici e le meraviglie archeologiche, le sue passeggiate magiche e i magnifici panorami, i quali lasceranno sicuramente un ricordo incancellabile. Allo stesso tempo, le attrazioni incredibilmente moderne della città promettono piacevoli emozioni a tutte le ore per tutti gli amenti di cultura, arte, musica e prelibatezze culinarie.</p>
					<h3>Attraversate 3000 anni di storia</h3>
					<p>La Città vecchia di Gerusalemme è una delle destinazioni preferite da tutti i visitatori che si recano la prima volta in Israele, ma anche da chi ci torna e dagli abitanti del posto.&nbsp; Circondata da un antico muro ricostruito nel corso delle varie epoche storiche, ha 7 porte che consentono di accedere ai luoghi storici e sacri.&nbsp; Camminando per le strade lastricate ritroverai a fare un viaggio nel tempo e ad attraversare migliaia di anni di storia, restando stupito e al tempo stesso entusiasto di come la modernità si ricolleghi all’antichità.&nbsp;</p>
					<h3>Scopi la Gerusalemme moderna e vitale</h3>
					<p>Esci dalla Città vecchia e scopri tutto ciò che una tipica città moderna ha da offrire, tra cui hotel, passeggiate, ristoranti e centri commerciali.&nbsp; Visita i musei, come ad esempio il Museo di Israele, che è il più grande istituto culturale del Paese e uno dei più importanti musei d’arte e archeologia del mondo e che espone, tra gli altri tesori, i famosi rotoli del Mar Morto (i più antichi manoscritti biblici).&nbsp; In Israele sono presenti fattorie, aziende vinicole e birrifici, i quali offrono numerose tipologie di prodotti enogastronomici, che vanno dalla cucina israeliana tradizionale alla moderna cucina fusion, abbinata a vini e birre squisiti e premiati che attirano i buongustai di tutto il mondo.&nbsp;</p>

					
					<p>Visita Mahane Yehuda, un mercato all’aria aperta variopinto e vivace e un’atmosfera ricca della cultura e degli aromi sprigionati dalle merci in vendita.&nbsp; Aspeta il tramonto e osserva come questo “shuk” si trasforma in un luogo di ritrovo alla moda, con musica dal vivo adatta a tutti gli stati d’animo e accompagnata dall’energia delle persone: una galleria di “street-art” abbinata a cibo e bevande squisiti.&nbsp; Mahane Yehuda offre un’esperienza speciale, quindi ti invitiamo a camminare per le vie, sostare presso un fast food, ballare un po’ bevendo un bicchierino e passare al prossimo locale.</p>
					<p>Immersa nell’arte, nella storia, nella cultura e nella diversità, alla capitale di Israele piace divertirsi e far provare ai visitatori il contrasto tra il fascino storico del vecchio mondo e lo stile di vita di una città moderna.&nbsp; Entrando a Gerusalemme non si può fare a meno di provare il fascino della cultura, dell’archeologia e della storia delle persone di diversa nazionalità che hanno calcato questo suolo, dove l’antico incontra il nuovo oltre le mura della Città vecchia, in questa capitale unica al mondo.</p>

         `,
      };
    },
  },

  {
    id: 9,
    bgImage: "posts/bank/5/1.jpg",
    mobBgImage: "posts/bank/5/M.jpg",
    title: "Jerusalem Old and new ",
    isVid: true,
    ctg: "jerusalem",
    vidId: "MXtcTm_JXus",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Ancient treasures and modern luxuries.</h3>

			<p>
				Downtown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.
			</p>
			<p>
				The area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.
			</p>
			<p>
				The center of Jerusalem includes some of the city’s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem’s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem’s Science Museum.
			</p>
			<h3>
				Machane Yehuda Market
			</h3>
			<p>
				Discover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.
			</p>
			<h3>
				Nahalat Shiv’a
			</h3>
			<p>
				This charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor cafés. Nahalat Shiva is home to Kikar Hamusica (Music Square) – a lively and trendy outdoor space that offers live music every day throughout the week.
			</p>
			<h3>
				Yemin Moshe
			</h3>
			<p>
				This lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.
			</p>
			<h3>
				Ein Kerem
			</h3>
			<p>
				Nestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem’s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest
			</p>  

			`,
      };
    },
  },

  {
    id: "Market_Madness",
    bgImage: "posts/bank/10/1.jpg",
    mobBgImage: "posts/bank/10/M.jpg",
    title: "Mercato di Machne Yehuda",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    ctg: "culinary",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                    <br/>
                    <h3>Pazzie al mercato</h3>
                    <p>Feste notturne nel mercato Mahane Yehuda di Gerusalemme</p>
					<p>
					Folle di locals e di turisti raggiungono questo mercato durante il giorno per gustarne l’autentica atmosfera ed il ritmo del lavoro quotidiano, ed ovviamente per fare la spesa. Una volta che i bottegai chiudono, arrivano i festaioli, anch’essi turisti e locals, per bere e divertirsi nei bar, nei ristoranti e nei vicoli.
					<br>
					Lo shuk non ha mai un giorno di riposo, e se siete in cerca di una serata veramente eletrizzante, allora giovedì è il momento giusto. Per i locals, si tratta dell’unica sera durante la quale si può uscire tranquillamente, senza pensare di doversi alzare per il lavoro il giorno successivo, quindi bar e ristoranti sono aperti fino a tardi, organizzando feste ed ospitando eventi che “debordano” per le strade.
					<br>
					Un amico ed io ci siamo dati appuntamento alle 19.30, quando ancora molti degli esercizi commerciali sono ancora aperti ed i passaggi affollati di acquirenti in cerca di concludere l’affare della fine di settimana; tuttavia, ecco che quando le botteghe chiudono i compratori si dileguano velocemente, facendo posto ai “goderecci”.
					<br>
					Anche se sembra ieri il tempo in cui lo shuk era solo un posto per fare le compere, ed al massimo prendere un boccone veloce in qualche piccola trattoria locale, nel corso degli ultimi 5 anni circa il numero di bar e ristoranti alla moda è salito vertiginosamente, tanto che con difficoltà è possibile seguire tutto quello che succede, tra quelli che spuntano ogni giorno come funghi, ed i posticini nascosti infilati in angoli che solo i veterani del shuk conoscono.
					<br>
					“Quando vediamo tutta la gente che viene a far festa allo shuk il giovedì sera, si dimentica facilmente che, solamente pochi anni fa, non si arebbe trovata anima viva qui di notte,” racconta la nostra locale guida turistica Joel Haber. “Credo che si tratti non solamente del passo più ovvio nell’evoluzione di Machane Yehuda, ma anche del contributo più vivace alla vita notturna della città. Lo shuk ha sempre rappresentato il punto d’incontro e di “commistione” dei gerosolimitani: giovani e meno giovani, religiosi e laici, vengono a sedersi insieme a bere birra ed a gustare il carattere tanto speciale del luogo.”
					<br>
					Tenete d’occhio qui alcuni dei locali che hanno ricevuto un gradimento quasi unanime e che promettono sempre una gradevole atmosfera.
				</p>



					<h3>
					   BEVI, MANGIA E BALLA
					</h3>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/1.jpg"} class="img-responsive" />
					</div>

					<h3>
					   CASINO DE PARIS
					</h3>

                    <p>

                          Nascosto nel settore georgiano dello shuk, tra il mercato coperto e quello scoperto, Casino de Paris ha una storia suggestiva. L’edificio che lo ospita è servito, nel corso degli anni, da casa da gioco, albergo, club degli ufficiali britannici e casa di appuntamenti, ma ora rappresenta uno dei ritrovi di classe del shuk. I clienti che lo frequentano generalmente sono maturi professionisti, tra i trenta e i quaranta, ma il giovedì sera l’atmosfera diventa decisamente divertita ed informale, quando il bar rimane aperto fino alle 2 o alle 3 del mattino, servendo ottimi ed originali cocktail ispirati allo shuk, birre artigianali, alcuni vini rinomati e degli eclettici piatti a base di formaggio, anche ispirati ad ingredienti e cultura del mercato.

                    </p>

                    <h3>
					   CINCO DE MAYO
					</h3>

					<p>
Se siete alla ricerca di un’atmosfera festaiola, Cinco De Mayo potrebbe essere un buon punto di partenza. Il bar ospita di frequente DJ che fanno ascoltare musiche di generi molto diversi, ed i frequentatori del giovedì si fermano volentieri a bere, mangiare e talvolta anche a ballare fino alle 2. Il posto è già strapieno attorno alle 22.30: dopo quest’ora sarà difficile trovare un posto a sedere, ma in tal caso potrete fare come i locals, prendendo qualcosa da bere all’interno per poi andare a zonzo per i vicoli.
Nonostante il nome, Cinco de Mayo non ha niente a che vedere col Messico o col 5 di maggio. Il gruppo di amici che hanno fondato il bar ha preso ispirazione dal tempo in cui abitavano insieme in una sorta di “comune” fuori dell’area urbana, ed avevano deciso di non lavorare mai il 5 maggio.
					</p>

                    <h3>
					  SHUKA BAR
					</h3>

					<p>
                       Pur essendo relativamente piccolo e trovandosi abbastanza lontano dai vicoli maggiormente frequentati, Shuka Bar in Egoz Street è uno dei posti più popolari dello shuk. E’ il tipo di posto che serve come piatto forte carne e patate, birre di sola produzione israeliana, liquori scelti e piccoli snack, ma il giovedì sera si trasforma da un ritrovo-bottega ad una sala da grandi eventi.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/2.jpg"} class="img-responsive" />
					</div>



					<h3>
					    QUE PASA
					</h3>

					<p>
Passiamo al prossimo, Que Pasa rappresenta il valoroso sforzo del proprietario, Yaniv Kovenshtein, di ricreare la cultura delle tapas che tanto aveva amato in Spagna.
Il co-proprietario e chef Avi Betito Golansky, da vita a questo sogno con un menù ricco di tapas di formaggio e pesce, compresa una gustosa Bruschetta Cuca (sardine, cipolla, peperone piccante, olio d’oliva ed un delizioso pane croccante), i Porcini Bruschetta (porcini saltati al burro con aglio, olio di mandorle e prezzemolo), carciofo tagliato coi tartufi, filetti di sardine ripiene di formaggio Saint Moor e fritte con burro alla salvia sopra una lussuregiante insalata di pomodori, anelli di triglia fritti con peperoni arrostiti e tanto altro. Se l’appetito aumenta, ci sono anche porzioni più grandi, come gli gnocchi, e il filetto di branzino o di triglia.
					</p>

					<p>
					   Anche se il motto del bar è “una birra pomeridiana può risolvere ogni grana,” val la pena di provare ad arrivare un giovedì sera al Que Pasa, che tra le altre cose, ospita sempre musicisti locali.
					</p>

					<h3>
					    SHEM TOV
					</h3>

					<p>
					Su Eshkol Street, vicinissima allo shuk aperto, Shem Tov riesce davvero a catturare lo spirito dello shuk con un ricco menù mediorientale, una scelta piuttosto ampia di birre, vini e liquori israeliani e, dulcis in fundo, musica da tutto il mondo che fa andare su di giri fino alle 2 o alle 3 di mattina.
E’ anche un buon posto per un bicchiere di sahlab, un must: una bibita che al mercato si serve calda, fatta con farina ricavata da tuberi di orchidee, acqua di rose, cannella e latte. Mmmh… Delizioso!
					</p>

					<h3>
					    SPUNTINO DELLA NOTTE
					</h3>

					<p>
					  Se siete usciti a bere, avrete probabilmente voglia di qualcosa da mangiare verso mezzanotte e, combinazione, ci sono ancora un sacco di posti che possono soddisfare i vostri bisogni!
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					    SORAMELO
					</h3>

					<p>
					  Se il gran bere vi ha messo voglia di cose dolci, puntate a Soramelo, all’entrata dello shuk coperto, dalla parte di Aggrippas Street, per gustare dei wafer ispirati allo spirito del luogo.
Dato che prende il nome da una leggendario personaggio locale, noto per creare storie su tutto, anche questo wafer-bar è riuscito a produrre alcune storie di sua propria mano!
Soramelo è normalmente pieno per tutta la serata, con gente che sosta per prendere una birretta, un caffè o un boccone di qualcosa di dolce, ma diviene davvero trafficato sul tardi, quando gli avventori spostano la loro attenzione dal bere al mangiare, mettendosi alla ricerca di un piccolo pasto che concluda la nottata. Se anche voi siete tra i nottambuli, avrete tempo fino alle 3 del mattino di giovedì per prendere un wafer che possa assorbire tutta la birra e l’arak che vi siete bevuti. Provate quello con cioccolato e tehina — non ve ne pentirete!
					</p>

					<h3>
					    MICHI’S
					</h3>

					<p>
					    Michi’s fa uso di un’idea semplice ma deliziosa per realizzare il perfetto posto per uno spuntino notturno: hamburger di ottima qualità e panini alla carne a prezzi scandalosamente bassi. Un hamburger semplice di 100 gr. con un pane fresco ed un abbondante contorno costa solo 17 NIS. Se siete davvero affamati, potrete ordinare porzioni maggiori di carne, roast beef e panini al pollo e molte altre cose. Michi’s è aperto fino a mezzanotte.
					</p>

					<h3>
					    MEORAV YERUSHALMI
					</h3>

					<p>
					   Forse il migliore posto per conoscere la famosa grigliata mista gerosolimitana: tagli di carne di vari tipi che costituiscono il ripieno di una pita, servita insieme ad un piatto di patate fritte ed insalata. Oltre alla ricetta classica, appena descritta, esiste anche la grigliata mista con pesce. Le porzioni hanno dimensioni notevoli: perfette per chi ha un robusto appetito. Assicuratevi solo di arrivare prima della mezzanotte.

					<h3>
					    PASTA BASTA
					</h3>

					<p>
Decisamente uno dei punti di ritrovo più popolari dello shuk, Pasta Basta serve pasta fresca a prezzi che non minacciano il conto in banca. Dovrete solamente scegliere la pasta ed il sugo, e con questo avrete il vostro piatto. I prezzi variano a seconda del tipo di sugo dai 19 ai 26 NIS. Gnocchi, ravioli o altri condimenti comportano costi aggiuntivi.
Pasta Basta è aperto fino a mezzanotte, e non siate sorpresi quando vedrete una lunga coda all’ingresso.
					</p>

              
			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "posts/bank/24/1.jpg",
    mobBgImage: "posts/bank/24/M.jpg",
    title: "The old city ",
    vidId: "k4OwoEk5wMw",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Feel the story come alive</h3>
			<p>
			   Become inspired by the world renowned treasures of the ancient city of Jerusalem.
			</p>
              
			`,
      };
    },
  },

  {
    id: 14,
    bgImage: "posts/bank/32/1.jpg",
    mobBgImage: "posts/bank/32/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
			<p>
			   Get high on life in the lowest place on earth.
			</p>
              
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "posts/bank/58/1.jpg",
    mobBgImage: "posts/bank/58/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
              <p>
						The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
              </p>
              <p>
              		This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
              </p>
              <p>
              		The Dead Sea is lined with spas, bathing beaches and spa hotels.
              </p>
			`,
      };
    },
  },

  {
    id: "Go_To_Guide",
    bgImage: "/posts/bank/gotoguide/1.jpg",
    mobBgImage: "/posts/bank/gotoguide/M.jpg",
    title: "Gerusalemme e Tel Aviv",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h3>
                    A meno di un’ora di distanza!
                    </h3>
					<p>Una delle cose migliori quando si visita Gerusalemme e Tel Aviv è vedere quanto queste due fantastiche destinazioni sono diverse tra di loro ma al tempo stesso così vicine. Le due città sono infatti a meno di un’ora di macchina (!) l’una dall’altra, il che significa che, se lo desiderassi, potresti trascorrere la giornata visitando i famosissimi siti storici di Gerusalemme e poi tornare a Tel Aviv in tempo per il tramonto, così da godertelo su una delle sue meravigliose spiagge prima di scatenarti tutta la notte in uno dei club più di tendenza della città. Quando si dice un giorno pieno di divertimento…</p>
                <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/1.jpg"} class="img-responsive" />
					</div>
                <p>Spostarsi tra Gerusalemme e Tel Aviv è semplice e ci sono tanti modi per farlo, in base alle tue preferenze e budget:</p>
                <p><strong>In auto:</strong> Se dovessi scegliere di noleggiare un’auto, la strada nr. 1 collega le due città - i cartelli sono sempre molto chiari e scritti in tre lingue. Tuttavia, potrebbe essere il caso di usare una delle tante app locali di navigazione per vedere la strada ed evitare il traffico. </p>
                
                <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/2.jpg"} class="img-responsive" />
					</div>
				<p><strong>In bus:</strong> ci sono tanti autobus pubblici che percorrono la strada tra Tel Aviv e Gerusalemme. Questo è di gran lunga il modo di viaggiare più conveniente e attento al budget. </p>
                <p<strong>In treno:</strong> Un comodo collegamento ferroviario unisce le due città, facendo sosta in tante stazioni diverse. Al momento, sono in corso dei lavori che presto permetteranno di avere una nuova, rapida strada che collegherà le due città.  </p>
                <p><strong>In taxi:</strong> I taxi per i viaggi interurbani possono essere fermati per strada o prenotati via telefono o con le apposite app, come ad esempio Gett (GetTaxi).</p>
                <p<strong>>Taxi Sherut:</strong> I taxi “Sherut” (servizio) sono dei minibus da 10-12 posti che,in genere, percorrono le più importanti strade di collegamento tra le città utilizzate dagli autobus. A livello di prezzi, i taxi sherut hanno una tariffa fissa proprio come i bus pubblici. I taxi sherut sostituiscono il servizio dei bus durante il venerdì.  </p>
                <p>Per informazioni riguardanti le stazioni ferroviarie, i percorsi e gli orari, visita <a href="https://www.rail.co.il/" target="_blank">www.rail.co.il</a></p>
                <p>Per informazioni riguardanti i percorsi e gli orari dei bus, visita <a href="https://www.bus.co.il/otobusimmvc?" target="_blank">www.bus.co.il</a></p>
                <p>Numero assistenza trasporti pubblici <a href="tel:*8787">*8787</a></p>
                <p>App locale dedicata ai trasporti pubblici - ‘Moovit’</p>
                <p>E allora vieni a visitare la epica Tel Aviv e l’indimenticabile Gerusalemme, a meno di un’ora di distanza l’una dall’altra!</p>

            	`,
      };
    },
  },

  {
    id: "Day_IsTrippin",
    bgImage: "/posts/bank/48/1.jpg",
    mobBgImage: "/posts/bank/48/M/1.jpg",
    title: "Una giornata a Tel Aviv",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>Da un porto all’altro</h3>

				
				
				
			 <p>Comincia la tua giornata al parco di Jaffa, con il suo magnifico panorama sulla costa israeliana: storicamente, questo è il punto da dove è iniziata, circa 4000 anni fa, la costruzione della metropoli. Prendi una tazza di caffè nell’antico porto ora completamente restaurato per poi spostarti verso nord per una bellissima passeggiata sul lungomare, ricco di divertimenti acquatici. </p>
                    <div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/37/2.jpg"} class="img-responsive" />
				</div>
                    <p>Attraversa la strada e raggiungi il “Tachana Compound”, un centro commerciale splendidamente rinnovato ospitato in una storica ex stazione ferroviaria che negli ultimi anni del XIX secolo era la stazione principale di Tel Aviv e Jaffa. </p>
                    <p>Visita poi il pittoresco quartiere di Neve Tzedek e attraversa i suoi magnifici viali. Concediti qualche sfizio nei suoi negozi e boutique, fino a raggiungere la colorata confusione del mercato di Carmel. Fermati ad assaggiare dell’eccellente street food e, se capiti di martedì o venerdì, considerati fortunato: potrai fare shopping nella tradizionale fiera di Nachlat Binyamin, nella quale gli artigiani locali espongono le loro opere. </p>
                    <div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/37/1.jpg"} class="img-responsive" />
				</div>
                    <p>Prosegui lungo il favoloso Rothschild Blvd, il cuore dell’architettura Bauhaus della città e patrimonio dell’umanità UNESCO. Questo è il posto perfetto per noleggiare una bicicletta e unirsi alla vita della città fino a raggiungere Habima Square, sede del teatro nazionale e dell’orchestra filarmonica israeliana. Spostati poi verso la trendy, vivace Dizengoff Street e mangia un boccone in una delle tante caffetterie in piazza, continuando a camminare o a pedalare fino a raggiungere Rabin Square. </p>
                    <p>Visita Eben Gabiroll Street, un luogo di tendenza nel cuore della città e sede di un gran numero di ristoranti pluripremiati e di eccellenti bar e pub in cui puoi pranzare o bere qualcosa facendo amicizia con i clienti del posto. </p>
                    <p>Prendi il bus nr. 5, una vera e propria icona urbana della città, e scendi al porto di Tel Aviv. Goditi il tramonto e guarda verso sud in direzione del panorama di Jaffa, dove è cominciata la tua giornata. Trascorri la serata in questa zona e osservala mentre si trasforma nel luogo più di tendenza per la vita notturna, piena di fantastici bar e nightclub fatti apposta per vivere serate memorabili. </p>


            	`,
      };
    },
  },

  {
    id: "Non_Stop_Culture",
    bgImage: "/posts/bank/non-stop-culture/1.jpg",
    mobBgImage: "/posts/bank/non-stop-culture/M/1.jpg",
    title: "Spazio alla cultura",
    isVid: false,
    // vidId:"MXtcTm_JXus",
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

                    <br/>
                    <h3>Una grande varietà di affascinanti musei e gallerie uniche</h3>

				    
                    


				       <h3>
				       Tel-Aviv Museum of Art (Museo d’arte moderna)
				    </h3>

					<p>
						Il musero d’arte moderna di Tel Aviv, propone numerose mostre, permanenti e temporanee, ed ospita il padiglione Helena Rubenstein, in Shaul Hamelech Boulevard, vicino all’Auditorio Mann. La mostra permanente comprende alcune delle opera migliori dell’arte israeliana, insieme ad opere di altri scultori del XX sec. fino ai nostri giorni. Presenta lavori della pittura europea dal XVI al XX sec. , di quella americana del XX sec., ed una pregevole collezione dedicata ad impressionismo e post-impressionismo. La collezione di grafica include oltre 20.000 tra stampe e schizzi. Tra le opere maggiormente degne di nota del museo menzioniamo dei rilievi dipinti appartenenti alla produzione giovanile di Alexander Archipenko ed opere di Chagall, donate dall’autore stesso prima della fondazione del museo. La nota collezione di stanze in miniatura di Helena Rubenstein fa parte della mostra permanente nell’omonimo padiglione.
					</p>
                     <div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/posts/non-stop-culture/1.jpg"} class="img-responsive" />
				    </div> 
					<h3>
				        ORARIO DI APERTURA:
				    </h3>

					<p>
					Domenica chiuso
					<br>
					Lun., merc, sab. 10:00-18:00
					<br>
					Mart., giov. 10:00-22:00
					<br>
					Ven. 10:00-14:00
					<br>
					Sab. 10:00-16:00 (luglio e agosto chiuso il sabato) <nt>
					<a href="//www.tamuseum.org.il/en/default.aspx" target="_blank">www.tamuseum.org.il</a>
					</nt></p>



                    <h3>
                        Beit Hatfutsot: The Diaspora Museum
                    </h3>

                   <p>
						Beit Hatfutsot: il museo della diaspora (The Diaspora Museum)
						Beit Hatefutsot- il museo della diaspora ebraica, situato nel campus dell’università di Tel Aviv, ha guadagnato un grande prestigio nel mondo ebraico per essere il primo museo della storia ad illustrare il contributo ebraico alla cultura ed alla creatività umana nel corso di duemila anni. La mostra permanente del museo presenta la storia del popolo ebraico nella diaspora tramite disegni, video clip, film, modelli di ricostruzioni ed altro. L’obiettivo è puntato su temi diversi, quali “Il ciclo della vita nella famiglia ebraica”, “la comunità”, “la fede”, e “il ritorno a Sion”.
						<br>
						<a href="//www.bh.org.il/" target="_blank">www.bh.org.il</a>
				    </p>

                    <!--<div class="img-wrapper">
						<img src=${this.url + "/assets/img/posts/10/2.jpg"} class="img-responsive" />
					</div>-->


                    <h3>
                          Eretz Israel Museum
                        </h3>
                        <p>
                          Il museo Eretz Israel a Tel Aviv è un’istituzione multi-disciplinare. Presenta la storia della terra di Israele e della sua cultura con un’estesa mostra permanente, oltre che con varie mostre temporanee dedicate ad archeologia, etnografia, folklore, judaica, storia della cultura, identità locali, manufatti tradizionali ed artigianato. I padiglioni del museo sono sparsi in uno spazioso cortile contenente  l’antico sito archeologico di Tel Kassile, i cui reperti sono esposti nelle sale centrali del museo. Notevole anche l’esposizione di ricostruzioni di antichi strumenti di produzione, quali torchi per il vino e per le olive, un mulino per la produzione di farina, ed un “mercato dell’artigiano” che mostra strumenti di lavoro tradizionali che erano in uso nei campi di. C’è un sofisticato planetario con un programma di “Viaggio nell’universo”. Il negozio del museo offre anche una grande scelta di regali e gioielli prodotti localmente.
                        </p>
                        <h3>
                          ORARIO DI APERTURA:
                        </h3>

                        <p>
                          Dom.-merc. 10:00-16:00 <br/>
                          Giov. 10:00-20:00<br/>
                          Ven.-sab. 10:00-14:00 <br/>
                          <a href="//www.eretzmuseum.org.il/e/" target="_blank">www.eretzmuseum.org.il</a>
                        </p>

                        <h3>
                          Beit Ha’ir
                        </h3>
                        <p>
                          Beit Ha’ir, rinnovato a cura del comune di Tel Aviv, era il vecchio municipio, su Bialik Street, ora divenuto un’esposizione sulla storia della citta.  Beit Ha’ir ospita una nuova mostra, che mette insieme  una vasta raccolta di materiale fotografico e narrativo su eventi, siti ed esperienze dei residenti nel corso degli anni, un progetto che faceva parte delle celebrazioni per il centenario della città. La sala principale ospita un’esposizione virtuale che comprende centinaia di film documentari e migliaia di foto e documenti rari che illustrano gli eventi piu importanti nei primi anni della vita della città.  A Beit Ha’ir potrete anche visitare la casa di  Dizengoff, la residenza restaurata di Meir Dizengoff, primo sindaco di Tel Aviv-Giaffa, che include una mostra permanente.

                        </p>
                        <h3>
                          ORARIO DI APERTURA:
                        </h3>
                        <p>
                          Dom. chiuso <br/>

							Lun.-giov. 9:00-17:00
							<br/>
							Ven.-sab. 10:00-14:00<br/>
							<a href="//beithair.org/" target="_blank">beithair.org</a>
                        </p>
                        <h3>

                          The Olympic Experience Museum
                        </h3>
                        <p>
                          Un nuovo museo a Tel Aviv-Giaffa, il Museo dell’esperienza olimpica, propone un itinerario di un’ora attraverso i maggiori record olimpionici, con un’enfasi speciale sulle migliori prestazioni degli atleti israeliani. Olympic Experience può vantare di una presentazione dei materiali basata su sistemi ad alta tecnologia, e tra i materiali presentati ricordiamo immagini ed illustrazioni, presentazioni audio-video, ologrammi, schermi interattivi, simulazioni e molto altro ancora.
							Visite guidate ogni 30 minuti per gruppi organizzati. Raccomandiamo di prenotare in anticipo.
							Orario di apertura: dom.-giov: 10:00-18:00, ven.:  10:00-14:00
							The Olympic Experience, 6 Shitrit Street, Hadar-Yosef. Tel: +972-3-6498385
							<br/>
							<a href="//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2" target="_blank">www.olympic.one.co.il</a>
                        </p>


                        <p>
                          Ilana Goor Museum –  Museo Ilana Goor a Giaffa
                          La casa privata di quest’artista famosa nel mondo è stata trasformata in un museo. Ci sono le sue sculture, ma anche il mobilio e la gioielleria, e si puo dare un’occhiata ad una casa molto speciale di Giaffa.
                        </p>
                        <h3>
                          ORARIO DI APERTURA:
                        </h3>
                        <h3>
                          Palmach Museum
                        </h3>
                        <p>
                         Dom.-ven. 10:00-16:00
                         <br/>
						Sab. 10:00-18:00
						<br/>
						www.ilanagoormuseum.org
                        </p>


                        <h3>
                          Altri musei importanti
                        </h3>
                        <p>
                         Tel Aviv-Giaffa ospita una grande quantita di piccolo musei specializzati, come Beit Ben Gurion (la casa di David Ben Gurion, il primo capo del governo israeliano), Beit Hatanach (la casa della Bibbia), il museo della Haganah (Haganah Museum), The I.Z.L. Museum (Irgun Zva’I Leumi – Museo dell’organizzazione militare nazionale), Beit Hasofer (la casa dello scrittore), Beit Reuven (la casa di Reuven), il museo Jabotinsky (The Jabotinsky Museum), e molti altri. Ognuno di questi piccoli musei è un tesoro di reperti storici. Per esempio, Beit Bialik – la casa del poeta nazionale, espone libri ed arredamento appartenenti al proprietario. La biblioteca personale di Bialik è ben conservata, e gli archivi del museo contengono migliaia di manoscritti, tra cui la maggiore raccolta dei suoi scritti.
                         <br/>
						ORARIO DI APERTURA DEI MUSEI DI TEL AVIV:
						<br/>
						Museo dell’Etzel – Etzel Museum:
						<br/>
						King George 38: Dom.-giov. 8:30-16:00
						<br/>
						<a href="//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx" target="_blank">www.goisrael.com</a>
                        </p>

                        <p>
                          Casa di Ben Gurion – Ben Gurion House: <br/>
							Dom., Mar.-giov. 8:00-15:00<br/>
							Lun. 8:00-17:00
							<br/>
							Ven. 8:00-13:00
							<br/>
							Sab. 11:00-14:00 <br/>
							<a href="//www.bg-house.org/?categoryId=6575" target="_blank">www.bg-house.org</a>
                        </p>
                        <p>
                          Istituto Jabotinsky in Israele –  Jabotinsky Institute in Israel: <br/>
							Dom.-giov. 8:00-16:00 <br/>
							<a href="//en.jabotinsky.org/" target="_blank">en.jabotinsky.org</a>
                        </p>

                        <p>
                          Il museo israeliano – The Israeli Museum: <br/>
							Dom., lun., merc. 9:00-17:00<br/>
							<br/>
							Mar., giov. 9:00-19:00
							<br/>
							Ven. 9:00-14:00 <br/>
							<a href="//www.imj.org.il">www.imj.org.il</a>
                        </p>
                        <p>
                          Centro visitatori di Giaffa – Jaffa Visitors Center:
							Estate dom. – giov., sab. 9:00-20:00 <br/>
							Ven. 9:00-17:00 <br/>
							Inverno dom. – giov., sab. 9:00-18:00 <br/>
							Ven. 9:00-15:00 <br/>
							<a href="//www.touristisrael.com/old-jaffa-visitors-center/3604/" target="_blank">www.touristisrael.com</a>

                        </p>
                        <p>
                          La sala dell’Indipendenza – Hall of Independence:
                          <br/>
						Dom.-giov. 9:00-17:00
						<br/>
						Ven. 9:00-14:00
						<br/>
						<a href="//eng.ihi.org.il">eng.ihi.org.il</a>
						                        </p>

						                        <p>
						                          Il museo della Bibblia – The Bible Museum:
						Dom.-ven. 10:00-13:00 + 16:00-18:30
						                        </p>

						                        <p>
						                          Casa di Joseph Bau – Joseph Bau House:
						Solo su appuntamento (inclusi weekend)
						<br/>
						<a href="//www.josephbau.com">www.josephbau.com</a>
						                        </p>
						                        <p>
						                          Museo Rubin – Rubin Museum: <br/>
						Domenica chiuso<br/>

						Lun., merc., giov. 10:00-15:00
						<br/>
						Mar. 10:00-20:00
						<br/>
						Sab. 11:00-14:00 <br/>
						<a href="//www.rubinmuseum.org.il">www.rubinmuseum.org.il</a>
                        </p>
                        <h3>
                          Gallerie d’arte
                          </h3>
                          <p>
                            Non perdete le dozzine di gallerie d’arte, situate soprattutto lungo Gordon Street e nella citta vecchia di Giaffa, che rappresentano gli sviluppi più recenti dell’arte israeliana. Non aggiungiamo altro: lasciamo che l’arte parli da sola.
                          </p>

            	`,
      };
    },
  },

  {
    id: "A_Taste_Of_Jerusalem",
    bgImage: "/posts/bank/taste-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/taste-of-jerusalem/M/1.jpg",
    title: "Cosa mangiare a Gerusalemme",
    ctg: "culinaryjerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smlTitle: "",
    html: function() {
      return {
        __html: `
               
	                    <br/>


				     <p>Gerusalemme è una città magica e incantevole. Tante persone che visitano Gerusalemme restano colpite dalla sua meravigliosa atmosfera, dai suoi luoghi indimenticbili, dai suoi panorami mozzafiato e tanto altro ancora. Tuttavia, per capire veramente l’essenza di Gerusalemme, ci sono delle cose che possono essere provate semplicemente usando il palato. Eccone solo alcune delle cose che devi veramente provare durante la tua visita a Gerusalemme:</p>
                    <p>Malabi: Una inimitabile combinazione tra una bevanda e un dessert, fatta con un mix di acqua di rose, latte, amido di mais e zucchero. Il Malabi è un piatto molto popolare a Gerusalemme e viene venduto in moltissimi ristoranti mediorientali e chioschi sparsi in tutta la città. Ti garantiamo che non assomiglia a nulla che tu                          abbia già assaggiato. </p>
                    <div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/thingsToDo/posts/39/1.jpg"} class="img-responsive" />
				    </div>
                    <p>Knafe: Un piatto molto interessante e dal gusto fenomenale, servito e mangiato appena fatto. Il Knafe è essenzialmente un dolce arabo fatto con formaggio di capra fuso con sopra capelli d’angelo all’arancia, affogato in un dolce sciroppo all’acqua di rose. Trovare il Knafe perfetto è una vera missione: una volta trovato, provoca davvero dipendenza. </p>
                    <p>Il pretzel di Gerusalemme: Un assoluto must quando si visitano gli affascinanti luoghi della città vecchia consiste nel fermarsi a da uno dei tanti venditori ambulanti e comprare un autentico pretzel di Gerusalemme. Insieme al pretzel , ti daranno una fragrante erba locale chiamata Zaatar, che si abbina perfettamente con la deliziosa e calda pasta del pretzel. </p> 
                    <p>Meorav Yerushalmi: La sua traduzione è “Mix Gerusalemme” e consiste in un delizioso mix di carni diverse con spezie locali...un vero sogno per ogni carnivoro! </p>
                    <p>“Ashtanur”: Ebraico “fuoco nel forno”, Ashtanur è un pane locale di tipo pita che si può trovare in città o nei mercati all’ora di pranzo. Se sei particolarmente affamato, provarlo avvolto intorno a una porzione di shawarma o di falafel. </p>
                    <p>Sabich: un piatto assolutamente originale, il Sabich è una pietanza tipica davvero unica che consiste in un pane pita imbottito di melanzane fritte, uova sode e sottaceti, generalmente guarnito con l’Amba, un condimento locale ricco di sapore. Una volta assaggiato, ne sarai dipendente per sempre. </p>


            	`,
      };
    },
  },

  {
    id: "Sectrets_Of_Jewish_Jerusalem",
    bgImage: "/posts/bank/sectrets-of-jewish-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/sectrets-of-jewish-jerusalem/M/1.jpg",
    title: "A taste of Jerusalem",
    ctg: "jerusalem",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                <p>Jerusalem is an open invitation for a journey. Climb the mountains, enter the city and feel the unique mix between past and present, ordinary and extraordinary. One of the most ancient cities in the world, sacred for Jews, Christians and Muslims, Jerusalem offers an unparalleled sensory and spiritual experience.</p>

                                <p>Enter. The heart of the holiest city in Judaism is the Old City. Enter through the historic entrance, The Jaffa Gate, or use The Zion Gate that leads straight to the Jewish Quarter, one of the four quarters of the walled city and home to Jews almost consecutively since 8 BCE. Wonder through the alleyways, see the people, visit the Cardo, Jerusalem's ancient main street and absorb the unique atmosphere. You're walking in the footsteps of kings and prophets – It's no ordinary thing.</p>
                                <div class="img-wrapper">
					                <img src=${getImgUrl() +
                            "/posts/sectrets-of-jewish-jerusalem/1.jpg"} class="img-responsive" />
				                </div>
							    <small style="color:#000; display:block;">
                      		        Credit: Noam Chen
                      	        </small>
								<p>Witness History Comes alive and Feel the Deep Spiritual Energy within the Walls </h3>

                                <p>What Lays Ahead.  The last remaining segment from the ancient walls that surrounded The Second Temple, The Western Wall, is a symbol of Jewish yearnings for their ancestral and spiritual homeland. Every Jew outside Jerusalem pray facing the place you stand in now, the place where according to Judaism, God resides. No matter what your beliefs are, it's a humbling experience. Honor the spirit of the site and place a note in the wall with a prayer or a wish.</p>

                                <p>What Lays Beneath. Jerusalem is literally covered with layers of history and touching history gets a whole new meaning here.</p>

                                <p>Take the fascinating tour at the Western Wall Tunnels and reveal the hidden sections of the Western Wall. History will come to life as you move through underground passages, discover life in Jerusalem during The Second Temple era and learn about the art, architecture and building practices.</p>

                                <p>Visit the nearby archeological site City of David and learn more about the history of the city King David declared as the unified capital of Israel's 12 tribes 3000 years ago. Go on a journey between ancient walls and fortresses, hidden springs where kings were coroneted and follow the path of fleeing Jerusalem residents after the city was conquered by the Romans.</p>

                                <h3>Marvel at the Breathtaking Extraordinary Vista and Feel on Top of the World</h3>

                                <p>What Lays Above. Originally built to protect the city against intruders, Jerusalem is surrounded by walls.  Today The Walls of Jerusalem offer an opportunity to explore the city from a different angle. Hear the stories, see the city below you and take in all this beauty.</p>

                                <p>You are just beginning to stretch the surface.</p>

            	`,
      };
    },
  },

  {
    id: "Jamie_Oliver",
    bgImage: "/posts/bank/jamie_oliver/1.jpg",
    mobBgImage: "/posts/bank/jamie_oliver/M/1.jpg",
    title: "Jamie Olivier si gode il gusto della tipica colazione di Tel Aviv",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "gGe4W8WaIiQ",
    smlTitle: "",
    html: function() {
      return {
        __html: `

						<small style="color:#000; display:block;position: relative;top: 5px;">
						Credit:  Israeli food channel
						</small>

            	`,
      };
    },
  },

  {
    id: 37,
    bgImage: "/posts/bank/enjoy-and-indulge/1.jpg",
    mobBgImage: "/posts/bank/enjoy-and-indulge/M/1.jpg",
    title: "Enjoy and Indulge",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h3>Tel Aviv - The ultimate luxury destination</h3>
					<p>
						Forget the Caribbean, Cannes or the Maldives, if it’s a luxury vacation you’re after -   Tel Aviv is the place to be! 
					</p>

					<p> 
						First of all, the city, named “the capital of cool” by the NY Times is only a few short hours away, meaning you don’t have to worry about wasting even a minute of your dream vacation on shaking off the Jet Leg.
					</p>
					<p>
						Once here, your first treat is the gorgeous year-round sunny weather – tailor-made for pleasure. 
					</p>
					<p> 
						Next – go and put your feet up and relax in the huge variety of luxury accommodations on offer – from world class 5-star hotels overlooking the beach to the numerous stunning boutique hotels in breathtaking locations all around the city. 
					</p>
                   	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/38/1.jpg"} class="img-responsive" />
					</div>
					<p>
						To complete the experience, throw on a towel and head to any of the gorgeous beaches, complete with all amenities needed for a fabulous day, not to mention the gorgeous cool waters.
					</p>
					<p> 
		 				Feeling hungry? No need to stand in line in London and Paris for their award-winning restaurants - Tel Aviv is home to famous chefs revered all over the world.  Aviv is renowned worldwide for its quality of cuisine, enjoy a huge selection of gourmet dining, from local to fusion, offered in exquisitely designed chef restaurant.  
		 			</p>
		 			<p>
						Time for some shopping – get your wallet and come check out the goodies in the local designer boutiques stores, chic upscale shops in places such as Kikar Hamedina and luxury shopping malls where you can find anything from Haute Couture to the latest international trends. 
					</p>
					<p>
						To finish off your day, grab a craft beer or a glamorous cocktail in any of the sensational nightclubs or glamourous bars around the city and dance your night away before heading off to your hotel for a well-earned 5 star slumber. 
					</p>
					<p>
						Luxury? Style? Glamour? We have it all! So hurry up and book your trip to Tel Aviv Today! 
					</p>

            	`,
      };
    },
  },

  {
    id: "Cool_Jerusalem",
    bgImage: "/posts/bank/cool-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/cool-jerusalem/M/1.jpg",
    title: "",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    smltitle: "Le sorprese di Gerusalemme",
    html: function() {
      return {
        __html: `\
				     <br/>
                    <h3>Una città che supera le aspettative</h3>
					
					

					<p>Gerusalemme è famosa in tutto il mondo. Ogni anno, moltissime persone visitano Gerusalemme per la sua importanza storica, i suoi siti religiosi, la sua meravigliosa e unica architettura e la sua incredibile atmosfera. Tuttavia, Gerusalemme è una città ricca di sorprese e offre tantissime attrazioni che la maggior parte delle persone non associano immediatamente alla città. Ecco alcune delle cose che non ti aspetteresti da Gerusalemme:</p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/40/1.jpg"} class="img-responsive" />
					</div>

                    <h3>Feste d’estate</h3>
                    <p>Ogni estate, il centro di Gerusalemme viene invaso da feste che cominciano a mezzogiorno del venerdì e sono ricche di musica, balli, gente meravigliosa proveniente da tutto il mondo e un’atmosfera contagiosa e scatenata, perfetta per cominciare con il piede giusto il tuo weekend.</p>


                    <h3>Follie al mercato </h3>
                    <p>Ogni giovedì sera vivrai una fantastica esperienza: il vivace mercato di Machne Yehuda si trasforma in un vero e proprio teatro ricco di fantastici bar e pub con musica dal vivo tutta la notte. </p>


                    <h3>Festival</h3>
                    <p>Gerusalemme è una città ricca di festival, da quelli dedicati al cinema ai festival del vino, fino alla rassegna internazionale delle marionette e alla festa della birra. Qualsiasi cosa ti interessi, stai pur certo che troverai un festival adatto a te! </p>

                    <h3>La maratona di Gerusalemme</h3>
                    <p>Una fantastica ed estremamente popolare maratona che offre una vasta scelta di percorsi, da quelli per professionisti a quelli adatti a tutta la famiglia e che attraversano gli affascinanti luoghi storici della città di Gerusalemme, con la sua storia lunga 3000 anni. Ogni tracciato garantirà a tutti i corridori e agli spettatori un’esperienza unica ed emozionante.</p>
                    <h3>Musei e mostre</h3>
                    <p>La variegata natura della città di Gerusalemme si manifesta anche nei suoi musei ed eventi culturali sparsi in tutta la città. Dal famosissimo museo di Israele fino allo Yad Vashem, passando per gli indimenticabili suoni e luci della cittadella e le passeggiate sulle mura, la città è semplicemente piena di incredibili esperienze culturali.</p>

                    <h3>Il mercato dei contadini </h3>
                    <p>Ogni venerdì, nella colonia tedesca situata nel cuore della città, si svolge un bellissimo mercato dei contadini. Il mercato offre una vasta gamma di ottimi prodotti e specialità locali a prezzi molto convenienti.</p>

                    <h3>Un acquario di livello mondiale </h3>
                    <p>Uno dei più grandi acquari del Medio Oriente, questa meravigliosa attrazione per bambini e adulti è stata inaugurata al pubblico quest’anno per la prima volta. L’acquario è grande 7000 mq e ospita 40 specie marine in 33 vasche, di cui quella più grande contiene 1,6 milioni litri di acqua. </p>


            	`,
      };
    },
  },

  {
    id: 39,
    bgImage: "/posts/bank/cycle-in-telaviv/1.jpg",
    mobBgImage: "/posts/bank/cycle-in-telaviv/M/1.jpg",
    //   vidId: "88OV6xU0vPI",
    vidId: "5nqL-oIC0GA",
    isVid: true,
    ctg: "telaviv",
    title: "Cycle Tel Aviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

					<h3>Get on your bicycle - explore the city in style</h3>
					<p>
						As one of the trendiest cities in the world, it is no surprise that Tel Aviv has, in recent years, joined the trend that’s sweeping the worlds most famous cities- the bicycle trend. 
					</p>
					<p>
						Exploring the city on a bike has a variety of benefits – it is environmentally conscious, substantially reducing your carbon footprint, it saves you precious vacation time otherwise spent fighting traffic and is of course extremely healthy. Biking is a fantastic means of exercise, and as a tourist or visitor, cycling as a means of exploring the city is a fabulous way of enjoying its sights, sounds and smells up close with no interference. 
					</p>
					<p>
						Here are just some of the things that make Tel Aviv a fantastic city for cycling: 
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/41/1.jpg"} class="img-responsive" />
					</div>
					<p>
						<strong>The dedicated bike lanes:</strong> 
						The city of Tel Aviv is a strong advocate of bicycles as a means of transport and to support the cause, there are over 100km of dedicated bike lanes paved throughout the city, for the safety and convenience of the city’s cyclists. 
					</p>
					<p>
						<strong>The fantastic weather:</strong> 
						Tel Aviv enjoys fantastic weather year-round with very little rainfall, making it an ultimate city for cycling in weather enjoying the cool breeze coming off the beach on the stunning promenade or zooming down the stunning inner streets with their fabulous Bauhaus architecture.  
					</p>
					<h3>Tel-O-Fun:</strong> 
						the Tel o Fun is an easy, simple and cost effective municipal public bike hire system. With Tel o Fun s residents and visitors alike can pick up and drop off excellent quality bicycles using a credit card at 150 convenient stations citywide.
					</p>
					<p>
						Should you wish you can rent a bike perfect for you in any of the bike rental places all across the city. Most hotels offer a bike rental option, allowing you to explore the city on 2  wheels, just like the locals. 
					</p>
					<p>
						Best thing of all, everything in Tel Aviv is so close, you can take your bike to the beach, cycle along the stunning promenade, take your bike and go for a fantastic picnic in park Ha’Yarkon and take them on a night on the town in the fabulous clubs and bars of Dizengoff or the harbor. 
					</p>
					<p>
						Cycling has never been easier, healthier, or more fun than in the gorgeous city of Tel Aviv. 
					</p>

            	`,
      };
    },
  },

  {
    id: "TelAviv_Adventures",
    bgImage: "/posts/bank/telaviv-adventures/1.jpg",
    mobBgImage: "/posts/bank/telaviv-adventures/M/1.jpg",
    title: "Cosa fare di bello a Tel Aviv",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
                   
                    <p>Tel Aviv è famosa in tutto il mondo per essere una città che non si ferma mai, rinomata per la sua fantastica vita notturna, le sue meravigliose spiagge, la sua incredibile cultura, arte e tanto altro. Ma ci sono tante altre cose meno note che puoi fare d’estate in questa città.</p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/42/1.jpg"} class="img-responsive" />
					</div>
                    <h3>Una serata nei Bracelet Bars</h3>
                    <p>I bracelet bars sono un gran bel modo per bere tutta la notte stando attenti al budget. Basterà andare in uno dei tanti bar di Tel Aviv in cui pagherai un prezzo fisso in anticipo e potrai bere quanto vuoi (e quanto riesci…) </p>
                    <h3>Le jam session di percussioni del venerdì</h3>
                    <p>Raggiungi la famosa Banana Beach di venerdì pomeriggio e potrai goderti uno spettacolo doppio: le jam session di percussioni sulla spiaggia e un meraviglioso tramonto...il tutto completamente gratis! </p>
                    <h3>Divertimento sulle terrazze</h3>
                    <p>Forse è il clima, forse per la vista...ma una cosa è certa: gli abitanti di Tel Aviv amano passare il tempo all’aperto, specialmente con un drink in mano. Durante l’estate vedrai tantissimi bar e pub smontare letteralmente il loro tetto e trasformarsi in locali all’aperto. Inoltre, spuntano sempre tanti nuovi bar sulle terrazze degli edifici commerciali e degli uffici. Per trovare questi fantastici posti, non dovrai fare altro che seguire i suoni della musica e del divertimento. </p>
                    <h3>Fitness all’aperto</h3>
                    <p>Niente è più importante della tua salute e una delle cose migliori che puoi fare per il tuo corpo è fare un po’ di esercizio. Tel Aviv offre tanti, fantastici modi di farlo: dalle nuotate in mare alle corse sulla costa, dai giri in bicicletta per le strade di questa favolosa città fino alle sue tantissime palestre, per finire agli attrezzi da ginnastica all’aperto (e gratis!) sparsi in giro per la città. </p>
                    <h3>Fantastici eventi estivi</h3>
                    <p>Da artisti internazionali a meravigliosi festival dedicati alla tecnologia, all’arte e alla birra, fino a inaugurazioni di gallerie, mostre, musica dal vivo per strada, cinema aperti e party sulla spiaggia che durano tutta la notte, Tel Aviv d’estate è una fonte inesauribile di divertimento che non puoi perderti! </p>


            	`,
      };
    },
  },

  {
    id: "2_AWESOME_CITIES",
    bgImage: "/posts/bank/27/1.jpg",
    mobBgImage: "/posts/bank/27/M.jpg",
    title: "2 fantastiche città",
    smltitle: "",
    isVid: true,
    vidId: "CV2TtpIHrrk",
    ctg: "telavivAndJerusalem",
    html: function() {
      return {
        __html: `

					<br/>
					<h3>Una magica e indimenticabile fuga verso il sole</h3>
					
					<p>
						L’animata e modernissima metropoli di Tel Aviv può vantare spiagge di fine sabbia dorata, un’atmosfera glamour e straordinarie opportunità di divertimento che convivono con i sapori più autentici del Medio Oriente, per non parlare dell’ottimo cibo e del caffè! A soli quaranta minuti di distanza, si scopre un contesto completamente diverso: Gerusalemme, una città di impareggiabile bellezza che non a caso è stata fonte di grande ispirazione per millenni.
					</p>

					<p>
                       Tel Aviv e Gerusalemme sono due città piene di molteplici attività, vivaci e intriganti, ricche di attrazioni imperdibili, ma non potrebbero essere più diverse tra loro. Nonostante la vicinanza geografica, hanno panorami, profumi e sapori completamente diversi. In quale altro luogo si possono trovare le spiagge più alla moda e una delle città più antiche e sacre della storia a pochi chilometri di distanza?
                       Di seguito sono presentati alcuni esempi di attività da non perdere nelle due città
					</p>

					<h3>Tel Aviv – la città che non dorme mai</h3>
					<p>
						Sei atterrato a Tel Aviv… Prova in prima persona tutte le emozioni che la più grande città ebraica ha da offrire. Immergiti nel incantevoli sfumature di azzurro del Mediterraneo, nei pittoreschi scorci della Città bianca e nei suoi mercati, ne ristoranti, dai sapori indimenticabili e nella sfavillante vita notturna. Scopriperché Tel Aviv è conosciuta come “la città che non dorme mai”, respirando a pieni polmoni la sua vitalità 24 ore al giorno.
                        Si parte!
					</p>
					<h3>
						Neve Tzedek:
					</h3>
					<p>
						scopri la magia di questo spettacolare quartiere completamente rinnovato nella parte sud della Tel Aviv Promenade, nei pressi di Giaffa. Inizia bene la giornata con una tipica colazione israeliana: deliziosi prodotti da forno, uova, formaggi e salse, insalata verde o mista, succo d’arancia e naturalmente un caffè eccellente. Non perdere il tour di Neve Zedek che ti mostrerà importanti luoghi storici e stupefacenti musei.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/7.jpg"} class="img-responsive" />
					</div>
					<h3>
						Hatachana:
					</h3>
					<p>
						dopo qualche ora di riposo, fai rotta verso Hatachana, che si trova a poca distanza. Qui si possono visitare gli edifici templari ristrutturati e l’antica stazione ferroviaria di Giaffa, anch’essa completamente rinnovata. Questo luogo racconta la storia della stazione, con la linea Giaffa-Gerusalemme attiva dal 1892 al 1948.
					</p>
					<h3>
						Giaffa
					</h3>
					<p>
						a questo punto non puoi perdere la straordinaria passeggiata vicino alla spiaggia di Tel Aviv, in direzione Giaffa. Ti consigliamo di visitare il Porto di Giaffa, considerato uno dei più antichi al mondo. Siediti ai tavoli di uno dei numerosi caffè presenti sul pontile e osserva i pescatori al lavoro, quindi prosegui verso il coloratissimo mercato delle pulci, dove potrai concederti un bell’acquisto vintage, ceramiche armene, un hamsa o scegliere tra la moltitudine di souvenir in vendita. Di sera la zona si trasforma nella meta ideale per appassionati di cucina e drink.
					</p>
					<h3>
						Una sgambata fino alla spiaggia:
					</h3>
					<p>
						Tel Aviv è nota anche come la capitale israeliana delle biciclette. Nelle belle giornate i più sportivi possono noleggiare una bicicletta presso una delle stazioni Tel-O-Fun o in qualsiasi altro luogo di noleggio in città. Una bella pedalata da Neve Zedek alla spiaggia di Tel Baruch nella parte nord della città è un’esperienza davvero spassosa.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/2.jpg"} class="img-responsive" />
					</div>
					<h3>
						Il Museo Eretz Israel:
					</h3>
					<p>
						se ti trovi nella parte nord della città, ti suggeriamo di visitare il Museo . È un museo multidisciplinare incentrato sulla storia e sulla cultura israeliana che presenta mostre permanenti e temporanee dedicate all’archeologia, all’etnografia, , alla filatelia, al folclore, alla tradizione giudaica, all’artigianato tradizionale, all’arte popolare, alla storia culturale e all’identità locale.
					</p>
					<h3>
						Rothschild Boulevard
					</h3>
					<p>
						sei alla ricerca di un locale dove mangiare bene? Prova uno dei ristoranti che si trovano nei pressi del Rothschild Boulevard, proprio nel centro città: è una delle tre zone che compongono la Città bianca, riconosciuta come Patrimonio UNESCO Questa strada, che rappresenta perfettamente l’essenza di Tel Aviv, offre opportunità straordinarie. Si può anche fare una passeggiata e ammirare la splendida architettura Bauhaus, il vecchio chiosco e i piccoli musei che raccontano la storia affascinante di Tel Aviv e del suo primo quartiere, Ahuzat Bayit.
					</p>
					<h3>
						La vita notturna:
					</h3>
					<p>
					     Per il tuo soggiorno in città, puoi scegliere uno dei grandi hotel sulla spiaggia, vicino alla passeggiata o uno degli incantevoli boutique hotel. E se hai ancora energie e non vedil’ora di uscire, non ti resta che scegliere il tipo di serata che fa per te: divertirsi in uno dei popolari bar o locali notturni, andare all’Opera, assistere a uno spettacolo di danza o partecipare a uno dei numerosi eventi e festival organizzati a Tel Aviv.
                         Hai provato la bella vita di Tel Aviv? Ora scopri il meglio dei due mondi facendo rotta a Gerusalemme. Dista soltanto 40 minuti! La Città Santa ti aspetta!
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/3.jpg"} class="img-responsive" />
					</div>
					<h3>
						Gerusalemme: la città più bella del mondo
					</h3>
					<p>
						Scopri la città sacra per tre religioni monoteiste: Ebraismo, Cristianesimo e Islam.. Visita i siti storici, assapora i profumi tipici, gusta i piatti speciali, respirat l’aria pura di montagna e divertiti nei locali sparsi per la città.
					</p>
					<h3>
						Ein Kerem
					</h3>
					<p>
						prima di giungere in città, puoi visitare il pittoresco quartiere di Ein Kerem. A soli 20 minuti di auto dal centro città, è famoso per la sua aria idilliaca. Ein Kerem, immerso nel verde, offre panorami mozzafiato, incantevoli case di pietra, chiese e moschee, meravigliosi siti storici, affascinanti viali, gallerie e speciali negozi, caffè e ristoranti raffinati e ancora splendidi hotel, sia antichi che moderni.
					</p>
					<h3>
						Museo della scienza di Bloomfield
					</h3>
					<p>
						il museo della scienza di Gerusalemme è un magico mondo per adulti e bambini, ricco di oggetti in movimento, illusioni ottiche, esperimenti con l’elettricità e tutto ciò che ha semplificato la nostra quotidianità.
					</p>
					<h3>
						La Città Vecchia
					</h3>
					<p>
						in pole position in qualsiasi itinerario di Gerusalemme! In poche parole, la Città Vecchia di Gerusalemme è uno scrigno ricco di scoperte e possibilità. La vera essenza di Gerusalemme è nascosta tra gli stretti e sinuosi vicoli della Città Vecchia: le antiche pietre rivelano un’atmosfera speciale e una storia affascinante ricca di segreti. Visitat il Muro occidentale, lasciati trasportare dalla sacralità dei resti del Tempio e lascia una richiesta per il Signore tra le sue pietre.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/4.jpg"} class="img-responsive" />
					</div>
					<p>
						Ripercorri i passi di Gesù sulla Via Dolorosa, verso la Basilica del Sacro Sepolcro, sede di due dei luoghi più sacri della cristianità: quello dove Gesù di Nazareth fu crocifisso e la tomba vuota, da i, secondo la tradizione, Gesù è risorto Prosegui verso il Monte Sion e visita il Cenacolo (noto anche come Stanza al piano superiore)tradizionalmente ritenuto il luogo dell’Ultima cena. Da qui, come Gesù faceva spesso, visita il Monte degli Ulivi per godere di un momento di meditazione sul Getsemani, dove Gesù pregò e i suoi discepoli dormirono la notte precedente alla sua crocifissione. A questo punto non ti resta che salire sul tetto dell’Ospizio austriaco della Sacra Famiglia per godere di una vista davvero mozzafiato su Gerusalemme e la Città Vecchia.
                        Per immergerti ancora di più nelle radici della vecchia Gerusalemme, percorri i tunnel del Muro occidentale, visitat la Cupola della Roccia, il luogo sacro in cui si pensa che Maometto sia asceso in Paradiso e la Chiesa Luterana del Redentore, che ospita uno dei più begli organi presenti in Israele.
					</p>
					<h3>
						Il Mercato Machane Yehuda:
					</h3>
					<p>
						è stata una giornata piena. Inizi a sentire i morsi della fame? Allora è giunto il momento di dirigersi verso il Mercato Machane Yehuda, il più vivace e frequentato mercato all’aperto di Gerusalemme. Negli ultimi anni, accanto ai suoi celebri chioschi, sono spuntati molti caffè e negozi di generi alimentari di lusso.
					</p>
					<h3>
						Lo shopping a Gerusalemme:
					</h3>
					<p>
						pronti per un giro di shopping e l’acquisto dei souvenir? Acquista ceramiche armene o oggetti ebraici nei bellissimi negozi della Città Vecchia. Anche nel centro città troverai negozi che vendono un’infinità di souvenir israeliani. La Ben-Yehuda Promenade ospita numerosi negozi d’abbigliamento. E, se sei alla ricerca di qualcosa di più autentico, non dimenticare di fare un salto nei negozi dell’usato. Ancora un ultimo consiglio: non può mancare una visita al Centro commerciale Mamilla, uno dei più attivi e frequentati della città.
					</p>
					<p>
						Gerusalemme e Tel Aviv, così particolari, così diverse, eppure così vicine, sono le mete ideali per un pacchetto di viaggio. Insiemeti offriranno storia e modernità, antiquariato e arte moderna, divertimento al sole e il viaggio più spirituale della tua vita. Cosa si può chiedere di più? Insomma, che aspetti? Prenotat subito il tuo soggiorno!
					</p>


           `,
      };
    },
  },

  {
    id: "Jerusalem",
    bgImage: "/posts/bank/jerusalem-p/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-p/M.jpg",
    title: "Jerusalem",
    smltitle: "",
    isVid: true,
    vidId: "FvAWuLQEOJw",
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `

					<h3>A CITY OF MAGIC AND RADIANCE BEYOND YOUR WILDEST DREAMS</h3>
					<h3>Jerusalem is The Capital of Israel and By Far One of The Most Famous and Fascinating Cities in the World, Where Thousands of Years of Glorious History Seamlessly Intertwine with Modern Day Life.</h3>
                              
                                <p>Discover the overwhelming power of this 3,000 year old city - its innumerable historic sites and archeological wonders, its magical walkways and magnificent views which are guaranteed to leave a lasting impression. At the same time, the city’s strikingly modern attractions promise around the clock excitement and pleasure for all lovers of culture, arts, music, and culinary delights.</p>

                                <h3>Walk through 3000 years of history</h3>

                                <p>The Old City of Jerusalem is a favourite for all visitors from first timers, seasoned visitors as well as the locals. Surrounded by an ancient wall that has been rebuilt throughout history, there are 7 gates allowing access to historical and holy sites here. Make your way down the stone cobbled streets and find yourself walking through four thousand years of history, leaving you humbled and yet excited as you connect the modern day present with the simple beginnings of the past.</p>
                              
                                <h3>Meet the modern vibrant Jerusalem</h3>

                                <p>Step outside of the Old City and find everything that a typical modern city offers including hotels, promenades, restaurants and shopping malls. Visit museums, like the Israel Museum which is the largest cultural institution in Israel and ranked among the world’s leading art and archaeology museums housing the infamous Dead Sea Scrolls (oldest biblical manuscripts) among other treasures. Local farms, wineries and breweries are set up around Jerusalem offering a variety of options to foodies ranging from the traditional Israeli cuisine to the contemporary and fusion fare paired with delicious award-winning wines and beers attracting enthusiast from all over the world.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Jerusalem-p/1.jpg"} class="img-responsive" />
							    </div>
                                <p>Visit Mahane Yehuda, a colourful and vibrant outdoor market with an attractive vibe filled with culture and delicious aromas of the delicacies sold here. Wait till sundown and see this ‘shuk’ transform into a trendy hangout with live music to suit every mood accompanied with energetic people, a growing ‘street-art’ gallery exceptional food and delightful drinks. Mahane Yehuda offers a special experience so walk down the streets, stop by a food joint, dance a little while enjoying a drink and make your way to the next spot.</p>

                                <p>Drenched in art, history, culture and diversity the capital city of Israel loves to have a good time while allowing one to experience the contrast between old world historical charm and modern city living. As you drive in to Jerusalem you can’t help but connect with the culture, archaeology and history of the many nations who have walked through here, where old meets new beyond the walls of the Old City in this unique world capital.</p>
                                
				


           `,
      };
    },
  },

  {
    id: "Magical_Deadsea",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "IL MAR MORTO",
    smltitle: "",
    isVid: true,
    vidId: "Kmq8NulV8Mo",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					            <br/>
					            <h3>La mente e il corpo si librano nel luogo più basso della terra</h3>
							   
								
								
								<h3>Rilassati nel “sale ristoratore" del Mar Morto e goditi un’indimenticabile vacanza rigenerante</h3>
								<p>Con bellezze naturali da togliere il respiro, stazioni termali ricche di minerali aventi comprovate capacità di guarigione e numerose esperienze uniche nel loro genere, non c’è da meravigliarsi che il Mar Morto sia diventato una delle destinazioni turistiche più apprezzate al mondo. Il misterioso lago salato è ideale per un’esperienza di vacanza perfetta per il corpo e la mente.</p>
								<p><strong>Rilassati</strong>. Sale, fango, sole… e non è tutto. Immergiti nelle sorgenti sulfuree naturali e calde, e approfitta dei trattamenti delle stazioni termali. Forse un “colpevole piacere?" Qui non vale. Non sentirti in “colpa" e goditi una vacanza salutare, rivitalizzate e rilassante.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Magical-Deadsea/1.jpg"} class="img-responsive" />
							    </div>
								<h3>Lasciati andare e approfitta di uno dei più meravigliosi doni della natura</h3>
								<p><strong>Galleggia.&nbsp;</strong>Grazie al livello di salinità eccezionalmente elevato dell’acqua, potrai vivere anche tu un piccolo “miracolo" galleggiando naturalmente, anche se non camminando, sull’acqua. Entra in acqua, distenditi e lascia che la natura faccia il suo corso. Potrebbe volerci un minuto per abituarsi, ma ti promettiamo che l’esperienza sarà magica.</p>
								<p><strong>Guarisci.&nbsp;</strong>Entrando nell’area del Mar Morto si ha quasi l’impressione di addentrarsi in un altro mondo. Panorama diverso, velocità diversa, aria diversa e addirittura sole diverso.</p>
								<p>Gli ultimi due elementi sono il risultato delle speciali condizioni geologiche dell’area e il motivo principale dei poteri di guarigione.</p>
								<p>L’atmosfera è diversa in quanto il sale presente nel mare si dissolve in minerali salubri che vengono assorbiti attraverso l’aria. Il sole è diverso, in quanto, grazie alla posizione notevolmente al di sotto del livello del mare, i pericolosi raggi UV vengono indeboliti e filtrati. Esci all’aperto e goditi i meravigliosi doni della natura.</p>
								<h3>Scopri il fanciullo che c’è in te e lasciati guarire dalla natura</h3>
								<p><strong>Copriti di fango</strong>&nbsp;– È stato dimostrato che il fango del Mar Morto fa bene alla salute. Migliora, rivitalizza e lenisce la pelle. Puoi comprarlo e usarlo a casa, ma perché lasciarti sfuggire l’opportunità di dare libero sfogo al fanciullo che è dentro di te? Copriti con il fango nero dalla testa ai piedi e divertiti. Ti sfidiamo a scattarti un selfie!<strong> </h3>
																
                               


           `,
      };
    },
  },
  // {
  // 	    id:"Next_Level_DS",
  //         bgImage : "/posts/bank/1.jpg",
  //         mobBgImage : "/posts/bank/M.jpg",
  //         title : "TAKE RELAXATION TO THE NEXT LEVEL",
  //         smltitle : "",
  //         isVid:true,
  //         vidId: "8p4qfkneH1c",
  //         ctg: "deadsea",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                      <p>
  // 					The Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World’s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.
  // 				</p>
  // 				<p>
  // 					From the healing powers of the Dead Sea’s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.
  // 				</p>
  // 				<p>
  // 					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.
  // 				</p>

  // 				<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/next-level/1.jpg"} class="img-responsive" />
  // 				</div>
  // 				<p>
  // 					The Magical Beaches of the Dead Sea
  // 				</p>
  // 				<p>
  // 					The beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.
  // 				</p>
  // 				<p>
  // 					On the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud – it’s healthy!
  // 				</p>
  // 				<p>
  // 					Discover the desert area around the Dead Sea
  // 				</p>
  // 				<p>
  // 					There is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.
  // 				</p>
  // 				<h3>
  // 					MOUNT KARKOM
  // 				</h3>
  // 				<p>
  // 					In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.
  // 				</p>
  // 				<p>
  // 					Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.
  // 				</p>
  // 				<p>
  // 					Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.
  // 				</p>
  // 				<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/next-level/2.jpg"} class="img-responsive" />
  // 				</div>
  // 				<p>
  // 					Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.
  // 				</p>
  // 				<p>
  // 					To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.
  // 				</p>

  //            `
  //     }
  //   }
  // },
  // {
  // 	    id:"Natures_Glory",
  //         bgImage : "/posts/bank/natures-glory/1.jpg",
  //         mobBgImage : "/posts/bank/natures-glory/M.jpg",
  //         title : "NATURE'S GLORY",
  //         smltitle : "",
  //         isVid:true,
  //         vidId: "M627s8TdaB8",
  //         ctg: "deadsea",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 			    <p>
  // 					Get high on life in the lowest place on earth
  // 				</p>
  // 				<p>
  // 					The Dead Sea, officially the lowest place on earth (428m below sea level) and one the world’s natural wonders, is an enthralling and evocative combination of natural splendor, compelling ancient history, and modern luxuries.
  // 				</p>
  // 				<p>
  // 					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions.
  // 				</p>
  // 				<h3>
  // 					NEW BOARDWALK AT THE DEAD SEA
  // 				</h3>
  // 				<p>
  // 					Just in time for the Passover and Easter holidays, a new, stone 4k boardwalk and free, accessible public beaches with full facilities have opened in the hotels area of the Dead Sea. The promenade will eventually extend another ten kilometers, to include a total of 16 public beaches, connecting Ein Bokek and Hamei Zohar, along the southern part of the Dead Sea. This is part of a major new leisure and hotel complex that is planned for the region.
  // 				</p>
  // 				<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/natures-glory/1.jpg"} class="img-responsive" />
  // 				</div>
  // 				<p>
  // 					Visitors to the Dead Sea - the lowest place on earth and the world’s largest natural spa known for its unique wellness properties since Biblical times – can now enjoy full access to wide, sandy beaches, walking, jogging, cycling or even taking a Segway along the entire length of the new boardwalk. The new beaches are all free to the public, with facilities that include beach chairs, showers, canopies, sports equipment, children’s playgrounds and more.
  // 				</p>
  // 				<p>
  // 					The beaches are accessible for the disabled, with special wheelchairs and trails that can take visitors right into the waters of the Dead Sea. Special illumination allows tourists and visitors to walk the boardwalk at night, while at the same time enjoying the very special atmosphere at the Dead Sea.
  // 				</p>

  //            `
  //     }
  //   }
  // },
  {
    id: "Natural_Spa2",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "MAR MORTO",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					<br/>
					<h3>Prova la sensazione di stare in cima al mondo – Nel luogo più basso della terra</h3>
				   
					
					<h3>Rilassati più che puoi</h3>
					<p>Il mar morto, ufficialmente il luogo più basso della terra (428 m. al di sotto del livello del mare) e candidato per essere inserito tra le 7 meraviglie naturali del mondo, è una combinazione affascinante e suggestiva di splendore naturale, avvincente storia antica e sontuosità moderna.</p>
					<p>Dai poteri di guarigione delle acque blu cobalto del Mar Morto alla stupefacente bellezza del paesaggio circostante, fino alla miriade di paesaggi incantevoli che questa area ha da offrire, il Mar Morto è un luogo di tranquillità, salute e ispirazione sia per il corpo che per l’anima.</p>
					<p>Galleggia sulle acque, fai un bagno di fango o scopri le bellezze della zona. Con 330 giornate di sole l’anno, l’area del Mar Morto è piena di stupende attrazioni, tra cui sorgenti termali naturali, magnifici percorsi naturalistici, ristoranti tipici e fast food, attrazioni che ti faranno salire l’adrenalina. Lungo la parte principale della striscia di terra di 75 km punteggiata da stupende spiagge, troverai anche hotel di prim’ordine e stazioni termali che ti garantiranno un’esperienza decisamente gratificante.</p>
                    <div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/posts/natural-spa2/1.jpg"} class="img-responsive" />
					</div>
					<h3>Le magnifiche spiagge del Mar Morto</h3>
					<p>Le spiagge del Mar Morto sono uniche al mondo. Chilometri e chilometri di luoghi stupendi e ben tenuti dove puoi immergerti mentre ti godi la tua vacanza da sogno. Scegli un posto sulla spiaggia e ammira il paesaggio mozzafiato con le incredibili catene montuose che circondano il mare. Le calde acque del Mar Morto sono sempre calme e offrono il massimo relax fin dal primo momento in cui ti immergerai in esse.</p>
					<p>Sulle spiagge meridionali nel punto più basso della terra troverai una serie di hotel dai quali ammirare il magico sorgere del sole sul mare con una serie di colori sui piccoli laghetti creati dalle formazioni saline sparse tutto intorno.&nbsp; Per completare l’esperienza del Mar Morto, prendi un po’ del fango nero e lucente e cospargilo sul tuo corpo, lasciando che la pelle assorba i minerali benefici. È stato dimostrato che il fango del Mar Morto fa bene alla pelle e al corpo. Ti sentirai rinfrescato e la pelle avrà un aspetto più giovane. Fatti le coccole che meriti e sporcati nel fango del Mar Morto: fa bene alla salute!</p>

					<h3>Scopri l’area desertica intorno al Mar Morto</h3>
					<p>Ci sono altre cose da fare, oltre che rilassarsi nelle stazioni termali e galleggiare sulle acque del Mar Morte.&nbsp; Se stai viaggiando verso sud, da Gerusalemme, completa la tua esperienza del deserto facendo una sosta presso il kibbutz Ein Gedi, un’oasi naturale alle pendici del deserto della Giudea. Fai un giro della riserva naturale, dove potrai ammirare animali come lo stambecco, e goderti le cascate che si infrangono sulle formazioni rocciose, creando delle pozze d’acqua. Ein Gedi è anche un hotel e una stazione termale con piscine di acqua sulfurea calda, che ha anch’essa diverse qualità curative e terapeutiche. Continua in direzione sud, verso Masada, località dalla forte connotazione storica, ubicata in cima a una montagna massiccia che gli amanti dell’avventura possono raggiungere attraverso un ripido sentiero. Tutti gli altri possono raggiungerla comodamente in funivia.</p>


           `,
      };
    },
  },
  {
    id: "Natural_Phenomena",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "NATURAL PHENOMENA",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
                        <p>
							The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
						</p>
						<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natural-phenomena/1.jpg"} class="img-responsive" />
					    </div>
						<p>
							This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
						</p>
						<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natural-phenomena/2.jpg"} class="img-responsive" />
					    </div>
						<p>
							The Dead Sea is lined with spas, bathing beaches and spa hotels.
						</p>          


           `,
      };
    },
  },
  {
    id: "Masada",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "SCOPRI MASADA",
    smltitle: "",
    isVid: true,
    vidId: "xH9m5hfimNQ",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					<br/>
					<h3>La “vetta del coraggio” nel cuore del deserto della Giudea</h3>
                    	
			
			
			
							    <h3>Rivivi la storia epica in cima alla gloriosa fortificazione nel deserto della Giudea</h3>
								<p>Vivi l’emozione di un &nbsp;viaggio nel parco nazionale di Masada, dove si erge l’antica fortificazione, solitaria e isolata sulla vetta di un dirupo, nel deserto della Giudea, affacciata sulla vicina oasi del Mar Morto. Sali lungo il sentiero tortuoso o la scala romana partendo dalla base della fortificazione, oppure entra nel centro di accoglienza per i visitatori e sali fino alla vetta del sito prendendo la funivia e inizia a respirare la storia antica, come se fosse ancora in corso.</p>
								<div class="img-wrapper">
																   <img src=${getImgUrl() + "/posts/masada/1.jpg"} class="img-responsive" />
															    </div>
								<h3>Esplora le rovine regali e sentiti parte della storia</h3>
								<p>Entra in quelli che una volta erano dei lussuosi castelli che costituivano l’ultima fortezza abitata dai combattenti per la libertà, i quali ebbero il coraggio di dichiarare guerra all’Impero romano a seguito della distruzione del Secondo tempio. Un sito così ricco di storia che le fresche pareti di pietra quasi trasudano le lacrime delle anime coraggiose che scelsero la morte piuttosto che la schiavitù sotto il regime nemico.</p>
								<h3>Dove cultura e religioni raggiungono nuovi traguardi</h3>
								<p>Passeggia tra le rovine dei castelli e scopri stanze e strutture, reperti archeologici che testimoniano la vita a Masada durante l’assedio romano. Entra nel castello sul lato nord, che era il palazzo-fortezza privato del re Erode. Sussurra una preghiera nell’antica sinagoga, dove gli ebrei si riunivano tre volte al giorno per pregare per la loro salvezza. Rendi omaggio ai combattenti morti per la libertà che tiravano a sorte nella “stanza della lotteria” per stabilire l’ordine con il quale andare a morire, fino all’ultimo uomo rimasto che poneva fine alla sua stessa vita.</p>
								<div class="img-wrapper">
																   <img src=${getImgUrl() + "/posts/masada/2.jpg"} class="img-responsive" />
															    </div>
								<p>Ammira i resti della chiesa bizantina e dei suoi mosaici, probabilmente frequentata per secoli dai monaci cristiani fuggiti all’inizio del I secolo, per un periodo di circa 600 anni.</p>
								<p>Visita Masada, uno dei siti dichiarati patrimonio mondiale dell’UNESCO, fatti accompagnare dai suoni e dalla luce del tramonto alla base della fortificazione, che rievocano la vita e le battaglie di secoli e secoli fa.</p>
											        


           `,
      };
    },
  },

  {
    id: "Tel_Aviv",
    bgImage: "/posts/bank/telaviv-p/1.jpg",
    mobBgImage: "/posts/bank/telaviv-p/M.jpg",
    title: "TEL AVIV",
    smltitle: "",
    isVid: true,
    vidId: "I9a4BFWO_6w",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
			                    <p>Hailed as ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’, Tel Aviv is without a doubt THE place to visit in the Mediterranean.</p>
								<p>Named by The New York Times "The Mediterranean Capital of Cool", Tel Aviv is a modern, vibrant cosmopolitan. Buzzing art scene, UNESCO recognized Bauhaus architecture, award-winning cuisine, world-class nightlife, friendly laid-back atmosphere and gorgeous beaches all earned the city its rightful place as one of the world's top travel destinations.</p>

                                <p>But even in the city that has it all, there is only one place to start - the beach.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/telaviv-p/1.jpg"} class="img-responsive" />
							    </div>
								<h3>Discover the Heart of a Sizzling City</h3>

                                <h3>What.</strong> The heart of the city National Geographic called "Miami beach of the Mediterranean" and included in its top 10 world's best Beach Cities list, is its coastline.</p>

                                <h3>Why.</strong> Sandy beaches, warm waters, plenty of watersports opportunities and great weather, need we say more? Tel-Aviv coastline is comprised of 13 unique beaches that each gives different view and offers a different experience. From the busy and trendy to the chill and laid-back, together they form a rich, colorful tapestry of this exciting and diverse city.</p>

                                <h3>Where.</strong> Located at the western edge of the city, in Tel-Aviv you're always one step away from the beach. No need to resist the temptation. Just cross the street, take off your shoes and start having fun.</p>

                                <h3>Choose your own Beach Adventure</h3>

                                <h3>Get Active.</strong> Beach and watersports are very popular in Tel-Aviv. Surfing, sailing, rowing, swimming, Supping, diving, volleyball – the list of possibilities goes on and on.</p>

                                <p>Choose your favorite activity and enjoy. Then, when you the click-clock sound of the Matkot on the beach, join the masses in this hugely popular Israeli paddle ball game. There are no winners or losers here, but it's still fun…and very addictive.</p>

                                <h3>Sign up</strong> for the SAIL TLV sailing tournament that takes place in the spring and includes sailing yachts, motor yachts and motor boats from all around the world. Enjoy the sports activities and the wonderful embracive community.</p>

                                <p>Want more? Join the locals and bike, walk or jog on the promenade.</p>

                                <h3>Get Social.</strong> Build castles in sand with your family, take your dog for a walk and mix with the friendly diverse crowd.</p>

                                <h3>Get Chilled.</strong>  Want to slow down and relax? No problem! Find a quiet spot in one of the less crowded beaches, watch (or join) the drum circles and sit at one of the restaurants along the coast. In the afternoon, get close to the water, grab a chair, sit back and watch one of those beautiful Tel-Aviv sunsets. It doesn't get better than this.</p>
            	      


           `,
      };
    },
  },

  {
    id: "Simply_Delicious",
    bgImage: "/posts/bank/simply-delicious/1.jpg",
    mobBgImage: "/posts/bank/simply-delicious/M.jpg",
    ctg: "culinarytelaviv",
    isVid: true,
    // vidId: "n4kCnPXEX7g",
    vidId: "JQD9JpMaw9g",
    title: "Tel Aviv – Semplicemente deliziosa",
    smltitle: "",
    html: function() {
      return {
        __html: `
                     <br/>
                    <h3>Tel Aviv – Semplicemente deliziosa</h3>
				     <p>
						Grazie ai suoi circa 4500 ristoranti, Tel Aviv è una vera Mecca per ogni appassionato di cibo. Molti ristoranti sono gestiti da famosissimi chef celebrati a livello internazionale, i quali hanno fatto esperienza in alcuni dei migliori locali del mondo per poi tornare in Israele per lasciare il loro inconfondibile segno sulla scena gastronomica locale.
				     </p>
					<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/simply-delicious/1.jpg"} class="img-responsive" />
							    </div>
					

         `,
      };
    },
  },

  {
    id: "Nonstop_Excitement",
    bgImage: "/posts/bank/35/1.jpg",
    mobBgImage: "/posts/bank/35/M.jpg",
    title: "Divertimento nonstop",
    vidId: "88OV6xU0vPI",
    isVid: true,
    smltitle: "",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				    <br/>
                    <h3>Bellissima, colorata ed eccitante – Fantastica Tel Aviv</h3>
					
					<p>
						Ricca di gioia e voglia di vivere che ti accoglierà a braccia aperte. Che cos’ha Tel Aviv che fa innamorare i turisti e li fa tornare più e più volte? Tel Aviv è nota come la “città che non dorme mai” ed è proprio così. I caffè sono gremiti di turisti 24 ore al giorno, l’ineguagliabile vita notturna della città inizia al tramonto e termina alle prime luci dell’alba.
						Per di più, con il clima mite e gradevole tutto l’anno,sarà alquanto probabile poter approfittare delle splendide spiagge, fare un giro a piedi o in bicicletta nello Yarkon Park, visitare i due porti antichi della città o girovagare tra le strade della città più grande di Israele, da cui ammirare lo straordinario accostamento di antichi edifici storici e palazzi più moderni. E, ultimo ma non meno importante aspetto, questa pulsante città offre una vasta scelta di eventi culturali e intrattenimento per tutte le età.
					</p>
					<p>
					Scopri perché il National Geographic ha inserito Tel Aviv tra le dieci città costiere più belle del mondo. Scopri perché la rivista enogastronomica Sauver l’ha definita “Straordinaria destinazione gastronomica” e le ha attribuito la valutazione “eccellente” nella categoria Migliori mercati e negozi. Ma c’è di più! Nel 2014 la giuria degli International Space Design Awards ha attribuito alla brasserie Pastel il titolo di Ristorante più bello del mondo. Seiappassionato di caffè? Secondo l’Huffington Post , questa moderna città di mare è una delle migliori al mondo per gli amanti del caffè. Impressionante, no? Ma non è tutto…
					</p>

					<p>Tel Aviv ha surclassato altre 250 città portandosi a casa il <a href="//www.smartcityexpo.com/awards-2014" target="_blank">World Smart Cities Award 2014</a>, grazie all’utilizzo di tecnologie innovative a beneficio dei residenti. Secondo la Lonely Planet, <a href="//www.israel21c.org/tel-aviv-named-worlds-third-top-city/" target="_blank">Tel Aviv conquista un’ottima posizione nell’elenco delle città che offrono le feste più belle del mondo</a>. E <a href="//www.jpost.com/LifeStyle/Tel-Aviv-named-worlds-best-gay-city-for-2011" target="_blank">Tel Aviv è orgogliosa di avere ricevuto il titolo di migliore città gay-friendly del mondo da GayCities</a> e American Airlines.
					<br>
					Stai programmando un viaggio a Tel Aviv? Di seguito sono riportati alcuni consigli che renderanno la tua vacanza un clamoroso successo.
					</p>

	                <h3>
	        	        Le spiagge
	                </h3>

					<p>
						La bella vita è in spiaggia! Per l’intera lunghezza della località di Giaffa in Tel Aviv, sulle coste del Mediterraneo, troverai ben 13 spiagge che si estendono per oltre 14 chilometri. Queste spiagge, perfette per nuotare, fare festa e rilassarsi, attirano migliaia di vacanzieri e amanti del mare da Israele e dall’estero. La stagione balneare inizia a maggio e termina a ottobre, ma anche d’inverno potraitrovare molte giornate piacevolmente miti.A Tel Aviv I ristoranti, i locali e le numerose aree di intrattenimento sulla lunga passeggiata richiamano una quantità infinita di visitatori. La città permette anche di svolgere una vasta scelta di sport acquatici.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/3.jpg"} class="img-responsive" />
					</div>
					<h3>
						I porti
					</h3>
					<p>
						Tel Aviv vanta la presenza di due porti antichi.Ti stupirà il modo in cui questi luoghi fondono passato e presente, trascorrendo la giornata (e la notte) negli innumerevoli locali, ristoranti o caffè e perdendoti nell’azzurro del Mar Mediterraneo.
					</p>
					<h3>
						Il porto di Tel Aviv:
					</h3>
					<p>
						il porto costruito nel 1938 è diventato un luogo clou di intrattenimento aperto al pubblico. La sua superficie di 14.000 m2, con i caratteristici pontili di legno, è costellata di bar, locali notturni, caffè, ristoranti e negozi. È una tappa imperdibile per chi ama la buona cucina, lo shopping e il divertimento. E, se non fosse abbastanza, non esiste luogo che offra tramonti più belli. Vieni a goderti la fresca brezza del mare, vieni ad incantarti davanti ad un indimenticabile tramonto, quando il porto si riempie di vita trasformandosi in uno dei quartieri di intrattenimento più vivaci della città.
					</p>

					<h3>
						Il porto di Giaffa
					</h3>

					<p>
						il porto di Giaffa, considerato uno dei più antichi al mondo, è stato utilizzato da pescatori, marinai, mercanti, crociati, conquistatori e immigranti per migliaia di anni. È ancora attivo come porto di pesca ed è stato rinnovato e trasformato in un’attrazione urbana che offre attività culturali e ricreative, shopping e turismo, preservando il suo inimitabile carattere storico e affascinante.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/2.jpg"} class="img-responsive" />
					</div>

					<h3>
						La vita notturna
					</h3>
					<p>
						Gli amanti della vita e de divertimento notturno hanno una vasta scelta di bar e locali di tendenza e possono toccare con mano l’ampia offerta di opportunità che la città che non dorme mai ha da offrire. In genere le serate a Tel Aviv iniziano alle 23.00 e, in alcuni locali, possono continuare fino all’alba. E non mancano i locali per la comunità omosessuale.
						Di seguito sono presentati alcuni dei locali più di tendenza dove potrai scatenartii per tutta la notte:
					</p>

					<h3>
						Haoman 17
					</h3>

					<p>
						Questo locale è il mega-club più grande e conosciuto di Tel Aviv. Ospita alcuni dei DJ più famosi del mondo.
					</p>

					<h3>
				    Dizingoff Club
					</h3>

					<p>
					  Con i suoi tre fornitissimi bar, la pista da ballo, posti a sedere, sale VIP e molto altro, il Dizenfoff Club è la meta di elezione per una clientela molto glamour. Troverai qualsiasi tipo di musica, dal rock al mainstream, dalla disco al funk.
					</p>


					<h3>
				    Dream Exhibition
					</h3>

					<p>
					Uno dei locali più popolari di Tel Aviv. La sua atmosfera chic e contemporanea insieme al sistema di diffusione del suono a 360° ti farà davvero sentire in un sogno.
					</p>

					<h3>
					    Kuli Alma
					</h3>

					<p>
					   È uno dei locali alternativi più apprezzati della città, con le pareti decorate con opere di “street art” e “video art”. Nella galleria ospita le mostre di artisti locali e dispone di un’incantevole area all’aperto, perfetta per sorseggiare un drink, mangiare un boccone e fare nuove conoscenze.
					</p>
					<h3>
					    The Cat and Dog

					</h3>

					<p>
					    Un locale underground situato nella zona di Carlebach, che offre musica eclettica, drink a fiumi e una pista da ballo scatenata. È senza alcun dubbio uno dei locali più frequentati di Tel Aviv.


					</p>
					<h3>
					    The Block
					</h3>

					<p>
					   Questo locale, vincitore di numerosi premi, tra cui Best Club of the Year (miglior club dell’anno), Best Line Parties of the Year (migliori line party dell’anno) e Best Party of the Year (miglior party dell’anno) a livello locale e segnalato da BBC Radio 1 come il club che dispone di “uno tra i cinque migliori sistemi di diffusione del suono al mondo”, merita certamente una visita.
					</p>
					<h3>
					   Ktovt

					</h3>

					<p>
					    Questo locale, il cui nome in ebraico significa “indirizzo”, è considerato da tutti il locale PER ECCELLENZA. Fatevi belli e andate a divertirvi al ritmo della musica dei famosi DJ internazionali che ospita.
					</p>
					<h3>
					    Biggy Z Bar
					</h3>

					<p>
					    Entrando in questo bar ti sembrerà di mettere piede nella Big Easy, New Orleans. Entra in modalità Martedì grasso grazie alla straordinaria proposta “All you can drink”. Sorseggia il tuo julep alla menta e divertiti…
					</p>
					<p>
					    E se sei alla ricerca di un gay bar…
					</p>
					<h3>
					    Apolo Sexy Bar
					</h3>

					<p>
					    L’Apolo, l’unico gay bar di Tel Aviv riservato agli uomini, si ispira ai locali europei più in voga.
					</p>
					<h3>
					   Amazona
					</h3>

					<p>
					    Con la sua atmosfera unica, è il bar lesbo più apprezzato della città.
					</p>
					<h3>
					    Barvaz
					</h3>

					<p>
					    Popolare bar lesbo che ogni sera ospita importanti DJ.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/4.jpg"} class="img-responsive" />
					</div>
					<h3>
					   I mercati
					</h3>
					<h3>
					    Il Carmel Market
					</h3>

					<p>
					   è il mercato più famoso e importante della città che, oltre ai colori dei suoi meravigliosi arazzi, offre anche un’infinita scelta di leccornie, spezie, cibi e altri prodotti cheti tenteranno eti conquisteranno. Il mercato è affollato tutto l’anno e, oltre ai clienti abituali, è una delle mete preferite dei turisti stranieri che si godono appieno questa straordinaria esperienza di acquisto in Medio Oriente.
					</p>
					<h3>
					   Il Levinsky Market
					</h3>

					<p>
					   una varietà infinita di prodotti da forno, punti vendita di specialità tipiche, ristoranti e negozi che vendono spezie, noci, frutta secca e cibi esotici. Vengono organizzati, inoltre, tour gastronomici del mercato in cui scoprire racconti, leggende e segreti del mercato di ieri e di oggi. Il carattere straordinario del Levinsky lo trasforma in una vera e propria attrazione sia per la gente del posto che per i turisti.
					<h3>
					   Il Flea Market
					</h3>

					<p>
					    il famoso mercato delle pulci, situato a Giaffa, offre prodotti per la casa, abiti e calzature di seconda mano, antiquariato, complementi d’arredo e mobili vintage. Troverai anche caffè e ristoranti di tendenza che offrono soltanto le fave e l’humus della tradizione e altri prodotti tipici del passato.
					</p>
					<h3>
					   I mercati alimentari
					</h3>

					<p>
					   negli ultimi anni, Tel Aviv ha visto l’apertura di tre mercati alimentari, Shuk HaNamal presso il porto di Tel Aviv, il Sarona Market a Sarona e Shuk Tzafon a Ramat Hahayal: tutti regaleranno ai visitatori un’esperienza che stuzzicherà i loro sensi. Questi mercati offrono prodotti freschi e materie prime di alta qualità per gli estimatori degli alimenti più raffinati, freschi e prelibati.
					</p>
					<h3>
					  Il mercato delle arti e dell’artigianato presso l’area pedonale Nahalat Binyamin:
					</h3>

					<p>
					    questo mercato aperto martedì e il venerdì ravviva la strada con un tripudio di colori. Girovagando tra i chioschi, troverai un’infinità di idee creative e originali per i tuoi regali: gioielli colorati, opere di cartapesta, dipinti a olio, giocattoli di legno, orologi decorativi da parete, statuette di vetro, Hamsa, bambole, oggetti per la casa e molto altro ancora.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/5.jpg"} class="img-responsive" />
					</div>

					<h3>
					    I ristoranti
					</h3>

					<p>
                        Tel Aviv è La Mecca della gastronomia! Oltre ai chioschi che offrono falafel e shawarma per strada, la città è piena di bistrot per buongustai gestiti dai più raffinati chef del Paese e incantevoli bar che servono pasti leggeri e un caffè divino. Accanto ai ristoranti che offrono praticamente di tutto nei propri menu, Tel Aviv vanta anche molti ristoranti e caffè kosher e ottimi locali vegetariani e vegani.
                        Di seguito sono presentate alcune straordinarie alternative che soddisferanno anche la fame dei più esigenti.
					</p>
					<h3>
					   MIZLALA

					</h3>

					<p>
					    Questo ristorante offre i piatti frutto della creatività e della passione dello Chef Meir Adoni. Situato nel quartiere trendy di Nachalat Binyamin in un edificio Bauhaus magnificamente ristrutturato, il Mizlala è caratterizzato da un’energia speciale e offre un’esperienza gastronomica indimenticabile.
					</p>
					<h3>
					   Topolpompo
					</h3>

					<p>
					   Il ristorante del drago di fuoco dello Chef Avi Avi Conforti, con la sua inimitabile struttura architettonica, offre sapori, profumi e sensazioni provenienti dal fuoco e dalle spezie. Una serata in questo locale è, come dice lo chef, bollente, sexy ed emozionante: un’esperienza assolutamente da non perdere.
					</p>
					<h3>
					   Abraxas North (Tzfon Abraxas)
					</h3>

					<p>
                       Il celebre chef locale Eyal Shani serve piatti ispirati, innovativi, semplici e assolutamente deliziosi. Questo locale di tendenza dispone di una cucina aperta, che consente di assaporare l’atmosfera insieme al cibo, guardando i cuochi all’opera e la loro energia contagiosa.
                       E se prefersci la cucina vegetariana o vegana…
					</p>
					<h3>
					   Hashwarma Hativonit
					</h3>

					<p>
					    Gusta gli hamburger vegani, gli hot dog vegani e lo straordinario shawarma vegano in questo locale considerato uno dei migliori ristoranti vegani di Tel Aviv nel campo dello street food.
					</p>
					<h3>
					   Nanuchka
					</h3>

					<p>
					    Offre uno squisito menu vegano della Georgia in un contesto caratterizzato da pavimenti antichi e le opere d’arte di alcuni degli artisti più apprezzati d’Israele. Il menu è così originale e gustoso che anche i carnivori più accaniti non sentiranno la mancanza della carne.
					</p>
					<h3>
					  Buddha Burgers
					</h3>

					<p>
					   Una popolare catena di fast-food vegani che offre un’atmosfera intima, prezzi abbordabili e un’ampia selezione di piatti, dagli hamburger agli hot dog, fino allo shawarma e ai burrito.
					</p>
					<h3>
					  Zakaim
					</h3>

					<p>
					   Questa boutique vegana offre esclusivamente piatti realizzati con ingredienti locali nel rispetto della stagionalità a prezzi assolutamente ragionevoli.
					</p>

					<h3>
					  Tenat
					</h3>

					<p>
					   Tenat, citato tra i migliori ristoranti vegani di Tel Aviv dalla Secret Tel Aviv Guide, serve un menu etiope completamente vegano e senza glutine.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/6.jpg"} class="img-responsive" />
					</div>

					<h3>
					  La cultura
					</h3>

					<p>
					  Gli appassionati di arte e cultura dispongono di un’ampia scelta di musei e gallerie d’arte sparsi per tutta la città.
					</p>

					<h3>
					  Il Museo d’arte di Tel Aviv:
					</h3>

					<p>
					  il più importante museo d’arte israeliana e internazionale della città affianca collezioni permanenti e mostre temporanee ed espone magnifici dipinti, sculture, opere di design e architettura, videografia, disegni e molto altro.
					</p>

					<h3>
					  Beit Hatfusot, il Museo del Popolo ebraico:
					</h3>

					<p>
					  Beit Hatfutsot è una delle istituzioni più importanti al mondo per la ricerca sull’ebraismo ed è considerato il primo museo ad aver analizzato approfonditamente la storia e le imprese compiute del popolo ebraico. Il museo offre un’esperienza ebraica assolutamente toccante e avvincenti mostre che presentano i racconti e gli avvenimenti più importanti della Diaspora ebraica nel corso della storia.
					</p>

					<p>
					  Tel Aviv offre tutto ciò che una grande località di vacanza deve offrire: mare e sole, grandi opportunità di relax in un contesto culturale vivace, cucina eccellente, straordinarie possibilità di shopping e una vitalità che non ha nulla da invidiare alle mete più in voga. Vienia scoprire perché tutti vanno pazzi per Tel Aviv, ci sono voli diretti dalla maggior parte delle città europee e statunitensi.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/7.jpg"} class="img-responsive" />
					</div>

					<h3>
					  Appuntamenti annuali
					</h3>

					<p>
					 Tel Aviv ha ancora di più in serbo per e! Offre ogni anno eventi sportivi, culturali e di intrattenimento. Scopri le date consultando i vari siti Internet. Di seguito sono presentati alcuni eventi che consigliamo caldamente:
					</p>

					<h3>
					  La Notte bianca di Tel Aviv:
					</h3>

					<p>
					 una notte per non dormire nel mese di giugno ! Ogni anno viene organizzata questa notte ricca di eventi: concerti, feste, performance di strada, spettacoli teatrali e molto altro, fino all’alba. I centri artistici e culturali della città restano aperti, così come i negozi e molti locali. La maggior parte degli eventi della Notte bianca è aperta al pubblico gratuitamente o previo versamento di una quota di partecipazione.
					</p>

					<h3>
					  L’Open House Festival:
					</h3>

					<p>
					  Sempre nel mese di maggio. Questo festival prevede una selezione di visite e tour speciali delle abitazioni e degli edifici più affascinanti della città, la maggior parte dei quali non è mai stata aperta al pubblico.
					</p>

					<h3>
					  La maratona notturna di Tel Aviv:
					</h3>

					<p>
					  questa maratona di 10 km che avrà luogo il 16 novembre 2016 attira migliaia di corridori e decine di migliaia di spettatori che vengono ad assistere a questo divertente evento. Al termine della gara, basta seguire la musica per ritrovarsi alla grande festa al parco Ganei Yehoshua.
					</p>

					<h3>
					  Marcia del Gay Pride di Tel Aviv:
					</h3>

					<p>
					  questo evento annuale che si tiene ogni anno nel mese di giugno a Tel Aviv ha trasformato la città in una delle mete preferite dagli omosessuali di tutto il mondo. La sfilata inizia con uno straordinario evento nel Meir Park, con discorsi, spettacoli di drag queen e molto altro. In seguito la parata percorre le strade più importanti della città, accompagnata da musica, moltissimi gruppi di partecipanti e decine di migliaia di spettatori. La marcia termina con una grande festa sulla spiaggia di Charles Chlor. Ma non è tutto… L’evento continua con dozzine di feste organizzate in giro per la città.
					</p>

					<h3>
					  Il festival dell’innovazione DLD
					</h3>

					<p>
					  la Digital Conference DLD di Tel Aviv è uno degli eventi più importanti in Israele, riunisce creativi e imprenditori di tutto il mondo e presenta centinaia di start-up, iniziative imprenditoriali, angel investor e multinazionali di spicco. Tel Aviv, che vanta i migliori talenti nel settore tecnologico, i maggiori investimenti in venture capital pro capite e centri multinazionali per leader del settore quali Intel, Google, Microsoft, Kimberly Clark, Amazon, GM, Amdocs, Facebook e molte altre, è il luogo ideale per entrare personalmente in contatto con il cuore pulsante dell’high-tech. Il festival comprende numerosi eventi, conferenze, incontri, occasioni di conoscenza e di ritrovo, tutti focalizzati su vari aspetti dell’innovazione digitale, tecnologica, sociale e urbana. Quest’anno il festival avrà luogo dal 24 al 29 settembre 2016.
					</p>

         `,
      };
    },
  },

  {
    id: "Vegan_Friendly_TelAviv",
    bgImage: "posts/bank/8/1.jpg",
    mobBgImage: "posts/bank/8/M.jpg",
    title: "Vegan-Friendly Tel Aviv",
    ctg: "culinarytelaviv",
    isVid: true,
    // vidId: "prLvetkAWwg",
    vidId: "9l04RfZ95J0",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                     <h3>Try this selection of top vegan restaurants in Tel Aviv</h3>
					<h3>Exploring Tel Aviv has never been so fun for vegans, or so yummy</h3>
					<p>Touring foreign cities can be rough on vegans, who adhere to a diet free of animal-based dishes. Not so in Tel Aviv, home to an all-vegan culinary school and scores of vegan-friendly eateries. Already a culinary hotspot for touring foodies and crowned “The World’s Best Culinary City” by Saveur Magazine, Tel Aviv has embraced veganism as it grows in popularity, leading The Daily Meal culinary magazine to declare the city “The World’s Best Vegan Destination,” ahead of eight other “vegan-friendly cities” as well.</p>
					
					<h3>What vegans want</h3>
					<p>Stroll through the city of Tel Aviv and you will stumble upon countless vegan and vegan-friendly restaurants, bistros and fast food stands. Take in the sweet and savory aromas wafting through the city air and know that nearby is a yummy treat you can most proxcbably eat. Keeping up with the tastes and demands of Tel Aviv locals and tourists, most of the city’s eateries- or at least those with any ounce of self-respect, have vegan-friendly options interspersed throughout their menus. Others have shifted to an entirely vegan spread, offering up a spin on local delicacies like egg-free falafel, seitan shawarma and dairy-free cheese pizza.</p>
					
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/2.jpg"} class="img-responsive" />
					</div>
                    <h3>Taste the fresh Mediterranean flavors</h3>
					<p>Breathing in the fresh Mediterranean air give you an appetite for some fresh local treats? For vegans touring Tel Aviv, your stomach grumbling is but an arrow pointing you in the direction of some of the freshest local produce transformed into scrumptious dishes reflecting many different cultures, culinary directions and trends.</p>
					
					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/3.jpg"} class="img-responsive" />
					</div>
                    <p>Israel is blessed with many vegan dining options, but when it comes to vegan eateries, Tel Aviv is a true vegan culinary gem. Whether it’s fast food, a gourmet menu or sweet desserts you are craving, Tel Aviv has a vegan option for you, making the seaside Israeli city a must-visit destination on your next Israel trip.</p>
					<p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in Tel Aviv &amp; Center at Tourist Information site</a></p>



			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "/posts/bank/28/1.jpg",
    mobBgImage: "/posts/bank/28/M.jpg",
    title: "Jerusalem Cuisine",
    ctg: "culinary",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>Exhilarating and diverse and oh so yummy</h3>

					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/2CSCe2WC7Ns/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<p>
						Jerusalem is filled with scores of lively and trendy restaurants and entertainment spots. The city is packed with areas offering excellent options for every form of day and night time entertainment, where you can enjoy a delightful evening over a great meal, a cold beer or dance to great music.
					</p>

					<p>
						In Jerusalem, they say that you come for the hummus, but stay for the incredibly diverse cuisine. From traditional Middle Eastern and North African to South American, Asian fusion, and continental European cuisine; from street food to fine dining, Jerusalem’s got it all. Jerusalem’s wide array of culinary options can be found literally everywhere local delicacies in street stalls, authentic restaurants in the markets, and if you are looking for the gourmet experience, you can reserve a spot at one of the city’s many exclusive chef restaurants.
					</p>

         `,
      };
    },
  },

  {
    id: "Coffee_In_TelAviv",
    bgImage: "posts/bank/42/1.jpg",
    mobBgImage: "posts/bank/42/M.jpg",
    title: "CAFFÈ IN TEL AVIV",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "rVr0gqFC364",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			
						<!--<div class="img-wrapper">
						    <img src=${getImgUrl() +
                  "posts/coffe-in-tlv/1.jpg"} class="img-responsive" />
					    </div>-->
						
              
			`,
      };
    },
  },

  {
    id: "Non_Stop_Markets",
    bgImage: "posts/bank/non-stop-markets/1.jpg",
    mobBgImage: "posts/bank/non-stop-markets/M.jpg",
    title: "Non Stop Markets",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			                 <p>A tour of the markets in Tel Aviv, with their unparalleled human tapestry and never-ending variety of delicacies is probably one of the best ways to get to know the true local spirit of Tel Aviv.<br>
                             Here are some of the markets that are definitely a must, when visiting the sunny city:</p>

                             <h3>Carmel Market:</h3>
                             <p>The city’s most famous market, renowned for its colorful spirit and food stalls, featuring fresh local delicacies and excellent restaurants serving fresh food straight from the market. You can also find hidden food placed behind the stalls and around the area. They are really worth finding. <br>
                             <h3>The Flea Market:</h3>
                             <p>Located in Jaffa, packed with fantastic authentic antiques from Tel Aviv and Jerusalem, a joy to bargain hunters. This market is also home to many fashionable and excellent cafés and restaurants of all varieties of cuisines: from Greek, to Italian, to Arabic.<br>
                             <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/non-stop-markets/1.jpg"} class="img-responsive" />
					         </div>
                             <h3>Nahalat Binyamin Arts & Crafts Market: </h3>
                             <p>Open on Tuesdays and Fridays, this is a ‘fair-like’ artists’ market, rich with creative and original ideas for gifts. It is just the place to pick up that perfect souvenir you won’t find in any store.<br> 
                             <h3>Sarona Market</h3>
                             <p>Offering a unique and fabulous culinary adventure, Sarona Market is located in the Trendy Sarona Complex, and is home to a modern and vibrant “food court” which offers a huge assortment of culinary options. Sarona is also extremely family friendly, filled with outdoor activities and fantastic playgrounds. <br>
                             <h3>Tel Aviv Port Market</h3>
                             <p>With more of a Farmers Market feel, this seaside Market is packed with tasty treats and specialty produce which you can enjoy, on the spot of take home as culinary souvenirs.<br>

              
			`,
      };
    },
  },

  {
    id: "Joys_Of_Jaffa",
    bgImage: "posts/bank/joys-of-jaffa/1.jpg",
    mobBgImage: "posts/bank/joys-of-jaffa/M.jpg",
    title: "MAGICA GIAFFA",
    ctg: "telaviv",
    isVid: true,
    // vidId:"xz05_8hA4q4",
    vidId: "tgF0zMUYY2g",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			            <br/>
			            <p>GIAFFA: Una città dal fascino multiculturale.<br/> Scopri tutte le ricchezze che la stupenda Giaffa antica può offrire.</p>

                        <h3>Porto di Jaffa</h3>
				        <p>
						La moderna città di Tel Aviv ha delle origini umili: il porto di Jaffa era il luogo dove immigrati, soldati e commercianti attraccavano con le loro navi. Il porto è famoso per essere uno dei più antichi del mondo: ancora oggi viene utilizzato dai pescatori locali, mentre la zona storica intorno ad esso è diventata una popolare destinazione per turisti.
				        </p>
                        <h3>Jaffa una città portuale da sogno</h3>
					    <h3>Storia pittoresca e irresistibile fascino orientale</h3>
						<p>Gli odori del mare si uniscono a quelli del caffè nero e delle spezie provenienti dai mercati. La cultura orientale si mescola con quella europea, l’antico con il nuovo: questa è Jaffa. Una delle città portuali più vecchie del mondo, la cui storia risale a migliaia di anni fa.&nbsp;La Jaffa moderna è una città vivace che non smette mai di sorprendere e innovare. Viali pittoreschi, gallerie d’arte, boutique esclusive, edifici antichi, luoghi meravigliosi e un gran numero di ristoranti mediorientali autentici: un visita nella vecchia Jaffa è un’esperienza multisensoriale stimolante per chiunque visiti Israele. Preparati a innamorarti.</p>
						
						<h3>Scopri la magia di una vivace città portuale&nbsp;</h3>
						<p>Ubicata su una collina con vista sul Mar Mediterraneo, nella parte meridionale di Tel-Aviv, per millenni Jaffa è stata al centro di eventi storici. Oggi il&nbsp;<strong>porto di Jaffa</strong>, molto attivo, è un ottimo posto da esplorare. Passeggia tra le gallerie d’arte, i negozi e i mercati in cui acquistare cibi prelibati. Cammina lungo i vecchi moli, ascolta la musica dal vivo, bevi, mangia e fai tua la speciale atmosfera.</p>
						<p>Per ammirare meglio il panorama della città, sali su per la collina fino al&nbsp;<strong>parco&nbsp;</strong><em><b>Ha'Pisga</b></em>, che sormonta la baia, e contempla la stupenda città sottostante. Sulla via del ritorno, esprimi un desiderio sul&nbsp;<strong>Ponte dei desideri.&nbsp;</strong>Chissà, magari potrebbe avverarsi!</p>
						<h3>Vive una romantica avventura urbana</h3>
						<p>Le vie di Jaffa sono piene di sorprese. Passeggia lungo le strette vie lastricate in pietra della vecchia Jaffa, scopri i cortili nascosti e soffermati sui piccoli dettagli: piastrelle di ceramica dipinte, piccole sculture e terrazze all’aria aperta. Guarda la gente, visita le gallerie d’arte, gli studi degli artisti e i negozi esclusivi.</p>
						<p>Continua ad esplorare. Dalla piazza della<strong>&nbsp;torre dell’orologio</strong>&nbsp;nel cuore della città, prosegui sino al famoso&nbsp;<strong>mercato delle pulci di Jaffa</strong>&nbsp;e districati tra le normali attività giornaliere e i tesori nascosti. È giunto il momento di mettere alla prova le tue capacità di contrattazione. Approfitta dei caffè piccoli e carini, dei ristoranti autenticamente mediorientali e degli ottimi bar e degusta i migliori hummus. Il piacere è garantito.</p>
						<p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>
					                  
			`,
      };
    },
  },

  {
    id: "Shakshuka_Time",
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "È l’ora della Shakshuka",
    smltitle: "",
    ctg: "culinary",
    isVid: true,
    vidId: "JjxXlP-Zk7M",
    html: function() {
      return {
        __html: `
                  <br/>
				<h3>Impara a cucinare la famosa Shakshuka!</h3>
<p>
					Quando chiedi alle persone che hanno visitato Tel Aviv e Gerusalemme qual è stato il loro piatto preferito durante il viaggio, molto spesso ti risponderanno la Shakshuka. Questa prelibatezza mediterranea, una delle specialità preferite dalle persone del posto, è fondamentalmente un piatto a base di uova cotte in una salsa di pomodoro, peperoncino e cipolle – è ricca di sapore e viene spesso accompagnata da pane e tahina. Ci sono ovviamente moltissime varianti in base alle tradizioni e ai gusti locali e viene generalmente servita a colazione o per il brunch, anche se vedrai che può anche diventare una fantastica cena.
      		</p>
      		<p>
					Il miglior modo per gustare la Shakshuka è decisamente sotto al sole di Tel Aviv o Gerusalemme, mentre ti godi una fantastica vacanza in città ricche di sapori ed esperienze indimenticabili.
      		</p>
      		<p>
					Se invece desideri provare una Shakshuka fai da te e ricreare il sapore di questo sensazionale piatto nella tua cucina, ecco come puoi fare:
      		</p>
      		<h3>
            Ingredienti:
          </h3>
          <ul>
                <li> UNA CIPOLLA GRANDE</li>
				<li>1/4 DI BICCHIERE DI OLIO D'OLIVA</li>
				<li>2 CUCCHIAI DI BURRO</li>
				<li>5 SPICCHI D'AGLIO</li>
				<li>UN PEPERONE ROSSO DOLCE</li>
				<li>UN PEPERONCINO PICCANTE</li>
				<li>UN CUCCCHIAIO DI PAPRICA - UN CUCCHIAIO DI SALE - 1/4 DI CUCCHIAIO DI PEPE NERO - 1/2 CUCCHIAIO DI CUMINO</li>
				<li>UN CUCCHIAIO DI SALSA DI POMODORO</li>
				<li>2 POMODORI GRANDI</li>
				<li>MEZZO BICCHIERE D'ACQUA</li>
				<li>MEZZA TAZZA DI CORIANDOLO/PREZZEMOLO TRITATI</li>
				<li>UN CUCCHIAIO DI ZUCCHERO</li>
				<li>UOVA quante ne desideri</li>
				<li>CUOCI COL COPERCHIO PER 15 MINUTI</li>
				<li>GODITELO!</li>
          </ul>
          <p>
          2 cucchiaini di olio d’oliva1 cipolla, tritata1 peperone rosso, senza semi e tagliato a cubetti4 spicchi d’aglio tritati2 barattoli di pomodori a pezzetti6 uova2 cucchiaini di coriandolo fresco tritato¾ di cucchiaino di sale1 cucchiaino di paprika¼ di cucchiaino di pepe nero1 peperoncino jalapeno (facoltativo)</p>
          <h3>
             Instruzioni
          </h3>
          <ol>
              <li>Prima di preparare il tutto, preriscaldare il forno a 375 gradi.</li>
              <li>Riscaldare l’olio d’oliva a fuoco medio in una pesante padella adatta al forno. Aggiungere la cipolla, il peperone e il peperoncino jalapeno e soffriggere fino a quando le cipolle non sono lucide.</li>
              <li>Aggiungere l’aglio e la paprika. Aggiungere il pomodoro, il sale e il pepe nero. </li>
              <li>Portare il tutto a bollore e poi ridurre il calore. Cucinare per 10-15 minuti.</li>
              <li>Creare 6 piccoli spazi nella salsa e aprire con delicatezza le uova in ciascuno degli spazi.</li>
              <li>Mettere la padella nel forno preriscaldato e lasciar cuocere finché gli albumi non sono fermi – ci vorranno circa 10 minuti.</li>
              <li>Prima di servire, aggiungere il coriandolo come decorazione.</li>
              <li>Servire accompagnato da pane e tahina e gustare il piatto!</li>
          </ol>

         `,
      };
    },
  },

  {
    id: "Gourmet_TelAviv",
    bgImage: "posts/bank/33/1.jpg",
    mobBgImage: "posts/bank/33/M.jpg",
    title: "TEL AVIV GOURMET SCENE",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Wake up your taste buds in Tel Aviv</h3>
			<p>
			   Tel Aviv's huge variety of amazing restaurants - The perfect place to treat yourself.
			</p>
              
			`,
      };
    },
  },

  {
    id: 34,
    bgImage: "/posts/34/1.jpg",
    mobBgImage: "/posts/34/M/1.jpg",
    title: "the DEAD SEA",
    ctg: "deadsea",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            
				<p>
               		A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction.

                </p>

                <p>
               		Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
					
                </p>

                <p>

					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.

                </p>
				
            	 `,
      };
    },
  },

  {
    id: "The_Gates_Of_Jerusalem",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/gates-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/gates-of-jerusalem/M.jpg",
    title: "LE PORTE DI GERUSALEMME",
    smltitle: "",
    html: function() {
      return {
        __html: `
				                 
				                 <br/>
				                 <h3>Attraversate le porte e scoprite un altro aspetto della città vecchia di Gerusalemme</h3>
				                

							    <p>Le mura della Città vecchia di Gerusalemme, costruita all’inizio del XVI secolo dal sultano turco Solimano il Magnifico, hanno otto porte. Tutte, tranne una (la porta della Misericordia), sono ancora usate dagli abitanti di Gerusalemme e dai visitatori che si recano al mercato e visitano i siti sacri e storici<span>.</span></p>
										<p>Di seguito vengono descritte brevemente le porte, procedendo in senso antiorario da sud a ovest<span>:</span></p>
										<h3>La porta di Sion:</h3>
										<p>il nome è quello biblico di Israele in ebraico e inglese, mentre il nome arabo di questa porta è “Porta del profeta David”, in quanto la tomba del re David si trova sul vicino monte Sion, a poca distanza. La porta di Sion conduce direttamente ai quartieri armeno ed ebraico.</p>
										<div class="img-wrapper">
						                    <img src=${getImgUrl() +
                                  "/posts/gates-of-jerusalem/1.jpg"} class="img-responsive" />
					                    </div>
										<p><strong>La porta delle immondizie</strong>: il nome insolito di questa porta è riconducibile ai rifiuti che nell’antichità venivano gettati nelle vicinanze della porta, dove i venti portavano via i cattivi odori. Neemia 2:13 afferma che una porta delle immondizie si trovava probabilmente vicino a questa. Questa porta conduce direttamente al Muro del pianto e al parco archeologico del muro meridionale.</p>
										<p><strong>La porta della misericordia</strong>: questa porta, sulle mura orientali del tempio, è forse la più famosa di tutte. Chiamata anche “porta aurea” o “porta orientale”, è rimasta bloccata per secoli e secoli e si dice che sia in attesa di un’apertura miracolosa quando arriverà il Messia e i morti resusciteranno.</p>
										<h3>La porta dei leoni:</h3>
										<p>Questa porta prende il nome dalle due coppie di leoni feroci scolpiti ai suoi fianchi. In realtà si tratta di tigri, il simbolo araldico del sultano Baybars, del XIII secolo. Viene chiamata anche “porta di Santo Stefano”, dal nome del primo martire cristiano, che secondo la tradizione fu lapidato nelle vicinanze. La porta dei leoni, che conduce alle piscine di Betzata, alla Via Dolorosa e ai mercati, divenne famosa durante la Guerra dei sei giorni.</p>
										<h3>La porta d’Erode:</h3>
										<p>Nonostante il suo nome, il famoso re ebraico non aveva nulla a che fare con questa porta. In arabo e in ebraico questa porta rivolta a nord, che conduce ai mercati della Città vecchia è denominata Porta dei fiori. Secondo alcuni il nome deriva da una rosetta scolpita sulla sua sommità. Tuttavia, in arabo una parola simile significa “risvegliato” e potrebbe fare riferimento a un vicino cimitero e alla speranza di risurrezione<span>.</span></p>
										<h3>La porta di Damasco:</h3>
										<p>È la porta più imponente di Gerusalemme, anch’essa rivolta verso nord e con il nome della grande città dalla quale provenivano i grandi governanti di Gerusalemme. È sempre molto trafficata, per via dei mercati al suo interno. Sotto al cancello del XVI secolo gli archeologi hanno scoperto una parte dell’ingresso fatto costruire dall’imperatore Adriano nel secondo secolo dell’era cristiana.</p>
										<h3>La nuova porta:</h3>
										<p>Questa è l’unica entrata per la Città vecchia e non fa parte del progetto originale delle mura del XVI secolo. Sul finire dell’impero ottomano fu aperta una breccia per consentire ai pellegrini cristiani di accedere più velocemente ai loro luoghi sacri all’interno dei bastioni.</p>
										<p><strong>La porta di Jaffa:</strong> era la destinazione dei pellegrini ebrei e cristiani che sbarcavano nel porto di Jaffa, da cui prese il nome. Conduceva (e ancora conduce) direttamente ai quartieri ebraico e cristiano, nonché alle parti più popolari del mercato e alla torre del museo di David, che una volta erano la cittadella di Gerusalemme e che oggi testimoniano la sua storia.</p>

         `,
      };
    },
  },

  {
    id: "Shopping_Delights",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"3g9T1HMP39Q",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/shopping-delights/1.jpg",
    mobBgImage: "/posts/bank/shopping-delights/M.jpg",
    title: "Dalla moda ai souvenir, Gerusalemme ha tutto",
    smltitle: "",
    html: function() {
      return {
        __html: `
				  
					<h3>
						From couture to souvenirs, Jerusalem has it all. 
					</h3>
				
                    <p>
						A Gerusalemme ci sono varie zone per gli acquisti, sia all’aperto che in centri commerciali, ma state sicuri che al momento di fare acquisti a Gerusalemme, potrete trovare tutto ciò che cercate, e per ogni tipo di tasca.
					</p>

					<h3>
					   CENTRO CITTA’: BEN YEHUDA E DINTORNI
					</h3>

					<p>Tutta la zona del centro città è divenuta una grande area di acquisti per i pedoni, ma il cuore del centro è senza dubbio <a href="//www.itraveljerusalem.com/ben-yehuda-street">Ben Yehuda St.</a>, una strada chiusa al traffico e piena di negozi e ristoranti, da pochi anni sottoposta a rinnovamento. La pavimentazione è stata rifatta con pietra di Gerusalemme, l’illuminazione è affidata a lampioni dall’aspetto molto classico, le aree per la sosta sono elevate rispetto alla superficie della via, e non poteva mancare anche una piccola fontana. Le stradine laterali hanno ricevuto anch’esse delle migliorie, con eleganti piastrelle grigie che coprono i marciapiedi e la stessa illuminazione che troviamo a Ben Yehuda. Tali rinnovamenti sono stati attuati in preparazione dell’inizio dei lavori per la metropolitana leggera, che percorre Jaffa Street.</p>

                    <p>
                      Di per se, Ben Yehuda St. è una elevazione collinare che connette King George St. in cima, a Jaffa St. a valle, dove si apre su una piazza, Zion Square (Kikar Tzion). Ben Yehuda ha tra i propri punti di riferimento i punti vendita di due famose compagnie israeliane: la Ahava, per i cosmetici creati con i prodotti del Mar Morto, e la Teva-Naot, per le scarpe in pelle comode e di qualità. Ben Yehuda St. è anche un buon posto per procurarsi a prezzi ragionevoli souvenir legati alla cultura ebraica ed a quella cristiana, ma, vi raccomandiamo: contrattate sempre! L’ area offre anche merce di uso quotidiano, tipo cappelli, ombrelli, ed utensili elettrici od elettronici.
                    </p>

                   <!-- Hadar aked to hide this paragraph 
                   <p>Al fondo di Ben Yehuda St., in Zion Square, troverete il grande magazzino &nbsp;HaMashbir LaTzarchan (comunemente denominato “HaMashbir”), i cui vari piani vi offrono tutto ciò che siete abituati a trovare in un grande magazzino. Vicino alla Zion Square, la gioielleria <a href="//www.itraveljerusalem.com/baltinester-jewelry-judaica-jerusalem" target="_blank">Baltinester (Jaffa St.</a>) è particolarmente conosciuta per la possibilità di ordinare collane personalizzate col nome.&nbsp;Da Zion Square, avrete acceso a Nachalat Shiva, una piccolo area centrata intorno a Yoel Salomon St., dove potrete trovare molte botteghe di ceramisti e di gioiellieri, ed anche boutique di abbigliamento.</p>
                   -->
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					   IL CENTRO COMMERCIALE MAMILLA ED IL CARDO DELLA CITTA’ VECCHIA: SHOPPING DI QUALITA’
					</h3>

					<p>Spostandosi da Ben Yehuda in direzione della città vecchia, troverete qualcosa di veramente chic:&nbsp;<a href="//www.itraveljerusalem.com/mamilla-mall" target="_blank">Alrov Mamilla Avenue Mall</a>, una passerella commerciale all’aperto immersa in una cornice architettonica estremamente suggestiva. La via inizia dall’albergo a 5 stelle Mamilla e si prolunga fino alla porta di Giaffa, uno degli accessi alla città vecchia, includendo filiali di marche di prestigio intenazionale, quali Versace, H. Stern, Nike e Gap, nonchè di ditte che producono articoli di judaica di alta qualità. Lungo tutto &nbsp;Mamilla Mall vengono regolarmente esposte opere di artisti, in particolare sculture, viene eseguita musica dal vivo nel suo teatro all’aperto, e vengono organizzate attività per le famiglie, specialmente nei periodi legati alle festività. Per informazioni più precise, vi invitiamo a tener d’occhio il nostro calendario degli eventi [<a href="//www.itraveljerusalem.com/eventcategory/cat_events/" target="_blank"><strong>events schedule</strong></a>].</p>

					<h3>
					IL CENTRO COMMERCIALE MALCHA
					</h3>

					<p>
					    Il Malcha Mall rappresenta una scelta solida per chiunque cerchi l’esperienza del centro commerciale suburbano, come pure per famiglie in cerca di una piccola uscita.
Sono passati più di vent’anni da quando il Malcha Mall di Gerusalemme era chiamato “Il più esteso centro commerciale del Medio Oriente”; ora comunque è a Gerusalemme che mantiene il proprio primato, con oltre 250 negozi tra i quali scegliere.
					</p>

					<p>
					   Il Jerusalem Malcha Mall ospita sia filiali di marchi israeliani che internazionali, passando da negozi a buon mercato per quelli di medio livello fino alle boutique. Troviamo marche famose a livello mondiale, come H&M, Zara, Home Depot, Toys R Us, e numerose marche di vestiario israeliane per ogni budget. Troviamo una filiale di HaMashbir LaTzarchan (lo stesso di Zion Square) ed un supermercato della linea Mega, oltre a servizi generali come la sinagoga, l’ufficio postale, la Bank Hapoalim. Per mangiare, una vasta scelta di ristoranti per piatti da esportazione, tutti casher.
					</p>

					<p>
					   Le attività includono una pista di pattinaggio interna durante l’inverno, e workshop di intrattenimento e di artigianato nel corso delle vacanze; anche qui, vi invitiamo a tener d’occhio il nostro calendario degli eventi per progettare le vostre uscite. Inoltre, il negozio di articoli per neonati Shilav offre un’area Gymboree per piccoli fino a sei anni.
Malcha Mall è facilmente raggiungibile in autobus dal centro, oppure in taxi da qualsiasi altro posto.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/2.jpg"} class="img-responsive" />
					</div>



                    <h3>
                       LO SHUK ARABO DELLA CITTA’ VECCHIA
                    </h3>

                    <p>
                       Se siete in cerca di autentico colore locale, lo shuk arabo della città vecchia è il posto dove andare. Situato nei quartieri musulmano e cristiano, vi si accede dalla porta di Giaffa andando dritti dentro al quartiere musulmano. Quando comincerete a vedere vestiti di ogni genere appesi in alto, sarete arrivati nel posto giusto. Una sorta di piccola Istanbul – lo shuk arabo nella città vecchia è un mercato mediorientale pieno di artigianato locale, sia nell’abbigliamento che nel cibo. Potrete trovare anche souvenir cristiani, ebraici ed arabi, sovente a prezzi minori che a Ben Yehuda St. – dipende da voi conoscere, e fare uso, delle vostre capacità di contrattazione (consiglio: iniziate dalla metà del prezzo proposto.)
                    </p>

                    <p>
                      Nello shuk arabo potrete avere un assaggio del modo di vivere di un tempo. I mercanti hanno lavorato nella città vecchia per un paio di millenni, in questi vicoli stretti, giorno dopo giorno; l’autenticità di questo secolare mercato mediorientale rimane qualcosa di ineguagliato nella cultura occidentale in generale, ed anche in Israele nel particolare.
                    </p>

                    <h3>
                        LO SHUK MAHANE YEHUDA (MERCATO)
                    </h3>

                   <p>Il mercato di Mahane Yehuda, o shuk, è soprattutto rinomato per tutto quanto ha a che fare col cibo locale – frutta fresca e secca, fornerie (come&nbsp;Marzipan), e posti di shwarma/falafel.&nbsp; Recentemente,&nbsp;<a href="//www.itraveljerusalem.com/mahane-yehuda-market" target="_blank">Mahane Yehuda</a>&nbsp;ha visto comparire un gran numero di attività più esclusive – passando da “shuk&nbsp;a chic” – con negozi specializzati di vini e formaggi, prodotti naturali, ristoranti vegetariani, e perfino una filiale di Café Aroma, un marchio israeliano con diffusione internazionale. Oltre al cibo, potrete trovare articoli da regalo, judaica, gioielleria e ceramica o terracotta. E’ possibile anche comprare articoli elettrici ed elettronici, telefoni cellulari, ed abiti a basso costo.</p>


                    <p>
                   Lo spirito dello shuk Mahane Yehuda, col suo ambiente autenticamente gerosolimitano, rimane intatto, pertanto visitarlo rimane assolutamente un must.
                    </p>

                    <h3>
                       IN BREVE
                    </h3>

                    <p>
                          Per tirare le somme, lo shopping a Gerusalemme riflette la città stessa, aprendo lo spettro delle sue sfumature, dall’antico al moderno, con opzioni per chi ha pochi soldi fino a quello che cerca solo l’esclusivo. Vi potrete rendere conto che lo shopping a Gerusalemme è sicuramente un’esperienza varia ed eletrizzante.
                          <br>– See more at: http://www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf
                    </p>

         `,
      };
    },
  },

  {
    id: 17,
    ctg: "telaviv",
    // isVid:false,
    bgImage: "/posts/bank/37/1.jpg",
    mobBgImage: "/posts/bank/37/M.jpg",
    title: "Tel-Aviv Highlights",
    smltitle: "",
    isVid: true,
    vidId: "LLOUxE-K_9Y",
    html: function() {
      return {
        __html: `
					
					<h3>Top 5 things to see and do in the city:</h3>
					<h3>
						Old Jaffa
					</h3>
					<p>
						Even though it dates back thousands of years, a visit to Old Jaffa always
						feels like an exciting discovery. Charming winding alleyways interspersed
						with art galleries, historic buildings, extraordinary landmarks and a
						multitude of quaint authentic restaurants. A tour of old Jaffa is an awe inspiring
						experience, a definite must for every tourist visiting Israel.
					</p>
					<h3>
						Jaffa Port
					</h3>
					<p>
						Considered one of the world’s most ancient ports, the Port of Jaffa
						served fishermen, sailors, merchants, crusaders, conquerors and
						immigrants for thousands of years. Today, the port continues to serve as
						a fishing port, and is also being renovated as an urban attraction, offering
						cultural and leisure activities, shopping and tourism, while preserving its
						unique historical and fascinating character.
					</p>
					<h3>
						TA Port
					</h3>
					<p>
						Recently restored, the trendy port area has really got it all. During the
						day, you can find yourself wandering through remarkable hanger style
						spaces for brand and boutique shopping, sharing a meal in restaurants
						with magnificent sea views and taking part in lots of activities for the
						whole family. At night however, crowds of young clubbers descend on
						the area, which transforms into one of the city’s most popular hotspots
						with some of the coolest clubs and bars in Tel Aviv.
					</p>
					<h3>
						The White City
					</h3>
					<p>
						Join a fascinating tour of the “White City” of Tel Aviv and discover why
						it has been declared a UNESCO World Heritage Site. The White City is
						home to the world’s largest grouping of international style buildings, also
						known as Bauhaus. Built in the 1920’s and 1930’s, and painstakingly
						restored to its original glory, the ‘White City’ quarter is a truly unique and
						memorable architectural treasure.
					</p>
					<h3>
						Neve Tzedek
					</h3>
					<p>
						Take a break from the hectic pace of Tel Aviv; this hidden gem of a
						neighborhood boasts beautiful oriental architectural style and charming
						narrow streets which make Neve Tzedek, literally meaning an Oasis of
						Justice, an actual oasis at the heart of the bustling city.
					</p>

         `,
      };
    },
  },

  {
    id: "Amazing_Nightlife",
    bgImage: "/posts/bank/18/1.jpg",
    mobBgImage: "/posts/bank/18/M.jpg",
    title: "Incredibile vita notturna",
    ctg: "telaviv",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // vidId:"WKfjMATNH8Q", - this is an old youtube video
    smltitle: "",
    html: function() {
      return {
        __html: `

					<div class="ac-cradit">
					<span class="ac-cradit-text">Credits:</span>
						<br/>
						<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
						<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
					</div>
					<p></p>
					</div>
                    <br/>
                    <h3>Una festa senza fine nella città che non si ferma mai!</h3>
                    <p>
						Non avrete veramente provato la cultura urbana di Tel Aviv fino a che non avrete ballato fino all’alba in uno dei suoi famosi locali notturni.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/2.jpg"} class="img-responsive" />
					</div>

					<p>
                         Dizingoff – Un vero mega-club, bella gente e musica commerciale. Cat and Dog – Non per i deboli di cuore. Qui la festa comincia quando gli altri club chiudono per la notte. Musica eclettica come la gente che lo frequenta. Biggy-Z –  Ispirato a Mardi Gras di New Orleans, con aree coperta e scoperta e con consumazioni illimitate per tutti coloro che comprano il bracciale del club. Dream Exhibition – Un club elegante con tutti i comfort moderni. Qui  gli avventori 24+ danzano al ritmo del rock, commerciale e house music.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/3.jpg"} class="img-responsive" />
					</div>

					<p>
                       Valium – Uno spazioso nightclub di lusso all’ultimo piano del Migdalor Building. Ci si può godere la musica sulla pista da ballo o sul più tranquillo attico. KTOVT – Un club alternativo con un décor interessante e DJ locali ed internazionali che propongono la musica a coloro che sono venuti solo per ballare.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/4.jpg"} class="img-responsive" />
					</div>

					<p>
                       Gay Nightclubs – Evita si rivolge a tutta la comunita GLBT, mentre Apolo Bar (Allenby 46) è per soli uomini, e Barvaz (Ha’Mehoga 10) o Amazona (23 Lilienblum St.) sono per sole donne, quest’ultimo per le avventrici oltre i 24.
                    </p>
                    <p>photo credit: Dana Friedlander</p>

         `,
      };
    },
  },

  {
    id: "Boutique_Hospitality",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "Boutique Hospitality",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `

                                <p>Tel Aviv has long been known as a young and vibrant seaside city, where life is fast-paced and non-stop. And with countless bars, restaurants, beaches, museums, shops and attractions lining every free inch of prime Tel Aviv real estate, the recent revolution in the city’s boutique hotel offerings in the past two years has paved the way for luxury and leisure packed vacations, combining action with relaxation and increased visitor satisfaction.</p>

                                <h3>A unique, personalized touch</h3>

                                <p>If you are seeking a unique hospitality experience in a trendy neighborhood establishment that blends into the local infrastructure, a Tel Aviv boutique hotel stay is just what you need. Perfectly bringing together desired service and amenity features with an added increasingly personalized customer service, boutique hotels are known for their staff’s exemplary accommodating attention to their visitors’ every request and fancy.</p>

                                <p>Built in converted heritage sites, restored old buildings or other contemporarily designed structures, each Tel Aviv neighborhood boutique hotel possesses unique themes, concepts and characteristics. Defined by their souls and coupled with uniquely designed guest rooms and a high level of customized service, the boutique hotels have great views of the “City that Never Sleeps” from sprawling rooftop terraces, in-house spas, internet hubs and restaurants.</p>
								<div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/boutique-hospitality/1.jpg"} class="img-responsive" />
						            Credit: Dana Friedlander
					            </div>
							   
								<h3>Live the big city</h3>

                                <p>Looking to enjoy a romantic couple’s getaway, find a quiet place to unwind during a weeklong business conference, gather your family for an intimate reunion or hang out with friends for a fun beach vacation? Don’t want to travel far from your hotel room or sit in traffic to reach big city attractions, nightlife and events? The warm and inviting yet luxurious nature of boutique hotel stays in Tel Aviv provide the ideal hospitality experience that lets you “live” Tel Aviv like a local, minus the onus of cleaning your own rooms and preparing your own meals.</p>

                                <p>Think of boutique hotels as upscale and authentic guest houses in the heart of the big city. Somewhere you can go to escape the hustle and bustle when it’s time to relax and be pampered, but still be able to pop out on a whim and casually enjoy the plethora of sites and services Tel Aviv offers the public, just like any one of  the city’s locals. And with many of the city’s boutique hotels situated in trendy areas, including in Neve Tzedek, along the coastline, in the diamond district and on Rothschild, Shenkin and Montefiore streets, a Tel Aviv boutique hotel stay is charming, authentic, pleasurable and exciting for all hospitality seekers.</p>
            

         `,
      };
    },
  },

  {
    id: 10,
    bgImage: "/posts/bank/12/1.jpg",
    mobBgImage: "/posts/bank/12/M.jpg",
    ctg: "telaviv",
    isVid: false,
    title: "Culture Time",
    smltitle: " ",
    html: function() {
      return {
        __html: `

					<h3>A variety of fascinating museums and unique galleries</h3>

				    <h3>
				        Tel-Aviv Museum of Art
				    </h3>

					<p>
						The Tel Aviv Museum of Art presents a variety of permanent and temporal exhibits at its home in the Helena Rubenstein Pavilion, located on Shaul Hamelech Boulevard, next to the Mann Auditorium. The permanent exhibits include some of the best works of Israeli art, as well as sculptures from the 20’s until today. It features European paintings – impressionism and post-impressionism – from the 16th to the 19th centuries, as well as European and American works of the 20th century. The museum’s graphic collection includes more than 20,000 prints and sketches. Among the museum’s outstanding works are a unique selection of early painted reliefs of Alexander Archipenko and works by Chagall, which he donated to the museum before its establishment. Helena Rubenstein’s well-known collection of miniature rooms is on permanent display in the pavilion, which bears her name.
					</p>

					<h3>
				        OPENING HOURS:
				    </h3>

				    <p>

                          Sun Closed <br>
                          Mon, Wed, Sat 10:00-18:00 <br>
                          Tue, Thu 10:00-22:00 <br>
                          Fri 10:00-14:00 <br>
                          Sat 10:00-16:00 (July-August closed on Sat)<br>
                    </p>

                    <p>
                       For more information, click to the&nbsp;<a href="//www.tamuseum.org.il/en/default.aspx" target="_blank">Tel-Aviv Museum of Art</a>
                    </p>

                    <h3>
                        Beit Hatfutsot: The Diaspora Museum
                    </h3>

                    <p>
                       Beit Hatefutsot-The Jewish Diaspora Museum, situated on the Tel Aviv University campus, has gained honorary distinction throughout the Jewish world as the first museum of the history of the Jewish people to showcase the Jewish contribution to human creativity and culture over a period of more than two millennia. The Museum’s permanent exhibition brings the story of the Jewish People throughout the Diaspora to life through drawings, video clips, films, reconstructed models and other means. The exhibit focuses on various subjects – including “The Jewish Family life cycle”, “the community”, “the faith”, and “the return to Zion”.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/10/2.jpg"} class="img-responsive" />
					</div>

					<p>

                          For more information, click to the&nbsp;<a href="//www.bh.org.il/" target="_blank">Beit Hatfutsot: The Diaspora Museum</a>

                    </p>

                    <h3>
                         Eretz Israel Museum
                    </h3>

                    <p>

                            The Eretz Israel Museum- Tel Aviv is a multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts. The museum’s pavilions are scattered throughout a spacious courtyard with the ancient archaeological mound of Tel Kassile, at which excavations revealed valuable findings, positioned at its center. The museum houses a variety of reconstructed ancient production devices, including wine presses, an olive oil press, and a flour mill, along with a “craftsperson’s marketplace” which showcases traditional work instruments that were used in the Land of Israel and throughout the region. There is also a sophisticated Planetarium with its “Journey to the Universe” program, and a museum shop offering a unique selection of locally produced gifts and ornaments.<br>

                            OPENING HOURS:<br>

                          Sun-Wed 10:00-16:00 <br>



                          Thu 10:00-20:00<br>



                          Fri-Sat 10:00-14:00<br>

                        </p>

                    <p>
                       For more information, click to the <strong>&nbsp;</strong><a href="//www.eretzmuseum.org.il/e/" target="_blank">Eretz Israel Museum&nbsp;</a>
                    </p>

					<h3>
					    Beit Ha’ir
					</h3>


					<p>

                          Beit Ha’ir, renovated by the city, was the old City Hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history.  Beit Ha’ir has a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years, a project that was part of the centenary celebrations of the city. The main hall has a virtual display, including hundreds of documentary films and thousands of rare photos and documents that showcase major events in the early years of city life.  At Beit Ha’ir you can also visit the Dizengoff House, the restored residence of Meir Dizengoff, first mayor of Tel Aviv-Yafo, which includes a permanent exhibition.

                          <br>
                          OPENING HOURS:
                          Sun Closed
                          Mon-Thu 9:00-17:00 <br>
                          Fri-Sat 10:00-14:00
                    </p>

                    <p>
                      For more information, click to the <a href="//www.eretzmuseum.org.il/e/" target="_blank">Beit Ha’ir</a>
                    </p>

                    <h3>
                        The Olympic Experience Museum
                    <h3>

                    <p>

                          A new museum in Tel Aviv-Yafo, The Olympic Experience Museum, presents a one-hour, five-ring trip through the greatest Olympic records, with a special focus on Israel’s finest moments. The Olympic Experience boasts state-of-the art high tech imaging and illustrations, audio-visuals presentations, holograms, interactive screens, hands-on trials and much, much more.

                          Guided tours for organized groups every 30 minutes. Advanced reservation is recommended.

                          Opening Hours: Sunday-Thursday: 10:00-18:00, Friday:  10:00-14:00

                          The Olympic Experience, 6 Shitrit Street, Hadar-Yosef. Tel: +972-3-6498385

                    </p>

                    <p>
                       For more information, click to the&nbsp;<a href="//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2" target="_blank">The Olympic Experience Museum</a>
                    </p>

                    <p>

                          Ilana Goor Museum in Jaffa

                          The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br>
                          OPENING HOURS: <br>
                          Sun-Fri 10:00-16:00 <br>
                          Sat 10:00-18:00<br>
                          <a href="//www.ilanagoormuseum.org/eng/">www.ilanagoormuseum.org</a>
                    </p>

                    <h3>
                         Palmach Museum
                    </h3>

                    <p>
                        Rated #1 Tel-Aviv museum on Trip Advisor, this museum examines the Palmach, the military wing of the Zionist Movement, which functioned until the establishment of the State of Israel.
                    </p>

                    <p>
                        For more information, click to the&nbsp;<a href="//info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0" target="_blank">Palmach Museum</a>
                    </p>

                    <h3>
                        Other unique Museums
                    </h3>

                    <p>
                        Tel Aviv-Yafo is home to a variety of smaller, specialized museums, such as Beit Ben Gurion (The home of David Ben Gurion, Israel’s first prime minister), Beit Hatanach (The home of the Bible), The Haganah (defense) Museum, The I.Z.L. (the Irgun Zva’I Leumi – National Military Organization) Museum, Beit Hasofer (author’s house), Beit Reuven, The Jabotinsky Museum, and many others. Each of these smaller museums is a treasure house of artifacts. For example, Beit Bialik – the house of the national poet, displays the books, furniture and belongings of Israel’s renowned national poet. Bialik’s personal library of more than 3,000 books has been preserved, and the museum’s archives contain thousands of manuscripts, including the most extensive collection of his writings.
                    </p>

                    <h3>
                        OPENING HOURS OF TEL AVIV MUSEUMS:
                    </h3>
                    <h3>
                        Etzel Museum:
                    </h3>

                    <p>

                          King George 38: Sun-Thu 8:30-16:00 <br>

                          For more information, click to the&nbsp;<a href="//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx" target="_blank">Etzel Museum</a>
                    </p>

                    <h3>
                        Ben Gurion House:
                    </h3>

                    <p>
                            Sun, Tue-Thu 8:00-15:00 <br>
                            Mon 8:00-17:00<br>
                            Fri 8:00-13:00<br>
                            Sat 11:00-14:00
                    </p>

                    <p>
                       For more information, click to the&nbsp;<a href="//www.bg-house.org/?categoryId=6575" target="_blank">Ben Gurion House</a>
                    </p>

                    <h3>
                        Jabotinsky Institute in Israel:
                    </h3>

                    <p>

                        Sun-Thu 8:00-16:00 <br>
                        For more information, click to the&nbsp;<a href="//en.jabotinsky.org/" target="_blank">Jabotinsky Institute in Israel</a>

                    </p>

                    <h3>
                           The Israeli Museum:
                    </h3>

                    <p>
                            Sun, Mon, Wed 9:00-17:00 <br>
                            Tue, Thu 9:00-19:00<br>
                            Fri 9:00-14:00 <br>
                            For more information, click to the
                            <a href="//www.imj.org.il/en/">www.imj.org.il</a>
                    </p>

                    <h3>
                       Jaffa Visitors Center:
                    </h3>

                    <p>

                            Summer Sun-Thu, Sat 9:00-20:00<br>

                            Fri 9:00-17:00<br>

                            Winter Sun-Thu, Sat 9:00-18:00<br>

                            Fri 9:00-15:00<br>

                            For more information, click to the  <br>

                            <a href="//www.touristisrael.com/old-jaffa-visitors-center/3604/" target="_blank">Jaffa Visitors Center</a>

                    </p>

                    <h3>
                         Hall of Independence:
                    </h3>

                   <p>

                            Sun-Thu 9:00-17:00 <br>

                            Fri 9:00-14:00<br>

                            For more information, click to the&nbsp;<a href="//eng.ihi.org.il/" target="_blank">Hall of Independence</a>

                    </p>

                    <h3>
                        The Bible Museum:
                    </h3>

                    <p>

                            Sun-Fri 10:00-13:00 + 16:00-18:30 <br>

                            For more information, click to the&nbsp;<a href="//www.blmj.org/en/" target="_blank">The Bible Museum</a>

                    </p>

                    <h3>
                        Joseph Bau house:
                    </h3>

                    <p>

                            By appointment only (including weekends) <br>

                            For more information, click to the&nbsp;<a href="//www.josephbau.com/" target="_blank">Joseph Bau house</a>

                    </p>

                    <h3>
                        Rubin Museum:
                    </h3>

                    <p>

                            Sun Closed <br>

                            Mon, Wed, Thu 10:00-15:00 <br>

                            Tue 10:00-20:00<br>

                            Sat 11:00-14:00<br>

                            For more information, click to the &nbsp;<a href="//www.rubinmuseum.org.il/" target="_blank">Rubin Museum</a>

                    </p>

                    <h3>
                        Art Galleries
                    </h3>

                    <p>
                        Don’t miss the dozens of fine galleries, primarily located along Gordon Street and in the Old City of Jaffa, featuring the very latest in contemporary Israeli art. We won’t say another word- we’ll let the art speak for itself.
                    </p>

         `,
      };
    },
  },

  {
    id: 99,
    bgImage: "/posts/bank/20/1.jpg",
    mobBgImage: "/posts/bank/20/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "k4OwoEk5wMw",
    title: "JERUSALEM MAIN SITES ",
    smltitle: "",
    html: function() {
      return {
        __html: `
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<h3>
				    	Discover the history that stretches back thousands of years
				    </h3>
					<p>
						Like any city, the charm and essence of Jerusalem is best absorbed by walking its streets. However, depending on your interests, you don’t want to miss out on exploring at least some of these major attractions.
					</p>

					<p>
                         When visiting religious sites, it’s advised to dress modestly and wear clothing that covers your knees and elbows.
                    </p>

					<p>
                       A good place to start is Jerusalem’s Old City, which has a very special and distinct atmosphere and is where many of the major attractions of Jerusalem are found.
                    </p>

                    <h3>
                        OLD CITY
                    </h3>

                    <h3>
                        JERUSALEM WESTERN WALL
                    </h3>

                    <p>
                      The Western Wall, also known as the Wailing Wall and Kotel, is the western retaining wall of the Second Temple. Considered Judaisms’s holiest site, the wall is divided into a men’s and women’s section where worshipers congregate throughout the day for morning, afternoon and evening services. Diverse crowds come to pray against the stones, to tuck small pieces of paper with prayers into the cracks and to simply marvel at the site.
                    </p>

                    <p>
                          Address: Jewish Quarter, Old City <br>
                          Phone: +972-2-627-3515<br>
                          Hours: 24/7<br>
                    </p>

                    <h3>
                        VIA DOLOROSA
                    </h3>

                    <p>
                        TCrossing the Muslim Quarter from east to west is this street that traces the last steps of Jesus Christ as he was led to his crucifixion. Popular with both pilgrims and general tourists, the route marks 14 events on Christ’s last walk and is also lined with shops and stalls. It is worth visiting on a Friday afternoon (3:00opm in winter; 4:00pm in summer) when the Franciscans lead a procession along the route.
                        <br>Address: Via Dolorosa, Muslim Quarter, Old City.
                    </p>

                    <h3>
                        JERUSALEM CHURCH OF THE HOLY SEPULCHER
                    </h3>

                    <p>
                        One of the holiest sites for Christians, this impressive building draws millions of pilgrims from around the world every year. The compound is believed to be the site of Golgotha (the Hill of Calvary), where, according to the New Testament, Jesus was crucified, buried and resurrected.
                        <br>
                        Address: Between Suq Khan e-Zeit and Christian Quarter Rd, Christian Quarter, Old City<br>
                        Phone: +972-2-627-3314 <br>
                        Hours: Sun – Sat: 5:00am – 8:00pm/9:00pm
                    </p>



					<h3>
					    DAVID’S CITADEL
					</h3>

					<p>
					   David’s Citadel (also known as the Tower of David) was originally built in the second century BC to strategically strengthen a weak point in the city’s defences, and was subsequently destroyed and rebuilt many times over the ensuing centuries. Since 1989, the grounds are home to a fascinating museum, which sheds light on the history of Jerusalem. Don’t forget to take in the splendid view of Jerusalem from its ramparts.
					</p>

					<p>
                          Address: Jaffa Gate, Christian Quarter, Old City <br>
                          Phone: +972-2-626-5333<br>
                          Hours: Sun-Thu: 10:00am -4:00pm, Fri: Closed, Sat: 10:00am – 2:00pm (September-June), Sun-Thu:<br> 10:00am – 5:00pm, Fri: 10:00am – 2:00pm, Sat: 10:00am – 5:00pm (July-August)
                    </p>

                    <h3>
                        CITY OF DAVID
                    </h3>

                    <p>
                        Situated deep below ground in the Arab village of Silwan is the remains of the once-grand citadel where a dynasty of Judean kings once ruled. A massive visitors’ center offers a tour that begins with an observation point overlooking the remains of ancient Jerusalem, then continues underground with a look at recent archaeological finds and ends at the Gihon Spring, where according to tradition Solomon was anointed king. Visitors can also wade through the waters of the 2,700-year-old Hezekiah’s Tunnel.
                    </p>

                    <p>
                          Address: Silwan, East Jerusalem <br>
                          Phone: +972-2-626-2341<br>
                          Hours: Sun-Thu: 8:00am – 5:00pm (winter), 8:00am – 7:00pm (summer), Fri: 8:00am – 1:00pm (winter), 8:00am – 3:00pm (summer)
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/9/3.jpg"} class="img-responsive" />
					</div>

					<h3>
                       MOUNT OF OLIVES
                    </h3>

                    <p>
                        The hill that rises to the east of the Old City, the Mount of Olives, is a great place to take in views of the Old City and the Dome of the Rock. Its slopes are filled with holy and burial sites and are home to several grand churches including the Church of all Nations. To take in all the sights, it’s best to start at the top, near to the Mosque of Ascension, and walk downhill to the Tomb of the Virgin. The Old City views are best in the morning. <br>
                        Address: Mount of Olives, East Jerusalem
                    </p>

                    <h3>
                        YEMIN MOSHE
                    </h3>

                    <p>
                        This charming neighbourhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. It is known for its windmill and communal housing block, known as Mishkenot Shaananim, which is now a venue for art and culture. The area is home to artists, writers and academics and is renowned for its Oriental-style houses, green parks, a music center, the YMCA, King David Hotel, Herod’s Family Tomb. <br>
                        CITY CENTER
                    </p>

                    <h3>
                        MAMILLA ALROV AVENUE
                    </h3>

                    <p>
                          Situated between the city center and the Old City, Mamilla Alrov Avenue is a pedestrian mall that offers a selection of luxury shops, as well as upscale restaurants and cafes. Mamilla is known for its chic and tasteful European feel, and offers spectacular views of the Old City walls. <br>
                          Address: 6 Yitzhak Kariv St, Jerusalem <br>
                          Phone: +972-2-636-0000<br>
                          Hours: Sun-Thu: 10:00am – 9:30pm (winter), 10:00am – 10:30pm (summer), Fri: 9:00am – 2:00pm (winter), 9:30am – 3:30pm (summer), Sat: One hour after Shabbat – 11:00pm
                    </p>

                    <h3>
                        BEN YEHUDA STREET
                    </h3>

                    <p>
                    One of Jerusalem’s prime hangout spots for locals and tourists alike, Ben Yehuda Street is a pedestrian mall extending between King George Street and Jaffa Road in downtown Jerusalem. The street is filled with gift shops, falafel and ice-cream stores, buskers, beggars, musicians and street performers.
                    </p>

					<h3>
                        NACHALAT SHIVA
                    </h3>

                    <p>
                          This charming cobblestone neighbourhood just south of Ben Yehuda Street in the&nbsp;<a href="//www.itraveljerusalem.com/placecategory/food-nightlife?multi_hood=11" target="_blank"><strong>city center</strong></a>&nbsp;offers a great selection of shops, restaurants, bars and outdoor cafes. This is a great place to experience in summer and at night with many bustling until late.
                    </p>

                    <h3>
                       MEAH SHEARIM
                    </h3>

                    <p>
                          Though it is just a few minutes’ walk from modern Ben Yehuda Street, the ultra-orthodox enclave of Mea Shearim is an entirely different reality. You will feel as though you have stepped into 18th Century Europe with Jewish Orthodoxy dressed in full traditional attire such as long black coats, black fur hats and stockings. When touring, it’s recommended to dress extremely modestly, covering up your wrists and ankles, and to take photos with discretion. <br>
                          Address: Meah Shearim Rd, Jerusalem
                    </p>

                    <h3>
                        Mahane Yehuda Market
                    </h3>

                    <p>
                          Often referred to as “the shuk”, Mahane Yehuda Market offers a huge assortment of fresh produce and food, as well as a variety of other shops like clothing stores, kitchenware shops, jewellery stores, ceramic stores and a variety of gentrified eateries. The shuk includes an open air and closed area, bounded by Jaffa Road on the one side and busy Agripas Street on the other. It’s worth taking public transportation to the shuk as there is not a huge abundance of parking, and a great deal of traffic. If you can handle crowds, go on a Friday to experience last minute Shabbat shopping.<br>
                          Address: Agripas and Jaffa Street, Jerusalem
                    </p>

                    <h3>
                        OTHER AREAS OF JERUSALEM
                    </h3>

                    <h3>
                       YAD VASHEM
                    </h3>

                    <p>
                          Yad Vashem, Israel’s national Holocaust memorial, commemorates the six million men, women and children murdered by the Nazis and their allies. Located at the foot of Mt. Herzl, Yad Vashem comprises several moving memorials, including the Hall of Remembrance and the haunting Children’s Memorial; the Holocaust History Museum; the Museum of Holocaust Art; sculptures and installations; a massive archive and a research institute. Dress appropriately, and make sure to reserve at least a few hours for a visit to the Museum.  Address: Har Hazikaron <br>
                          Phone: +972-2-644-3400
                    </p>

                    <h3>
                       ISRAEL MUSEUM
                    </h3>

                    <p>
                          You’ll want to devote at least a day to Israel’s largest cultural institution, the Israel Museum, which was re-launched in the summer of 2010 after a major overhaul. The Museum is made up of many different wings and a huge collection of art, archaeological findings and Judaica. One of the major highlights is the distinctly shaped Shrine of the Book, which houses many ancient manuscripts including the Dead Sea Scrolls. Other highlights include the Youth Wing for children, the Billy Rose Art Garden, which showcases the development of western sculpture over the centuries, the Museum’s Fine Arts Wing and its in-depth Archaeology Wing.
                    </p>

         `,
      };
    },
  },

  {
    id: "Sensational_Beaches",
    ctg: "telaviv",
    isVid: true,
    vidId: "XDei1Zy_cu4",
    bgImage: "/posts/bank/17/1.jpg",
    mobBgImage: "/posts/bank/17/M.jpg",
    title: "Spiagge sensazionali",
    smltitle: "",
    html: function() {
      return {
        __html: `
					
					<br/>
					<h3>
						Vieni a rilassarti sulle assolate spiagge di Tel Aviv
					</h3>

                   

					
                 	<p>
						Tel Aviv-Giaffa presenta una lunga passeggiata lungomare che fiancheggia tutta la spiaggia, formandone il suo confine occidentale. La gente usa quest’area per camminare, fare jogging, andare in bici, o sedersi sulle panchine a riempire i polmoni di aria di mare, tutto questo in una gloriosa cornice davanti alla linea blu dell’orizzonte, con vele bianche che saltellano sulle onde.
						<br>
						Dozzine di ristoranti, caffè e gelaterie sono affollati durante tutto il corso della giornata, mentre pub, discoteche e jazz club sbocciano con dopo il tramonto. A qualsiasi ora, le attrazioni di strada abbondano – clown, caricaturisti, artisti del tatuaggio, acconciatori, prestigiatori e, naturalmente, il continuo e variegato passaggio della gente che cammina per raggiungere le spiagge.
						In spiaggia troverete sabbia pulita, sedie a sdraio, gelatai ambulanti, ed irriducibili sportivi che nuotano ogni giorno, d’estate e d’inverno, in qualsiasi condizione metereologica. Ognuna delle 13 bellissime spiagge di Tel Aviv presenta caratteristiche uniche ed offre vari servizi, oltre alle importantissime stazioni di sorveglianza dei bagnini, tanti chioschi, ristoranti, aree di gioco per bambini, palestre all’aperto, e tanto altro.
					</p>
                      <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>
                    

					<h3>
						Alcuni suggerimenti
					</h3>

					<ul>
	          <li>I venerdì pomeriggio, alla spiaggia del Dolphinarium, potrete unirvi ad uno spettacolo improvvisato di capoeira e percussioni..</li>
	          <li>Gordon Beach va benissimo per la pallavolo</li>
	          <li>I religiosi osservanti potranno recarsi a Hof Hadatiyim (Nordau Beach), a sud del porto di Tel Aviv. I giorni aperti a donne e ragazze sono domenica, martedì e giovedì, per uomini e ragazzi lunedì, mercoledì e venerdì. La spiaggia è aperta il sabato per tutta la famiglia.</li>
	          <li>La comunità GLBT tende a gravitare attorno alla zona dell’Hilton, che si è guadagnata il titolo della spiaggia gay-friendly della citta.</li>
	          <li>La sottile striscia di sabbia accanto alla Marina è meno affollata e piu tranquilla di tutte le altre spiagge, e nel porticciolo riservato alle sole barche da diporto potrete noleggiare windsurf, tavole da surf, imbarcazioni a vela ed a motore, attrezzatura per immersioni.</li>
	          <li>Il surf è particolarmente popolare alla Hilton beach, dove uno speciale sistema di illuminazione recentemente installato permette di praticarlo anche di notte.</li>
	          <li>Il kitesurf è praticabile ad Aviv Beach.</li>
	          <li>Per il windsurf, andate a Dolfinarium Beach.</li>
	          <li>Per la pallavolo, Aviv e Gordon Beach.</li>
	          <li>Le spiagge cittadine sono ben attrezzate con camerini, docce e toilet. La sorveglianza dei bagnini è in vigore durante tutta la stagione balneare (da maggio ad ottobre) e la polizia turistica offre sicurezza, assistenza ed informazioni.</li>
	      	</ul>

        	<h3>
						Un po’ di dati
					</h3>

					<ul>
					<li>Ogni anno, 8.500.000 bagnanti frequentano queste spiagge.</li>
					<li>La stagione balneare ufficiale va da maggio ad ottobre.</li>
					<li>Le spiagge di Tel Aviv-Giaffa sono 13.</li>
					<li>Quattro spiagge sono accessibili a persone con disabilità: Tzuk, Tzuk nord, Metzizim e Hilton (in pratica, tutto il versante nord della citta).</li>
					<li>Le spiagge di Tel Aviv-Giaffa hanno una valutazione molto alta nei test praticati dal Ministero per l’Ambiente israeliano, e sono quindi considerate molto pulite.</li>
					<li>Lo sport da spiaggia più popolare è costituito da una versione israeliana del tamburello, chiamata&nbsp;<a href="//www.gomatkot.com/the-game/" target="_blank">Matkot</a>, (sempre attenti alla testa!).</li>
					<li>L’anguria col formaggio feta costituisce uno degli spuntini maggiormente amati. Gli artikim, i ghiaccioli, rimangono comunque un classico, col gusto banana – cioccolato in cima alla lista delle preferenze.</li>
					</ul>
                  	<h3>
						Direttive per la balneazione
					</h3>

					<ul>
						<li>I bagnanti devono conformarsi alle direttive dei bagnini e delle guardie di soccorso.</li>
						<li>La balneazione è proibita in assenza di bagnini.</li>
						<li>La balneazione è proibita con la bandiera nera.</li>
						<li>Gli sport a motore sono vietati.</li>
						<li>I veicoli a motore non possono accedere a spiagge e lungomare.</li>
						<li>E’ vietato accendere fuochi sulle spiagge.</li>
						</ul>

                    <h3>
                    	Stagione balneare
                    </h3>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>

				

					<p>
						Nel corso della stagione, i servizi di soccorso, sorveglianza e pronto soccorso vengono forniti nelle seguenti spiagge: North Beach Cliff, South Beach Cliff, Tel Baruch Beach, Hilton Beach, Gordon Beach, Frishman Beach, Borgashov Beach (che apre piu tardi a causa di lavori di rinnovo), Jerusalem Beach, Charles Clore Beach, Givat Aliyah Beach.
					</p>
					<p>
						<strong>
							Orario delle attivita:
						</strong>
					</p>

					<p>
					Maggio: 7.00-17.00 <br>
					Giugno: 7.00-18.00 <br>
					Luglio e agosto: 7.00-19.00 <br>
					Settembre e ottobre: 7.00-17.00 <br>
					Ispezioni e pulizia verranno eseguite in tutte le spiagge sopra menzionate dalle 7.00 fino alle ore serali.
					</p>

										<p>
											<strong>
												Prezzi indicativi:
											</strong>
										</p>
									<p>
					Pita o altro pane con hummus o insalata – 12 NIS <br>
					Bottiglia piccola di acqua minerale – 7 NIS<br>
					Ghiacciolo – 5 NIS<br>
					Sedia a sdraio per un giorno – 12 NIS <br>
					Sedia fissa per un giorno – 6 NIS <br>
					Ombrellone per un giorno – 6 NIS <br>
					</p>

         `,
      };
    },
  },

  {
    id: "Modern_And_Vibrant",
    bgImage: "/posts/bank/39/1.jpg",
    mobBgImage: "/posts/bank/39/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    // vidId: "MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    title: "Moderna e vivace",
    smltitle: "",
    html: function() {
      return {
        __html: `

                <br/>
                <h3>C’è tanto da vedere nel vivace centro di Gerusalemme</h3>
                           <p>
						Il centro di Gerusalemme è il cuore pulsante della moderna metropoli, ricco di vita notturna e con una vasta scelta di ristoranti e attrazioni culturali che possono competere con qualsiasi grande città del mondo.
					</p>
					<p>
						Questa zona è formata da diversi quartieri ed è ricca di bellissimi posti, come l’affascinante Nachlat Shiva, le vivaci Yafo Street e Ben Yehuda Street, ognuna con la sua diversa personalità e atmosfera. Assolutamente da non perdere!
					</p>
					<p>
						Il centro di Gerusalemme è composto da alcuni dei più affascinanti quartieri della città e ospita molte delle sue più straordinarie attrazioni. Per un’esperienza culturale imbattibile, potrai visitare una grande quantità di affascinanti musei, tra cui il famoso Museo di Israele, il Museo delle terre bibliche e il Museo delle scienze di Gerusalemme.
					</p>
					<h3>
						Mercato di Machane Yehuda
					</h3>
					<p>
						Scopri l’atmosfera senza pari di questo mercato e la sua varietà, capace di attrarre migliaia di turisti ogni giorno. Una volta terminato lo shopping e dopo la chiusura delle bancarelle di cibo, unisciti alla folla di giovani alla moda, sia locali che stranieri, che raggiungono il mercato per bere qualcosa e fare festa fino all’alba nei suoi bar, ristoranti e viali.
					</p>
					<h3>
						Nahalat Shiv’a
					</h3>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/modern-and-vibrant/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Questo affascinante quartiere con strade in ciottoli, situato nel cuore della città, offre un’eccellente selezione di negozi, ristoranti, bar e caffè all’aperto. Nahalat Shiva è anche la sede della Kikar Hamusica (Piazza della musica) – un vivace spazio all’aperto che propone musica dal vivo ogni giorno della settimana.
					</p>
					<h3>
						Yemin Moshe
					</h3>
					<p>
						Questo bellissimo quartiere, situato di fronte alle mura della città vecchia, fu originariamente costruito nel diciannovesimo secolo per affrontare il sovraffollamento della città. Il quartiere è la casa di artisti, scrittori e accademici: Yemin Moshe è famoso per il suo magnifico mulino e per le sue case in stile orientale, i suoi parchi verdi, il suo vivace centro musicale e il suo panorama mozzafiato.
					</p>
					<h3>
						Ein Kerem
					</h3>
					<p>
						Nascosto in una tranquilla vallata tra le montagne e le colline terrazzate di Gerusalemme, Ein Kerem è uno dei quartieri più pittoreschi di Gerusalemme. Con le sue tortuose strade lastricate, le sue bellissime case in pietra ornate da archi, le sue chiese e il suono delle campane che si diffonde nella sua aria pulita, Ein Kerem è ricco di fascino e bellezza, come se fosse un’isola al centro di una foresta verde.
					</p>
					
					
         `,
      };
    },
  },

  {
    id: "Jerusalem_After_Dark_Fun",
    bgImage: "/posts/bank/modern-and-vibrant/1.jpg",
    mobBgImage: "/posts/bank/modern-and-vibrant/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    title: "After Dark Fun in the Holy City",
    smltitle: "",
    html: function() {
      return {
        __html: `

                

					

					            <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
                              <p>To check it out, make your way to the City Center and explore the narrow streets just off Jaffa Street. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. Rivlin Street is a popular hangout for young people, while Shoshan Street and the surrounding area offers a more laid-back grown up vibe.</p>
                              <div class="img-wrapper">
						          <img src=${getImgUrl() +
                        "/posts/modern-and-vibrant/1.jpg"} class="img-responsive" />
					          </div>
                              <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing. </p>
                              <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session. </p>
                              <p>For a daytime change of pace head to the German Colony (Moshava) and, particularly, the neighborhood of Baka. Start at Beit Lechem Street where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up Emek Refaim Street or through HaMesila (Railway) Park until you reach The First Station – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>
            	

         `,
      };
    },
  },

  {
    id: "Jerusalem_Musts",
    bgImage: "/posts/bank/38/1.jpg",
    mobBgImage: "/posts/bank/38/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    // vidId: "WVGEqXhtipI",
    vidId: "FvAWuLQEOJw",
    title: "I must di Gerusalemme",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <br/>
				    <h3>Le 5 cose da fare e vedere in questa incantevole città</h3>
					<h3>
						Tour Segway
					</h3>
					<p>
						Questa adrenalinica maniera di visitare la città ti permetterà di immergerti nella bellezza di Gerusalemme da una prospettiva completamente nuova. I tour con i Segway partono da numerosi luoghi centrali, tra cui Armon HaNatziv, la Promenade (Talpiot Est), Yemin Moshe e dalla città vecchia, nonché dalla zona presso il Knesset e all’area dei musei.
					</p>
					<h3>
						La Prima stazione (Hatachana)
					</h3>
					<p>
						La Prima stazione si trova nel cuore di Gerusalemme, a metà strada tra la città vecchia e il centro della città, tra lo storico quartiere della Colonia tedesca e Yemin Moshe. In questo posto si trovava la prima stazione ferroviaria di Gerusalemme, costruita nel 1892; dopo essere stata sottoposta a un’opera di restauro e conservazione, la Prima stazione è stata riaperta e adibita a centro per l’intrattenimento ed è aperta tutti i giorni della settimana.
					</p>
					<h3>
						L’Ascensore del tempo
					</h3>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/jerusalem-must/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Se sei un fan delle corse avventurose, adorerai farti stimolare i sensi dall’Ascensore del tempo. Si tratta di un’esperienza interattiva che porta i visitatori in fantastici viaggi in luoghi affascinanti, il tutto in una sala ricca di effetti speciali dotata di poltrone che si muoveranno insieme a te.
					</p>
					<h3>
						Lo Zoo della Bibbia
					</h3>
					<p>
						Sviluppato lungo 62 acri, questo meraviglioso zoo a due livelli si sviluppa intorno a un vasto lago artificiale con tanto di cascate e piscine, circondato da vasti prati e da ombrosi luoghi per riposo. Adatto sia ai bambini che agli adulti, lo zoo ospita più di 200 specie, la maggior parte delle quali menzionate nella Bibbia e oggi in via d’estinzione. Ciò non significa che non ci siano anche animali più comuni: ci troverai persino dei pinguini! Nelle vicinanze dello zoo, inoltre, c’è anche un magnifico e gigantesco acquario aperto ai visitatori sia di giorno che di sera, nel quale sono stati riprodotti gli habitat marini del Mediterraneo, del Mar Rosso e tanto altro ancora.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/jerusalem-must/2.jpg"} class="img-responsive" />
					</div>
					<h3>
						Teddy Park
					</h3>
					<p>
						Questo parco è dedicato a Teddy Kollek, sindaco di Gerusalemme dal 1965 al 1995; il Teddy Park è divertente, bellissimo e ha un grande significato storico. Esso rappresenta un importante punto di incontro tra la vecchia e nuova Gerusalemme e include anche un laghetto dei desideri, una straordinaria meridiana originale, edifici storici restaurati e una fantastica fontana, intorno alla quale si svolgono spettacolari giochi di luce e suoni nel corso di bellissimi show serali.
					</p>

         `,
      };
    },
  },

  {
    id: "Destination_For_All",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: true,
    vidId: "QWA7qwsbbGY",
    title: "UNA META PER TUTTI",
    smltitle: "",
    html: function() {
      return {
        __html: `

         
			<p>Il numero di persone che visitano Israele sta registrando negli anni una crescita senza precedenti. Sempre più persone da tutto il mondo stanno realizzando il loro sogno di visitare Israele e Il Ministero del turismo si adopera per consentire la visita a chiunque, a prescindere da eventuali disabilità.</p>
            <p>Quando si tratta di accessibilità, Israele è leader mondiale in ambito legislativo. Dall'infrastruttura ai servizi, Israele è in grado di fornire un soggiorno senza problemi e sempre accogliente.</p>
            <p>Di seguito sono riportati tutti i link che possono essere di aiuto e assicurare un soggiorno senza difficoltà, piacevole e senza barriere.</p>

		    <div class="img-wrapper">
			   <img src=${getImgUrl() +
           "/posts/destination-for-all/1.jpg"} class="img-responsive">
			</div><br>
			<h2 class="ac-margin-bottom-20">ONG e viaggi</h3>
			<p><b>Keren Kayemeth LeIsrael</b></p>
			<p><u>Foreste, parchi e siti accessibili in Israele</u><br/>
			Negli ultimi anni, il Fondo Nazionale Ebraico ha lavorato per sviluppare strutture adeguate alle esigenze dei diversamente abili, nelle sue foreste e nei suoi parchi. Il nostro obiettivo è quello di aprire la natura a tutti i settori della popolazione, creando un ambiente attraverso il quale le persone con mobilità limitata possano spostarsi in modo sicuro e confortevole. Abbiamo anche fatto un passo avanti e portato la natura nel cortile delle scuole con progetti unici per quelle speciali. 
			<a href="//www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/" target="_blank">www.kkl-jnf.org</a>
		   </p>

		   <p><b>Autorità israeliana per i parchi e la natura</b></p>
		   <p>Negli ultimi anni, l’INPA ha lavorato per rendere i suoi siti accessibili alle persone con disabilità. In tutti i parchi nazionali, nelle riserve naturali, presso i siti archeologici e siti del patrimonio sono in corso lavori per migliorare l'accessibilità e fornire mezzi di accesso.<br/>
              L'INPA sta facendo tutto il possibile per aumentare il numero di visitatori con disabilità che possano visitare e godere dei siti, con tutte le attività che hanno da offrire.
              Sul sito Web è possibile trovare ulteriori informazioni e le mappe corrispondenti. 
              <a href="https://www.parks.org.il/en/accessibility/" target="_blank">www.parks.org.il</a></p>
			 
			<div class="img-wrapper">
			<img src=${getImgUrl() +
        "/posts/destination-for-all/2.jpg"} class="img-responsive">
		 </div><br>
			 <p><b>Yad Sarah per i turisti</b></p>
			 <p>Viaggiare all'estero presenta sfide speciali per le persone con bisogni speciali. Yad Sarah offre assistenza in grado di garantire una vacanza piacevole e rilassante a chi ha bisogni speciali e alla sua famiglia. Una volta definiti i piani con l’Ufficio turistico, il visitatore può rilassarsi, sicuro che tutta l’organizzazione è stata affidata alle abili mani di un rappresentante di Yad Sarah.</p>
		   
				<p> <u>Alcuni dei servizi disponibili:</u>:<br/>
				 
				• Prestito delle necessarie attrezzature mediche. La consegna in hotel o residence può essere organizzata ad costo modesto.<br/>
                • Allestimento della camera d'albergo per rendere il soggiorno più confortevole, compresi letti speciali, sedie, ecc.<br/>
                • Prestito di bombole / concentratori di ossigeno.<br/>
                • Trasporto in furgoni con blocco per sedie a rotelle, compresi i trasferimenti da e per l'aeroporto e le visite turistiche.<br/>
                • Raccomandazione di guide turistiche specializzate nella guida di viaggiatori con mobilità ridotta e bisogni speciali, compresi consigli su siti turistici di facile accesso.<br/>

				<br/>
				Il servizio personalizzato di Yad Sarah è disponibile, previo accordo con il Ministero del Turismo, per tutti i turisti con esigenze speciali.<br/>
		

		    Il servizio è disponibile in tutto lo stato di Israele.<br/>

			Per ulteriori dettagli o per organizzare un trasporto o un tour, si prega di contattare il Ministero del Turismo al numero   <a href="tel:+97226444382">+972-2-6444382</a> o di inviare una e-mail all’indirizzo: <a href="mailto:chaimvi@yadsarah.org.il">chaimvi@yadsarah.org.il</a></p>
			<div class="img-wrapper">
			<img src=${getImgUrl() +
        "/posts/destination-for-all/3.jpg"} class="img-responsive">
		 </div><br>
			<p><b>Access Israel</b></p>
			<p>Access Israel è un'organizzazione senza scopo di lucro che promuove l'accessibilità e l'inclusione delle persone con disabilità e degli anziani in tutte le sfere della vita. Access Israel è stata fondata nel 1999 da Yuval Wagner, un ex pilota dell’aviazione, in sedia a rotelle a seguito di un incidente in elicottero. Access Israel conduce vari progetti per raggiungere l'obiettivo di una società pienamente accessibile e inclusiva, quali progetti di sensibilizzazione nelle scuole, consulenza e corsi sull'accessibilità per le imprese, corsi di lingua dei segni, conferenze su vari argomenti in tema e altro ancora. Inoltre, Access Israel lavora per promuovere l'accessibilità nella legge israeliana, gestisce un centro reclami riguardanti l'accessibilità e organizza eventi di sensibilizzazione per il pubblico. 
				<a href="https://www.aisrael.org/?CategoryID=3030" target="_blank"> Turismo accessibile sul sito Web di Access Israel</a></p>

				<p><u>LOTEM</u> è la più grande organizzazione in Israele per attività di apprendimento all'aperto destinata a bambini con bisogni speciali tramite attività educative ed escursioni accessibili. Surin Hershko, un eroe di guerra gravemente ferito nell'operazione Entebbe nel 1976, è fondatore e presidente di LOTEM. La sua ispirazione per LOTEM viene dal cuore: "Dare ai bambini il diritto fondamentale di vivere la vita all'aperto è lo scopo della mia vita e questo mi riempie di grande gioia." Il sito principale, Emek HaShalom (Valle della Pace), è una fattoria di 16 ettari nel nord di Israele, vicino a Yokneam. Situata al centro di una splendida vallata, la fattoria è circondata dalla natura rigogliosa e da un tranquillo fiume. Fornisce un'esperienza pratica di apprendimento con un giardino didattico, frantoio, torchio e forno, nonché percorsi accessibili in sedia a rotelle.</p>
				<p><u>LOTEM</u> comprende il ruolo vitale che la vita all'aperto svolge nella vita degli israeliani e l'impatto incommensurabile che deriva dal fatto di rendere accessibile la società, non solo sull'individuo con un bisogno speciale, ma anche sulla sua famiglia e sulla comunità. Nell’ambito del suo lavoro teso a garantire che nessun membro della società venga lasciato indietro, LOTEM offre l'opportunità a bambini e adulti con bisogni speciali di apprendere e partecipare alle attività all'aperto in tutto il Paese. 
				<a href="https://www.lotem.net/?page_id=386" target="_blank">www.lotem.net</a></p>

				<h2 class="ac-margin-bottom-20 ac-margin-top-20"> Trasporti</h3>
				<p><b>Autorità aeroportuale israeliana</b></p>
				<p>Per legge, l'autorità aeroportuale israeliana è responsabile della fornitura dell'infrastruttura fisica per l'attività delle entità che forniscono servizi ai passeggeri assistiti. Tuttavia, secondo le norme di trasporto, la responsabilità della gestione dei passeggeri assistiti e del loro bagaglio, dal momento del loro ingresso nell'edificio del terminal o del loro sbarco dall'aeromobile, spetta alla compagnia aerea con cui i passeggeri volano. Il servizio effettivo presso l'aeroporto Ben Gurion è fornito da società di assistenza a terra. Il servizio comprende l'accompagnamento e l'assistenza ai passeggeri disabili attraverso le procedure di partenza e di arrivo. 
				<a href="https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx" target="_blank">www.iaa.gov.il</a></p>
				<p><b>Queste sono le società di assistenza a terra: </b></p>
				<p>Aero Handling: <a href="//www.aerohandling.com/" target="_blank">www.aerohandling.com</a><br/>
				Laufer Aviation: GHI <a href="//lauferghi.com/" target="_blank">www.lauferghi.com</a><br/>
				QAS: <a href="//www.qasisrael.co.il" target="_blank">www.qasisrael.co.il</a><br/>


				</p>
				<div class="img-wrapper">
				<img src=${getImgUrl() +
          "/posts/destination-for-all/4.jpg"} class="img-responsive">
			 </div><br>

				<p>Linea di assistenza del Ministero dei trasporti (chiamata locale) <a href="tel:5678*">5678*</a></p>
				
				<p><b>Trasporto pubblico</b></p>
				<p>Treni - se per salire e scendere dal treno hai bisogno dell’assistenza di un membro del personale della stazione ferroviaria, ti preghiamo di coordinare il tuo viaggio con le ferrovie israeliane in anticipo, attraverso il sito Web o attraverso la hotline di servizio su  <a href="tel:*5770">*5770</a>.</p>
				 
				<p><u>Le ferrovie israeliane </u> faranno del loro meglio per offrirti il miglior servizio possibile, anche se non hai coordinato il tuo viaggio in anticipo.</p>
				<p>In ogni caso, ricorda di coordinare in anticipo i viaggi tra le 20:00 di sera e le 06:00 del mattino successivo, nonché i viaggi che si svolgono il sabato sera.</p>
				<p><u>Autobus</u>: tutte le linee di autobus all'interno della città sono adattate per fornire un servizio a tutti. I pullman nazionali sono parzialmente accessibili.</p>
				<p><u>Taxi </u>: è raro prendere un taxi accessibile senza averlo prenotato. Si consiglia di preordinare da  <a href="https://www.aisrael.org/?CategoryID=2657&ArticleID=64179" target="_blank">questo elenco.</a>.</p>


				<h2  class="ac-margin-bottom-20 ac-margin-top-20">Alloggio</h3>
				<p>Alloggio </p>
				<div class="img-wrapper">
				<img src=${getImgUrl() +
          "/posts/destination-for-all/5.jpg"} class="img-responsive">
			 </div><br>
				
				
				<div id="ac-left-nav">
				<h2 class="ac-margin-bottom-20 pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Accessibility for those with special needs at the beaches:</span>
								</h3>
				<ul id="chaptersList" class="list-unstyled xs-mb-0">
					
						<!-- ngRepeat: chapter in Guide.Chapters -->
						<li data-show="1" class="ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt nounderline  ng-binding reforma-bold">Northern District</span>						                  
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
						
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<li data-show="2" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Haifa District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<li data-show="3" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Central District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
					
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<div class="clear show-on-mobile"></div>
						<li data-show="4" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Tel Aviv District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
					
						</li>
						<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show="5" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Southern District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
					
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<div class="clear"></div>
					</ul>
				</div>

				<div id="res">
					<!-- ac part -->
					<div class="ac-part ac-part-1 ac-part-active">

						<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Northern District</span>
								</h3>
							</div>

							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->

						<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
							<div class="position-relative col-lg-10 lg-p-0">
								<!-- ngIf: CurrChapter.Image.ClickURLRef -->

								<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
								</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
								<!--Image desc-->
								<div>
									<div class="position-absolute">
										<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
									</div>
									<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
										<span class="small-txt ng-binding"></span>
										<span class="small-txt ng-binding"></span>
									</div><!-- end ngIf: CurrChapter.Image -->
								</div>
							</div>
						</div><!-- end ngIf: CurrChapter.Image -->
													<!-- End IMAGE TAG  ------->

													<div class="row row-gov no-gutters">
														<!--Content Text-->
														<div id="GuidesChapterContent-1" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
							<tbody>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Kineret Municipal Unio</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking&nbsp;&nbsp; &nbsp;</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Tzinbari</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>No</td>
									<td>No</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Berniki</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>At the nearby Shikmim beach</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Shikmim</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Hukok</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>No</td>
									<td>No</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Amnon</td>
									<td>Yes&nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>No</td>
									<td>No</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Kinar</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Doga</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>Closed</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Tze’elon</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Kursi</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>At the nearby Levanon beach</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Levanon</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Halukim</td>
									<td>At the nearby Levanon beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>At the nearby Levanon beach</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Shizaf</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Dugit – Golan</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Gofra</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Tiberias</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Guy</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Galei Kineret - Rimonim</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Leonardo Pacific</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>Closed for renovations</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Coco Hot / Holiday Inn</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Jordan Valley Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Ein Gev Vacation</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Ginnosar</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Migdal Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Restal Magdala</td>
									<td>Yes</td>
									<td>No</td>
									<td>&nbsp;</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td class="rtecenter" colspan="6"><strong>Mateh Asher Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Banana Beach Achziv</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Nahariya</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Sokolov</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Galil Central</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Acco</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Argaman Central</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Hatmarim</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
							</tbody>
						</table></div></div>

						<p>&nbsp;</p>
						</div>

														<!--Chapters/Collapse-->
														<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
															<!-- ngRepeat: collapse in CurrChapter.Collapses -->
														</div>

														<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
														<!--End of Chapters/Collapse-->

														<div class="col-12 xs-mb-25 lg-mb-30">
															<!-- Files for Download-->
															<!-- Files for Download-->
						<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

															<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

																<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																	<!-- horizontal line -->
																	<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																		<div class="horizontal-line"></div>
																	</div>
																</div><!-- end ngIf: Guide.Chapters.length > 1 -->

																<!--arrows subject nav  דפדוף-->
																<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																	<!--  לדף הקודם -->
																	<!-- ngIf: CurrChapterindex > 0 -->

																	<!--  לדף הבא -->
																	<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																		<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																			<span class="small-txt gray-txt width-100">Next page:</span>
																			<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																		</div>
																		<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																	</div>
																</div>
															</div><!-- end ngIf: !isOnPrintMode -->
														</div>
													</div>
												</div>
											</div>

					</div>
					<!-- ac- part -->

					<!-- ac part 2 -->
					<div class="ac-part ac-part-2">
					<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Haifa District</span>
						</h3>
					</div>

					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->

<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
<div class="position-relative col-lg-10 lg-p-0">
	<!-- ngIf: CurrChapter.Image.ClickURLRef -->

	<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
	</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
	<!--Image desc-->
	<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
	</div>
</div>
</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->

						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-2" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table align="left" cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
<tbody>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Kiryat Yam</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zevulun</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Haifa</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Zamir 1</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zamir 2</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Neot Kiryat Haim Central</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Bat Galim 1</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Bat Galim 2</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Hof Hacarmel Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Dor Central 2</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Neve Yam</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Aqueduct</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Jisr a-Zarka Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Jisr</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Hadera</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Kfar Yam&nbsp;</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Olga Central 2</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
</tbody>
</table></div></div>

<p>&nbsp;</p>
</div>

							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>

							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->

							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->

									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> Previous page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Northern District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->

										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">Next page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
					</div>
					<!-- end ac part-2 -->

					<!-- ac-part-3 -->
					<div class="ac-part ac-part-3">
												<div ng-include="chapterItem" class="row row-gov ng-scope">
												<!-- Sub Title -->
												<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
													<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
														<!-- ngIf: Guide.ShowChaptersIndex -->
														<span class="ng-binding">Central District</span>
													</h3>
												</div>
						
												<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
													<!-- IMAGE TAG  ------->
													<!--- Image-->
						
						<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
							<div class="position-relative col-lg-10 lg-p-0">
								<!-- ngIf: CurrChapter.Image.ClickURLRef -->
						
								<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
								</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
								<!--Image desc-->
								<div>
									<div class="position-absolute">
										<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
									</div>
									<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
										<span class="small-txt ng-binding"></span>
										<span class="small-txt ng-binding"></span>
									</div><!-- end ngIf: CurrChapter.Image -->
								</div>
							</div>
						</div><!-- end ngIf: CurrChapter.Image -->
													<!-- End IMAGE TAG  ------->
						
													<div class="row row-gov no-gutters">
														<!--Content Text-->
														<div id="GuidesChapterContent-3" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
							<tbody>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Emek Hefer Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Michmoret – Station number 1</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Michmoret – Station number 2</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>Joint with number 1</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beit Yannai</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>NeUrim Beach</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Netanya</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Kiryat Tzanz</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>HaOnot Beach</td>
									<td>אין חניה בחוף עצמו</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Ampi Beach</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Herzl</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Sironit Beach A</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Sironit Beach B</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Argaman Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Poleg Beach</td>
									<td>Yes</td>
									<td>Bathrooms only</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Hof Hasharon Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Shefayim (Ga’ash)</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Rishon Le-Zion</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Beach number 1 – Hakachol (Blue) Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beach number 2 – Neve Hof Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Beach number 3 – Hofit Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beach number 4 – Tel Yonah Beach</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Beach number 5 – Hayeladim (Children’s) Beach</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beach number 6 – separate beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td class="rtecenter" colspan="6"><strong>Gan Raveh Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Palmahim Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
							</tbody>
						</table></div></div>
						
						<p>&nbsp;</p>
						</div>
						
														<!--Chapters/Collapse-->
														<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
															<!-- ngRepeat: collapse in CurrChapter.Collapses -->
														</div>
						
														<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
														<!--End of Chapters/Collapse-->
						
														<div class="col-12 xs-mb-25 lg-mb-30">
															<!-- Files for Download-->
															<!-- Files for Download-->
						<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
						
															<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
						
																<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																	<!-- horizontal line -->
																	<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																		<div class="horizontal-line"></div>
																	</div>
																</div><!-- end ngIf: Guide.Chapters.length > 1 -->
						
																<!--arrows subject nav  דפדוף-->
																<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																	<!--  לדף הקודם -->
																	<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
																		<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
																		<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
																			<span class="small-txt gray-txt width-100"> Previous page:</span>
																			<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																		</div>
																	</div><!-- end ngIf: CurrChapterindex > 0 -->
						
																	<!--  לדף הבא -->
																	<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																		<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																			<span class="small-txt gray-txt width-100">Next page:</span>
																			<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
																		</div>
																		<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																	</div>
																</div>
															</div><!-- end ngIf: !isOnPrintMode -->
														</div>
													</div>
												</div>
											</div>
					</div>
					<!-- end ac-part-3 -->

					<!-- ac-part-4 -->
					<div class="ac-part ac-part-4">
					<div ng-include="chapterItem" class="row row-gov ng-scope">
			<!-- Sub Title -->
			<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
				<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
					<!-- ngIf: Guide.ShowChaptersIndex -->
					<span class="ng-binding">Tel Aviv District</span>
				</h3>
			</div>

			<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
				<!-- IMAGE TAG  ------->
				<!--- Image-->

<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
<div class="position-relative col-lg-10 lg-p-0">
<!-- ngIf: CurrChapter.Image.ClickURLRef -->

<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
<!--Image desc-->
<div>
<div class="position-absolute">
	<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
</div>
<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
	<span class="small-txt ng-binding"></span>
	<span class="small-txt ng-binding"></span>
</div><!-- end ngIf: CurrChapter.Image -->
</div>
</div>
</div><!-- end ngIf: CurrChapter.Image -->
				<!-- End IMAGE TAG  ------->

				<div class="row row-gov no-gutters">
					<!--Content Text-->
					<div id="GuidesChapterContent-4" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
<tbody>
<tr style="background-color: rgb(255, 255, 255);">
<td class="rtecenter" colspan="6"><strong>Municipality of Herzliya</strong></td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td><strong>Name of beach</strong></td>
<td><strong>Parking</strong></td>
<td><strong>Bathrooms and showers</strong></td>
<td><strong>Access to shade</strong></td>
<td><strong>Access to water</strong></td>
<td><strong>Bathing chairs for the disabled</strong></td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Nof Yam</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Hasharon&nbsp;&nbsp; &nbsp;Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Zevulun</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Acadia North Beach&nbsp;&nbsp; &nbsp;</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Acadia South Beach</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Acadia South Beach – Disabled</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Separate beach</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td class="rtecenter" colspan="6"><strong>Municipality of Tel Aviv - Jaffa</strong></td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td><strong>Name of beach</strong></td>
<td><strong>Parking</strong></td>
<td><strong>Bathrooms and showers</strong></td>
<td><strong>Access to shade</strong></td>
<td><strong>Access to water</strong></td>
<td><strong>Bathing chairs for the disabled</strong></td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>HaTzuk Beach – Station number 1</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Tel Baruch Beach – Station number 1</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Nordau (Metzitzim) Beach</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Nordau separate beach</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Gordon</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Bograshov</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Allenby (Jerusalem)</td>
<td>No</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Charles Clore</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Jaffa – Givat HaAliyah</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Hilton North</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>HaTzuk Beach – Station number 2</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Frishman</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Aviv Beach</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td class="rtecenter" colspan="6"><strong>Municipality of Bat Yam</strong></td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td><strong>Name of beach</strong></td>
<td><strong>Parking</strong></td>
<td><strong>Bathrooms and showers</strong></td>
<td><strong>Access to shade</strong></td>
<td><strong>Access to water</strong></td>
<td><strong>Bathing chairs for the disabled</strong></td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>HaSela – Station number 1</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>HaSela – Station number 2</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>HaSela – Station number 3</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Sample Beach</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Riviera</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Separate beach</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Tayo</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
</tbody>
</table></div></div>

<p>&nbsp;</p>
</div>

					<!--Chapters/Collapse-->
					<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
						<!-- ngRepeat: collapse in CurrChapter.Collapses -->
					</div>

					<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
					<!--End of Chapters/Collapse-->

					<div class="col-12 xs-mb-25 lg-mb-30">
						<!-- Files for Download-->
						<!-- Files for Download-->
<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

						<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

							<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
								<!-- horizontal line -->
								<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
									<div class="horizontal-line"></div>
								</div>
							</div><!-- end ngIf: Guide.Chapters.length > 1 -->

							<!--arrows subject nav  דפדוף-->
							<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
								<!--  לדף הקודם -->
								<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
									<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
									<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
										<span class="small-txt gray-txt width-100"> Previous page:</span>
										<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
									</div>
								</div><!-- end ngIf: CurrChapterindex > 0 -->

								<!--  לדף הבא -->
								<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
									<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
										<span class="small-txt gray-txt width-100">Next page:</span>
										<span class="reforma description-txt blue-txt width-100 ng-binding">Southern District</span>
									</div>
									<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
								</div>
							</div>
						</div><!-- end ngIf: !isOnPrintMode -->
					</div>
				</div>
			</div>
		</div>
					</div>
					<!-- end ac-part-4 -->

					<!-- ac-part-5 -->
					<div class="ac-part ac-part-5">
					<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Southern District</span>
						</h3>
					</div>

					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->

<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
<div class="position-relative col-lg-10 lg-p-0">
	<!-- ngIf: CurrChapter.Image.ClickURLRef -->

	<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
	</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
	<!--Image desc-->
	<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
	</div>
</div>
</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->

						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-5" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
<tbody>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Ashdod</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Mei Ami Beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Lido</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Oranim</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>Yes</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Hakshatot</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Rova K</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Riviera</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td colspan="6" style="text-align: center;"><strong>Hof Ashkelon Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Nitzanim</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zikim</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Ashkelon</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Bar Kochva North</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Bar Kochva South</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Delila North</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Delila South</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Ashkelon National Park Beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>לא</td>
		<td>לא</td>
		<td>לא</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Tamar Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Mazor Springs</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Meridian Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Hod Hotel Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Tzel Harim</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Crown Plaza Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Lot</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Lot’s Wife</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Ein Bokek South</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Daniel Hotel Beach</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Solarium Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Isrotel Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>International Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Leonardo Plaza Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zohar Springs (North)</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Leonardo Club Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Eilat&nbsp;&nbsp; &nbsp;</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><br>
		Separate beach</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Herod’s beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><br>
		Northwestern Beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
</tbody>
</table></div></div>

<p>&nbsp;</p>
</div>

							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>

							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->

							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->

									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> Previous page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->

										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="true">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">Next page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding"></span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
					</div>
					<!-- end ac-part-5 -->

				</div>
				<div class="img-wrapper">
				<img src=${getImgUrl() +
          "/posts/destination-for-all/6.jpg"} class="img-responsive">
			 </div><br>
					
					`,
      };
    },
  },

  {
    id: 16,
    bgImage: "/posts/bank/34/1.jpg",
    ctg: "eilat",
    isVid: true,
    vidId: "yXzhH92kREg",
    mobBgImage: "/posts/bank/34/M.jpg",
    title: "NEGEV MAJESTIC DESERT",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Action adventures in the desert sun. With so much to see and do, there is never a dull moment in the Negev</h3>

					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/yXzhH92kREg/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<h3 class="negev-secondary-title">
								 The Negev Desert - Pure Magic Desert
							</h3>


							\n

                            <!--negev text-->

                            <p>
								The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.
							</p>
							<p>
								Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.
							</p>
							<p class="p-margin">
								There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.
							</p>

							<h3>
                                The Israeli desert is special for the following reasons:
                            </h3>

							<ul class="p-margin">
							    <li>
										<b>The desert is very near:</b> just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).
										Starting from November, there will be direct flights from Europe and Russia to Ovda airport including Ryanair, Wizzair, and SAS.
							    </li>
                                <li>
                                        <b>Easy to Hike and Bike:</b> There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:<br>
                                        <a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a>
                                        <a href="//www.en.aravaway.co.il " target="_blank">www.en.aravaway.co.il</a>
							    </li>
							    <li>
                                        <b>Cordial local population:</b> The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.
							    </li>
							    <li>
                                        <b>Tourists Activities:</b> Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.
							    </li>
							    <li>
                                        <b>Magnificent landscapes:</b> Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety<br>
                                        <ul>
                                        	<li>
                                        		There are spectacular sand dunes in the north.
                                        	</li>
                                        	<li>
                                        		The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.
                                        	</li>
                                        	<li>
                                        		In the east, one experiences the African desert with wide savannas and acacia trees.
                                        	</li>
                                        	<li>
                                        		To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.
                                        	</li>
                                        </ul>
                                        During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.
										Many tourists decide for to stay for 2 or 3 days in each region of the Negev.

							    </li>
							    <li>
                                        <b>The Negev is very safe to travel.</b> In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.
							    </li>
							</ul>
							<h3>
							    More information and tips for accommodation and recommendations:
							</h3>
							<p>
							   <a href="//www.negevtour.co.il/homepage/accommodation/?lang=en" target="_blank">www.negevtour.co.il</a><br>
							   <a href="https://en.aravaway.co.il/business/category/1/" target="_blank">www.en.aravaway.co.il</a>
							</p>
							<p class="p-margin">
							   <a href="//goisrael.de/taxonomy/term/85" target="_blank">Travel deals</a><br>

							</p>




                            <!--Negev - Transportations-->

							<h3>
							    NEGEV - LOCATION AND APPROACH
							</h3>
							<p class="p-margin">
							   Landing at the airports of Ovda or Eilat with the  onward journey to Mitzpe Ramon or Sde Boker:
							</p>

							<h3>
							   Public means of transportation:
							</h3>
							<p>
								Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p>
								Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.
							</p>
							<p>
								Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p class="p-margin">
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Bus service </a><br>
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Shuttle service from Ovda Airport </a>
							</p>
							<h3>
							   Car rental in Eilat, Mitzpe Ramon and Be'erSheva:
							</h3>
							<p>
								There a multiple option in renting a car in these cities.
                                There is a choice of international and Israeli companies.

							</p>
							<p class="p-margin">
								Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon

							</p>
							<h3>
							   Public means of transportation:
							</h3>
							<p>
								Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.
								<a href="//www1.rail.co.il/EN/Pages/Homepage.aspx" target="_blank">Train from Ben Gurion or Tel Aviv to Be'erSheva.</a>
                            </p>
                            <p>
								From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes).
                                Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.
                            </p>
                            <p class="p-margin">
								More information about the public means of transportation is given <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">here</a> or <a href="//www.egged.co.il/HomePage.aspx">here</a>
                            </p>


                             <!--NEGEV DESERT-don't miss-->








                            <h3 class="margin-h">
                                 NEGEV ROAD DISTANCES
                            </h3>
							<table>
							  <tr>
							    <th></th>
							    <th>Tel Aviv</th>
							    <th>Jerusalem</th>
							    <th>Bee'r Sheva</th>
							    <th>Eilat</th>
							  </tr>
							  <tr>
							    <td class="place-table"> <strong>Old Town <br class="show-on-mobile"> Beer Sheva</strong></td>
							    <td>113 Km</td>
							    <td>122 Km</td>
							    <td></td>
							    <td>232 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Tel Arad</strong></td>
							    <td>134 Km</td>
							    <td>144 Km</td>
							    <td>40 Km</td>
							    <td>229 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ben-Gurion's House <br class="show-on-mobile">in Sde Boker</strong></td>
							    <td>162 Km</td>
							    <td>171 Km</td>
							    <td>49 Km</td>
							    <td>185 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ramon Crater</strong></td>
							    <td>210 Km</td>
							    <td>192 Km</td>
							    <td>97 Km</td>
							    <td>141 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Hai Bar Wildlife <br class="show-on-mobile"> reserve Yotvata</strong></td>
							    <td>323 Km</td>
							    <td>288 Km</td>
							    <td>202 Km</td>
							    <td>35 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Timna Park</strong></td>
							    <td>330 Km</td>
							    <td>294 Km</td>
							    <td>208 Km</td>
							    <td>30 Km</td>
							  </tr>
							</table>

                            <h3>
								NEGEV DESERT - DON'T MISS
							</h3>

							 <h3>
                                Ramon Crater
                            </h3>

                            <p>
                                At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon.
								Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.
								Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.
								The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/7.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
                                Timna Park
                            </h3>

                            <p>
                               15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.
                               With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/9.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h2 class="title-to-play">
								CLICK TO PLAY: Timna Park - An Exhilarating Desert Adventure
							</h3>
							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

						

                            <h3>
							    Sandboarding in the desert
							</h3>
							<p>
								An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?
							</p>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/1.jpg"} class="img-responsive" />
							</div>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/2.jpg"} class="img-responsive" />
							</div>

							<!--<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/3.jpg"} class="img-responsive" />
							</div>-->

							<h3>
							    Negev at night
							</h3>
							<p>
								The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/4.jpg"} class="img-responsive" />
							</div>

							<h3>
							    Sunrise at Masada
							</h3>
							<p>
								Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/6.jpg"} class="img-responsive" />
							</div>


							<h3>
                                NEGEV - ISRAEL’S MAJESTIC DESERT
                            </h3>
                            <h3>
                                Where Adventure and Inspiration Await
                            </h3>
                            <p>
                              An ideal destination for travelers who love adventure in the great outdoors.
							  The south of Israel is sparsely populated, but packed with fascinating sites and activities.

                            </p>
                            <p class="p-margin">
                                With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset.
								A desert but definitely not deserted, there is so much to see and do here – there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert.
								Simply put, this majestic Southern region is one of the country’s greatest assets and an absolute must on the itinerary.

                            </p>


							<h3>
                                Sde Boker
                            </h3>

                            <p class="p-margin">
                                A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50’s.
                                Sde Boker is renowned as the home of David Ben Gurion, Israel’s first Prime Minister whose home is now a museum open to the public.


                            </p>

                            <h3>
                                Vidor Center
                            </h3>

                            <p class="p-margin">
                                A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.
                            </p>



                            <h3>
                                Nevatim
                            </h3>

                            <p class="p-margin">
                               A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world.
                               The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.
                            </p>

                            <h3>
							   MidBurn Festival
							</h3>

							<p class="p-margin">
								Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.
							</p>

							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

							<br>

                            <h3>
                                The Bedouin Experience
                            </h3>

                            <p>
                               The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.
                               A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/8.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
                                The Culinary Queens of Yeruham
                            </h3>

                            <p class="p-margin">
                              For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham – a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors.
                              Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.

                            </p>
                            <h3>
                                The Old City of Be'er Sheva
                            </h3>

                            <p class="p-margin">
                               Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.
                            </p>
                            <h3>
                                Carasso Science Park
                            </h3>

                            <p>
                               New in the Old City of Be’er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel.
                               Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.

                            </p>
                            <h3>
                                Arad
                            </h3>

                            <p class="p-margin">
                               Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style.
                               With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.

                            </p>


							<h3>
                               Yotvata Hai-Bar
                            </h3>

                            <p>
                               The Yotvata Hai-Bar Nature Reserve is the area’s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators’ center with its live predators and small desert animals, a Nocturnal animal’s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/10.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>


							<h3>
                               Extreme Adventures
                            </h3>

                            <p>
                               The south of Israel is a total dream destination for adventure-hungry travelers.  Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/11.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
							    Camel rides
							</h3>
							<p>
								A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/5.jpg"} class="img-responsive" />
							</div>


                            <!--NEGEV - וPDATED TEXT SITES-->

                            <h3>
                                EVENTS IN THE NEGEV: CALENDAR
                            </h3>
						


							<div class="row-1 mounth-row">
					             <div class="mounths active">
					            <p id="myHeader1" data-div="newboxes1" onClick="toggleMounth(event)" href="">January <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid">
					            <p id="myHeader2" data-div="newboxes2" onClick="toggleMounth(event)" href="">February <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes3" onClick="toggleMounth(event)" href="">May <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes4"onClick="toggleMounth(event)"  href="">June <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes5" onClick="toggleMounth(event)" href="">July <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>
					        </div>



					        <div class="row-2 mounth-row">
					          <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes6" onClick="toggleMounth(event)" href="">August <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes7"onClick="toggleMounth(event)"  href="">October <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes8" onClick="toggleMounth(event)" href="">November <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid" >
					            <p id="myHeader3" data-div="newboxes9" onClick="toggleMounth(event)" href="">December <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					        </div>



					         <div class="newboxes" id="newboxes1" style="    display: block;"> <!--Jen-->
					                Round The Arava Race - The 63-kilometer bike race named after Yoni Friedman offers a breathtaking desert landscape, endless expanses of nature, the power of spirituality, serenity and serenity and a connection to an extraordinary sporting experience. The starting point and end of the race are in Moshav Hatzeva.<br>
					                <a href="https://www.arava-active.co.il/MenuDefault.aspx?id=4240" target="_blank">www.arava-active.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes2"><!--Feb-->
					                Darom Adom is an annual festival held during the Anemone flower's blossoming season in the northern Negev region. The festival offers agricultural tours, farmers' markets, and countryside lodging, as well as sports activities such as marches, race, bike tours through the red fields of the northern Negev and other activities such as artistic performances. The local tourism association "Shikma Besor" is responsible for the festival and its yearly activities.<br>
					                <a href="//daromadom.habsor.co.il/" target="_blank">www.daromadom.habsor.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes3"><!--May-->
					                The cherry festival takes place in the Yatir Forest, which is the largest forest in Israel where large orchards of orchards grow, and is a 5-minute drive from Be'er Sheva. The event includes a cherry harvest for the whole family, sweet and sour snacks, baking pita bread, sheep herding, cheese gibbon, local farmers' market, klezmer melodies, climbing wall, omega and many other activities for the whole family.<br>
					                <a href="//kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/" target="_blank">www.kinderland.co.il</a>
					        </div>

					        <div class="newboxes" id="newboxes4"><!--June-->
					                Experience the magic of Ramadan nights in Rahat - when the night becomes a day and the streets are bustling with life. Join an unforgettable tour at the most special time of the year, giving a unique glimpse into Bedouin culture in Rahat. Meet the authentic dishes, absorb the fragrances of spices and roasted coffee, discover the secrets of Rahat from local guides and enjoy street performances, Debka music and more.<br>
					                <a href="//ramadan-nights.co.il/" target="_blank">www.ramadan-nights.co.il</a><br>
					                The Cinema South Festival, initiated by the School of Sound and Screen Arts at Sapir Academic College, started in 2002 with an emphasis on student films. Within a few years, however, became the festival an international film festival that provides a central stage for Israeli cinema, international quality and radical cinema. The festival takes place every year in June for five full days in various locations throughout the northern and western Negev. This is a festival that opens its doors to anyone, free of charge. The South Cinema Festival is produced from a unique cultural agenda relevant to the place where it was created.<br>
					                <a href="//csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html" target="_blank">www.csf.sapir.ac.il</a>
					        </div>
					        <div class="newboxes" id="newboxes5"><!--July-->
					               The International Fringe Festival Beer Sheva is a multi-disciplinary festival that crosses audiences and ages and constitutes a quality stage for the best Israeli and international artists from the fields of theater, dance, music, street art and the plastic arts. The festival is considered one of the major fringe events in Israel and the largest and leading cultural festivals in the south of the country. The festival was recently received by the EFFE (European Festivals Association) and is gaining a reputation as a prestigious event.<br>
					               <a href="https://www.iffb7.com/" target="_blank">www.iffb7.com</a>
					        </div>
					        <div class="newboxes" id="newboxes6"> <!--Aug-->
					               Negev Of Stars - Like every summer, the Earth passes through the shrapnel left behind by the comet SWIFT-TATTLE. These fragments penetrate our atmosphere and create a spectacular view of "shooting stars". During this time in the Negev celebratethe people the amazing experience of the Perseid Meters, a number of astronomical events - a joint observation of the meteor shower, observation points with elaborate telescopes, lectures and many other activities.
					        </div>
					        <div class="newboxes" id="newboxes7"><!--Oct-->
					                The Tamar Festival is a combination of the ideal Israeli soundtrack and the spectacular vista of Masada and the Dead Sea region. The extraordinary experience takes place with concerts over 4 days at various locations and at different times over 24 hours, when the audience ventures out to the country's most extraordinary sites and landscapes.<br>
					                <a href="//www.tamarfestival.com/" target="_blank">www.tamarfestival.com</a><br>
					                Desert Magic Festival - The first Bedouin festival: A variety of experiential activities for the whole family that provide an authentic glimpse into the ancient Bedouin tradition.<br>
					                <a href="//www.kesem-hamidbar.co.il/" target="_blank">www.kesem-hamidbar.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes8"><!--Nov-->
					                The Arava Film Festival is a unique event that has been going on for several years every November in the heart of the Arush Nature Reserve, adjacent to Tzukim. The films at the festival are screened in the evening and in the night, under the stars in the open air. They are the first line of international production that has been screened at world film festivals in the last year. Among the films of the festival are films for children and teenagers, as well as short films produced and filmed during the past year in the Arava. The films are screened on a giant screen and the audience can relax on a spacious and surprisingly comfortable platform, which was built especially for this purpose in the valley between the mountain cliffs of the eastern Negev.<br>
					                <a href="https://www.aravaff.co.il/" target="_blank">www.aravaff.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes9"><!--Dec-->
					                Ben-Gurion's march has been taking place for more than 20 years, at the initiative of the Ramat Negev Regional Council, following the daily sporting march of the first Prime Minister, David Ben-Gurion, during his stay in Kibbutz Sde-Boker. The march takes place on three tracks – a short track for families (7 km), a medium pathway (15 km) and a long one (22 km).<br>
					                <a href="//www.zaadatbg.org.il/" target="_blank">www.zaadatbg.org.il</a><br>
					                 Docaviv Negev - Docaviv, the Tel Aviv International Documentary Film Festival, is the largest film festival in the city of Tel Aviv, and the only festival in Israel dedicated in its entirety to documentary films. In order to expose as wide an audience as possible to documentary work, the NPO also organizes a regional festivals: Docaviv Negev, held in Yeruham, as well as dozens of documentary film screenings at cultural centers located throughout the country. Each year, Docaviv NPO awards Israel’s largest prize for an original Israeli documentary production, and alongside it, prizes for the Best International Film Award, prizes for outstanding student filmmakers, and an additional prize within the Depth of Field framework, for innovative, inspiring documentary films from around the world.<br>
					                <a href="//www.docaviv.co.il/" target="_blank">www.docaviv.co.il</a>
					        </div>




                            <a href="//graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#" target="_blank">FOR MORE IMFORMATION CLICK HERE </a>


         `,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: 41,
    bgImage: "/posts/bank/family/1.jpg",
    mobBgImage: "/posts/bank/family/M/1.jpg",
    title: "VIAGGIARE CON I BAMBINI",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Divertimento non stop per tutta la famiglia</h3>

              		
		
              		
		
              		            <p> Visitare Tel Aviv e Gerusalemme con i tuoi bambini sarà un’esperienza fantastica. Entrambe le città sono molto attente ai bisogni delle famiglie: dalla natura alla cultura, ci sono tantissime fantastiche attrazioni ed entusiasmanti attività. </p>

                                <p> Con i suoi 300 giorni di sole all’anno, le splendide spiagge di Tel Aviv offrono una fantastica combinazione di sole e divertimento e il lungomare di Tel Aviv è un ottimo posto per passeggiare con i bambini, fare una corsa o girare in bici o in scooter. Assicuratevi di visitare i tanti musei della città e di assistere agli spettacoli di strada, trascorrendo una bellissima giornata all’aperto nell’HaYarkon Park. </p>
 

                                <p> Una visita a Gerusalemme scatenerà la fantasia dei più piccoli grazie ai suoi pittoreschi vicoli, inimitabili musei e alla sua affascinante storia. Con i suoi parchi ricchi d’ombra, fontane, spettacoli e mostre dedicate ai bambini, troverai sicuramente qualcosa adatto a tutti. </p>

                                <p> La grande varietà di fantastiche attività garantisce una visita a Tel Aviv e Gerusalemme indimenticabile per tutta la famiglia. </p>
                                <p>  Gerusalemme e Tel Aviv sono destinazioni perfette per tutte le famiglie alla ricerca di divertimento ed emozioni.  Entrambe le città offrono tantissime, fantastiche attività e attrazioni da vivere insieme a tutta la famiglia. Ecco solo alcuni dei favolosi modi in cui potrai vivere una fantastica esperienza con la tua famiglia a Gerusalemme e Tel Aviv: tutto quello che dovrai fare è scegliere quella giusta e...partire! </p>
                                <div class="img-wrapper">
			                        <img src=${getImgUrl() +
                                "/thingsToDo/posts/35/1.jpg"} class="img-responsive" />
		                        </div>
                              <h3>
                                              Tel Aviv
                              </h3>
                              <p><strong>“Luna Park": </strong>Un fantastico parco divertimenti nel cuore della città che offre tantissime divertenti attrazioni e giostre per tutta la famiglia. Il Luna Park si trova proprio di fronte al meraviglioso Hayaron Park, il polmone verde di Tel Aviv.
                              <p><strong> HaYarkon Park:</strong> Il tranquillo Yarkon Park, situato appena fuori questa frenetica città, offre bellissimi spazi verdi, la possibilità di girare in barca sul fiume, pedalare in bicicletta sulle piste ciclabili, praticare sport e tante altre attività per tutta la famiglia. Goditi un picnic con vista sullo stupefacente skyline di Tel Aviv.
                              <p><strong> Mongolfiera:</strong> Dopo esserti rilassato nel meraviglioso HaYarkon Park, vivi l’esperienza mozzafiato di ammirare la bellissima Tel Aviv come non l’hai mai fatto prima, fluttuando sopra Yarkon Park per un momento romantico o di divertimento in famiglia.
                              <p><strong> Osservatorio:</strong> Durante la tua permanenza a Azrieli, assicurati di visitare il meraviglioso osservatorio situato all’ultimo piano, con una vista a 360° su Tel Aviv che i più piccoli non dimenticheranno facilmente.  
                              <p><strong> Il Planetario: </strong>Grazie alla sua divertente introduzione all’astronomia, sarai trasportato nello spazio da mostre interattive, sedili rotanti e momenti informativi adatti a tutta la famiglia.
                              <p><strong> Safari</strong>: Con la più grande varietà di animali in tutto il Medio Oriente, potrai passare una bellissima giornata nella natura a soli 15 minuti dal centro di Tel Aviv, dove potrai goderti tutte le altre magnifiche attrazioni della città.
                              <p><strong> HaTachana, la vecchia stazione ferroviaria di Tel Aviv:</strong> Una delizia per tutta la famiglia, l’edificio della vecchia stazione ferroviaria ha qualcosa per tutti i gusti: ristoranti, attività per bambini, gallerie d’arte, spettacoli di strada e persino la possibilità di fare un piccolo viaggio in carrozza.
                              <p><strong> Porto di Tel Aviv:</strong> Respira l’aria di mare e goditi l’atmosfera del meraviglioso lungomare, mangia qualcosa di buono e gustati i bellissimi spettacoli musicali, di magia, teatro e tanto altro direttamente in strada...pensati proprio per la gioia dei più piccoli!  
                              <p><strong> Fiera di Nachlat Binyamin Street:</strong> La più grande nel suo genere in Israele, questa fiera è un’esperienza vivace ed eccitante, grazie ai suoi artigiani, alla sua musica, spettacoli di strada e caffè adatti a tutte le età.
                              <p><strong> Sarona:</strong> Con i suoi ristoranti, caffè e bar alla moda, questo mercato coperto è una destinazione popolare per coppie, gruppi di amici e famiglie alla ricerca di uno dei posti più cool della città.  

                              <h3>
                                             Musei: 
                              </h3>
                              <p><strong>Museo d’arte di Tel Aviv:</strong> Con un gran numero di collezioni, guide, attività creative e interattive e giochi, il museo è un vero tesoro per genitori e bambini.
                              <p><strong>Museo di storia naturale:</strong> Inaugurato nel 2018, questo museo a 5 piani conta più di 3.000 oggetti e offre ai bambini la possibilità di osservare da vicino gli animali che vivono in campagna.
                              <p><strong>Il museo Olympic Experience:</strong> Disponibile con tour guidati, il museo offre la possibilità di vivere in maniera interattiva la storia dello sport israeliano attraverso mostre multimediali divertenti per tutta la famiglia.
                              <p><strong>Independence Hall -</strong> il luogo di nascita dello Stato di Israele e della prima città di lingua ebraica, Tel Aviv. Un affascinante viaggio attraverso la storia adatto a tutta la famiglia. 

                               <div class="img-wrapper">
			                       <img src=${getImgUrl() +
                               "/thingsToDo/posts/35/2.jpg"} class="img-responsive" />
		                       </div>
                              <h3>
                                           Gerusalemme 
                              </h3>
                              <p><strong>  La città di Davide: </strong>Un’esperienza archeologica immersiva nel cuore dell’antica Gerusalemme che include scavi archeologici, tour guidati e un percorso all’interno di un tunnel idrico sotto terra.
                              <p><strong>  Spettacolari spettacoli serali di luci e suoni:</strong> Uno stupefacente spettacolo unico nel suo genere, nel quale le mura della Cittadella diventano il palcoscenico di uno spettacolo notturno che celebra i 4.000 anni di storia di Gerusalemme attraverso suggestive immagini e suoni.
                              <p><strong>  L’acquario:</strong> Una delle attrazioni più in voga a Gerusalemme, aperta alla fine del 2017, offre un’accattivante avventura attraverso i quattro mari di Israele che incanterà tutti, grandi e piccini.
                              <p><strong>  La macchina del tempo: </strong>Immergiti nella realtà virtuale per un viaggio attraverso l’affascinante storia di Gerusalemme, con sedili mobili ed effetti speciali che stupiranno i più giovani.
                              <p><strong>  Il giardino botanico: </strong>Una incantevole gemma nel cuore della città con più di 6.000 specie di piante provenienti da tutto il mondo: l’orto botanico rappresenta un posto tranquillo che piacerà davvero a tutti.
                              <p><strong>  Tour in segway: </strong>Adatti ai ragazzi più grandi e agli adulti, i tour a bordo del segway offrono un’esperienza indimenticabile e attraversano i luoghi più affascinanti della città, permettendoti di ammirarne sia il carattere antico che quello più moderno.
                              <p><strong>  Mini Israele:</strong> Con le sue centinaia di riproduzioni in scala dei più importanti luoghi di Israele, questa attrazione permette una visione di insieme dei siti storici, religiosi e moderni di tutto il paese.

                              <h3>
                                   Musei: 
                              </h3>
                              <p><strong> Museo di Israele: </strong>Un importantissimo museo dedicato all’arte e all’archeologia, che ti permetterà di immergerti nella ricca storia e cultura del paese e della sua gente, grazie alle sue mostre in grado di affascinare visitatori di tutte le età.
                              <p><strong> Museo della Torre di Davide:</strong> L’ingresso storico della città vecchia di Gerusalemme, la cittadella medioevale offre modelli 3D, percorsi nascosti, tour per famiglie e tante altre attività.
                              <p><strong> Museo interattivo Ein Yael:</strong> Grazie ai suoi percorsi attraverso un’antica strada romana, laboratori creativi, preparazione del pane pita e incontri individuali con gli attori, le famiglie adoreranno questa esperienza.
                              <p><strong> Il Museo della scienza Bloomfield:</strong> Un fantastico museo per bambini orientato verso cultura e istruzione, pieno di mostre interattive dedicate a scienza e tecnologia. 


            	`,
      };
    },
  },

  {
    ctg: "telaviv",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    id: "Party_Capital",
    bgImage: "/posts/bank/party-capital/1.jpg",
    mobBgImage: "/posts/bank/party-capital/M.jpg",
    title: "Party Capital",
    smltitle: "",
    html: function() {
      return {
        __html: `

						<div class="ac-cradit">
							<span class="ac-cradit-text">Credits:</span>
								<br/>
								<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
								<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
							</div>
							<p></p>
						</div>

                            <h3>Epic Nights in the non stop city</h3>
              		        <p>Tel Aviv is rightly famous as one of the world’s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that’s pulsing with life.</p>

                            <h3>Tel Aviv by Night</h3>
                            <p>No matter what time it is, there’s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv’s pumping, pulsing clubs to dance the night away.</p>
                            
                            <p>Foodies will love the amazing cocktails mixed by Tel Aviv’s expert baristas, Israel’s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>
                            <div class="img-wrapper">
			                    <img src=${getImgUrl() +
                            "/posts/party-capital/1.jpg"} class="img-responsive" />
		                    </div>
                            <h3>Making the Most of Tel Aviv’s Nightlife</h3>
                            <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you’ll be introduced to some of Israel’s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv’s new and exciting gallery bars that display pieces by up and coming artists.</p>

                            <p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv’s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn’t reach full swing until 2am in most of Tel Aviv’s wildly popular nightclubs, manned by top DJs. You’ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>

                            <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you’ll find countless places to hang out at every hour of the day and night.</p>
                            <p>Tel Aviv’s awesome nightlife scene has become famous worldwide. The city the doesn’t stop is teaming up with endless possibilities designed for an epic night out! </p>
                            <p>Start slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.</p>
                            <p>Now that you’re in a mellow mood, it’s time to get your groove on. you’ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv’s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long. </p>
                            <div class="img-wrapper">
			                    <img src=${getImgUrl() +
                            "/posts/party-capital/2.jpg"} class="img-responsive" />
		                    </div>
                            <p>A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.</p>
                            <p>Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.</p>
                            <p>Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv! </p>

            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    // isVid:false,
    id: "Mamilla_Avenue",
    bgImage: "/posts/bank/mamila-avenue/1.jpg",
    mobBgImage: "/posts/bank/mamila-avenue/M.jpg",
    title: "VIALE MAMILLA",
    smltitle: "",
    isVid: true,
    vidId: "3g9T1HMP39Q",
    html: function() {
      return {
        __html: `
                                
                                <br/>
                                <h3>Viale mamilla una passeggiata nell’arte</h3>
                                <h3>Moderni prodotti di lusso venduti al dettaglio con l’antico splendore di Israele </h3>
								<p>Nella cerniera tra la vecchia e la nuova Gerusalemme, di fronte alla vista mozzafiato delle mura della Città vecchia e a pochi passi dalla Porta di Jaffa e dal Muro del pianto, troverai il viale Alrov Mamilla. Il moderno centro commerciale all’aperto ha riscosso molto successo tanto tra gli abitanti del posto che tra i turisti grazie alla sua vicinanza alla Città vecchia e in quanto esso offre il meglio delle possibilità: storia ricca, cultura locale e raffinata esperienza di acquisto al dettaglio in un contesto di alta qualità.</p>
								<div class="img-wrapper">
			                         <img src=${getImgUrl() +
                                 "/posts/mamila-avenue/1.jpg"} class="img-responsive" />
		                         </div>
								<h3>Scopri il moderno centro di intrattenimento ai piedi della Città vecchia di Gerusalemme </h3>
								<p>Cammina sulle strade lastricate di pietra di Gerusalemme e cercate le targhe che raccontano le storie dei monumenti storici presenti nell’area.&nbsp; Assisti agli spettacoli teatrali di strada, siediti i al tavolo di uno dei numerosi ristoranti e caffè ed entra in uno dei tanti negozi alla moda presso i quali è possibile acquistare i prodotti firmati dai migliori stilisti del mondo.</p>
								<p>Di sera, siediti &nbsp;al tavolo di uno degli ottimi bar della zona, alza lo sguardo per ammirare il panorama spettacolare della città vecchia davanti a te. Non esiste nulla di simile al mondo.</p>
								<h3>Visita le vie che collegano la vecchia e la nuova Gerusalemme&nbsp; </h3>
								<p>Il viale Mamilla è un centro di intrattenimento contemporaneo che consente ai visitatori di assaporare la cultura ricca, originale e sempre innovativa di Gerusalemme.</p>
								<p>Per fruire appieno di ciò che il viale Mamilla ha da offrire, il momento migliore per farvi visita è quando fa caldo. Ogni sera d’estate, migliaia di persone passeggiano lungo il viale e assistono a numerosi eventi culturali. Unisciti alla folla e osserva le mostre artistiche in strada, le esibizioni all’aperto, il teatro di strada, clown, acrobati, percussionisti e spettacoli musicali durante tutto il giorno.&nbsp; Con tutte le cose da vedere e da fare, non avrai più voglia di partire.</p>
								                              
                                

            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    id: "First_Time_In_Jerusalem",
    bgImage: "/posts/bank/first-time-in-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/first-time-in-jerusalem/M.jpg",
    title: "FIRST TIME IN JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>The must list for the first-time visitor</h3>

              		<p>
						Scour the globe it’s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it’s difficult to know where to begin. Here are a few suggestions…
              		</p>
					<p>
						Jerusalem is the nexus of three of the world’s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.
					</p>
					<p>
						Almost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters – Jewish, Christian, Muslim, and Armenian – and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/first-time-in-jerusalem/1.jpg"} class="img-responsive" />
					</div>
					<p>
						A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.
					</p>
					<p>
						Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.
					</p>
					<p>
						Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!
					</p>
            	`,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: 44,
    bgImage: "/posts/bank/travelling-on-budget/1.jpg",
    mobBgImage: "/posts/bank/travelling-on-budget/M.jpg",
    title: "TRAVELLING ON A BUDGET",
    smltitle: "",
    html: function() {
      return {
        __html: `

				    <h3>Making It Count in Tel Aviv and Jerusalem!</h3>

              		<p>
						So you’ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.
              		</p>
					<p>
						For affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes’ walk from Tel Aviv’s Beaches and Jerusalem’s main attractions.
					</p>
					<p>
						Getting around? In both cities it’s a snap with a Rav Kav card. Purchase one for little more than a dollar at”Al Hakav” (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/80/1.jpg"} class="img-responsive" />
					</div>
					<p>
						What to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.
					</p>
					<p>
						Finally, everyone’s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.
					</p>
					<p>
						So come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.
					</p>
            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    isVid: false,
    id: 45,
    bgImage: "/posts/bank/upscale-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/upscale-jerusalem/M.jpg",
    title: "UPSCALE JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h3>Modern luxuries for the pampered traveler</h3>
              		<p>
						When it comes to luxury travel, high class accommodations, fine dining, and top-drawer shopping options Jerusalem is a city that’s truly arrived.
              		</p>
					<p>
						The city features numerous 5-star and boutique hotels ready to custom cater to your needs for comfort and relaxation, offering amazing rooftop views and inhouse spa treatments to boot.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/81/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Looking to delight your palette? Well, in 2018, several Jerusalem establishments were listed in the prestige French restaurant guide, Gault & Millau. Beyond that, the city features and is increasingly attracting some of the world’s best chefs.
					</p>
					<p>
						When it comes to style, fashion, and swanky shopping, Jerusalem has any number of places you’ll want to visit. Among these are Arlov Mamilla Avenue. This happening and trendy outdoor mall complex is a must for your go-to city destinations. Even better, it’s situated just steps away from the Old City’s Jaffa Gate.
					</p>
					<p>
						Another not-to-be-missed stop on your itinerary is the elegant The First Station. For over 100 years a railway depot, the site has been transformed into an urban shopping and culinary mecca that’s chock-a-block with restaurants, shops, art galleries and an artists’ marketplace three days a week, as well as live performances and more.
					</p>
					<p>
						And as long as you’re in the neighborhood, treat yourself to a romantic afternoon or evening on Emek Refaim Street, the German Colony’s main thoroughfare. Its beguiling architecture laid back mood, stylish boutiques, intimate restaurants, and 1920s-era cinema offer an absolute treat for all the senses.
					</p>
            	`,
      };
    },
  },

  // End Posts

  {
    id: 5,

    ctg: "deadsea",
    isVid: false,
    bgImage: "posts/bank/100/1.jpg",
    mobBgImage: "posts/bank/100/M.jpg",
    title: "Dead Sea Joys",
    smlTitle: "",
    html: function() {
      return {
        __html: `
					<h3>For a floating good time</h3>

			              <p>
			                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. 
			                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. 
			                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, 
			                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. 
			                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			              </p>

			              <p>
			                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
			              </p>
			              
			`,
      };
    },
  },

  //No Translation
  // {
  // 	id:"Ultimate_Beach_Fun",
  //                bgImage : "/posts/bank/17/1.jpg",
  //         	mobBgImage : "/posts/bank/17/M.jpg",
  //               title : "ULTIMATE BEACH FUN",
  //               ctg:"telaviv",
  //               isVid:true,
  //               vidId:"I9a4BFWO_6w",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //             		<p>Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.</p>

  //         		 	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />

  // 					</div>

  //             		<p>Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!</p>

  //             		<div class="videoWrapper">
  // 						            <iframe width="100%" height="400px" src="https://www.youtube.com/embed/8p4qfkneH1c?autoplay=1&amp;controls=0&amp;loop=1&amp;rel=0&amp;playlist=8p4qfkneH1c&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0" frameborder="0" allowfullscreen=""></iframe>
  // 						        </div>

  //                                 <p>The Dead Sea’s desert beaches possess a unique atmosphere in the clear air and of course a sea which is not for swimming but for floating and taking care of your skin.</p>

  //                                 <p>Last but not least the beaches in Eilat boast crystal clear blue waters of the Red Sea that are very seldom wavey. Eilat is known for its beautiful diving spots and swimming with dolphins. They have wonderful beach bars, restaurants, water sports and attractions a perfect destination for holiday makers.</p>

  //             	 `
  //     }
  //   }
  // },
  // End No Translation

  {
    id: "Purchases_In_Israel",
    bgImage: "/posts/bank/purches-in-israel/1.jpg",
    mobBgImage: "/posts/bank/purches-in-israel/M.jpg",
    title: "ACQUISTI ESCLUSIVI IN ISRAELE",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
              
              
                                <div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/purches-in-israel/1.jpg"} class="img-responsive" />
						        </div>
                                <p>Fare shopping in Israele non consiste solo in comprare delle cose, ma è il modo migliore di pensare ad amici e parenti che sono restati a casa, offrendo loro (e anche a voi) una borsa, una bottiglia o una scatola rappresentativa della bella esperienza che avete vissuto. Passeggiando tranquillamente tra mercati, negozi e gallerie, l’incredibile varietà di prodotti vi consentirà di trovare qualcosa per tutti e al tempo stesso di divertirvi.</p>
								<h3>Stupendi souvenir del Medio Oriente </h3>
								<p>Alcuni dei ricordi più ricchi di significato vi stanno aspettando presso i luoghi sacri di Israele, in Galilea e a Gerusalemme. Le appariscenti ceramiche armene blu e bianche decorate con i motivi familiari dei luoghi sacri sono utilizzati come oggetti ricordo oppure come piatti da portata. Legno di ulivo e madreperla, l’artigianato è vecchio di secoli e secoli e ancora oggi è usato per abbellire Bibbie, scatole, spille e molti altri oggetti che terranno vivi i vostri ricordi e sentimenti.</p>
								<h3>Prodotti artigianali esclusivi</h3>
								<p>E quale modo migliore di ricordarsi di Safed, Gerusalemme, Jaffa o altri centri ebraici se non adornare il tavolo da pranzo con uno Challah o un matzah ricamati a mano (leggeri e facili da mettere in valigia) o dei candelieri, una tazza Kiddush o un candelabro a sette bracci Chanukkah in stile contemporaneo o tradizionale, d’argento, peltro, vetro o ceramica. I mezuzah sono un regalo perfetto per le feste di l'inaugurazione di una nuova casa, mentre un scialle da preghiera è un ricordo Bar/Bat Mitzvah che durerà tutta la vita.</p>
								<h3>Prodotti minerali del Mar Morto</h3>
								<p>Israele ospita la stazione termale all’aria aperta più grande del mondo: il Mar Morto. Dopo essersi immersi nelle sue acque ricche di minerali, la pelle e i capelli saranno lisci come la seta. Eh sì, l’acqua è disponibile anche in bottiglia! Potete acquistare un’intera gamma di prodotti minerali del Mar Morto, tutti confezionati splendidamente, per portare un regalo perfetto da Israele<span>.</span>&nbsp;</p>
								<h3>Shopping </h3>
								<p>Durante il vostro soggiorno vorrete sicuramente curiosare tra gli scaffali degli outlet o delle boutique degli stilisti israeliani di fama mondiale. Anche i vestiti per bambini israeliani al 100% di cotone possono essere riposti facilmente nella vostra valigia già ben piena per poi regalarli a una persona cara. A forza di visitare Israele vi fanno male i piedi? Prima della fine del viaggio, scegliete un paio di sandali o di scarpe prodotti in Israele, a un prezzo imbattibile rispetto a quello del vostro Paese.</p>
								<h3>Gioielli </h3>
								<p>I prodotti dei gioiellieri israeliani fanno bella mostra di sé nei numerosi negozi del Paese. Particolarmente affascinanti sono i braccialetti alla moda, con i loro cristalli variopinti e le perline con modelli apparentemente senza fine, ma anche le creazioni di malachite verde-blu (pietra di Eilat) che faranno scoprire a tutti che siete stati in Israele<span>.</span></p>
								<p>Israele è da sempre famoso per i diamanti tagliati e lucidati e l’esperienza, le conoscenze e le abilità dei suoi esperti di diamanti. E, poiché il Paese è un esportatore di diamanti, spesso gli acquisti in Israele sono meno costosi. Inoltre, potete visitare un centro di taglio e lucidatura di diamanti, per scoprire tutti i segreti del settore<span>.</span>&nbsp;</p>
								<h3>Non dimenticate la cucina </h3>
								<p>In un Paese la cui cucina è rinomata in tutto il mondo, i prodotti alimentari confezionati sono ideali da portare a casa. Ci sono le spezie, come l’issopo biblico da regalare al vostro chef preferito, i dolci datteri in bellissime confezioni da offrire ai vostri colleghi di lavoro e numerose varietà di tè alle erbe, miele, vini premiati e altri prodotti<span>.</span></p>
								<p>E quando voi e i vostri regali arriverete in aeroporto apprezzerete lo speciale incentivo del rimborso dell’IVA per gli acquisti di importo superiore a $100 offerto dai negozi che partecipano all’iniziativa.</p>
								      
            	 `,
      };
    },
  },

  {
    id: "Jerusalem_Fun",
    bgImage: "/posts/bank/jerusalem-fun/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-fun/M.jpg",
    title: "JERUSALEM FUN",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    smltitle: "",
    html: function() {
      return {
        __html: `
              
                               <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
                                <div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/jerusalem-fun/1.jpg"} class="img-responsive" />
						
					               </div>
                                 <p>To check it out, make your way to the <b>City Center</b> and explore the narrow streets just off <b>Jaffa Street</b>. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. <b>Rivlin Street</b> is a popular hangout for young people, while <b>Shoshan Street</b> and the surrounding area offers a more laid-back grown up vibe.</p>

                                 <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing.</p>
                                 <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session.</p>

                                 <p>For a daytime change of pace head to the <b>German Colony (Moshava)</b> and, particularly, the neighborhood of <b>Baka</b>. Start at <b>Beit Lechem Street</b> where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up <b>Emek Refaim Street</b> or through <b>HaMesila (Railway) Park</b> until you reach The <b>First Station</b> – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>
                           
            	 `,
      };
    },
  },

  {
    id: "Western_Wall_Wonders",
    bgImage: "/posts/bank/30/1.jpg",
    mobBgImage: "/posts/bank/30/M.jpg",
    title: "WESTERN WALL WONDERS",
    ctg: "jerusalem",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
              

				<p>
					The Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by the great King Herod.
				</p>

				<p>
					The Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount support walls remained standing.  Throughout the generations since the Temple’s destruction, the Western Wall was the remnant closest to the site of the Temple’s ‘holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present.  The actual remains of the Temple can be found the Western Wall Tunnels, which are an extraordinary journey through time.
				</p>
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/27/1.jpg"} class="img-responsive" />
				</div>

				<p>
					For centuries Jewish People from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions’ pouring out their heart with prayers as the wall is believed to have enormous spiritual significance. 
				</p>

				<p>
					It is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/27/2.jpg"} class="img-responsive" />
				</div>

				<p>
					The Western Wall is a national symbol as the ancient bricks have seen Israel and the Jewish peoples  birth, exile and redemption. It’s a very popular location for national ceremonies and even Bar Mitzvah to take place
				</p>
				<p>
					For more information   <a  target="_blank" href="//www.thekotel.org">www.thekotel.org</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: 28,
    bgImage: "/posts/bank/white-city-splendor/1.jpg",
    mobBgImage: "/posts/bank/white-city-splendor/M.jpg",
    title: "WHITE CITY SPLENDOR",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
              
				

				<p>
					Tel Aviv’s “WHITE CITY” is a UNESCO World Heritage Site, because the city is home to more Bauhaus, modern and “International” architecture than any city on earth.
				</p>

				
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/28/1.jpg"} class="img-responsive" />
				</div>

				<p>
					Tel Aviv was founded in 1909 as a garden suburb of the crowded port city of Jaffa. Very quickly it grew into a bustling metropolis so that by 1929, it was a flourishing city that was the apex of the Zionist dream. With the rise to power of Hitler in 1933, dozens of German Jewish architects escaped to Palestine – many of whom were students or graduates of the legendary Bauhaus school of design. The burgeoning of Tel Aviv required more and more buildings, and the arriving architects very quickly adapted their northern European Bauhaus design to the needs of the eastern Mediterranean heat. A walk through central Tel Aviv will bring you face to face with dozens of these extraordinary office buildings, apartment buildings and stores.
				</p>

				<p>
					<a  target="_blank" href="//www.bauhaus-center.com/">www.bauhaus-center.com/</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: "Tower_Of_David_Museum",
    bgImage: "/posts/bank/30/1.jpg",
    mobBgImage: "/posts/bank/30/M.jpg",
    title: "TOWER OF DAVID MUSEUM",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					Jerusalem’s Citadel, known as the “Tower of David”, is a historical and archaeological asset of international significance. The Tower is a medieval fortress that is located near the Jaffa Gate, the historical entrance to the Old City and has been the symbol for the city of Jerusalem for generations.
				</p>

				
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/1.jpg"} class="img-responsive" />
				</div>

				<p>
					At the Tower of David Museum you are presented with Jerusalem’s astounding story. While absorbing yourself in legends of the past and their dramatic chronicles it will not take you long to realise that the very stones of the museum are part of this city’s living history.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/2.jpg"} class="img-responsive" />
				</div>


				<p>
					The 500-year-old walls are part of the Turkish citadel; its name derives from a tower so massive that early Jerusalemites ascribed it to their great King David and despite the name being ‘The Tower of David’ it was actually build by King Herod.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/3.jpg"} class="img-responsive" />
				</div>

				<p>
					Your visit can begin with a breath-taking view of old and new Jerusalem from the top of the tower. Each ancient room has been revamped to showcase a different period, allowing the tempestuous events of 4,000 years to fall perfectly into place in your mind.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
				</div>

				<p>
					The windows frame glimpses of modern Jerusalem, and with each doorway you exit, you look down into the citadel’s central courtyard, where archaeologists have unearthed remains dating from the Maccabees to the Middle Ages. This incredible site really is a maze of time!
				</p>

				<p>
					The museum also utilizes its unique space for multi-sensory exhibits by leading designers and artists from Israel and abroad. This One of a kind museum hosts the annual ‘Night Spectacular’ which is a unique sound and light show where the whole of the Citadel is lit up with stunning designs!
				</p>

				<p>
					For more information:   <a href="//www.tod.org.il/en/">www.tod.org.il/en/</a>

				</p>
                
            	 `,
      };
    },
  },

  {
    id: "Must_Eat_In_Jerusalem",
    bgImage: "/posts/bank/must-in-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/must-in-jerusalem/M.jpg",
    title: "MESMERIZING AND MAGICAL CITY",
    ctg: "jerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                                <p>
						            Jerusalem is a mesmerizing and magical city. Many people who visit Jerusalem rave about the amazing atmosphere, the unforgettable sites, the breathtaking views and more. However, to truly understand what Jerusalem is all about, there are some things that you simply have to experience through your stomach. Here are just a few of the things you really should try while visiting Jerusalem:
						        </p>
                               <div class="img-wrapper">
						                 <img src=${getImgUrl() +
                               "/posts/must-in-jerusalem/1.jpg"} class="img-responsive" />
				                 </div>

							    <h3>Malabi:</strong> A unique a combination of beverage and dessert, made of a mixture of rosewater, milk, cornstarch and sugar. Malabi is a very popular Jerusalem dish, sold in many middle eastern restaurants and kiosks throughout the city. Guaranteed to be nothing like anything you have ever tasted.</p>

                                <h3>Knafe:</strong> A very interesting and sensationally tasty dish when served and eaten fresh. Knafe is essentially an Arabic desert made of melted goats cheese and topped with hairs of orange pastry hairs, dipped in sweet rosewater syrup. Finding the perfect Knafe is a mission, once you find it, eating it becomes an addiction.</p>

                                <h3>Jerusalem Pretzel:</strong> An absolute must when touring the fascinating sites of the old city is stopping by one of the small green carts and purchasing an authentic Jerusalem pretzel. Along with it, you will get a fragrant local green herb called Zaatar which goes great with the delicious warm doe.</p>

                                <h3>“Meorav Yerushalmi”:</strong> Directly translates to “Mixed Jerusalem” this delicious mix of different meats in a special local blend of spices is an absolute carnivores’ heaven.</p>

                                <h3>“Ashtanur”:</strong> Short in Hebrew for “fire in the oven” Ashtanur is an authentic local pitta bread which you can find in midtown or the markets during lunchtime. If you’re especially hungry, try it wrapped around a portion of shawarma or falafel.</p>

                                <h3>Sabich:</strong> an absolute original, the Sabich is a truly unique local dish comprised of a Pitta bread packed with fried eggplant, hard-boiled eggs, and pickles, usually topped by Amba, a local, flavorful condiment. Once you try it, you’ll be hooked for life.</p>
                                
                
            	 `,
      };
    },
  },

  {
    id: "Jerusalem_Arts",
    bgImage: "/posts/bank/jerusalem-art/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-art/M.jpg",
    title: "JERUSALEM’S ART",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                                <h3>Finding Inspiration in Jerusalem</h3>

                                <p>There's no doubt Jerusalem is one of the most fascinating cities in the world. Its fusion of diverse religions, traditions, ancient history and modern city life intrigues visitors for centuries. It's also what attracts artists there. Today's Jerusalem is full of Museums, galleries, marketplaces and cultural festivals, which together form a vivid and unique Art and Culture scene. Prepare to be inspired.</p>

                                <p>Discover. On a hill next to the Knesset and Israel's Supreme Court, situated Israel's largest cultural institution and one of the world's leading museums in art and archeology, The Israel Museum. Start with the archeological wing. Organized chronologically, the pieces there form the most extensive collection in the world for biblical and Holy Land archeology. Continue to the outstanding Jewish Art and Life wing, the impressive Fine Arts collection and the rotating contemporary art exhibitions. Don't miss few of the museum's highlights – The Shrine of The Book which holds the Dead Sea Scrolls and the stunning Art Garden looking over the Jerusalem Mountains. Tip: Give yourself time. It's an accessible, fascinating museum and there's so much to see.</p>
                                <div class="img-wrapper">
						                <img src=${getImgUrl() +
                              "/posts/jerusalem-art/1.jpg"} class="img-responsive" />
				                </div>
							    <small style="color:#000; display:block;">
                      		        Credit: Noam Chen
                      	        </small>

								<p>In close proximity to the Israel Museum you'll find the riveting <strong>Bible Lands Museum</strong>. Describes as "an interactive time capsule", it's the only museum of its kind in the world. Tour through the galleries and discover the wonders of the lives of ancient cultures in the Near East and their interrelations from the dawn on of civilization to the early Christian era.</p>

                                <h3>Experience</strong>. Go to <strong>The Artists' Colony of Jerusalem</strong> (Hutzot Hayotzer) and experience creativity. This Art and Craft complex is a workplace for artists and designers from various fields. Stroll down this picturesque boulevard of shops and galleries underneath the northern walls of the Old City and see artists at work. Hear stories, learn about traditional and more contemporary art techniques and purchase works directly from the artists.</p>

                                <p>See the <strong>Tower of David Light Show</strong>, known as the Jerusalem Night Spectacular. This truly stunning show combines modern technology with the city's history and the beauty of the Tower. You'll witness the walls and walkways comes alive with a 3D light show and vibrant music that pulls the viewer into an almost dreamlike experience.</p>

                                <h3>Celebrate</strong>. Jerusalem has rich history but it's also a bustling modern city that loves to celebrate. Make sure to check the city's rich schedule of festival and cultural events and enjoy of the best Jerusalem has to offer throughout the year.</p>

                                <p>Celebrate <strong>The Israel Festival</strong>, Israel's prominent multidisciplinary international festival that presents a large variety of outstanding theatre, contemporary dance, classical music and performance from all around the world. Join the Jerusalem Arts and Craft fair Hutzot Hayotzer where you'll meet Israeli and international artists and listen to great music; visit Jerusalem Night Market and stroll through the many stalls set by all types of artists and designers, showing off and selling their wares; Experience the Light in Jerusalem Festivalthat provides a dramatic unique and artistic dimension to the old city through use of light; listen to opera in the Jerusalem Opera Festival. Set in the Sultan pool, you'll watch great performance with the great Jerusalem night summer air and stunning view as a backdrop.</p>

                                <p>Don't miss the Jerusalem Sacred Music Festival. As part of the Jerusalem Season of Culture, this extraordinary festival brings together diverse artists from huge array of fields, cultures and traditions that show and explore 'sacred' music from all around the world.</p>
            	
                
            	 `,
      };
    },
  },

  {
    id: "All_Sensory_Markets",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: "ALL SENSORY MARKETS",
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					For a genuine Middle Eastern experience you can’t beat a visit to one of Israel’s many markets (Shuks).  The different colours, textures, smells, tastes and sounds of these hives of activity can be a highlight of any Israel visit.  
				</p>

				<p>
					These markets are a melting pot of cultures and a great place to give your bartering skills a go. Through the winding cobbled streets you will find, fresh produce, souvenirs, art and handmade jewellery…the list is endless. Bring home a gift for your friends and family or just enjoy walking around and tasting different flavours.
				</p>
				
				
             	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/1.jpg"} class="img-responsive" />
				</div>

				<h3>
					Tel Aviv
				</h3>
				<p>
					The Carmel Market, or Shuk HaCarmel, is the most famous of all Tel Aviv’s marketplaces. In recent years, it’s even joined the ranks of Tel Aviv’s trendy spots for bars, restaurants, coffee shops and chef-owned food stalls. It’s no wonder Shuk HaCarmel is Tel Aviv’s largest and most-centrally located shuk: From hand-made Jachnun, a traditional Yemenite dish, to boutique cheeses, and from one-off cotton clothes to designer threads, HaCarmel has it all. Plan your visit around your tastebuds and food preferences - salted fish, cured meats, Middle Eastern fare, fresh baked French pastries, and local-roasted coffee or fresh-pressed fruit or vegetable juice blends to wash it all down.
				</p>

				<p>
					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
						www.shuktlv.co.il/en/category/carmel-market
					</a>
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/2.jpg"} class="img-responsive" />
				</div>

				<p>
					Nachlat Binyamin arts and crafts fair was established in 1988. It is the oldest and biggest of its kind in Israel, and one of the nicest in the world. The market is home to over two hundred artists who use materials such as wood, glass, fabric, plastic, paper…even rocks (almost anything) to hand-make what they sell on their stall. 
				</p>

				<p>
					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
						www.shuktlv.co.il/en/category/carmel-market
					</a>
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/3.jpg"} class="img-responsive" />
				</div>
				<h3>
					Jerusalem
				</h3>

				<p>
					The Machane Yehuda market is widely recognized as a symbol of the Jerusalem, and for a very good reason: Jerusalemites see it as a place that represents them, symbolizes them, and gives them a unique identity in a larger Israeli social context. Jerusalem today has many shopping and entertainment centres, but there is something about the Machane Yehuda market that attracts people, even without a shopping list.  From the heady scent of spices to the colourful displays of fruits and vegetables, a trip to this market is pleasing for all your senses.
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
				</div>

				<p>
					One option of experiencing this market is by buying a ‘Machane Yehuda Bites Card’.  This card is comprised of vouchers curated in order to give you a chance to try a variety of products, flavours and the aromas of the market - without having to depend on an organized group or tour.  For more information please click here: 
				</p>

				<p>
					<a target="_blank" href="//www.machne.co.il/en/">
						http://www.machne.co.il/en/
					</a>
				</p>
				
                
            	 `,
      };
    },
  },

  {
    id: 31,
    bgImage: "/posts/bank/20/1.jpg",
    mobBgImage: "/posts/bank/20/M.jpg",
    title: "UNFORGETTABLE YAD VASHEM",
    ctg: "jerusalem",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					Yad Vashem, Israel’s main Holocaust remembrance and education centre is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem.
				</p>

				<p>
					Israel’s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps.
				</p>
				
				
             	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/31/1.jpg"} class="img-responsive" />
				</div>

				<p>
					The new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with “the Final Solution” and mass genocide
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/31/2.jpg"} class="img-responsive" />
				</div>


				<p>
					The personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum’s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum itself is the Hall of Names, an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive.
				</p>

				<p>
					In addition to the Holocaust History Museum Yad Vashem has other memorials and monuments including  the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children’s memorial, commemorating the one and a half million Jewish children who were murdered in the Holocaust;
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/31/3.jpg"} class="img-responsive" />
				</div>
				
				<p>
					The Memorial to the Deportees, an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.
				</p>

				<p>
					The Avenue of the Righteous Among the Nations has over 2,000 trees which were planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; The archives and library of Yad Vashem House the world’s largest repository of material about the Holocaust;
				</p>

				<p>
					Visiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust.
				</p>

				<p>
					For more information   <a target="_blank" href="//www.yadvashem.org/">www.yadvashem.org</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: "What_To_Pack",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "COSA METTERE NELLA VALIGIA",
    smltitle: "",
    html: function() {
      return {
        __html: `

								<p>Israele è un Paese moderno e sviluppato e durante il vostro soggiorno potete acquistare praticamente tutto ciò di cui avete bisogno, tra cui vestiti, cosmetici, prodotti per l’igiene.</p>
                                <p>Se visitate Israele in estate avete bisogno di indumenti leggeri: magliette a maniche corte e canottiere, calzoncini, sandali, scarpe da spiaggia e costume da bagno.&nbsp; È anche opportuno portare con sé un maglioncino o una giacca, in quanto di notte sulle montagne e nel deserto può fare freddo.&nbsp;</p>
                                <p>Se visitate Israele in inverno avete bisogno di indumenti autunnali e/o invernali, cappotto (preferibilmente anche un impermeabile), scarpe chiuse, ombrello, guanti, sciarpa e altri indumenti caldi.&nbsp; In Israele non fa freddo quanto in Europa, ma le giornate possono essere piovose e fredde.&nbsp;</p>
                                <p>Per le escursioni di un giorno è opportuno portare con sé uno zaino.&nbsp; Se visitate Eilat o il Mar Morto è bene portare il costume da bagno, in quanto fa abbastanza caldo per nuotare anche in inverno.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/what-to-pack/1.jpg"} class="img-responsive">
							    </div>
                                <p>Crema solare, cappello e occhiali da sole sono articoli essenziali da portare con sé tutto l’anno.</p>
                                <p>Se avete intenzione di fare delle escursioni avrete bisogno di un buon paio di scarpe e molta acqua, in una borraccia o in bottiglia. Avrete bisogno di sacco a pelo, tenda e attrezzatura da campeggio solo se avete intenzione di dormire all’aperto.&nbsp; La maggior parte degli ostelli mette a disposizione lenzuola e coperte.</p>
								
								

		                        `,
      };
    },
  },
  {
    id: "Electrical_Appliances",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ELECTRICAL APPLIANCES",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>
									The local power supply is single phase 220 volts at 50 Hertz. Most power sockets in Eilat have three pinholes, but many of them will work with double-pin European plugs. Visitors who want to use shavers, traveling irons and other small appliances may need both transformers and adaptor plugs.
		                        </p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/electrical-appliances/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Weather",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "METEO",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>Con appena 40 giorni di pioggia l’anno in media, Israele è famoso per le giornate di sole. Tuttavia, è bene tenere presente che si tratta di un Paese con 4 stagioni. Le estati sono lunghe e vanno da aprile a ottobre, mentre il picco del caldo e dell’umidità si verifica solitamente in luglio-agosto. Autunno e inverno durano da novembre a marzo.</p>
                                 <p>La città meridionale di Eilat gode di 360 (!) giornate di sole l’anno, il che di fatto la rende la città più calda di Israele.</p>
                                 <p>Servizio meteorologico israeliano: <a href="//www.ims.gov.il">www.ims.gov.il</a>&nbsp;&nbsp;</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/weather-planyour-trip/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Transportation",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "TRASPORTI",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>Israele è un piccolo Paese, il che consente di spostarsi velocemente e facilmente. I taxi sono molto diffusi in Israele, sia per gli spostamenti urbani che interurbani e possono essere chiamati per strada oppure prenotati telefonicamente o mediante apposite app internazionali, come GetTaxi.</p>
								<p>I principali mezzi di trasporto pubblico sono gli autobus e i treni, che consentono di recarsi in praticamente qualsiasi destinazione del Paese a prezzi contenuti.</p>
								<p>Servizi informativi sui treni: <a href="//www.rail.co.il/en" rel="nofollow" target="_blank">www.rail.co.il</a>&nbsp;&nbsp; / Telefono: 08-6831222 o *5770.</p>
								<p>Servizi informativi sugli autobus: <a href="//bus.gov.il/?language=en#/origindestination/1/0" rel="nofollow" target="_blank">www.bus.co.il</a>&nbsp; / Telefono: 1-900-72-1111</p>
								<p>I biglietti possono essere acquistati presso le biglietterie delle stazioni centrali degli autobus di tutte le città oppure dal conducente.&nbsp;&nbsp;La maggiore parte delle linee di autobus non è operativa in corrispondenza dello Shabbat e delle festività ebraiche.&nbsp;&nbsp;Il servizio termina il venerdì pomeriggio e riprende il sabato sera.&nbsp;</p>
								<p>Gli studenti hanno diritto a sconti sulle linee di autobus che collegano le città.&nbsp;&nbsp;Per ottenere uno sconto, al momento dell’acquisto devono esibire la tessera internazionale di studente.</p>
								<h3>Tessera per il trasporto intelligente - Rav Kav</h3>
								<p>I turisti possono acquistare una tessera anonima Rav Kav.&nbsp;Essa può essere acquistata a bordo del mezzo di trasporto e ricaricata con un normale biglietto per corsa singola o più corse, di solito all’interno della regione che offre lo sconto del 20%.</p>
								<p>I turisti non possono usare la tessera personale Rav Kav, la quale riporta tutti i dati personali del passeggero ed è destinata all’uso da parte dei cittadini residenti.</p>
								<p>Nota:</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/transportation/1.jpg"} class="img-responsive">
							    </div>
								<p>·&nbsp;La tessera Rav Kav può essere usata per pagare il trasporto di più passeggeri,</p>
								<p>·&nbsp;Il costo del trasporto di un bambino è lo stesso di un adulto.</p>
								<p>·&nbsp;La tessera Rav Kav può essere usata all’interno di una determinata regione e non in regioni diversi, a meno che essa non venga specificamente ricaricata per i percorsi desiderati.</p>
								<p>·&nbsp;In alcune aree è possibile usufruire di corse giornaliere illimitate solo entro una determinata regione.</p>
								<h3>Voli nazionali </h3>
								<p>Israele è un piccolo Paese e per questo motivo vale la pena prendere in considerazione la possibilità di volare solo tra Eilat e Tel Aviv. Diverse compagnie aeree organizzano voli da Eilat all’aeroporto Ben Gurion o a Sde Dov, a nord di Tel Aviv.&nbsp; Il costo dei biglietti aerei è contenuto, ma più elevato di quello degli autobus.&nbsp;</p>
								<p>Esistono anche delle compagnie aeree private che, su richiesta, organizzano voli speciali da qualsiasi parte del Paese.</p>
								<p>Arkia:&nbsp; <a href="//www.arkia.com/flights-in-israel" rel="nofollow" target="_blank">www.arkia.com/flights-in-israel</a>&nbsp; Telefono: 00 972 3 690 2222,<br>Israair:&nbsp; <a href="//int.israirairlines.com/cat_domestic.asp" rel="nofollow" target="_blank">&nbsp;int.israirairlines.com/cat_domestic.asp</a> Telefono: 00 972 3 795 5777</p>
								<h3>Autonoleggio</h3>
								<p>La maggior parte delle aziende internazionali di autonoleggio e delle aziende locali ha uffici nelle grandi città e nell’aeroporto Ben Gurion.&nbsp; Dall’estero è consigliabile prenotare un’auto in anticipo.</p>
								<p>Per noleggiare un’automobile in Israele il conducente deve avere più di 24 anni di età ed essere in possesso di una patente internazionale valida e di una carta di credito internazionale.</p>
								<p>Israele dispone di una rete stradale eccezionale quasi tutta coperta dalla segnaletica (in ebraico, inglese e arabo).&nbsp;&nbsp;</p>
								<h3>Guidare in Israele</h3>
								<p>In Israele l’età <strong>minima</strong> per guidare è di 17 anni e la guida è a destra. I limiti di velocità vanno da 30 a 50 km/h in città, 80-90 sulle superstrade, 130 sulle autostrade e l’Autostrada 6. Le cinture di sicurezza sono obbligatorie e, se vi piace la vita notturna, tenete presente che per chi guida in stato di ebrezza vige una politica di tolleranza zero, quindi è consigliabile designare un guidatore sobrio e divertirsi in tutta sicurezza.</p>
								<h3>Autostrada 6&nbsp;</h3>
								<p>L’autostrada 6 è a pagamento, con caselli a pedaggio elettronici senza barriere né all’ingresso né all’uscita e senza semafori, il che consente di viaggiare senza essere costretti a fermarsi. I sistemi informatici computerizzati installati lungo l’autostrada includono caselli elettronici a pedaggio, identificazione dei veicoli, classificazione dei tipi di pedaggi (su abbonamento o non registrati) e calcolo del numero di tratte autostradali percorse da ciascun veicolo. Ogni viaggio viene classificato e fatturato automaticamente. I conducenti fanno un’esperienza di viaggio interessante, pratica e sicura, con un limite di velocità di 130 km l’ora.</p>
								<p>I turisti che noleggiano un’automobile pagheranno l’importo dovuto con la carta di credito.&nbsp;&nbsp;Per informazioni su condizioni e tariffe, rivolgetevi all’azienda di autonoleggio.</p>
								<p>La maggior parte delle aziende di autonoleggio non offre l’assicurazione per le aree della Cisgiordania sotto il controllo dell’Autorità Palestinese.&nbsp; I turisti che desiderano guidare con automobili a noleggio nelle zone dell’Autorità Palestinese dovranno procurarsi un’assicurazione adeguata.&nbsp;</p>
																

            	

		                        `,
      };
    },
  },
  {
    id: "Israeli_Currency",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "VALUTA ISRAELIANA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <br/>
								<p><a href="//www.boi.org.il/en/Markets/ExchangeRates/Pages/Default.aspx" target="_blank" ><strong>Tassi di cambio valutari</strong></a><br>La valuta dello Stato di Israele è il Nuovo Shekel israeliano (NIS) o shekel (il cui plurale in ebraico è “shkalim”, mentre in inglese è “shekels”). Uno shekel è suddiviso in 100 agorot (“agora” è la forma singolare). Le banconote sono denominate in NIS da 20, 50, 100 e 200; le monete sono denominate in NIS10, NIS5, NIS2 NIS1 e 50 e 10&nbsp; agorot.&nbsp;</p>
								<p>Cambio di&nbsp;valuta<br><br>In Israele è possibile portare somme illimitate di valuta locale ed estera sotto forma di contanti, travelers’ checks, carte di credito o obbligazioni dello Stato di Israele. Le valute estere di qualsiasi tipo possono essere scambiate negli aeroporti, nelle banche, negli uffici postali e nella maggior parte degli hotel e delle agenzie di cambio munite di licenza nelle grandi città. Quando si scambiano travelers’ checks è necessario esibire un passaporto. I tassi variano da un luogo all’altro e le banche addebitano una commissione. È consigliabile, anche se non obbligatorio, portare con sé una piccola quantità di dollari USA, in quanto presso alcuni siti turistici, specialmente nella&nbsp;Città vecchia&nbsp;di&nbsp; Gerusalemme, sono accettati i pagamenti in dollari.&nbsp;Ulteriori informazioni sono disponibili&nbsp;<a href="https://www.boi.org.il/en/ConsumerInformation/Pages/Default.aspx" target="_blank">qui</a>.</p>
								<h3>Ritiro di contanti</h3>
								<p>I possessori di carte di credito internazionali possono ritirare valuta locale o estera presso le banche che accettano le carte di credito di cui sono in possesso. All’esterno della maggior parte della banche sono presenti degli sportelli bancomat.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/israeli-currency/1.jpg"} class="img-responsive">
							    </div>
            	

		                        `,
      };
    },
  },
  {
    id: "Immigration_Customs",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "IMMIGRATION & CUSTOMS",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <h3>Passport Control</h3>
                                <p>Upon arrival in Israel, visitors go to passport control and must present a passport that is valid for at least six months from the <strong>date of their departure.</strong><br>
                                   Please note, Israel has incorporated a new and modern technological system instrumental in meeting the needs of the various Immigration, security, Airport and Tourism authorities as well as providing the tourist with the credentials necessary to prove his visa status without stamping the passport. At a press of a button, the Border Control station will print a card including the principle details of the traveler as in the first page of the passport. The card will also depict the date of arrival and visa information. This card is called The “Electronic Gate Pass”.
                                </p>
                                <div class="img-wrapper">
								    <img src=${getImgUrl() +
                      "/posts/immigration-customs/1.jpg"} class="img-responsive">
							    </div>
							    <h3>The Gate Pass is an official form of identification while in Israel. We ask all tourists to keep the card at hand at all times as proof of their status.</strong><br>
										Arrival by Air and Land Crossings – Incoming travelers continue to the passenger luggage area after having their passports inspected. Carts are at their disposal. From there, they continue to customs control and to the airport exit.</p>
										<p><a href="https://www.gov.il/BlobFolder/service/group_entry_to_israel/en/land%20gateways%202017ENGLISH%20update.doc" target="_blank" rel="nofollow noopener" data-mk-aweb-org-font-size="17">Information Regarding&nbsp;Israel’s Land Gateways&#8203;</a></p>
										<h3>Customs</h3>
										<p>General information regarding the laws and policies of the Customs Authority can be downloaded:<br>
										<a href="https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page" target="_blank" rel="noopener">https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page</a></p>
										<h3>Please make note that travel through Allenby Bridge Crossing has specific limitations and directives. For example, visitors passing through the Allenby Bridge between Israel/Jordan may carry no more than the cash value of 2000 Jordanian Dinars.</h3>
										<h3>Customs and V.A.T. for Tourists:</h3>
										<p><a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a><br>
										<strong>Aside from Allenby Bridge Crossing, and for all other Gateways including airports,</strong> the following tourist guide is relevant for visitors as defined by the Customs and Tax Authority:<br>
										<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br>
										<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a><br>
										Please note: there is a two-lane customs transit system, one green and the other red, at Ben Gurion Airport and the various Crossing Points. Visitors who do not have goods to be declared may go through the green lane at the exit from the passenger arrival hall.</p>
								
		                        `,
      };
    },
  },
  {
    id: "Frequently_Asked_Questions",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "DOMANDE FREQUENTI",
    smltitle: "",
    html: function() {
      return {
        __html: `
									

                                    
                                    <h3>Frequently Asked Questions about the COVID-19 </h3>

                                    <p>
                                        <ol start="1">
									      <li>
							                <strong>Sono un turista in Israele e sono preoccupato di avere contratto COVID-19, dove devo andare?</strong><br/>
							                Se dovessi avere la febbre a 38° o maggiore, tosse, problemi respiratori, o altri sintomi legati alla respirazione, devi immediatamente entrare in auto isolamento e chiamare il 101 Servizio di Emergenza per un parere medico. Non andare in un pronto soccorso in ospedale.
							              </li>
							              <li>
							                <strong>Quando Israele verrà riaperta ai visitatori?</strong><br/>
							                Al momento non è possibile comunicare alcuna data di riapertura ai visitatori.
							              </li>
									       
									      </ol>
                                    </p>
									<h3>Israele non è lontano?</h3>
									<p>Non quanto si potrebbe pensare: appena 10 ore da New York (si fa prima a volare da New York in Israele che da New York alle Hawaii!), o 14 ore da Los Angeles. Ci sono circa dieci voli diretti al giorno dal Nord America a Israele, organizzati dalle compagnie aeree Air Canada, American Airlines/US Airways, Delta, El Al Israel Airlines e United. Inoltre, Israele è collegato a decine di città europee.</p>
									<h3>Quali documenti servono per recarsi in Israele?</h3>
									<p>I cittadini di U.S.A e Canada hanno bisogno solo di un passaporto valido almeno per i sei mesi successivi alla data di arrivo in Israele. (per i soggiorni superiori a tre mesi il visto non è necessario). Anche se non si è cittadini U.S.A. o canadesi, le stesse condizioni sono applicate ai cittadini della maggior parte dei Paesi occidentali, ma è consigliabile verificare nel sito: <a href="//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" rel="nofollow" target="_blank">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
									<h3>Viaggiare in Israele è sicuro?</h3>
									<p>Non ti inviteremmo a venire a trovarci se non lo fosse. Ogni anno, tra 3 e 4 milioni di turisti trascorrono le vacanze in Israele e, a parte chi si innamora di un’israeliana o di un israeliano – o di Israele – tornano tutti a casa sani e salvi. Se il Paese non fosse sicuro, gli aerei di oltre 90 compagnie aeree non volerebbero in Israele.&nbsp;</p>
									<h3>Ho sentito dire che prima di salire a bordo dell’aereo bisogna sottoporsi a un colloquio di sicurezza…</h3>
									<p>Se voli con EL AL, la compagnia di bandiera israeliana (oppure, dall’Europa, con Arkia Israel Airlines o Israir), devi sapere che le misure di sicurezza adottate dalle compagnie aeree israeliane sono invidiate dalla compagnie aeree di tutto il mondo. Al momento del check-in, prima del volo, ti verrà fatta una serie di domande, nel corso di un colloquio di sicurezza. Alcune delle domande potrebbero sembrarti poco ortodosse, invadenti, irrilevanti o ripetitive. Rispondi semplicemente con sincerità e spontaneità, senza perdere la calma. Tieni presente che lo scopo delle domande è proteggere te e i tuoi compagni di viaggio. Quando lasci Israele, la procedura di partenza è identica a quella descritta per tutte le compagnie aeree. &nbsp;</p>
									<h3>Posso combinare la mia visita in Israele con quella della Giordania e/o dell’Egitto?</h3>
									<p>Certamente. Tra Tel Aviv e Il Cairo e Tel Aviv e Amman vi sono dei voli regolari. Oppure puoi spostarti via terra, attraversando il confine tra Israele ed Egitto a Eilat/Taba oppure tra Israele e Giordania a Eilat oppure il ponte dello sceicco Hussein a sud del Lago di Tiberiade. Avrai bisogno di un visto per Giordania ed Egitto, ma i cittadini di U.S.A. e Canada possono ottenerlo alla frontiera. I cittadini di altri Paesi devono verificare i requisiti necessari per ottenere il visto rivolgendosi ai consolati locali di Egitto e Giordania.</p>
									<h3>Cosa devo fare per visitare un altro Paese arabo?</h3>
									<p>Partire, semplicemente. Come molti Paesi europei, Israele non timbra più i passaporti dei visitatori, quindi il passaporto non indica che sei stato qui.</p>
									<h3>Posso visitare l’Autorità Palestinese?</h3>
									<p>Visitare Betlemme è semplicissimo e ogni anno lo fanno migliaia di visitatori che si recano in Israele. Puoi fare un’escursione (informati presso la portineria del tuo hotel) oppure prendere un taxi fino al confine tra Gerusalemme/Betlemme e proseguire con un taxi palestinese fino a Betlemme.&nbsp;</p>
									<h3>Cosa bisogna sapere su sanità, medicine e vaccinazioni?</h3>
									<p>Israele è un Paese ultra-moderno che vanta il più alto numero di dottori pro capite e un sistema sanitario e ospedaliero invidiati in tutto il mondo. Per visitare Israele non sono necessarie vaccinazioni (a meno di non essersi recati di recente in una zona in cui ci sono state epidemie di febbre gialla, colera o ebola). In Israele è possibile acquistare i farmaci da banco più diffusi equivalenti a quelli disponibili in Nord America. Inoltre, puoi portare con te una scorta dei farmaci che ti sono stati prescritti dal medico. (Se devi portare con te siringhe e fiale di farmaci, richiedi al tuo dottore una lettera indicante le tue necessità, per qualsiasi esigenza.) Qualora desiderassi consultare un medico in Israele, rivolgiti alla portineria del tuo hotel. L’assicurazione sul viaggio (compresa la copertura delle spese mediche) è sempre consigliabile per tutti i viaggi all’estero.</p>
									<h3>Cosa devo indossare?</h3>
									<p>Come in quasi ogni parte del mondo, la “regola” per qualsiasi escursione è di indossare indumenti comodi.&nbsp; Porta un buon paio di scarpe da passeggio o sportive e vestiti indossabili “a strati”. Agli israeliani (specialmente alle donne) piace vestire con “eleganza casual” per trascorrere le serate a Tel Aviv e Gerusalemme.&nbsp; Per visitare alcuni santuari religiosi è necessario un abbigliamento dal taglio modesto (braccia e gambe coperte e, talvolta, niente pantaloni per le donne). Non dimenticare il costume da bagno e, per il Mar Morto, scarpe di plastica o aqausox.</p>
									<h3>Cosa bisogna sapere sul denaro?</h3>
									<p>La valuta israeliana è lo shekel (il nome ufficiale è “nuovo sheckel israeliano”), che vale circa 30 centesimi di dollaro.&nbsp;<a href="//www.boi.org.il/en/Markets/ExchangeRates/Pages/Default.aspx" rel="nofollow" target="_blank">Per informazioni sul tasso di conversione ufficiale, fare clic qui</a>. All’arrivo in Israele è opportuno usare la carta bancomat per ritirare alcuni shekel dallo sportello ATM presente nella sala arrivi dell’aeroporto Ben Gurion oppure cambiare piccole quantità di dollari o travelers’ checks in banca o in hotel. Su tutto il territorio di Israele sono presenti sportelli ATM e le carte di credito sono accettate ovunque.</p>
									<h3>Elettricità</h3>
									<p>Quasi tutte le stanze di albergo sono dotate di asciugacapelli e dispongono di prese per rasoi elettrici.&nbsp; Per quanto riguarda gli altri elettrodomestici, in Israele l’elettricità è a 220 V C/A, monofase, 50 cicli; si possono usare trasformatori 110 V-220 V.&nbsp; Le prese israeliane sono tripolari, ma di solito le spine bipolari europee sono utilizzabili. Se non si dispone di un adattatore funzionante, contattare la portineria dell’hotel o acquistarlo in una ferramenta.</p>
									<h3>Mantenere i contatti</h3>
									<p>La maggior parte degli hotel dispone di wi-fi gratuito nell’atrio e alcuni hotel lo mettono a disposizione gratuitamente nella stanza. Inoltre, molti hotel dispongono di business center nei quali è possibile utilizzare gratuitamente e-mail e Internet. I telefoni cellulari che funzionano all’estero funzionano anche in Israele. Il fuso orario di Israele è avanti di 6 o 7 ore rispetto a quello della costa est degli USA, a seconda della stagione.</p>
									<h3>Temperature</h3>
									<p>Le temperature sono molto variabili, quindi è opportuno portare con sé indumenti idonei per la stagione in corso e non si avranno problemi.&nbsp; Le stagioni cambiano, naturalmente, ma è possibile tenere conto di alcune linee guida generali:<br>&nbsp;<br>ESTATE (giugno/luglio/agosto/inizio settembre):&nbsp; le temperature sono intorno a 26º C, 33º C.&nbsp; Tel Aviv e Tiberiade sono città calde e umide (come New York o Miami).&nbsp; Gerusalemme ha un clima più secco e fresco, in particolare di notte.&nbsp; Masada ed Eilat sono estremamente calde (oltre 43° C), ma il clima è secco.&nbsp; In pratica, non piove mai.<br>&nbsp;<br>PRIMAVERA E AUTUNNO (fine marzo/aprile/maggio/fine settembre/ottobre/novembre): le temperature diurne sono molto gradevoli, con una temperatura intorno a 24° C in gran parte del Paese (ma nei pressi del Mar Rosso e del Mar Morto fa più caldo). Di sera, Gerusalemme ha una temperatura compresa tra 21°C e 10° C.&nbsp; Ogni tanto piove, ma non si verificano piogge torrenziali.<br>&nbsp;<br>INVERNO (dicembre/gennaio/febbraio/inizio marzo):&nbsp; il tempo invernale può avere delle oscillazioni.&nbsp; Alcuni inverni sono miti e assolati, mentre altri freddi e con molte nuvole. Spesso piove forte e in gennaio e febbraio si possono verificare delle nevicate. Nella maggior parte dei casi le temperature sono comprese tra 10° C e 15° C, ma a Gerusalemme e in Galilea scendono fino a 4° C e di notte fa freddo.</p>
									<h3>Mezzi di trasporto</h3>
									<h3>AUTOBUS:</strong>&nbsp;Israele ha una delle reti di autobus migliore e meno costosa del mondo, con quasi ogni grande città, cittadina e paesino collegati al sistema.</p>
									<p><br><strong>TRENI:&nbsp;</strong>i treni ad alta velocità collegano l’aeroporto di Ben Gurion a Tel Aviv, Gerusalemme e Haifa e la maggior parte del Paese è coperta da un collegamento ferroviario efficiente ed economico.&nbsp; I viaggi in treno sono economici e facilmente accessibili.&nbsp;Per informazioni complete <a href="//www.rail.co.il/EN/Pages/Homepage.aspx" rel="nofollow" target="_blank">fai clic qui</a>.<br>&nbsp;<br><strong>VOLI</strong>: Tel Aviv ed Eilat sono collegate da diversi voli giornalieri delle compagnie aeree Arkia, El Al e Israir. Ci sono anche dei voli verso Haifa e la Galilea.<br>&nbsp;<br><strong>TAXI:&nbsp;</strong>nelle città sono disponibili dei taxi e i tassisti acconsentono anche a svolgere il servizio di trasporto tra città. Prima di partire è opportuno informarsi sul costo del viaggio.<br>&nbsp;<br><strong>TAXI CONDIVISI:&nbsp;</strong>i taxi condivisi, o “sherut”, sono molto diffusi. Le stazioni di “sherut” sono presenti in ogni città. Per informazioni sulla stazione di sherut più vicina, informarsi presso l’hotel.<br>&nbsp;<br><strong>AUTONOLEGGIO:</strong><br>La maggior parte delle agenzie di autonoleggio internazionali ha degli uffici in Israele. Sono presenti anche delle ottime società di autonoleggio israeliane. La patente americana o canadese è valida anche in Israele.</p>
											                       
		                        `,
      };
    },
  },
  {
    id: "Passports_Visa",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "PASSPORTS AND VISA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <p>All visitors to Israel must hold a passport that is valid for at least six months from the date they are departing the country. People with no nationality must hold a valid laissez-passer, as well as a visa back to the country that issued it.</p>
                                <p>Visitors are entitled to remain in Israel up to three months from the date of their arrival, in accordance with the conditions of the visa issued to them. Visitors intending to work in Israel must submit a request to the Ministry of the Interior for a special visa.</p>
                                <p>Israel no longer stamps passports at airports and most Land Crossings. Nonetheless, because at times technical difficulties arise, and at times, the border control must revert to back to the method of stamping passports, we recommend that tourists continuing from Israel on to Arab countries <strong>officially request</strong> that an Israeli stamp does not appear on their passport. The tourist must notify the clerk of this request before documents are stamped.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/passports-visa/1.jpg"} class="img-responsive">
							    </div><br>
							    <h3>The “Electronic Gate Pass”</h3>
								<p>In accordance to section 13 of the law regarding entrance to Israel of 1952, an official inspector or police officer can request identification and proof of legal status in Israel. With this in mind, at a press of a button the Border Control station will print a card including the principle details of the traveler as in the first page of the passport. The card will also depict the date of arrival and visa information. This card is called The “Electronic Gate Pass” and it is a new and modern technological system instrumental in meeting the needs of the various Immigration, security, Airport and Tourism authorities as well as providing the tourist with the credentials necessary to prove his visa status. <strong>The “Electronic Gate Pass” replaces the system whereby passports were stamped.</strong> At the airport, this card allows the traveler to exit the arrival terminal without further delays.</p>
								<h3>The Gate Pass is an official form of identification while in Israel.</strong> We ask all tourists to keep the card at hand at all times as proof of their visa status. At the airport and designated Land Crossings, this card allows the traveler to exit the arrival terminal and continue to the luggage pickup area.</p>
								<h3>The tourist is asked to keep the card at hand at all times.</h3><br>
								<h3>&#8203;Tourist Visas</h3>
								<p>We welcome visitors to Israel. Many countries have a Visa Waiver Program with Israel, which allows their citizens to visit Israel without a visa arranged in advance. Before embarking on a trip, visitors desiring to stop in Israel on their way to other destinations must check if they need a prearranged tourist visa. The list of countries in the following link specifies from which countries tourists are required to present a prearranged visa.</p>
								<p><a href="//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" target="_blank" rel="noopener">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
								<p>All Visa Waiver Program travelers must present a machine-readable passport at the port of entry in order to enter Israel without a prearranged visa; otherwise, a visa is required. This applies to tourists arriving with a passage card from countries with a Waiver Program.</p><br>
								<h3>Extension of Your Stay</h3>
								<p>&#8203;Your visa can be extended (fee required) at the Ministry of the Interior office closest to you, please call their call center at: *3450 or dial 12223450.</p>
            	
		                        `,
      };
    },
  },

  {
    id: "Crazy_Night",
    ctg: "telaviv",
    bgImage: "/posts/bank/crazy-night/1.jpg",
    mobBgImage: "/posts/bank/crazy-night/M.jpg",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    title: "Looking for a crazy nightlife?",
    smltitle: "",
    html: function() {
      return {
        __html: `<div class="ac-cradit">
									<span class="ac-cradit-text">Credits:</span>
										<br/>
										<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
										<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
									</div>
									<p></p>
								</div>
                               <h3>
                                 Book your trip to Tel Aviv!
                               </h3>
                               <p>
                                 Amazing nightlife in Tel Aviv <a href="https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife" target="_blank">Click here >> </a>
                               </p>
		                        `,
      };
    },
  },

  {
    id: "Heart_Of_The_World",
    ctg: "jerusalem",
    bgImage: "/posts/bank/heart-of-the-world/1.jpg",
    mobBgImage: "/posts/bank/heart-of-the-world/M.jpg",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    title: "Gerusalemme: il cuore del mondo",
    smltitle: "",
    html: function() {
      return {
        __html: `
						<br/>
                                <h3>Scopri gerusalemme scopri i segreti della magica città vecchia</h3>
                                <p>Fai un viaggio spirituale indimenticabile nella stupefacente Gerusalemme.</p>
								<p>Gerusalemme è un invito aperto a viaggiare. Scala le montagne, entra nella città e assapora il mix unico di passato e presente, ordinario e straordinario. Una delle città più antiche del mondo sacra per ebrei, cristiani e musulmani, Gerusalemme offre un’esperienza sensoriale e spirituale unica.</p>
								<p>Entra.Il cuore della città più sacra dell’ebraismo è la Città vecchia. Passa dall’ingresso storico, la<em> Porta di Jaffa</em>, oppure utilizza la <em>Porta di Sion</em> che conduce direttamente al<b>quartiere ebraico</b>, uno dei quattro quartieri della città cinta da mura e abitata dagli ebrei in modo quasi del tutto continuativo a partire dall’VIII secolo prima dell’era volgare. Passeggia lungo i vialetti, guarda i passanti, visita il <b>Cardo</b>, l’antica via principale di Gerusalemme, e respira la sua atmosfera esclusiva. Stai seguendo le orme di re e profeti. Non è una cosa di tutti i giorni.</p>
								<h3>Osserva la storia prendere vita e prova l’energia spirituale emanata dalle mura</h3>
								<p>Cosa ha in serbo il futuro.&nbsp;L’ultimo segmento rimasto delle vecchie mura che circondavano il Secondo tempio costituisce il<b>muro del pianto</b>, simbolo del desiderio ardente degli ebrei della loro terra ancestrale e spirituale. Tutti gli ebrei al di fuori di Gerusalemme pregano rivolti verso il luogo in cui ora ti trovi, il luogo in cui, secondo l’ebraismo, risiede Dio. Non importa quali siano i tuoi credo religiosi, l’esperienza induce umiltà. Onora lo spirito del luogo e del posto e lascia un biglietto nel muro, con una preghiera o un auspicio.&nbsp;</p>
								<p>Cosa c’è sotto.Gerusalemme è letteralmente coperta da strati di storia e qui toccare la storia ha un significato completamente nuovo. &nbsp;</p>
								<p>Percorri i tunnel affascinanti del Muro del pianto e scoprine le sezioni nascoste. La storia prenderà vita mano a mano che ti sposterai nei passaggi sotterranei, alla scoperta della vita di Gerusalemme durante l’era del Secondo tempio, imparando a conoscerne l’arte, l’architettura e le tecniche edili.</p>
								<p>Visita il vicino sito archeologico della Città di Davide scopri la storia della città del Re David, dichiarata capitale unificata delle 12 tribù di Israele 3000 anni fa. Fai un viaggio tra le antiche mura e la fortezza, le sorgenti nascoste in cui furono incoronati i re, e segui il percorso degli abitanti di Gerusalemme in fuga dopo la conquista della città da parte dei romani.</p>
								<h3>Ammira il panorama mozzafiato e prova la sensazione di stare in cima al mondo</h3>
								<p>Cosa c’è al di sopraCreata originariamente per proteggere la città dagli intrusi, Gerusalemme è circondata da mura. Oggi le <b>mura di Gerusalemme</b> offrono l’opportunità di esplorare la città da un’angolazione diversa. Ascolta le storie, guarda la città al di sotto di te e fai tua tutta questa bellezza.</p>
								<p>Stai per iniziare ad andare oltre la superficie.</p>
		                        `,
      };
    },
  },

  {
	  id: "Neot_Semadar",
	  ctg: "eilat-negev",
	  bgImage: "/posts/bank/Neot_Semadar/1.jpg",
	  mobBgImage: "/posts/bank/Neot_Semadar/M.jpg",
	  isVid: false,
	  title: "Neot Semadar",
	  smltitle: "",
	  html: function() {
		return {
		  __html: `
								  
  
						<p>Incastonato nel cuore del deserto dell'Arava in Israele, Neot Semadar offre ai viaggiatori un’esperienza unica dove arte, ecologia e comunità si intrecciano. Questo straordinario kibbutz è molto più di una destinazione: è una tela vivente di creatività umana e armonia ambientale.</p>
						<p>Immaginate un luogo dove il prodigio architettonico incontra l'innovazione ecologica. Il centro artistico del kibbutz rappresenta una forte testimonianza di design collaborativo, caratterizzato da un edificio eccezionale con strutture tondeggianti e una torre di osservazione a spirale alta 38 metri: ogni elemento racconta una storia di visione collettiva ed espressione artistica.</p>
						<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/Neot_Semadar/1.jpg"} class="img-responsive">
						</div>
						<p>I visitatori possono esplorare le molteplici sfaccettature di questa comunità desertica: i laboratori degli artisti mostrano l'artigianato locale, inclusa la pittura su seta; l'intaglio del legno e la tessitura. Il paesaggio circostante offre a 360 gradi panorami mozzafiato, invitando i viaggiatori a connettersi con la bellezza primordiale dell'ambiente naturale.</p>
						<p>Oltre ad avere una valenza estetica, Neot Semadar rappresenta un impegno profondo verso uno stile di vita sostenibile. La comunità pratica l'agricoltura biologica, produce prodotti artigianali e mantiene una biodiversità sorprendente che attrae ricercatori scientifici. Con oltre 196 specie di fauna documentate, il kibbutz si distingue come un unico santuario ecologico.</p>
						<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/Neot_Semadar/2.jpg"} class="img-responsive">
						</div>
						<p>Per coloro che cercano un'esperienza immersiva, il sito offre opportunità di coinvolgimento nella vita comunitaria, partecipazione a workshop e consumo di cibi biologici locali. Gli alloggi offrono un rifugio sereno nel deserto, permettendo agli ospiti di staccare la spina e riconnettersi con i ritmi della natura.</p>
						<p>Una visita a Neot Semadar va oltre l'esperienza turistica tradizionale: è un viaggio all'interno di una comunità consapevole e creativa che ridefinisce il potenziale umano in perfetta armonia con il paesaggio desertico.</p>
						<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/Neot_Semadar/3.jpg"} class="img-responsive">
						</div>
						<p>Per ulteriori informazioni sul kibbutz e le opzioni di visita, visitate il nostro sito web: <a href="https://neot-semadar.com/en" rel="noopener" target="_blank">https://neot-semadar.com/en</a></p>
						 `,
		};
	  },
	},

  {
    id: "Magic_City_Of_Splender",
    ctg: "jerusalem",
    bgImage: "/posts/bank/heart-of-the-world/1.jpg",
    mobBgImage: "/posts/bank/heart-of-the-world/M.jpg",
    isVid: true,
    vidId: "RwzdqkM3_CU",
    title: "GERUSALEMME UNA CITTÀ MAGICA DI SPLENDORE",
    smltitle: "",
    html: function() {
      return {
        __html: `
						<br/>
						<h3><i>Prova&nbsp;</i>l’ardore spirituale irradiato dalle grandi mura di pietra</h3>
						<p>Visita la città vecchia di Gerusalemme è come viaggiare in un nuovo mondo mistico e magico. Da tempo una delle località più sacre e visitate, al suo interno si trovano strutture e rovine caratteristiche delle tre religioni monoteiste: Giudaismo, Cristianesimo e Islam. Una passeggiata attraverso i suoi percorsi consacrati ti consentirà di immergerti in un’entusiasmante esperienza storica, culturale e spirituale da non perdere, che ti cambierà la vita.</p>
						<div class="img-wrapper">
														   <img src=${getImgUrl() +
                                 "/posts/magic-city-of-splender/1.jpg"} class="img-responsive">
													    </div>
						<h3>Un ambiente spirituale e illuminante</h3>
						<p>Unisciti ai gruppi di turisti che ogni giorno visitano la città vecchia di Gerusalemme e lasciati trasportare indietro nel tempo. Scopri come ebrei, musulmani, cristiani e armeni vivono e interagiscono mentre visiti i numerosi siti ricchi di ispirazione e spiritualità, nascosti nei vicoli tortuosi della città vecchia e celati dalla fresca pietra di Israele. Cammina lungo il percorso della Via Crucis e visitate le numerose chiese, tra cui la Chiesa del Santo Sepolcro, omaggiate la Tomba del giardino, sussurrate una preghiera presso il Muro occidentale (Kotel), fate un giro nei tunnel sotterranei del Kotel oppure addentrati nell’effervescente mercato arabo. Le strutture sono sensazionali e costituiscono gli ultimi collegamenti con un’epoca ormai passata.</p>
						<h3>Una passeggiata moderna nella storia antica</h3>
						<p>Entra nella città vecchia attraversando uno dei suoi grandi e imponenti cancelli e sarai trasportato immediatamente in un’epoca antica, con i suoi odori autentici e la gente del posto vestita con gli abiti tradizionali. Qui le strade strette e i vicoli sono percorsi da carretti trainati da asini, biciclette e veicoli su misura, che ti faranno provare le emozioni di un mondo antico e agreste. Dei personaggi caratteristici si muovono affaccendati all’interno dei loro negozi, chioschi e ristoranti, vendendo la loro merce con grande energia.</p>
						<p>Nella città vecchia, non dimenticarti di fare una camminata lungo le antiche mura di pietra, dove potrai ammirare gli stupendi edifici storici, le attrazioni locali e immergervi nell’atmosfera affascinante della vita quotidiana. Passeggiando lungo le mura della città vecchia o visitando la vicina torre del museo di David, dove la storia rivive attraverso i suoni e la luce, potrai ammirare la bellezza e comprendere il significato dei ciottoli che calpestate.</p>
						                                
		                        `,
      };
    },
  },

  {
    id: "Privacy_Policy",
    ctg: "telaviv",
    bgImage: "/HomeSlider/desktop/1.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "PRIVACY POLICY",
    smltitle: "",
    html: function() {
      return {
        __html: `


							<p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>
							
							<h3><span>OUR COMMITMENT TO YOU</span><span>&nbsp;</span></h3>
							<p>We, at&nbsp;The Israeli government, the Ministry of Tourism ("<strong>us</strong>", "<strong>we</strong>" or the<strong>&nbsp;"Ministry</strong>") respect the privacy of our users (each, a "<strong>User</strong>" or "<strong>you</strong>") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>&nbsp;</strong>"<strong>Website</strong>" and "<strong>App</strong>" respectively, and collectively the "<strong>Service(s)</strong>"). &nbsp;</p>
							<p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>
							
							<h3><span>CONTENTS</span></h3>
							<p>
							  <a href="#Grounds" style="color:#000"><span>1. </span>GROUNDS FOR DATA COLLECTION</a><br/>

							  <a href="#WhatType" style="color:#000"><span>2. </span>WHAT TYPE OF DATA WE COLLECT?</a><br/>

							  <a href="#HowDoWeUse" style="color:#000"><span>3. </span>HOW DO WE USE THE DATA WE COLLECT?</a><br/>

							  <a href="#Tracking" style="color:#000"><span>4. </span>TRACKING TECHNOLOGIES</a><br/>

							  <a href="#WitWhom" style="color:#000"><span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</a><br/>

							  <a href="#HowWeProtect" style="color:#000"><span>6. </span>HOW WE PROTECT YOUR INFORMATION</a><br/>

							  <a href="#Retention" style="color:#000"><span>7. </span>RETENTION</a><br/>

							  <a href="#UserRigths" style="color:#000"><span>8. </span>USER RIGHTS</a><br/>

							  <a href="#Transfer" style="color:#000"><span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA</a><br/>

							  <a href="#OurPolicy" style="color:#000"><span>10. </span>OUR POLICY TOWARD CHILDREN</a><br/>

							  <a href="#HowToContactUs" style="color:#000"><span>11. </span>HOW TO CONTACT US?</a><br/>

							  <a href="#Updates" style="color:#000"><span>12. </span>UPDATES TO THIS POLICY</a><br/>
							</p>

							
							<h3 id="Grounds"><span>GROUNDS FOR DATA COLLECTION</span><span>&nbsp;</span></h3>
							<p><span>Processing of your “<strong>Personal Data</strong>” (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>
							<p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>
							
							<h3 id="WhatType"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>
							<h3><span>Personal Data</span></h3>
							<p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>&nbsp;or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>
							<ul style="list-style-type: disc;margin-left:0in;">
							  <li><span>When you send us an email&nbsp;</span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>
							  <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>
							</ul>
							<h3><span>Non-Personal Data</span></h3>
							<p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:&nbsp;</span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>
							<p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.&nbsp;</span></p>
							
							<h3 id="HowDoWeUse"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>
							<ul>
							  <li><strong><span>Provision of the Service</span></strong><em><span>&nbsp;–&nbsp;</span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.&nbsp;</span></li>
							  <li><strong><span>Service announcements</span></strong><span>&nbsp;- we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>
							  <li><strong><span>Analytics, surveys and research</span></strong><span>&nbsp;- from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>
							  <li><strong><span>Protecting our interests</span></strong><em><span>&nbsp;-&nbsp;</span></em><span>we may use your Personal Data when we believe it’s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.&nbsp;</span></li>
							  <li><strong><span>Enforcing of policies</span></strong><span>&nbsp;- we may use your Personal Data in order to enforce our policies, including but not limited to our <a href="https://new.goisrael.com/international/Posts/telaviv/Privacy_Policy" style="text-decoration:underline;color:#000" target="_blank"> Terms </a></span><span style="line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;">
								 
								</span><span style="line-height:;font-family:Calibri;line-height:;color:windowtext;">.&nbsp;</span></li>
							  <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>&nbsp;- we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>
							  <li><strong><span>Newsletter</span></strong><span>&nbsp;- we may use your Personal Data in order to send you our newsletter, if you subscribed to it. &nbsp;</span>
								<ol style="list-style-type: circle;">
								  <li><u><span>Opt-out of receiving our newsletter</span></u><span>&nbsp;- You may choose not to receive our newsletter by clicking on the “unsubscribe” link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.&nbsp;</span></li>
								</ol>
							  </li>
							</ul>
							
							<h3 id="Tracking"><span>TRACKING TECHNOLOGIES</span></h3>
							<p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, "<strong>Tracking Technologies</strong>"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services’ performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>
							<p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>
							<h3>Types of Tracking Technologies We Use</h3>
							<p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>
							<p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are "session cookies" and expires upon closing of your browser. Other cookies are "persistent cookies", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>
							<p>For example, we use a performance tracking technology tool called “<strong>Google Analytics</strong>” to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google’s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at 
							  <a href="//www.google.com/analytics/terms/us.html" target="_blank" style="text-decoration:underline;color:#000">www.google.com/analytics/</a>, and the Google Privacy Policy, available at 
							  <a href="//www.google.com/policies/privacy/" target="_blank" style="text-decoration:underline;color:#000">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at 
							  <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" style="text-decoration:underline;color:#000">tools.google.com/dlpage/gaoptout</a>.
							</p>
							<h3><span>Interest-Based Advertising &amp; User Choice</span></h3>
							<p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>
							<h3><span>How to Manage Your Tracking Technologies Settings</span></h3>
							<p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>
							<p style="margin-bottom:6.0pt;"><strong>Turning off cookies via your web browser
								<br>&nbsp;
							  </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the "Help" section of the web browser. Below are some links to some commonly used web browsers:</p>
							<p>
							  <a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank" style="text-decoration:underline;color:#000"><span>Google Chrome</span></a><br/>

							  <a href="https://support.microsoft.com/en-us/kb/260971" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Explorer</span></a><br/>

							  <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" style="text-decoration:underline;color:#000"><span>Mozilla Firefox</span></a><br/>

							  <a href="https://support.apple.com/kb/PH5042?locale=en_US" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Desktop)</span></a><br/>

							  <a href="https://support.apple.com/en-us/HT201265" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Mobile)</span></a><br/>

							  <a href="//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067" target="_blank" style="text-decoration:underline;color:#000"><span>Android Browser</span></a><br/>

							  <a href="//www.opera.com/help" target="_blank" style="text-decoration:underline;color:#000"><span>Opera</span></a><br/>

							  <a href="//www.opera.com/help/mobile/android#privacy" target="_blank" style="text-decoration:underline;color:#000"><span>Opera Mobile</span></a>
							</p>
							<p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>
							<p style="margin-bottom:6.0pt;"><strong>Turning off third party cookies
								<br>&nbsp;
							  </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;
							  <a href="//www.networkadvertising.org/choices/" target="_blank" style="text-decoration:underline;color:#000">Network Advertising Initiative</a>.
							</p>
							<h3><span>Other helpful resources</span><br/></h3>
							<p>
							<span>To learn more about advertisers’ use of cookies the following links may be helpful:</span><br/>
							  <a href="//www.youronlinechoices.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>

							  <a href="//www.iab.net/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (US)</span></a><br/>

							  <a href="//www.iabeurope.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (EU)</span></a>
							</p>
							<p style="margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;"><strong>Turning off cookies on a mobile device</strong></h3>
							<p>You can-opt out of certain types of interest-based advertising, by accessing the “settings” on your device:</p>
							<ul style="list-style-type: disc;margin-left:undefined;">
							  <li><strong><span>If you're using an Apple device</span></strong><span>&nbsp;you can configure your device to limit ad tracking to by clicking on "settings" &gt; "privacy" &gt; "advertising" and toggling "limit ad tracking" to ‘on.’</span></strong></li>
							  <li><strong><span>If you're using an Android device</span></strong><span>&nbsp;you can opt out of most app-based tracking for advertising by opening the "Google Settings" app on your device, selecting "Ads", and then selecting the option to opt-out of interest-based ads.</span></strong></li>
							</ul>
							<p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>
							
							<h3 id="WitWhom"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>
							<ul>
							  <li><strong><span>Internal concerned parties</span></strong><span>&nbsp;- we may share your information with other</span><span style="color:windowtext;">&nbsp;</span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>
							  <li><strong><span>Business partners</span></strong><span>&nbsp;- we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>
							  <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>&nbsp;- we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.&nbsp;</span></li>
							</ul>
							
							<h3 id="HowWeProtect"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>
							<p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn’t publicly available. We limit access of your information only to those employees or partners on a “need to know” basis, in order to enable the carrying out of the agreement between us.&nbsp;</span></p>
							<p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.&nbsp;</span></p>
							
							<h3 id="Retention"><span>RETENTION</span></h3>
							<p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.&nbsp;</span></p>
							
							<h3  id="UserRigths"><span>USER RIGHTS</span></h3>
							<h4><strong><span style="font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;">EU User Rights</span></strong></h4>
							<p><span>As an EU resident, you may request to:&nbsp;</span></p>
							<ol start="1" style="list-style-type: lower-alpha;margin-left: 0px;">
							  <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.&nbsp;</span></li>
							  <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.&nbsp;</span></li>
							  <li><span>Request rectification of your Personal Data that is in our control.</span></li>
							  <li><span>Request erasure of your Personal Data.&nbsp;</span></li>
							  <li><span>Object to the processing of Personal Data by us.&nbsp;</span></li>
							  <li><span>Request to restrict processing of your Personal Data by us.</span></li>
							  <li><span>Lodge a complaint with a supervisory authority.</span></li>
							</ol>
							<p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.&nbsp;</span></p>
							<p><span>Users Outside the EU -&nbsp;</span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>
							
							<h3 id="Transfer"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>&nbsp;</span></h3>
							<p><span>If you reside in the European Union ("<strong>EU</strong>"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>
							
							<h3 id="OurPolicy"><span>OUR POLICY TOWARD CHILDREN</span></h3>
							<p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; “<strong>Age of Consent</strong>”). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>
							
							<h3 id="HowToContactUs"><span>HOW TO CONTACT US?</span></h3>
							<p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href="mailto:Dpo@tourism.gov.il" style="text-decoration:underline;color:#000"> Dpo@tourism.gov.il</a>
							</p>
							
							<h3 id="Updates"><span>UPDATES TO THIS POLICY</span></h3>
							<p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the "Last Updated" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.&nbsp;</p>

						   
							`,
      };
    },
  },
  {
    id: "Dead_Sea2",
    bgImage: "/posts/videos/deadsea/1/1.jpg",
    mobBgImage: "/posts/videos/deadsea/1/M.jpg",
    title: "Il Mar Morto",
    vidId: "Kmq8NulV8Mo",
    ctg: "deadsea",
    isVid: true,
    smlTitle: "",
    html: function() {
      return {
        __html: `
					<h3>È giunto il momento di rilassarsi nella natura. Goditi la vita nel luogo più basso della Terra.</h3>
					<p>
              			Una meraviglia geologica in un ambiente unico e sereno, il Mar Morto è un'attrazione turistica estremamente popolare. Sperimentare la calma, la tranquillità dell'acqua con le sue distinte proprietà curative mentre si gode della bellezza senza pari del paesaggio circostante
              			<strong>Il Mar Morto, noto anche come la più antica Spa naturale del mondo, è consacrato da una concentrazione di sale estremamente elevata pari al 31,5%, che consente ai turisti di tutto il mondo di sperimentare senza alcuno sforzo le acque del posto più basso della Terra. Inoltre qui è possibile </strong> fare il bagno nel fango nero della zona o esplorare i paesaggi affascinanti e ricchi di storia.
              		</p>

              		<p>
              			Alberghi di lusso, cucina varia da ristoranti gourmet a fast food, negozi di souvenir, la straordinaria storia della vicina Masada e molte attività culturali durante tutto l'anno, rendono il Mar Morto una destinazione popolare per i turisti locali e per i visitatori internazionali.
              		</p>

					`,
      };
    },
  },
  {
    id: "TelAviv_On_Wheels",
    ctg: "telaviv",
    bgImage: "/posts/bank/40/1.jpg",
    mobBgImage: "/posts/bank/40/M.jpg",
    isVid: true,
    vidId: "-eNQe5STaGY",
    title: "Avventure all’aperto",
    smltitle: "",
    html: function() {
      return {
        __html: `

		            <p>
		                Una città ricca di energia – perfetta per persone attive.<br/>
						La gente di Tel Aviv vive la vita al massimo – e lo fa all’aperto. Questa città è stracolma di attività da svolgere all’aria aperta e potrai scegliere quella che più preferisci. È una città ricca di avventure, perfetta per le persone più attive.
					</p>
					<div class="img-wrapper">
		                <img src=${getImgUrl() +
                      "/posts/55/1.jpg"} class="img-responsive" />
		            </div>
					<h3>
						Hayarkon Park
					</h3>
					<p>
						Noto come il Central Park di Tel Aviv, Hayarkon Park viene visitato da circa 16 milioni di persone ogni anno. Le sue attrazioni spaziano dai picnic sui suoi immensi prati alle barche a pedali per godersi un giro nel lago artificiale, fino alle piste ciclabili e alle visite guidate nei suoi incredibili giardini – una vera oasi naturale nel cuore della città.
					</p>
					<h3>
						Ciclismo in città
					</h3>
					<p>
						Una delle maniere migliori per esplorare Tel Aviv è attraverso i suoi 100 km di piste ciclabili. Potrai usufruire del servizio pubblico di noleggio Tel-O-Fun che permette ai residenti di prendere e poi riconsegnare un’agile bicicletta verde in più di 150 punti in tutta la città. Se ti piace passare del tempo sulle ruote, ti consigliamo di dare un’occhiata ai tanti parchi dedicati allo skate, dove potrai guardare allenarsi gli spericolati del posto, oppure noleggiare il tuo skateboard o pattini e unirti a loro.
					</p>
		        `,
      };
    },
  },

  {
    id: "Dead_Sea_Video",
    bgImage: "/posts/bank/natures-glory/1.jpg",
    mobBgImage: "/posts/bank/natures-glory/M.jpg",
    title: "Il Mar Morto",
    ctg: "deadsea2",
    isVid: true,
    vidId: "ixFocykfYHo",
    smlTitle: "",
    html: function() {
      return {
        __html: `
				<br/>
                      <p>È giunto il momento di rilassarsi nella natura. Goditi la vita nel luogo più basso della Terra</p>
                   
         	`,
      };
    },
  },

  {
    id: "Jerusalem_Calling",
    bgImage: "/posts/bank/25/1.jpg",
    mobBgImage: "/posts/bank/25/M.jpg",
    vidId: "1Yx2Uht4rms",
    ctg: "jerusalem",
    isVid: true,
    title: "Gerusalemme ti chiama",
    smltitle: "",
    html: function() {
      return {
        __html: `
						<br/>
						<h3>La città più magica e splendida sulla Terra</h3>
                     <p>
						Cos’altro si può dire della città più esclusiva del mondo? Benvenuti a Gerusalemme, il luogo dove una storia senza eguali si intreccia con un’atmosfera moderna e dinamica.
					</p>

					<p>
						Gerusalemme ospita molti affascinanti siti storici, magici viali, vedute mozzafiato al tramonto, innumerevoli possibilità di svago, ristoranti che offrono piatti squisiti, una vivace vita notturna e un’offerta formidabile di centri artistici e culturali.
					</p>

					<h3>
					   La Città Vecchia
					</h3>
					<p>
						Non esiste altro luogo al mondo che offra una concentrazione simile di affascinanti attrazioni e siti turistici in un solo chilometro quadrato. La Città Vecchia di Gerusalemme pullula di opportunità per scoprire il fulgido passato, la storia, la cultura e la spiritualità della città. Nella Città Vecchia troverai tesori archeologici risalenti a migliaia di anni fa, arte contemporanea e mercati brulicanti di persone dove assaggiare deliziosi manicaretti.
					</p>


					<h3>
					  Il Muro occidentale:
					</h3>
					<p>
						il Muro occidentale, considerato l’unica sezione rimasta del Secondo Tempio, è diventato l’emblema di Gerusalemme. Con le sue migliaia di anni di età, è il luogo di preghiera più importante al mondo per l’ebraismo; è qui che i tredicenni vengono a celebrare il loro bar mitzvah, il momento di confermazione della propria fede e l’ingresso ufficiale nella comunità degli adulti, ed è alle sue crepe che milioni di visitatori e turisti provenienti da tutto il mondo affidano richieste e preghiere.
					</p>
					<h3>
					   La Città di Davide:
					</h3>
					<p>
						situato nei pressi della Porta dei "Rifiuti", questo sito presenta la storia di Gerusalemme durante i regni di Re Davide, Re Salomone e Re Ezechia. Durante gli scavi sono stati riportati alla luce molti tesori archeologici, tra cui un orecchino d’oro risalente a duemila anni fa.
					</p>
					<p>
					   In questo sito avrai la possibilità di prendere in mano una torcia e farti strada tra le acque del tunnel di Siloam, edificato durante il regno del Re Ezechia.
					</p>

					<h3>
					 La Basilica del Santo Sepolcro:
					</h3>
					<p>
						i cristiani di tutte le confessioni ripercorrono i passi di Gesù sulla Via Dolorosa e le 14 stazioni della Via Crucis, ricostruendo il fatidico percorso che rivoluzionò il corso della storia.
					</p>

					<h3>
					  Church of the Holy Sepulchre:
					</h3>
					<p>
						secondo la tradizione cristiana, la Basilica è il luogo in cui Gesù fu crocifisso, sepolto e dove poi risuscitò. È stato per lungo tempo e continua a essere un’importante meta di pellegrinaggio per i cristiani di tutto il mondo.
					</p>

					<h3>
					 Il mercato della Città Vecchia:
					</h3>
					<p>
						questa attrazione imperdibile è costituita da una serie di stradine in cui si ammassano locali che offrono una varietà incredibile di souvenir, articoli d’abbigliamento, cibo (prodotti da forno, spezie, dolciumi, tahini e molto altro), bancarelle che vendono succhi di frutta di ogni genere, ceramiche armene, tamburi e altri strumenti musicali, recipienti di terracotta e tanto altro ancora. Questo colorato mercato regala un’esperienza autentica ed estremamente piacevole: da non perdere.
					</p>

					<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/4/2.jpg"} class="img-responsive" />
							</div>

					<h3>
						Attrazioni
					</h3>

					<h3>
						Tour in segway:
					</h3>
					<p>
						la visita della città in segway è un’esperienza di pura adrenalina che consente di cogliere lo splendore di Gerusalemme da un punto di vista completamente nuovo. I tour in segway partono da vari punti centrali, tra cui la Passeggiata Armon HaNatziv (East Talpiot), Yemin Moshe e la Città Vecchia, nei pressi del Knesset (parlamento) e della zona dei musei.
					</p>

					<h3>
                        La prima stazione (Hatachana)
					</h3>

					<p>
					   la Prima stazione si trova proprio nel cuore di Gerusalemme, tra la Città Vecchia e il centro città e tra i quartieri storici della Colonia tedesca e di Yemin Moshe. Qui, nel 1892, fu edificata la prima stazione ferroviaria di Gerusalemme. In seguito a importanti interventi di ristrutturazione e salvaguardia, la Prima stazione è stata riaperta e trasformata in un vivace luogo di intrattenimento.
					</p>

					<h3>
                        L’Ascensore del tempo
					</h3>

					<p>
					   gli amanti dei parchi divertimento impazziranno per le sensazioni che regala l’Ascensore del tempo. È un’esperienza interattiva che porta i visitatori in luoghi affascinanti, con le straordinarie sedute in movimento in una sala piena di effetti speciali.
					</p>

					<h3>
					   Il Mercato Machane Yehuda
					</h3>

					<p>
					   per conoscere la città nella maniera più autentica possibile, non si può prescindere da una sosta al Mercato Machane Yehuda. Rappresenta la Gerusalemme del presente e del futuro. Machane Yehuda fonde in maniera straordinaria antico e moderno, con il mercato ortofrutticolo, prodotti alimentari eccellenti e una vivace zona di intrattenimento.
					</p>

					<h3>
					   I musei
					</h3>

					<p>
					   In una città così piena di musei, ci sono innumerevoli opportunità di scoprire e toccare con mano gli avvenimenti del passato e visitare mostre d’arte moderna e contemporanea.


					</p>

					<h3>
					   Il Museo d’Israele
					</h3>

					<p>
					   il Museo d’Israele è la più importante istituzione culturale del Paese. È caratterizzato da numerose gallerie e vaste collezioni di opere d’arte, archeologia e oggetti ebraici. Una delle punte di diamante del museo è il Santuario del Libro, edificio che con il suo design straordinario è stato paragonato alla città stessa.
					</p>

					<h3>
					   Il Museo della Torre di Davide:
					</h3>

					<p>
					 migliaia di anni fa, Gerusalemme era una cittadina tra i cui vicoli re e profeti passeggiavano a piedi o a cavallo. Da allora la Torre di Davide è diventata uno dei simboli più celebri della città, con la torretta che si erge in tutta la sua magnificenza al di sopra dell’antica fortezza, che è ormai diventata uno dei musei più importanti della città.
					</p>

					<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/4/3.jpg"} class="img-responsive" />
							</div>

					<h3>
					   I ristoranti
					</h3>

					<p>
					  Gerusalemme vanta moltissimi ristoranti, dove si può gustare una vasta scelta di squisitezze locali e internazionali, comuni ed esotiche. Un consiglio per i buongustai: prenota il tuo tavolo in uno dei ristoranti degli chef più esclusivi.
Di seguito sono indicati cinque tra i locali più eleganti e popolari di Gerusalemme, che attirano folle di persone da mattino a sera:
					</p>

					<h3>
					   Café Kadosh
					</h3>

					<p>
					 Questo caffè molto popolare serve piatti kosher, tutti fatti in casa e tutti da leccarsi i baffi!
					</p>

					<h3>
					   Tmol Shilshom
					</h3>

					<p>
					 Un caffè libreria nel centro città dall’atmosfera accogliente, che offre piatti deliziosi e un servizio cordiale. Non lasciartii sfuggire la shakshuka o il filetto di salmone con salsa ai fichi!
					</p>

					<h3>
					   The Eucalyptus
					</h3>

					<p>
					  Questo ristorante kosher, situato nel Quartiere degli artisti, serve piatti che rappresentano l’interpretazione della cucina biblica dello Chef Moshe Basson. Ogni piatto trae ispirazione da scene bibliche e tutte le spezie e le erbe utilizzate crescono, come nei tempi antichi, sulle colline che circondano Gerusalemme e la Giudea. Un’esperienza davvero indimenticabile.
					 </p>

					<h3>
					   Darna
					</h3>

					<p>
					 Un vero ristorante marocchino glatt kosher (solo di carne) nel cuore della città. Scopri l’accoglienza e il vero significato dell’ospitalità marocchina, gustando l’eccellenza culinaria del Maghreb
					</p>

					<h3>
					   Ristorante Ima
					</h3>

					<p>
					  Situato in fondo alla strada del mercato Machane Yehuda, Ima offre eccellenti piatti kosher mediorientali, serviti in un’atmosfera familiare e rilassata.
E non si può andare via da Gerusalemme senza avere assaggiato dell’humus accompagnato da una pita appena sfornata. Ecco alcuni locali in centro dove vivere questa vera esperienza culinaria:
					</p>


					<div class="cradit">
							<p>
							<strong>Azura,</strong><small> nella parte irachena del Mercato Machane Yehuda  </small><br>
							<strong>Lina,</strong><small> nel Quartiere cristiano della Città Vecchia</small><br>
							<strong>Hummus Acramawi,</strong><small>nel Quartiere mussulmano della Città Vecchia</small><br>
							<strong>Hummus Ben Sira</strong><small> nel centro città vicino al Mamilla Hotel</small><br>
							<strong>Abu Shukri,</strong><small>nel Quartiere mussulmano della Città Vecchia di Gerusalemme</small><br>
							</p>
				    </div>

				    <h3>
				        La vita notturna
				    </h3>

				    <p>
				        Gerusalemme è ricca di ristoranti e locali aperti anche di venerdì sera (lo Shabbat). Le zone più dense di locali di Gerusalemme hanno alternative per tutti i gusti di venerdì e di sabato sera, da chi vuole sorseggiare una buona birra in compagnia a chi ama scatenarsi in pista.
Di seguito è presentata una selezione di bar e locali notturni che il venerdì sera pullulano di vita: non vorrai più tornare a casa…
				    </p>

				    <h3>
				       Mantra
				    </h3>

				    <p>
				       Un ristorante e wine bar molto intimo, dove un’atmosfera cordiale si fonde con una cucina strepitosa.
				    </p>

				    <h3>
				       Gatsby Cocktail Room
				    </h3>

				    <p>
				       Questo cocktail lounge e bar richiama l’atmosfera magica dei ruggenti anni ’20 e degli spettacoli di cabaret.
				    </p>

				    <h3>
				        HaTaklit
				    </h3>

				    <p>
				       Questo bar di tendenza, il cui nome in ebraico significa “il disco”, è decorato con le copertine interne dei vinili. Ti aspetta per farti scoprire i suoi drink, la musica live, i DJ e i performer indipendenti che ospita.
				    </p>

				    <h3>
				       Toy Bar (HaTza’atzua)
				    </h3>

				    <p>
				      Questo straordinario locale notturno situato in posizione centrale offre squisiti drink e l’ottima musica di alcuni dei migliori DJ locali.
				    </p>

				    <h3>
                        Sira
				    </h3>

				    <p>
                       Uno dei locali underground più eclettici della città, con una sala giochi e una pista da ballo. Il pub ospita anche eventi e spettacoli.
				    </p>

				    <h3>
                        Even / Juke
				    </h3>

				    <p>
				       Un club di musica che ospita le band più creative di Israele, soprattutto nell’ambito del jazz, del blues e del funk.
				    </p>

				    <h3>
                       Video Pub
				    </h3>

				    <p>
				       Jerusalem’s only “official” gay bar is home to some of the wildest parties in the city.
				    </p>

				    <p>
				       L’unico gay bar “ufficiale” di Gerusalemme detiene il record delle feste più scatenate della città.

JGerusalemme è il non plus ultra delle destinazioni di vacanza! C’è così tanto da vedere e da fare, così tanto per stimolare i sensi e risvegliare la curiosità… un viaggio a Gerusalemme è la promessa di un’esperienza indimenticabile. Prenota subito il tuo soggiorno!
				    </p>

				    <div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/4/4.jpg"} class="img-responsive" />
							</div>


					<h3>
					   Appuntamenti annuali
					</h3>

					<p>
					   Gerusalemme ospita moltissimi eventi annuali straordinari. Per ulteriori informazioni e date, fai una ricerca su Internet.
					</p>

					<h3>
					   Festival delle luci:
					</h3>

					<p>
					   ha luogo nella Città Vecchia ogni anno tra la fine di maggio e l’inizio del mese di giugno. Sarà una esperienza indimenticabile lasciarsitrasportare dagli incantevoli giochi di luci e colori delle decine di opere di artisti israeliani e internazionali. Segui all’interno della Città Vecchia i percorsi che ti guideranno da una straordinaria installazione all’altra.
					</p>

					<h3>
					   Fiera internazionale di Arti e Mestieri (Khutsot Hayotser):
					</h3>

					<p>
					  Ha sempre luogo nel mese di agosto. Le mura della Città Vecchia faranno da cornice a questa fiera, in cui i visitatori avranno l’opportunità di trascorrere serate in un’atmosfera speciale con musica dal vivo. Concedeti una passeggiata nei giardini e qualche sosta presso gli stand in cui artisti israeliani e internazionali di fama mondiale esporranno dipinti, stampe, ceramiche, oggetti in metallo, gioielli, tessuti e filati, oggetti della cultura ebraica, giocattoli, oggetti artigianali realizzati con le tecniche più disparate, oggetti in legno e tanto altro ancora.
					</p>

					<h3>
					   Festival di Israele
					</h3>

					<p>
					   Ogni anno, tra la fine di maggio e l’inizio di giugno. È il primo festival internazionale tenuto in Israele. Ha luogo ogni anno in primavera e presenta straordinarie performance teatrali, di danza contemporanea, musica classica e spettacoli provenienti da tutto il mondo, insieme a innovative opere israeliane. Il festival prevede numerosi eventi organizzati in luoghi della città carichi di una storia lunga centinaia, se non migliaia, di anni. Vengono allestiti anche spettacoli di strada aperti a tutti.
					</p>

					<h3>
					  Festival del cinema di Gerusalemme
					</h3>

					<p>
					  Appuntamento estivo che ha luogo ogni anno nel mese di luglio. Il festival cosparge la città di polvere di stelle con il grande cinema e l’arrivo di attori e scrittori di fama mondiale. Molte celebrità vi hanno presenziato nel corso degli anni. Oltre 200 film israeliani e stranieri dei generi più disparati saranno proiettati e candidati per l’assegnazione dei premi. Il festival offre l’opportunità di incontrare gli artisti e partecipare a laboratori, feste ed eventi musicali.
					</p>

					<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/4/5.jpg"} class="img-responsive" />
							</div>


		         `,
      };
    },
  },

  {
    id: "Jerusalem_Main_Sites",
    ctg: "jerusalem",
    bgImage: "/posts/bank/20/1.jpg",
    mobBgImage: "/posts/bank/20/M.jpg",
    isVid: true,
    vidId: "k4OwoEk5wMw",
    title: "LUOGHI IMPORTANTI DI GERUSALEMME",
    smltitle: "",
    html: function() {
      return {
        __html: `
                      <br/>
                      <h3>Lo spirito di Gerusalemme. Alla scoperta di migliaia di anni di storia</h3>










			                    <p>
Come per ogni città, anche per Gerusalemme il fascino e l’essenza del luogo vengono meglio assaporati percorrendo la città a piedi, quindi, a seconda degli interessi personali di ognuno, non è il caso di omettere una visita ad almeno parte dei siti che vi elenchiamo qui sotto.
<br>
Raccomandiamo di vestirsi in modo modesto in occasione di visite a siti religiosi, facendo uso di abiti che coprano ginocchia e spalle.
<br>
La città vecchia è un buon punto dal quale iniziare ad esplorare Gerusalemme: l’atmosfera che vi si respira è molto speciale, e contiene inoltre molti dei siti più interessanti di quest’area urbana.
</p>

                    <h3>
                        LA CITTA’ VECCHIA
                    </h3>

                    <h3>
                        IL MURO OCCIDENTALE DI GERUSALEMME
                    </h3>

                 <p>
Il Muro Occidentale, anche conosciuto con i nomi di Muro del Pianto e Kotel, è il muro perimetrale occidentale del Secondo Tempio. Considerato il luogo più santo per l’ebraismo, il muro ha due accessi, rispettivamente per gli uomini e per le donne, che si riuniscono per compiere la preghiera mattutina, pomeridiana e serale. Molte e diverse le persone che si affollano per pregare appoggiate alle antiche pietre infilando negli interstizi piccoli pezzi di carta dove sono scritte preghiere personali, o semplicemente per ammirare il posto.
<br>
Indirizzo: Quartiere ebraico, Città vecchia <br>
Telefono: +972-2-627-3515<br>
Orario: 24/7<br>
</p>

                    <h3>
                        LA VIA DOLOROSA
                    </h3>

                    <p>
                        Attraversando il quartiere musulmano da est ad ovest, troverete la strada che porta le tracce degli ultimi passi di Gesù verso la crocifissione. E’ una meta popolare tanto per i pellegrini che per il turista generico: il percorso si sviluppa lungo 14 eventi legati all’ultimissima parte della vita di Gesù, il tutto immerso tra tipici negozi e bancarelle. Raccomandiamo di visitarla venerdì pomeriggio (alle 15:00 durante i mesi invernali, alle 16:00 in quelli estivi) quando i Francescani la percorrono con una processione.
Indirizzo: Via Dolorosa, Quartiere musulmano, Città vecchia
                    </p>

                    <h3>
                        LA CHIESA DEL SANTO SEPOLCRO A GERUSALEMME
                    </h3>

                    <p>
                      Uno dei luoghi più sacri ai cristiani, questo impressionante edificio richiama ogni anno milioni di pellegrini da ogni parte del mondo. Secondo la tradizione, l’area corrisponderebbe al Golgota (il monte Calvario), dove i testi dei Vangeli localizzano la crocifissione, la sepoltura e la resurrezione di Gesù.
Indirizzo: tra il Suq Khan e-Zeit e la via del Quartiere cristiano, Città vecchia
Telefono: +972-2-627-3314
Orario: Dom.– Sab. Dalle 5:00 – alle 20:00/21:00
                    </p>

                   <h3>
                        IL DUOMO DELLA ROCCIA
                    </h3>

                    <p>
Il terzo luogo santo per l’Islam. Il Duomo della Roccia è costruito in cima al Monte del Tempio e si staglia sulla linea dell’orizzonte di Gerusalemme. Al centro del santuario la Pietra di Fondazione, dalla quale, secondo la tradizione musulmana, il profeta Maometto è asceso al cielo. Ai non musulmani non viene consentito l’accesso diretto fino alla Pietra di Fondazione, mentre l’entrata al Duomo della Roccia viene consentita durante un orario limitato.
Indirizzo: accesso tra il Muro Occidentale e la Porta dei rifiuti, Città vecchia
Telefono: +972-2-628-3292 or +972-2-628-3313
Orario: Dom.- Giov. 7:30 – 11:00, 13:30 – 14:30 (aprile-settembre), Dom.- Giov.: 8:00 – 10:00,
12:30 – 14:00 (ottobre-marzo), Ven.-Sab.: chiuso.
                    </p>

                    

					<h3>
					   OUTSIDE THE OLD CITY WALLS
LA CITTADELLA DI DAVIDE
					</h3>

					<p>
La Cittadella di Davide (nota anche col nome di Torre di Davide) è stata edificata originariamente nel secondo secolo a.C.per rinforzare un punto strategicamente debole nelle difese della città, di conseguenza venne sovente distrutta e riedificata nel corso dei secoli. A partire del 1989, i locali della Cittadella ospitano un museo affascinante che illustra la storia di Gerusalemme. Non va dimenticato di godersi dai bastioni la splendida vista della città.
<br>
Indirizzo: Porta di Giaffa, Quartiere cristiano, Città vecchia<br>
Telefono: +972-2-626-5333<br>
Orario: Dom.- Giov.: 10:00 – 16:00, Ven.: chiuso, Sab: 10:00 – 14:00 (da settembre a giugno)<br>, Dom.- Giov.: 10:00 – 17:00, Ven.: 10:00 – 14:00, Sab.: 10:00 – 17:00 (luglio-agosto)
</p>
                    <h3>
                        LA CITTA’ DI DAVIDE
                    </h3>
<p>
I resti della città, un tempo molto estesa, risalente ai tempi dei re di Giudea, sono situati nel sottosuolo dell’area del villaggio arabo di Silwan. Un centro visitatori grande e molto organizzato offre un tour che parte da un punto di osservazione sui resti dell’antica città, proseguendo poi per passaggi sotterranei che permettono di attraversare siti archeologici di recente scoperta, e termina alle sorgenti del Ghihon dove, secondo la tradizione, Salomone sarebbe stato unto re. Possibile anche percorrere il tunnel di Ezechia, vecchio di 2.700 anni.
<br>
Indirizzo: Silwan, Gerusalemme Est <br>
Telefono: +972-2-626-2341 <br>
Orario: Dom.- Giov.: 8:00 – 17:00 (inverno), 8:00 – 19:00 (estate), Ven.: 8:00 – 13:00 (inverno), 8:00 – 15:00 (estate)
</p>

                    <div class="img-wrapper">
			            <img src=${getImgUrl() + "/posts/9/3.jpg"} class="img-responsive" />
			          </div>

					<h3>
                      IL MONTE DEGLI ULIVI
                    </h3>

                    <p>
                        E’ la collina che si erge ad est della Città vecchia. Il Monte degli Ulivi offre un incredibile colpo d’occhio sulla Città vecchia ed il Duomo della Roccia. Le pendici sono coperte da da sepolture e luoghi sacri tra cui ad esempio la Chiesa delle Nazioni. Per riuscire ad avere uno sguardo su tutto, raccomandiamo di iniziare la passeggiata dalla cima, accanto alla Moschea dell’Ascensione, per poi scendere passando per la Tomba della Vergine. Il migliore panorama della Città vecchia si può vedere la mattina.
Indirizzo: Monte degli Ulivi, Gerusalemme Est.
                    </p>

                    <h3>
                        YEMIN MOSHE
                    </h3>

                    <p>
                       Questo quartiere affascinante che guarda la Città vecchia era stato originariamente costruito per sfuggire al sovraffollamento della Città vecchia nel XIX sec.. E’ famoso per il suo mulino a vento e per un blocco di costruzioni condominiali, denominato Mishkenot Shaananim, ora divenuto un centro per eventi culturali ed artistici. Yemin Moshe fa parte di un’area nella quale abitano numerosi artisti, scrittori ed accademici, con molti edifici di stile orientale, parchi verdi, un centro musicale, il YMCA, l’albergo King David e la tomba della famiglia di Erode.
                    </p>

                    <h3>
                        IL CENTRO CITTA’
MAMILLA ALROV AVENUE
                    </h3>

<p>
Mamilla Alrov Avenue è un centro commerciale ed isola pedonale, situato tra il centro città e la Città vecchia. Mamilla, che presenta numerosi negozi di lusso e buoni ristoranti e caffè, è conosciuta per la sua atmosfera europea, fatta di chic e buon gusto, ed offre una vista spettacolare sulle mura della Città vecchia.
<br>
Indirizzo: 6 Yitzhak Kariv St, Gerusalemme
<br>
Telefono: +972-2-636-0000<br>
Orario: Dom.- Giov.: 10:00 – 21:30 (inverno), 10:00 – 22:30pm (estate), Ven.: 9:00 – 14:00 (inverno), 9:30 – 15:30 (estate), Sab.: a partire da un’ora dopo la fine dello Shabbat – 23:00.
</p>
                    <h3>
                        BEN YEHUDA STREET
                    </h3>

                    <p>
                    Uno dei principali luoghi di ritrovo di Gerusalemme, sia per gli abitanti che per i turisti. Ben Yehuda Street è un centro commerciale ed isola pedonale, situato tra King George Street e Jaffa Road, nel centro di Gerusalemme. E’ una strada piena di negozi di, gelaterie e rosticcerie, artisti di strada e mendicanti.
                    </p>

                    <div class="img-wrapper">
			            <img src=${getImgUrl() + "/posts/9/3.jpg"} class="img-responsive" />
			        </div>

					<h3>
                        NACHALAT SHIVA
                    </h3>

                    <p>
                          This charming cobblestone neighbourhood just south of Ben Yehuda Street in the city center offers a great selection of shops, restaurants, bars and outdoor cafes. This is a great place to experience in summer and at night with many bustling until late.
                    </p>

                    <h3>
                       NACHALAT SHIVA
                    </h3>

                    <p>
Ecco un affascinante quartiere dalle stradine lastricate a sud di Ben Yehuda Street, in pieno centro città [city center] che offre una grande scelta di negozi, ristoranti, bar e caffè all’aperto. Gradevolissimo da frequentare durante le sere d’estate, quando continua ad essere animato fino a tardi.
                    </p>

                    <h3>
                        Il mercato di Mahane Yehuda
                    </h3>

                    <p>
                         Sovente denominato “lo shuk”, il mercato di Mahane Yehuda offre un vasto assortimento di prodotti freschi e cibarie, oltre che una grande varietà di negozi di altro genere di articoli, quali abiti, attrezzatura per la cucina, gioielli, ceramiche, nonchè una scelta gastronomica estremamente differenziata. Lo shuk comprende un’area chiusa ed una aperta, limitate da Jaffa Road da una parte, e dalla frequentatissima Agrippas dall’altra. Raccomandiamo di recarsi al shuk in autobus o in tram, dato che i parcheggi non sono mai sufficienti, ed il traffico è notevole. Se la gran folla non vi disturba, potreste recarvi al mercato il venerdì pomeriggio, per provare il brivido della spesa “dell’ultimo minuto” prima dell’inizio di Shabbat.
Indirizzo: Agrippas e Jaffa Street, Gerusalemme
                    </p>


                    <h3>
                       YAD VASHEM
                    </h3>

                    <p>
                        Yad Vashem, il memoriale israeliano dell’Olocausto, commemora i sei milioni di uomini, donne e bambini uccisi dai nazisti e dai loro alleati. E’ situato ai piedi del monte Herzl, ed è diviso in diversi toccanti memoriali, tra i quali la Sala della Memoria ed il Padiglione dei Bambini; il Museo della storia dell’Olocausto; il Museo dell’arte nel periodo dell’Olocausto; sculture ed installazioni; un enorme archivio ed un istituto di ricerca. Raccomandiamo di vestirsi in modo appropriato e di riservare alcune ore alla visita del museo. Indirizzo: Har Hazikaron
Telefono: +972-2-644-3400
                    </p>

                    <h3>
                      IL MUSEO D’ISRAELE
                    </h3>

                    <p>
                          Assolutamente fondamentale dedicare almeno una giornata alla visita della maggiore Istituzione culturale di Israele: il Museo d’Israele, che ha passato una profonda revisione nel 2010. Il Museo è costituito da diverse ali e di un’importante collezione di opere d’arte, reperti archeologici e oggetti legati al culto ed alla tradizione ebraica. Una delle parti più affascinanti è il Tempio del Libro, racchiuso in un edificio architettonicamente molto caratteristico, che ospita molti antichi manoscritti, tra i quali i Rotoli del Mar Morto. Importante anche l’ala dei giovani, dedicata ai bambini, il Billy Rose Art Garden, che presenta lo sviluppo della scultura occidentale nel corso dei secoli, nonchè l’ala delle Belle Arti e quella, estremamente curata, dedicata all’Archeologia.
                    </p>




			        `,
      };
    },
  },

  {
    id: "TelAviv_Highlights",
    ctg: "telaviv",
    bgImage: "/posts/bank/37/1.jpg",
    mobBgImage: "/posts/bank/37/M.jpg",
    isVid: true,
    // vidId: "R0QsWBZfIpU",
    vidId: "tgF0zMUYY2g",
    title: "I must di Tel Aviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

                          <br/>
                        <h3>Le 5 cose da fare e vedere in città:</h3>
			          <h3>
					    Jaffa vecchia
					</h3>
					<p>
							Anche se questa zona ha una storia ormai millenaria, una visita nel centro storico di Jaffa ti darà sempre le emozioni di una nuova scoperta. I suoi sinuosi e affascinati viali sono intervallati da gallerie d’arte, edifici storici, straordinari monumenti e da una grandissima quantità di pittoreschi ristoranti tipici. Un giro nel centro storico di Jaffa è un’esperienza profonda e ispirante, decisamente un must per qualsiasi turista che visita Israele.
          </p>
					<h3>
							Il porto di Jaffa
					</h3>
					<p>
							Considerato uno dei porti più antichi del mondo, il porto di Jaffa è stato un punto di riferimento per pescatori, marinai, mercanti, crociati, conquistatori e immigrati per migliaia di anni. Oggi, il porto continua a essere utilizzato per la pesca; inoltre, è stato recentemente rinnovato in modo da trasformarlo in un’attrazione urbana ricca di attività culturali e di divertimento, shopping e turismo, mantenendo al tempo stesso il suo affascinante carattere storico.
          </p>
					<h3>
							Il porto di Tel Aviv
					</h3>
					<p>
							Recentemente restaurata, la zona del porto è trendy e ha veramente tutto. Durante il giorno potrai ritrovarti a vagare nei suoi impressionanti spazi in stile hangar alla ricerca di boutique nelle quali fare shopping, assaporando ottimo cibo in uno dei ristoranti con vista sul mare o partecipare a una delle tante attività adatte a tutta la famiglia. Di notte, gruppi di giovani clubber popolano la zona, che si trasforma in uno dei punti di ritrovo più popolari della città grazie alla presenza di alcuni dei club e bar più alla moda di Tel Aviv.
          </p>
					<h3>
					    La città bianca
					</h3>
					<p>
							Unisciti a un affascinante tour della “Città bianca” di Tel Aviv e scopri perché è stata dichiarata patrimonio dell’umanità dall’UNESCO. La Città bianca è sede di uno dei più grandi raggruppamenti di edifici in stile internazionale, anche noto come Bauhaus. Costruita nel corso degli anni ’20 e ’30, la “Città bianca” è stata magnificamente restaurata in modo da riportarla alla sua gloria originale, continuando a essere un unico e memorabile tesoro dell’architettura.
          </p>
					<h3>
					    Neve Tzedek
					</h3>
					<p>
							Prenditi una pausa dal ritmo frenetico di Tel Aviv; questo quartiere è un autentico gioiello nascosto, ricco di edifici in stile orientale e affascinanti vicoli. Tutto ciò rende Neve Tzedek, che letteralmente significa “oasi di giustizia”, una vera e propria oasi nel cuore di una vivace città.
          </p>

			        `,
      };
    },
  },

  {
    id: "TLV_Vegan_Scene",
    ctg: "culinarytelaviv",
    bgImage: "/posts/bank/8/1.jpg",
    mobBgImage: "/posts/bank/8/M.jpg",
    isVid: true,
    vidId: "SP0kGcLSVQk",
    title: "L’ATMOSFERA VEGANA DI TEL AVIV",
    smltitle: "",
    html: function() {
      return {
        __html: `
			         <br/>
			         <h3>Provate i migliori ristoranti vegani che abbiamo scelto per voi a Tel Aviv</h3>
			         
                      <p>
						Quest’anno il sito web statunitense The Daily Meal ha nominato Tel Aviv destinazione privilegiata per i viaggiatori vegani: dato che la città ospita oltre 400 ristoranti vegan-friendly sarebbe un po’ difficile avere fame.
					</p>

					<h3>
					   Nanuchka
					</h3>

					<p>
                         un ristorante tradizionale georgiano che nel 2014 è passato alla cucina vegana. Adesso serve piatti georgiani tradotti vegan, compreso il tradizionale stufato, dove i funghi prendono il posto del manzo.
                    </p>

                    <div class="img-wrapper">
			            <img src=${getImgUrl() + "/posts/6/2.jpg"} class="img-responsive" />
			          </div>

					<h3>
					   HaShwarma HaTzemchonit
					</h3>

                    <p>
                       rappresenta una alternativa per i vegani che vogliono provare la cucina tradizionale locale, con lo shwarma vegetale. Tofu e seitan speziati prendono il posto della carne, e vengono serviti in panino, pita, tortilla o focaccia. Aba Gil è un altro ristorante di Tel Aviv dove vengono serviti piatti tipici del Medio Oriente in versione vegana.
                    </p>

                    <h3>
					  Buddha Burgers
					</h3>

					<p>
                       e una catena di ristoranti di hamburger vegetali: ha filiali ad Haifa e ad Eilat. Il menu copre le pietanze fast food più amate nel mondo, compresi hamburger e hot dogs in versione indiana, italiana ed americana, ovviamente senza carne. Disponibile anche un cheese burger casher, tutto di soya.
                    </p>

					<h3>
					    Zakaim
					</h3>

					 <div class="img-wrapper">
			            <img src=${getImgUrl() + "/posts/6/3.jpg"} class="img-responsive" />
			          </div>

					<p>
					    è un ristorante boutique che serve piatti innovativi preparati con ingredienti freschissimi. Si servono varianti vegane di piatti classici, quali la Caesar salad, il cavolo ripieno e la zucca.
					</p>

					<p>
					    Tanat, serve autentica cucina etiopica ma vegan-friendly. Il delizioso pane injera senza glutine (fatto con farina di teff) vi farà innamorare di questo genere di cibo. Se lo visiterete lunedì sera, potrete anche godervi uno spettacolo di jazz dal vivo.
					</p>

					<h3>Tel aviv la migliore destinazione vegana del mondo</h3>
					<h3>Esplorare Tel Aviv non è mai stato così divertente per i vegani</h3>
					<p>Visitare le città può risultare difficile per i vegani, i quali seguono una dieta priva di piatti a base di animali. Non a Tel Aviv, dove è nata una scuola culinaria vegana e tantissimi ristoranti che servono cibo vegano. Già centro culinario per i turisti buongustai e incoronata come “La migliore città culinaria del mondo” da&nbsp;<i>Saveur Magazine</i>, Tel Aviv ha adottato il veganismo, che sta diventando sempre più popolare, inducendo la rivista di cucina&nbsp;<i>The Daily Meal&nbsp;</i>a nominare la città “La migliore destinazione vegana del mondo” davanti ad altre otto “città vegane”.</p>

					<h3>Cosa vogliono i vegani</h3>
					<p>Fai una passeggiata per le vie di Tel Aviv e ti imbatterai in tantissimi ristoranti vegani e vegetariani, bistrò e bancarelle di fast food. Respira gli aromi dolci e saporiti che si diffondono nell’aria della città e lasciati andare alla voglia di assaggiare le pietanze. Per accontentare i gusti e le richieste degli abitanti e dei turisti di Tel Aviv, la maggior parte dei ristoranti offre piatti vegani. Gli altri offrono comunque la possibilità di aggiungere un tocco vegano ai piatti locali, come il falafel senza uova, il seitan, shawarma e la pizza senza prodotti caseari.</p>
					<h3>Gusta i sapori freschi del Mediteranno</h3>
					<p>Respirare l’aria fresca del Mediterraneo ti fa venire voglia di assaggiare i freschi piatti locali? I vegani in vacanza a Tel Aviv con un languorino allo stomaco possono trovare appagamento grazie ai freschi prodotti locali trasformati in prelibatezze culinarie che riflettono diverse culture, tradizioni e tendenze culinarie.</p>
					<p>Israele offre numerose varietà di cucina vegana ma, per quanto riguarda i ristoranti vegani, Tel Aviv è un vero e proprio tesoro. Sia che tu abbia voglia di fast food, menù da buongustaio o dessert, Tel Aviv ha una grande varietà vegana da offrire, il che fa della città balneare una destinazione da non perdere in occasione del tuo prossimo viaggio in Israele.</p>
								    
			        `,
      };
    },
  },

  {
    id: "Jerusalem_Cuisine",
    ctg: "culinaryjerusalem",
    bgImage: "/posts/bank/28/1.jpg",
    mobBgImage: "/posts/bank/28/M.jpg",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    title: "La cucina di Gerusalemme",
    smltitle: "",
    html: function() {
      return {
        __html: `

                     <p>
						Gerusalemme è ricchissima di ristoranti vivaci e alla moda e di luoghi di intrattenimento. La città è piena di zone che offrono ottime possibilità sia di giorno che di notte, dove potrete trascorrere una stupenda serata degustando un ottimo piatto, una birra fredda o ballare ascoltando ottima musica.
					</p>

					<p>
						A Gerusalemme si dice che la gente venga per assaggiare l’hummus, ma resti per la sua cucina incredibilmente varia. Dalla cucina tradizionale mediorientale e nordafricana fino a quella sudamericana, alla fusion asiatica e alla cucina europea continentale, dal cibo di strada alle cene squisite, Gerusalemme ha tutto. La varietà dell’offerta culinaria di Gerusalemme è visibile letteralmente ovunque: sulle bancarelle per le vie della città, dove sono in vendita le specialità locali, nei ristoranti tipici dei mercati e, se siete alla ricerca di un’esperienza da buongustai, potete prenotare un tavolo in uno dei numerosi ristoranti esclusivi della città.
					</p>
			        `,
      };
    },
  },

  {
    id: "TLV_Gourmet_Scene",
    ctg: "culinary",
    bgImage: "/posts/bank/33/1.jpg",
    mobBgImage: "/posts/bank/33/M.jpg",
    vidId: "jfyHxk8ZRrI",
    isVid: true,
    title: "Il panorama culinario di Tel Aviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

			            
			                       
			                        <small style="color:#000; display:block;position: relative;top: -14px;">
			                          A film by VIA TOLILA
			                        </small>
			                        <br/>
			                        <p>Risvegliate le vostre papille<br> gustative a Tel Aviv. Un gran numero di incredibili ristoranti - Il luogo perfetto per Trattarsi bene</p>
			                        <div class="img-wrapper">
			              <img src=${getImgUrl() +
                      "/posts/53/1.jpg"} class="img-responsive" />
			            </div>
			                       
			                        <div class="img-wrapper">
			              <img src=${getImgUrl() +
                      "/posts/53/2.jpg"} class="img-responsive" />
			            </div>
			                        <small style="color:#000; display:block;margin-bottom:20px;">
			                          Credit: Dana Friedlander
			                        </small>
			                        <div class="img-wrapper">
			              <img src=${getImgUrl() +
                      "/posts/53/3.jpg"} class="img-responsive" />
			            </div>
			          `,
      };
    },
  },

  {
    id: "Cycle_TelAviv",
    ctg: "telaviv",
    bgImage: "/posts/bank/60/1.jpg",
    mobBgImage: "/posts/bank/60/M.jpg",
    isVid: true,
    vidId: "88OV6xU0vPI",
    title: "Girare in bici a Tel Aviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

				                    <p>Essendo una delle città più trendy al mondo, non è certo una sorpresa che Tel Aviv si sia unita negli ultimi anni alla tendenza che sta invadendo le città più famose di tutto il mondo: la bicicletta! </p>
				                    <p>Esplorare la città in bici ha moltissimi vantaggi: è ecologico perché riduce l’emissione di carbonio, ti farà risparmiare tantissimo tempo (perché sprecare la tua vacanza bloccati nel traffico?) e, ovviamente, fa benissimo alla salute. Girare in bici è un ottimo modo per fare esercizio e, come turista o viaggiatore, per esplorare la città e godersi i suoi fantastici panorami, profumi e suoni senza alcuna interferenza. </p>
				                    <p>Ecco solo alcune delle cose che rendono Tel Aviv una città perfetta per girare in bicicletta: </p>
				                    <div class="img-wrapper">
								      <img src=${getImgUrl() + "/posts/38/1.jpg"} class="img-responsive" />
								    </div>
				                    <p><strong>Piste ciclabili riservate alle bici:</strong> La città di Tel Aviv promuove l’uso delle biciclette come mezzo di trasporto e, per supportare questa causa, sono stati realizzati oltre 100 km di piste ciclabili lungo tutta la città, in modo che i ciclisti siano sempre al sicuro e pedalare sia pratico. </p>
				                    <p><strong>Clima fantastico:</strong> Tel Aviv gode di un clima fantastico tutto l’anno: le sue piogge scarse rendono la città davvero ideale per andare in bicicletta sul lungomare godendosi la brezza che proviene dalla spiaggia, oppure per scorrazzare tra i suoi bellissimi vicoli e strade interne, ammirando l’architettura Bauhaus della città. </p> 
				                    <p><strong>Tel-O-Fun:</strong> il Tel-O-Fun è un modo semplice, rapido ed economico per noleggiare le biciclette messe a disposizione dal comune. Con Tel-O-Fun, turisti e residenti possono prendere una bicicletta utilizzando una carta di credito e poi lasciarla in uno dei 150 pratici punti di raccolta sparsi per la città.</p>
				                    <p>E infine la ciliegina sulla torta: a Tel Aviv tutto è vicino e potrete pedalare sulla spiaggia oppure sul suo meraviglioso lungomare, andare in bici al parco Ha’Yarkon per un pic-nic oppure pedalare di notte in città per visitare i suoi fantastici bar, club e il porto. </p>
				                    <p>Andare in bici non è mai stato così semplice e divertente come nella bellissima città di Tel Aviv. </p>
				            	
				    

				              `,
      };
    },
  },

  {
    id: "Enjoy_And_Indulge",
    ctg: "telaviv",
    bgImage: "/posts/bank/57/1.jpg",
    mobBgImage: "/posts/bank/57/M.jpg",
    title: "La destinazione di lusso che non ti aspetti",
    smltitle: "",
    html: function() {
      return {
        __html: `

				    
				      <p>Oltre i Caraibi, Cannes o le Maldive… se stai cercando una vacanza all’insegna del lusso, Tel Aviv è il posto giusto! </p>

                    <p>Per prima cosa la città, nominata dal NY Times “La capitale del cool”, è a poche ore di distanza da te: ciò significa che non dovrai preoccuparti di sprecare neanche un minuto della tua vacanza da sogno a riprenderti dal jet lag.</p>
                    <p>Una volta arrivato, sarai subito accolto dal suo meraviglioso clima, assolato tutto l’anno – come se fosse fatto apposta per il tuo piacere. </p>
                    <p>Poi, rilassati un po’ grazie all’immensa varietà di sistemazioni di lusso offerte dalla città, dagli hotel internazionali a 5 stelle con affaccio sulla spiaggia fino agli innumerevoli boutique hotel situati nelle posizioni più mozzafiato della città. </p>
                    <div class="img-wrapper">
				        <img src=${getImgUrl() + "/posts/35/1.jpg"} class="img-responsive" />
				      </div>
                    <p>Per completare l’esperienza, prendi un asciugamano e passa un po’ di tempo su una delle meravigliose spiagge della città, ricche di attrazioni e divertimenti adatti a farti passare una bellissima giornata...senza contare poi il suo incantevole mare!</p>
                    <p> Hai fame? Goditi la vasta scelta di raffinati ristoranti offerti dalla città, dalla cucina locale alla fusion. Tel Aviv è famosa in tutto il mondo per la qualità del suo cibo, grazie ai suoi famosi ristoranti pluripremiati e deliziosamente arredati. </p>
                    <p>È il momento di fare shopping – prendi il portafogli e da’ un’occhiata ai prodotti realizzati dai designer locali in vendita nelle boutique, oppure visita i negozi chic o i centri commerciali di lusso dove potrai trovare di tutto, dalla Haute Couture alle ultime mode internazionali. </p>
                    <p>Per terminare la giornata in bellezza, sorseggia una birra artigianale o un ricercato cocktail in uno dei tanti, sensazionali nightclub e bar sparsi per la città, per poi ballare tutta la notte prima di un po’ di meritato riposo nella tua stanza a 5 stelle. </p>

                    <p>Lusso? Stile? Glamour? Abbiamo tutto! Fai presto, prenota il tuo viaggio a Tel Aviv oggi stesso! </p>


				              `,
      };
    },
  },

  {
    id: "Dead_Sea1",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "Le gioie del Mar Morto",
    smltitle: "",
    isVid: false,
    ctg: "deadsea",
    html: function() {
      return {
        __html: `
				                         <h3>Per un buon tempo fluttuante</h3>
				                        <p>
					              			Una meraviglia geologica in un ambiente unico e sereno, il Mar Morto è un'attrazione turistica estremamente popolare. Sperimentare la calma, la tranquillità dell'acqua con le sue distinte proprietà curative mentre si gode della bellezza senza pari del paesaggio circostante
					              			<strong>Il Mar Morto, noto anche come la più antica Spa naturale del mondo, è consacrato da una concentrazione di sale estremamente elevata pari al 31,5%, che consente ai turisti di tutto il mondo di sperimentare senza alcuno sforzo le acque del posto più basso della Terra. Inoltre qui è possibile </strong> fare il bagno nel fango nero della zona o esplorare i paesaggi affascinanti e ricchi di storia.
					              		</p>

					              		<p>
					              			Alberghi di lusso, cucina varia da ristoranti gourmet a fast food, negozi di souvenir, la straordinaria storia della vicina Masada e molte attività culturali durante tutto l'anno, rendono il Mar Morto una destinazione popolare per i turisti locali e per i visitatori internazionali.
					              		</p>
							
				           `,
      };
    },
  },
  {
    id: "Vita_Nortuna_It",
    bgImage: "/posts/bank/33/1.jpg",
    mobBgImage: "/posts/bank/33/M.jpg",
    title: "VITA NOTTURNA A TEL AVIV",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>La città è anche uno dei luoghi più gay-friendly al mondo</h3>
                    
						                    <p>Non è un caso che Tel Aviv sia nota anche come “la città che non dorme mai”. La sua popolazione giovane e multiculturale e la grande attenzione alle novità, alla moda e al design ne hanno fatto un vero e proprio paradiso della vita notturna, con migliaia di turisti che ogni anno vengono qui a sperimentarlo direttamente. 
						                    <div class="img-wrapper">
				                              <img src=${getImgUrl() +
                                        "/posts/33/1.jpg"} class="img-responsive" />
				                            </div>
						                    <p>La città è costellata di innumerevoli discoteche e pub, pensati per tutte le età a e per tutti i gusti. La maggior parte di questi è già aperta al mattino e non chiude fino a quando anche l’ultimo festaiolo non è andato a dormire, solitamente quando le luci dell’alba sono già ben visibili. Tra le principali discoteche, concentrate soprattutto nel centro città, troviamo il Kuli Alma, il The Block, il Jimmy Who? e lo Sputnik Bar. Questi sono i quattro club più gettonati, ma lungo il centralissimo Rothschild Boulevard è possibile trovarne molti altri. Se invece si preferisce la musica dal vivo ai dj set, non può mancare una tappa al Levontin 7 o all’Abraham Hostel. Anche nella città vecchia - Jaffa, al contrario di quanto si potrebbe pensare, c’è una vita notturna molto intensa e un’ampia scelta di locali nei quali divertirsi e bere un buon drink. Provare per credere! Per non perdersi nulla, poi, diverse associazioni organizzano i “bar tour”, che di locale in locale mostrano ai turisti i luoghi più popolari tra gli abitanti della città.</p>

						                    <p>Poiché il litorale di Tel Aviv è uno degli elementi che hanno reso la città così celebre in tutto il mondo, era inevitabile che anche la spiaggia diventasse una delle fonti principali di divertimento notturno. Gordon Beach e Alma Beach sono due luoghi solitamente molto affollati, così come la Hilton Beach e la spiaggia di Metzitzim. Le feste in spiaggia, qui, sono all’ordine del giorno.</p>
						                    <div class="img-wrapper">
				                              <img src=${getImgUrl() +
                                        "/posts/33/2.jpg"} class="img-responsive" />
				                            </div>
						                    <p>Tel Aviv è anche nota per la sua notte bianca, che quest’anno andrà in scena il 16 maggio 2019. In quell’occasione, molti negozi del centro rimarranno aperti fino a tardi, seguiti da numerosi ristoranti e musei. La Tel Aviv White Night, istituita nel 2005 per celebrare l’introduzione della Città Bianca (il quartiere Bauhaus) nella lista dei Patrimoni dell’Umanità UNESCO e da allora ripetuta annualmente, offre anche concerti e spettacoli teatrali.</p>

						                    <p>La voglia di divertimento e la grande apertura di Tel Aviv ne hanno fatto anche un polo gay-friendly riconosciuto in tutto il mondo. La scena LGBT di Tel Aviv è molto vivace, ha numerosi locali di riferimento ed è solita ritrovarsi per festeggiare sulla Hilton Beach, recentemente inclusa da NewsWeek tra le 10 spiagge gay più belle. Il momento più importante per la comunità gay di Tel Aviv (e non solo) è però il Gay Pride, evento che ogni anno accende l’estate israeliana.</p>
						                    
						                    <div class="img-wrapper">
				                              <img src=${getImgUrl() +
                                        "/posts/33/3.jpg"} class="img-responsive" />
				                            </div>
						                    <p>L’edizione di quest’anno, prevista tra il 9 e il 14 giugno, vedrà oltre 200.000 persone provenienti da tutto il mondo affollare le vie della città. Per tutta la settimana si susseguiranno eventi e concerti gay-friendly, in attesa della tradizionale sfilata del venerdì. Questa partirà dal Gan Meir Park, nel cuore del quartiere gay della città, e finirà a Gordon Beach con un’epocale festa sulla spiaggia che si protrarrà fino a tarda serata.</p>
						                    <p>Credit foto: Dana Friedlander, Haim Yosef.</p>
							
				           `,
      };
    },
  },
  {
    id: "Street_Food_It",
    bgImage: "/posts/bank/34/1.jpg",
    mobBgImage: "/posts/bank/34/M.jpg",
    title: "STREET FOOD",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>Innovazione e tradizione nella tecnologica città israeliana, anche per il cibo!</h3>
							              <p>Intrattenimento, storia e design sono tra i principali motivi che spingono ogni anno migliaia di turisti internazionali a visitare Tel Aviv, ma non sono gli unici. Negli ultimi anni, infatti, con il diffondersi della cultura foodie, la città israeliana è diventata un punto di riferimento del turismo gastronomico e si distingue per la varietà e qualità della sua ricca offerta culinaria. 
							              <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/34/1.jpg"} class="img-responsive" />
				                        </div>
							              <p>Così come Israele, uno Stato al cui interno convivono anime molto diverse tra loro, anche Tel Aviv è da sempre una città molto sensibile alle contaminazioni. Non stupisce quindi che, accanto a piatti tipici della tradizione israeliana, si possano trovare ristoranti arabi, europei, africani e fusion. Ma chi pensa di concludere la sua esperienza gastronomica a Tel Aviv con un giro tra i ristoranti più rinomati si sbaglia di grosso! Tra innumerevoli mercati e bancarelle, infatti, la città è una vera e propria capitale dello street-food, fenomeno che sta spopolando un po’ ovunque e che qui ha trovato una sua efficacissima dimensione.

							              <p>Basti pensare ai piatti tipici della cucina israeliana: semplici, leggeri, trasportabili. Un fast-food che ben poco ha a che vedere con l’ingombrante “collega” americano, ma che si sposa perfettamente con la filosofia del cibo di strada. Tra le pietanze più celebri troviamo sicuramente l’hummus, una crema a base di ceci e sesamo che in Israele va fortissimo e che non è raro trovare anche dalle nostre parti. Si consuma accompagnato dal tradizionale pane pita, ma spesso fa da condimento a un altro piatto tipico: i falafel. Questi altro non sono che piccole polpette a base di verdure e spezie, fritte e servite ancora calde. O ancora, i borekas: piccoli involtini di pasta sfoglia di derivazione turca ripieni di formaggio, spinaci, carne o patate. Per non parlare poi del sabich (un panino a base di melanzane e uova), dello shakshuka (uova, peperoni e salsa di pomodoro) o dei tantissimi e squisiti dolci.
							               <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/34/2.jpg"} class="img-responsive" />
				                        </div>
							              <p>Il luogo migliore dove gustare tutte queste (e tante altre) specialità è sicuramente il mercato: tra esuberanti venditori, materie prime freschissime, pane appena sfornato e fiumi di spezie, è questo il posto ideale per avere un assaggio autentico della cucina e della tradizione israeliana. Ancora una volta, sembra essere Tel Aviv il posto giusto per vivere un’esperienza di questo genere. Una volta qui, è d’obbligo una tappa al Carmel Market, il più grande della città che dedica grandissimo spazio al cibo di strada. Anche il Namal Food Market, come suggerisce il nome stesso, non è da meno. Si tratta di un altro mercato, questo interamente al coperto, che fa delle specialità gastronomiche israeliane uno dei suoi punti di forza.

							              <p>Un’esperienza, quella del lato food di Israele, che non dimentica i viaggiatori veg. La cucina vegana ha riscosso negli ultimi anni un inaspettato successo e Tel Aviv l’ha presto fatta sua, promuovendola in tutto il mondo e reinventandola continuamente. Si stima che in Israele i vegani siano il 13% della popolazione: un numero che difficilmente è riscontrabile in altri Paesi e che è solo in parte giustificato dalla dieta kosher tipica dall’ebraismo. 
							              <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/34/3.jpg"} class="img-responsive" />
				                        </div>
							              <p>Oggi, stando a quanto affermato dal quotidiano britannico The Independent e testimoniato da numerosi viaggiatori-foodie, Tel Aviv è una delle città più vegan-friendly al mondo, grazie a ristoranti che continuano ad aprire (oggi se ne contano oltre 400!), a una cucina innovativa ma sempre genuina e ai molteplici vegan-tour. Questi portano i turisti alla scoperta dei locali più trendy della città e dei loro piatti tipici, rigorosamente kosher e vegani. Anche lo street food non è da meno: falafel, hummus e alcune varianti dei bourekas sono tutte deliziose ricette senza carne né derivati!
							              <p>Credit foto: Dana Friedlander, Haim Yosef.</p>
							
				           `,
      };
    },
  },
  {
    id: "La_Musica_A_Telaviv_It",
    bgImage: "/posts/bank/35/1.jpg",
    mobBgImage: "/posts/bank/35/M.jpg",
    title: "LA MUSICA A TEL AVIV",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>Dal 14 al 18 maggio 2019 i migliori talenti europei si esibiranno all’Expo Tel Aviv per la 64esima edizione del festival musicale</h3>
					                    <p>Sarà una primavera all’insegna della musica quella che si vivrà a Tel Aviv. Questo perché dal 14 al 18 maggio andrà in scena l’Eurovision Song Contest, il festival musicale europeo che ogni anno riunisce i più grandi talenti del continente e li fa esibire in una settimana di grande spettacolo. </p>
					                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/35/1.jpg"} class="img-responsive" />
				                        </div>
					                    <p>La 64esima edizione dell’Eurovision, la terza in Israele dopo quelle del 1979 e del 1999, avrà luogo all’interno di Expo Tel Aviv, in un padiglione in grado di ospitare fino a 10.000 spettatori che già si prevede tutto esaurito. 
					                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/35/2.jpg"} class="img-responsive" />
				                        </div>
					                    <p>Per Israele, paese ospitante che ha vinto lo scorso anno a Lisbona con il brano “Toy” di Netta, si esibirà Kobi Marimi, che proporrà la canzone “Home”. Toccherà invece a Mahmood rappresentare i colori italiani: il fresco vincitore del festival di Sanremo porterà sul palco la sua hit “Soldi”. Per quanto riguarda la conduzione del contest, accanto alla supermodella Bar Rafaeli ci saranno tre volti noti della televisione israeliana: Erez Tal, Assi Azar e Lucy Ayoub.</p>
					                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/35/3.jpg"} class="img-responsive" />
				                        </div>
					                    <p>L’Eurovision Song Contest contribuirà ad aumentare notevolmente il flusso di turisti internazionali verso la città (in tutto il 2019 ne sono attesi oltre due milioni, contro gli 1,85 milioni dello scorso anno), e la municipalità di Tel Aviv-Yafo non si farà certo trovare impreparata. L’Amministrazione ha infatti già raccolto oltre 1.500 candidature volontarie di ragazzi del posto per accogliere chi viene da fuori e ribadire l’ospitalità che ha reso Tel Aviv celebre in tutto il mondo. Il loro contributo aiuterà turisti e giornalisti a vivere a pieno le tante esperienze che la città offre: dal cibo alla cultura, all’intrattenimento. </p>

					                    <p>La manifestazione è anche destinata a cambiare, seppur temporaneamente, il volto della città, con il Charles Clore Park, il parco cittadino affacciato sulle rive del Mediterraneo, che è stato scelto per ospitare l’EuroVillage. Qui, per tutta la settimana dell’Eurovision, ci sarà posto per oltre 20.000 tra giornalisti e turisti che vorranno entrare nel giusto clima pre-concerto. Ci saranno numerose esibizioni di artisti israeliani, diverse attività all’aria aperta, negozi di souvenir e anche postazioni street food, vera e propria icona di Tel Aviv. Inoltre, nei mesi di maggio e giugno, per gestire al meglio i grandi numeri che ci si aspetta (ricordiamo che dopo Eurovision toccherà al Gay Pride, in programma per il 14 giugno 2019), Yarkon Park si trasformerà in un immenso e centralissimo campeggio. Nel polmone verde di Tel Aviv verranno così ricavati oltre 2.000 posti tenda pensati per quei visitatori che, pur attirati dalla vita mondana della città, non vogliono rinunciare allo stretto contatto con la natura. </p>
					                    <p>Credit foto: Eurovision in Concert, Kan_Eurovision, Tel aviv Yafo.</p>
							
				           `,
      };
    },
  },
  {
    id: "La_Citta_Bianca_It",
    bgImage: "/posts/bank/36/1.jpg",
    mobBgImage: "/posts/bank/36/M.jpg",
    title: "TEL AVIV, LA CITTÀ BIANCA",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>Tel Aviv, la città bianca, ha festeggiato nel 2019 i 100 anni del Bauhaus.</h3>
					                    <p>La scuola di architettura tedesca, nata nel 1919 a Weimar, in Germania, ha infatti trovato in Israele terreno fertile e ha finito per contagiare Tel Aviv, che proprio in quegli anni era al centro di un grande fermento urbanistico. Oggi è anche nota con il nome “Città Bianca”, dal colore dominante tra le case di questo stile.</p>
					                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/36/1.jpg"} class="img-responsive" />
				                        </div>
					                    <p>Nel cuore della città si contano fino a 4.000 edifici appartenenti a questa corrente. Ispirate a un design essenziale, ideato dall’architetto tedesco Walter Gropius, queste strutture si sono adattate benissimo allo skyline di Tel Aviv e sono ancora oggi una delle attrazioni principali della città. Risalgono soprattutto agli anni ’30, quando una prima ondata di ebrei tedeschi (tra i quali figuravano numerosi architetti) decise di trasferirsi in Israele. Negli ultimi anni sono state diverse le case Bauhaus protagoniste di importanti restauri che sono così ritornate al loro antico splendore. Dal 2003 sono annoverate tra i Patrimoni dell’Umanità UNESCO, quali autentico esempio dell’architettura del XX° secolo. </p>

					                    <p>Gli edifici Bauhaus sono ancora oggi una delle attrazioni principali che Tel Aviv ha da offrire e sono facilmente osservabili percorrendo le centralissime vie Rothschild, Dizengoff e Bialik. Il Bauhaus Center, situato proprio su Dizengoff Street, offre tour a piedi del quartiere, oltre che informazioni sulle storie parallele della città e della sua architettura. Collabora inoltre attivamente per la conservazione e la promozione di questo patrimonio architettonico.</p>

					                    <p>A settant’anni di distanza dall’arrivo del Bauhaus in Israele, Tel Aviv resta un centro molto vivace e interessante per quanto riguarda il design. La città è tra le più giovani al mondo e ha saputo trasformarsi nel corso degli anni, lasciando gradualmente spazio a diversi stili e correnti che oggi convivono armoniosamente. </p>
					                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/36/2.jpg"} class="img-responsive" />
				                        </div>
					                    <p>Il Tel Aviv Museum of Art, che si distingue per il suo taglio decisamente più contemporaneo, entra di diritto tra le tappe da non perdere in un tour della città incentrato sul design. Al suo interno si trova quella che un tempo era la ricca collezione privata del primo sindaco della città, oggi arricchita da nuove illustri acquisizioni che vanno dagli Old Masters fino alle più audaci avanguardie.</p>

					                    <p>Sempre in tema musei, nella periferia sud della città, si trova il Design Museum Holon. Questo imponente edificio di acciaio e cemento, progettato dal celebre architetto Rad Arad, raccoglie al suo interno il meglio del design israeliano e ospita numerose mostre sull’arte contemporanea e sulle nuove tendenze.</p>

					                    <p>Il quartiere Florentin offre un’esperienza decisamente più alternativa. Caratterizzato da una popolazione giovane e da una vita notturna dalle numerose alternative, questo luogo ha però qualcosa da dire anche in pieno giorno, grazie ai numerosi murales che colorano le sue strade. </p>

					                    <p>E poiché il design non si riflette solo nell’architettura ma anche nella moda, non può mancare una visita al mercato di Nahalat Binyamin. Qui si danno appuntamento, ogni martedì e venerdì, artisti e artigiani locali per mettere in mostra le loro creazioni. Per un giro più tradizionale tra diverse boutique, invece, il posto giusto è Shenkin, una lunga via pedonale nel cuore della città e vero e proprio punto di riferimento per gli amanti dello shopping.</p>

					                    <p>Restando sul tema moda e talenti locali, va segnalato il grande lavoro della Israel Designers Guild, una società basata proprio a Tel Aviv il cui obiettivo è quello di raccogliere e promuovere i lavori dei più interessanti designer israeliani.</p>
					                     <p>Credit foto: Dana Friedlander.</p>
							
				           `,
      };
    },
  },
  {
    id: "Cesarea_It",
    bgImage: "/posts/bank/42/1.jpg",
    mobBgImage: "/posts/bank/42/M.jpg",
    title: "Cesarea",
    smltitle: "",
    isVid: false,
    ctg: "north",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	Alla scoperta di Cesarea, storia millenaria e acque cristalline
					                	</h3>
					                	<p>
					                		Un porto risalente a migliaia di anni fa e splendide spiagge frequentate ancora oggi: sono i due elementi che rendono Cesarea una meta imperdibile durante un viaggio in Israele. Questa località marittima si trova a metà strada tra Haifa e Tel Aviv, dista poco più di un’ora di auto da entrambe le città e ha decisamente molto da offrire, anche a coloro che decidono di trascorrervi una sola giornata.
					                	</p>
					                   	<p>
					                   		La storia delle origini di Cesarea risale addirittura al I secolo a.C., quando Erode il Grande fece costruire un grande porto attorno al quale si sviluppò presto una vivace cittadina. Il centro rimase amministrato dall’Impero Romano prima e Bizantino poi, salvo venire distrutto e abbandonato nel XIII secolo. La Cesarea moderna sorge a poca distanza dal nucleo originale e, grazie a importanti scavi archeologici svolti a partire dal 1950, numerosi reperti (soprattutto architettonici) sono stati riportati alla luce. Oggi fanno tutti parte del Caesarea National Park, aperto al pubblico tutto l’anno e diventato presto uno dei centri archeologici più popolari di Israele, grazie all’ottima conservazione della città di Erode. Gli scavi proseguono ininterrotti ancora oggi e continuano a riportare in superficie opere che si credevano perdute per sempre: l’ultimo ritrovamento risale al 2018 e consiste in uno splendido mosaico di 3 metri per 8 risalente al II o III sec. d.C. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/42/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Dana Freidlander
					                	</small>
				                        </div>
					                	
					                	<p>
					                		Cesarea è anche la casa di un museo subacqueo unico al mondo: poiché alcune rovine del porto si trovano oggi sott’acqua, è possibile armarsi di muta e bombole e, partendo dalla Harbor Beach, seguire una guida esperta del Caesarea Dive Club e andare alla scoperta di queste meraviglie sottomarine.
					                	</p>
					                	<p>
					                		Ma non c’è solo archeologia a Cesarea! La città vanta infatti una delle spiagge più belle di Israele: la Acquaduct Beach, a pochi passi fuori dal sito archeologico. Questa spiaggia, attraversata da un acquedotto di epoca romana, non ha nulla da invidiare alle popolari spiagge del sud del Paese, ma si distingue per un’atmosfera decisamente più tranquilla e meno mondana, con splendide viste sulla campagna circostante. 
					                	</p>
					                	<p>
					                		Per quanto riguarda l’aspetto culturale, la città ospita il Ralli Museum, ricco di reperti dedicati all’archeologia locale, all’arte sefardita e quella sudamericana. L’ingresso è gratuito, dato che il museo è non-profit e fa parte di un circuito internazionale finanziato dal filantropo Harry Recanati. Nel calendario della città ci sono anche numerosi concerti locali e internazionali, tutti organizzati nella suggestiva location dell’antico anfiteatro cittadino, ancora perfettamente conservato. Cesarea offre anche un campo da golf perfettamente attrezzato, in grado di ospitare regolarmente tornei internazionali ed eventi speciali. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/42/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Dana Freidlander
					                	</small>
					                	</div>
							
				           `,
      };
    },
  },
  {
    id: "Tel_Aviv_Eurovision_It",
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "Tel Aviv Eurovision",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	TUTTO PRONTO PER L’EUROVISION A TEL AVIV
					                	</h3>
					                	<p>
											Dopo mesi di grandi preparativi, è finalmente arrivato per la città di Tel Aviv il momento di ospitare l’Eurovision Song Contest 2019. Questa importante rassegna musicale, che si è già tenuta in Israele nel 1979 e nel 1999, è giunta alla sua 64esima edizione e si svolgerà interamente all’EXPO Tel Aviv, con le fasi preliminari che inizieranno il 14 maggio e la finale che andrà invece in scena sabato 18 maggio. 
					                	</p>
					                   	<p>
											Già il 12 maggio, in realtà, sarà possibile avere un assaggio del festival, dato che all’interno dell’Habima Theatre andrà in scena la cerimonia di apertura. In quell’occasione, in Habima Square, sarà inoltre allestito uno speciale “orange carpet”, sul quale sfileranno tutti i cantanti in gara prima di entrare nel teatro. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/43/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: KAN
					                	</small>
				                        </div>
					                	
					                	<p>
											Per assicurare la buona riuscita dell’evento, la Municipalità di Tel Aviv ha investito grandi risorse nelle proprie infrastrutture, potenziando i trasporti e l’ospitalità e creando al tempo stesso un cartellone di eventi in grado di intrattenere al meglio le decine di migliaia di persone che parteciperanno. 
					                	</p>
					                	<p>
											Uno degli interventi più importanti è sicuramente l’introduzione di navette gratuite per tutti i possessori di un biglietto valido per l’Eurovision, i quali potranno così spostarsi liberamente tra l’EXPO e il Carmelit Terminal, la stazione dei bus cittadina. Sempre per quanto riguarda i trasporti, vanno segnalati il potenziamento dei treni (con l’introduzione della fermata Tel Aviv University, a pochi passi dall’EXPO) e la convenzione con i tassisti di “Share Route”, che in quei giorni offriranno tariffe agevolate per spostarsi attraverso la città. Sono anche stati aperti in luoghi strategici dei centri informazioni aperti 24/7: uno è all’aeroporto di Ben Gurion, l’altro alla stazione centrale di Savidor. 
					                	</p>
					                	<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/43/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: KAN
					                	</small>
				                        </div>
					                	
					                	<p>
											Al Charles Clore Park, il parco affacciato sul Mar Mediterraneo, è stato costruito il più grande Eurovillage di sempre: qui si terranno numerosi eventi a tema Eurovision, tra i quali spiccano i concerti di Dana International e Izhar Cohen, i precedenti vincitori israeliani della rassegna. Per tutti i turisti che non sono in possesso di un biglietto, sarà inoltre possibile assistere alle finali proiettate su un maxischermo, magari sorseggiando un drink al nuovo bar che qui è stato allestito. 
					                	</p>
					                	<p>
					                		Non mancheranno poi gli eventi collaterali. Dal 12 al 18 maggio andrà in scena il Tel Aviv Eat Festival, la rassegna dedicata alla cucina della città che coinvolge ogni anno i migliori chef locali e attira migliaia di persone grazie alla sua carica innovativa e ai suoi deliziosi sapori. Il 16 maggio si terrà invece la Tel Aviv White Night, che vedrà negozi, ristoranti e musei restare aperti per tutta la notte, movimentando così la vita notturna della città. Ci saranno anche concerti, spettacoli e mostre, per vivere al meglio uno degli eventi più popolari della calda primavera di Tel Aviv. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/43/3.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: KAN
					                	</small>
				                        </div>
					                	
							
				           `,
      };
    },
  },
  {
    id: "Gay_Pride_It",
    bgImage: "/posts/bank/44/1.jpg",
    mobBgImage: "/posts/bank/44/M.jpg",
    title: "Gay Pride",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	Non solo Eurovision: il Gay Pride animerà l’estate di Tel Aviv
					                	</h3>
					                	<p>
											Se Tel Aviv è universalmente riconosciuta come una delle città più gay-friendly al mondo, gran parte del merito va sicuramente al suo Pride, l’evento che ogni anno riunisce centinaia di migliaia di persone in una coloratissima parata per i diritti e l’uguaglianza. 
					                	</p>
					                   	<p>
											L’edizione inaugurale si tenne nel lontano 1993, anche se le prime rivendicazioni della comunità gay della città vengono fatte risalire al 1979. Queste hanno permesso di far diventare Israele uno dei paesi più avanzati al mondo per quanto riguarda la percezione dei gay e una delle mete più gettonate per il turismo LGBTQ+. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/44/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Guy Yechiely, Kobi Wolf
					                	</small>
				                        </div>
					                	
					                	<p>
											Il Pride di quest’anno inizierà il 9 giugno 2019, con una serie di eventi che per tutta la settimana accompagneranno i partecipanti fino al momento clou delle celebrazioni: la grande parata del 14 giugno. Questa partirà in mattinata dal Gan Meir Park e attraverserà il centro cittadino fino al Charles Clore Park. Lungo la strada ci sarà un clima di grande festa, con musica, spettacoli in costume e un corteo di oltre 200.000 persone (nell’edizione dell’anno scorso si sfiorarono le 250.000 presenze). 
					                	</p>
					                	<p>
											Quando tutti saranno arrivati al parco, nel primo pomeriggio, avrà inizio la vera e propria festa: artisti e dj internazionali si daranno il cambio fino a tarda sera in un tripudio di musica e colori. 
					                	</p>
					                	<p>
											Al Charles Clore Park, il parco affacciato sul Mar Mediterraneo, è stato costruito il più grande Eurovillage di sempre: qui si terranno numerosi eventi a tema Eurovision, tra i quali spiccano i concerti di Dana International e Izhar Cohen, i precedenti vincitori israeliani della rassegna. Per tutti i turisti che non sono in possesso di un biglietto, sarà inoltre possibile assistere alle finali proiettate su un maxischermo, magari sorseggiando un drink al nuovo bar che qui è stato allestito. 
					                	</p>
					                	<p>
					                		Non mancheranno poi gli eventi collaterali. Dal 12 al 18 maggio andrà in scena il Tel Aviv Eat Festival, la rassegna dedicata alla cucina della città che coinvolge ogni anno i migliori chef locali e attira migliaia di persone grazie alla sua carica innovativa e ai suoi deliziosi sapori. Il 16 maggio si terrà invece la Tel Aviv White Night, che vedrà negozi, ristoranti e musei restare aperti per tutta la notte, movimentando così la vita notturna della città. Ci saranno anche concerti, spettacoli e mostre, per vivere al meglio uno degli eventi più popolari della calda primavera di Tel Aviv. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/44/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Guy Yechiely, Kobi Wolf
					                	</small>
				                        </div>
					                	
							
				           `,
      };
    },
  },
  {
    id: "Mountain2Valley_It",
    bgImage: "/posts/bank/45/1.jpg",
    mobBgImage: "/posts/bank/45/M.jpg",
    title: "Mountain2Valley",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	Torna la Mountain2Valley, la più importante corsa a staffetta di Israele
					                	</h3>
					                	<p>
											Il 16 e 17 maggio si correrà in Israele l’undicesima edizione della Mountain 2 Valley, celebre corsa a staffetta che segna l’ultimo grande evento sportivo prima dell’arrivo dell’estate. 
					                	</p>
					                   	<p>
											La Mountain2Valley è un evento unico, che ha poco in comune con le grandi maratone che solitamente lo precedono. Si tratta infatti di una corsa a staffetta che attraversa tutto il nord di Israele e che dura ben 24 ore. Il percorso principale, di 215 km, si snoda lungo un mix di strade asfaltate e sentieri sterrati, attraversando luoghi di grande interesse storico e aree panoramiche che lasciano senza fiato per la loro vastità.
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/45/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto : Mountain2Valley
					                	</small>
				                        </div>
					                	
					                	<p>
											Data la lunghezza della corsa, è possibile partecipare in squadre di 4, 6 o 8 persone, con ogni squadra che dovrà affrontare le 24 sezioni minori in cui è stato diviso il tracciato (la cui lunghezza varia tra i 5 e i 12 km). La partenza è prevista da Tel Hai e l’arrivo è all’insediamento di Tamrat, sulla piana di Esdraelon. Ci saranno anche momenti di corsa in notturna e all’alba: un’esperienza unica che, nell’incontaminata natura israeliana, sarà ancora più speciale.
					                	</p>
					                	<p>
											La gara non è competitiva, ma è un’ottima occasione per scoprire le notevoli bellezze naturali di questa regione. 
					                	</p>
							
				           `,
      };
    },
  },
  {
    id: "Tourist_Info_It",
    bgImage: "/posts/bank/41/1.jpg",
    mobBgImage: "/posts/bank/41/M.jpg",
    title: "Informazioni di viaggio",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        <h3>
											Come raggiungere Tel Aviv dall’aeroporto:
										</h3>
										<p>
											Il modo più economico di raggiungere il centro di Tel Aviv dall’aeroporto Ben Gurion è in treno. Segui i cartelli per la stazione ferroviaria che è adiacente all’aeroporto (le indicazioni sono chiarissime) e cerca un treno diretto a Tel Aviv-HaHagana (per la parte sud di Tel Aviv), Tel Aviv-HaShalom (per il centro di Tel Aviv), Tel Aviv-Savidor Center (per il distretto Old North), o Tel Aviv-University (per la location dell’Eurovision Song Contest). Nota bene: la stazione di Tel Aviv HaShalom è chiusa tutti i venerdì fino a settembre 2019. 
											Un biglietto di sola andata costa 13 shekel e 50 e il tragitto dura circa 25 minuti. Quando scendi dal treno, potrebbe essere una buona idea prendere un taxi per raggiungere il tuo alloggio. Quando sali su un taxi, chiedi all’autista di utilizzare il tassametro (“monet”) e assicurati di avere i contanti a portata di mano per pagare. Qui sotto puoi trovare informazioni sulle app dei servizi taxi. Per maggiori informazioni e per pianificare il viaggio, visita - <a href="https://www.rail.co.il/en" target="_blank">https://www.rail.co.il/en</a>: è in inglese!
										</p>
										<p>
											Se preferisci prendere il taxi direttamente dall’aeroporto fino a Tel Aviv, mettiti in coda nell’area dedicata ai taxi ufficiali fuori dal terminal arrivi. Un membro dello staff ti chiederà dove devi andare e con quanti passeggeri e bagagli, poi ti darà un biglietto da consegnare all’autista. Puoi usare il tassametro oppure accettare un prezzo fisso. I tragitti solitamente costano intorno a 150-170 shekel a persona. 
										</p>
										<h3>
											Come raggiungere Gerusalemme da Tel Aviv:
										</h3>
										<h3>
											In autobus
										</h3>
										<p>
											Dirigiti alla stazione ferroviaria centrale Tel Aviv Savidor e prendi il bus 480. Il tragitto dura circa 45 minuti. La linea termina alla stazione centrale dei bus di Gerusalemme su Jaffa Road. Da lì, puoi prendere il tram o qualsiasi altro mezzo di trasporto disponibile per raggiungere la tua destinazione. 
										</p>
		              					<h3>
											In treno
										</h3>            
		              					<p>
											Puoi anche prendere il treno, nuovo di zecca! Per arrivare a Gerusalemme direttamente dall’aeroporto Ben Gurion, prendi il treno diretto alla Navon Station a Gerusalemme. Il tragitto dall’aeroporto dura circa 25 minuti. Se parti da un’altra stazione di Tel Aviv, puoi prendere il treno per l’aeroporto Ben Gurion e poi cambiare lì e prendere la coincidenza per Navon.  
										</p>            
										<h3>
											Come muoversi a Tel Aviv
										</h3>
										<p>
											Il comune di Tel Aviv offrirà trasporto pubblico gratuito in città durante il weekend dell’Eurovision Song Contest. 
											Venerdì 17 e sabato 18 maggio, in città circoleranno bus gratuiti.
											Tuttavia, di solito, il trasporto pubblico non è in funzione di sabato a Tel Aviv (fatta eccezione per i taxi).
										</p>
										<p>
											Per gli altri giorni della settimana dell’Eurovision, dovrai procurarti una carta Rav Kav: Simile all’Oyster Card londinese, la Rav Kav è una smart card ricaricabile che ti permette di muoverti in autobus senza preoccuparti di avere i contanti per pagare. Infatti, gli autisti non accettano più i pagamenti in contanti, per cui è importantissimo procurarsi una Rav Kav appena si arriva a Tel Aviv.
											Per procurarti una carta, è sufficiente saltare su un autobus ad una fermata qualsiasi e chiedere una carta Rav Kav all’autista; costa 5 shekel e dovrai avere i soldi contati per pagarla. Poi, quando scendi dall’autobus, porta con te la tua carta. Molti 7/11 (chioschetti) del posto offrono servizi di ricarica; chiedi di aggiungere credito alla tua carta. 50 shekel, che equivalgono ad una decina di tragitti locali (ogni tragitto costa 5 shekel e 90), probabilmente ti basteranno per una settimana. 
											Puoi anche acquistare una carta Rav Kav all’ufficio Rav Kav situato al 35 di Iban Gabirol Street, aperto dalla domenica al giovedì dalle 8 alle 20, e al venerdì e nei prefestivi dalle 8 alle 13, oppure alle stazioni ferroviarie Tel Aviv Savidor e Carmelit Central. È possibile ricaricare la carta in qualsiasi stazione ferroviaria. 
										</p>
										<h3>
											In bicicletta
										</h3>
										<p>
											Tel Aviv è a misura di ciclisti e ci sono piste ciclabili in tutta la città, tra le quali anche una che corre lungo tutta la passeggiata a mare da Jaffa a sud fino alla parte nord di Tel Aviv ed oltre; percorsi mozzafiato per muoversi in bici e godere al massimo dell’atmosfera e dell’architettura di Tel Aviv. Se possiedi un casco da bici, portalo con te. 
										</p>
										<h3>
											Col monopattino elettrico
										</h3>
										<p>
											I monopattini sono diventati super popolari a Tel Aviv! Si tratta infatti di un modo economico e divertente di spostarsi in città. Ci sono diverse marche che li offrono - non devi fare altro che scaricare la app che ti interessa, seguire le istruzioni e partire! Preferisci uno zaino alle borse: ti sarà più facile rimanere in equilibrio. Ricordati di tenere d’occhio il traffico e non ascoltare la musica mentre vai in monopattino. Se hai un casco, è consigliabile indossarlo.
										</p>
										<h3>
											A piedi
										</h3>
										<p>
											Muoversi a piedi è un’altra opzione eccellente - il tuo contapassi schizzerà alle stelle, in un paio di giorni nella città che non si ferma mai! Procurati una mappa, un cappellino per il sole e una bottiglia d’acqua, e vai alla conquista dei marciapiedi della città!
										</p>
										<h3>
											App per il trasporto 
										</h3>
										<p>
											Ci sono diverse app che puoi scaricare prima del tuo arrivo in città, per progettare i tuoi spostamenti. Cercane una per ogni categoria: ci sono app di taxi, di noleggio biciclette, noleggio monopattini o app per pianificare i viaggi. Puoi anche chiedere consigli sugli spostamenti alla reception del tuo hotel o al tuo host - saranno lieti di aiutarti! 
										</p>
										<h3>
											WIFI
										</h3>
										<p>
											La città di Tel Aviv ha una rete WiFi gratuita. Certa la rete “Free TLV” sul tuo telefono; è accessibile da 80 punti in tutta la città. La maggior parte dei bar e dei locali hanno reti WiFi pubbliche che puoi utilizzare; devi soltanto chiedere la password al momento di ordinare. Anche gli hotel hanno il WiFi gratuiti, puoi richiedere la password quando effettui il check-in.
										</p>
										 <a href="//visit.tel-aviv.gov.il/move/airport" target="_blank" class="transportation">Transportation.</a>
							
				           `,
      };
    },
  },
  {
    id: "Writers_Festival_It",
    bgImage: "/posts/bank/46/1.jpg",
    mobBgImage: "/posts/bank/46/M.jpg",
    title: "Writers Festival",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	L’International Writers Festival arriva a Gerusalemme dal 12 al 16 maggio 2019
					                	</h3>
					                	<p>
											Dal 12 al 16 maggio 2019 si terrà a Gerusalemme la 7° edizione dell’International Writers Festival, una rassegna dedicata al mondo della scrittura che ogni anno richiama diversi autori internazionali per affrontare i grandi temi della letteratura contemporanea. L’evento si svolgerà nel quartiere ebraico di Mishkenot Sha’anamim e vedrà intervenire numerosi scrittori, i quali discuteranno delle loro esperienze su amore, compassione, #metoo e asilo politico. Gli incontri saranno accompagnati da laboratori, letture, proiezioni di film e concerti, rendendo l’International Writers Festival, nonostante il nome, un evento multidisciplinare a tutti gli effetti. Il primo giorno ci sarà anche il Jerusalem International Book Forum, un evento di respiro internazionale che si ripete dal 1963 e che è pensato per tutti i professionisti dell’editoria.
					                	</p>
					                   	<p>
											Le principali location saranno la Jerusalem International YMCA (che ospiterà l’apertura del festival e il Jerusalem International Book Forum), il Konrad Adenauer Conference Center (dove si svolgerà la gran parte degli eventi), l’Israel Museum, la Jerusalem Cinematheque e il Tmo Shilshom Café. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/46/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Photos: Tomiwa Ajayi, Dan Haimovich, Kat Kaufmaunn and David Scouri
					                	</small>
				                        </div>
					                	
					                	<p>
											Tra gli invitati di quest’anno figurano Joyce Carol Oates (vincitrice del Premio Gerusalemme per la Letteratura nel 2019), André Aciman (autore del best-seller “Chiamami col tuo nome”, recentemente trasformato in un film di successo), Éric Vauillard, Andrés Neumann, Sjòn, Lana Lux, Lauren Grodd, Ahmad Danny Ramadan, Sharlene Teo e Ayo Bami Adebayo. Parteciperanno anche il Presidente di Israele Reuven Rivlin e la figlia di Amoz Oz, Fania Oz-Salzeberger. I due dialogheranno la prima sera del Festival per ricordare il grande scrittore israeliano recentemente scomparso.
					                	</p>
					                	<p>
											Il festival è organizzato dalla Jerusalem Foundation, dal Ministero della Cultura e dalla Municipalità di Gerusalemme e la sua realizzazione è possibile grazie alle donazioni di numerose organizzazioni private e associazioni.
					                	</p>
					                	<p>
					                		Per maggiori informazioni e per il programma completo:<br/>
					                		<a href="//mishkenot.org.il/writersfestival2019/en/" target="_blank">http://mishkenot.org.il/writersfestival2019/en/</a>
					                	</p>
							
				           `,
      };
    },
  },
  {
    id: "Yom_HaZikaron_End_HaAtzmaut_It",
    bgImage: "/posts/bank/47/1.jpg",
    mobBgImage: "/posts/bank/47/M.jpg",
    title: "Yom HaZikaron e HaAtzmaut",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	Lo Yom HaZikaron e lo Yom HaAtzmaut celebrano la storia di Israele
					                	</h3>
					                	<p>
											Maggio è un mese molto importante per la storia di Israele, dato che in questo periodo ricorrono due delle più importanti festività nazionali: Yom HaZikaron (7-8 maggio 2019) e Yom HaAtzmaut (8-9 maggio 2019).
					                	</p>
					                   	<p>
											Yom HaZikaron, il Giorno del Ricordo, cade ogni quarto giorno di Iyar – l’ottavo mese del calendario ebraico – ed è un momento molto solenne per tutti gli israeliani. In questo giorno, infatti, l’intero Paese si ferma a ricordare tutti i soldati morti in guerra e, più recentemente, anche i civili caduti sotto i colpi del terrorismo. Le prime celebrazioni risalgono agli anni ’50, ma la festa è ufficialmente riconosciuta dal 1963. La sera precedente lo Yom HaZikaron viene suonata una sirena che invita gli israeliani a interrompere le loro attività per un minuto di silenzio. Le celebrazioni ufficiali, accompagnate da bandiere a mezz’asta e visite ai sacrari sparsi per il Paese, si tengono invece alle 11 della mattina successiva. La sera stessa, con una solenne cerimonia sul Monte Herzl, la giornata finisce, lasciando spazio allo Yom HaAtzmaut. In questa occasione solitamente interviene il Presidente della Knesset, il cui discorso viene seguito da concerti e spettacoli pirotecnici nelle principali piazze di Israele. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/47/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Noam Chen, Itamar Grinberg, Dana Friedlander
					                	  </small>
				                        </div>
					                	
					                	<p>
											Lo Yom HaAtzmaut celebra l’anniversario dell’indipendenza di Israele dal mandato britannico, ottenuta il 14 maggio 1948. I militari aprono alcune delle loro basi per permettere al pubblico di visitarle, mentre le famiglie solitamente approfittano del bel tempo e del caldo per un picnic o una gita fuori porta. Essendo una festività nazionale, infatti, la maggior parte delle persone resta a casa dal lavoro. Il senso di appartenenza in Israele è molto forte, quindi non è affatto raro vedere centinaia di bandiere sventolare dai balconi delle abitazioni civili. La giornata si conclude con la tradizionale assegnazione dell’Israeli Prize, una benemerenza statale che va a tutti quegli israeliani che si sono distinti nel campo della scienza, dell’arte, della cultura e del sociale. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/47/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Noam Chen, Itamar Grinberg, Dana Friedlander
					                	  </small>
				                        </div>
					                	
							
				           `,
      };
    },
  },
  {
    id: "Festival_Of_Lights_It",
    bgImage: "/posts/bank/48/1.jpg",
    mobBgImage: "/posts/bank/48/M.jpg",
    title: "JERUSALEM FESTIVAL OF LIGHTS",
    smltitle: "",
    isVid: false,
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	JERUSALEM FESTIVAL OF LIGHTS
					                	</h3>
					                	<p>
											Dal 26 giugno al 4 luglio 2019 la Città Vecchia di Gerusalemme tornerà a illuminarsi di mille colori, grazie a una nuova edizione del Festival delle Luci. Questo evento, giunto al suo decimo anno, attrae ogni anno centinaia di migliaia di visitatori da tutto il mondo e porta tra le antiche mura del centro storico la più innovativa arte contemporanea, sotto forma di stravaganti installazioni luminose. È proprio il riuscito contrasto tra questi due elementi a rendere il festival uno degli appuntamenti più caratteristici e attesi dell’estate israeliana. 
					                	</p>
					                 	<p>
											Il Festival si divide in quattro percorsi differenti, i quali si snodano lungo le vie della Città Vecchia e si distinguono l’uno dall’altro per temi e colori. Tutti includono grandi installazioni luminose, ologrammi e videoproiezioni, oltre che spettacoli di luci e di suoni. Durante quella settimana, inoltre, le principali attrazioni del centro storico restano aperte fino tardi e sono visitabili anche dopo il tramonto. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/48/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Noam Chen
					                	</small>
				                        </div>
					                	
					                	<p>
											Il programma completo del Festival delle Luci e i percorsi a disposizione dei visitatori sono disponibili qui: <a href="//www.lightinjerusalem.org.il/index.php?langpage=eng" target="_blank">http://www.lightinjerusalem.org.il/</a>
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/48/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Noam Chen
					                	</small>
				                        </div>
							
				           `,
      };
    },
  },
  {
    id: "Eurovision_2019_It",
    bgImage: "/posts/bank/49/1.jpg",
    mobBgImage: "/posts/bank/49/M.jpg",
    title: "Eurovision 2019",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	Eurovision 2019: è Israele il vero vincitore!
					                	</h3>
					                	<p>
											Eurovision 2019: è Israele il vero vincitore!
											L’Eurovision Song Contest 2019 si è chiuso con un grandissimo successo per Tel Aviv e Israele, che hanno visto puntati su di loro gli occhi di tutto il mondo per quattro giorni. Grazie a una regia straordinaria, a uno svolgimento senza intoppi e a memorabili esibizioni, si può dire che anche la città ospitante, e non solo l’olandese Duncan Laurence, sia uscita vincitrice dal festival.
					                	</p>
					                 	<p>
											Qui sono accorsi migliaia di turisti da tutta Europa per vivere una settimana di grande festa e ottima musica, senza rinunciare alla vivace scena culinaria e alle splendide spiagge sul Mediterraneo, due vere e proprie icone di Tel Aviv. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/49/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: KAN
					                	</small>
				                        </div>
					                	
					                	<p>
											Su quanto sia stato positivo l’impatto dell’Eurovision per la città, i numeri ufficiali rilasciati dal Ministero del Turismo sono abbastanza chiari. Complessivamente sono arrivati in città (solo per l’Eurovision) 10.000 turisti; le visite all’EuroVillage del Charles Clore Park hanno sfiorato le 500.000 mentre alla White Night ha preso parte un milione di persone. Per seguire il festival sono arrivati a Tel Aviv 1.500 giornalisti internazionali, di cui circa 500 hanno preso parte ai 95 tour del Paese offerti dal Ministero del Turismo. Si tratta di numeri che fanno capire la grande portata del fenomeno, nonostante il boom del turismo israeliano sia proseguito ininterrotto anche nei mesi precedenti (con gli arrivi mensili che si sono ormai assestati da tempo sulle 400.000 unità).
					                	</p>
					                	<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/49/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: KAN
					                	</small>
				                        </div>
					                	
					                	<p>
					                		Ma l’Eurovision non è stata un’ottima vetrina solo per la città di Tel Aviv: l’intero stato di Israele ha beneficiato di questa esposizione mediatica più che positiva. Grazie alle 41 postcards, che hanno accompagnato le esibizioni dei cantanti in gara e agli speciali tour del Ministero del Turismo è stato possibile allargare lo sguardo ben oltre i confini di Tel Aviv, fotografando un Paese pieno di sorprese e di opportunità. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/49/3.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: KAN
					                	</small>
				                        </div>
					                	
							
				           `,
      };
    },
  },
  {
    id: "Jerusalem_Design_Week_It",
    bgImage: "/posts/bank/50/1.jpg",
    mobBgImage: "/posts/bank/50/M.jpg",
    title: "Jerusalem Design Week",
    smltitle: "",
    isVid: false,
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	A giugno una nuova edizione della Jerusalem Design Week
					                	</h3>
					                	<p>
											Torna a Gerusalemme uno degli appuntamenti più attesi dagli amanti del design e delle nuove tendenze, la Jerusalem Design Week. L’edizione di quest’anno si svolgerà in città dal 13 al 20 di giugno e sarà ancora una volta patrocinata dall’Hansen House Center for Design and Media. Questo luogo, un tempo una casa di cura per lebbrosi, è oggi un vivace centro culturale dove artisti ed esponenti del mondo accademico hanno la possibilità di mettere in mostra i loro lavori, rafforzando giorno dopo giorno il legame tra Gerusalemme e la sua innovativa scena creativa. 
					                	</p>
					                 	<p>
											La JDM, nata nel 2011, è diventata “grande” nel 2016, quando si è data un tono internazionale e iniziato a organizzare eventi e mostre in diversi punti della città, coinvolgendo le più importanti gallerie d’arte e i principali poli culturali della capitale. Nonostante l’apertura verso l’esterno, la manifestazione è sempre rimasta profondamente legata alle sue radici israeliane, assegnando ogni anno un tema di portata globale ma sempre riferibile al contesto di Gerusalemme e dintorni. L’edizione di quest’anno conta 150 partecipanti – sia israeliani che internazionali – distribuiti su 40 eventi, con un pubblico che si stima possa raggiungere i 22.000 visitatori. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/50/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Omkaar Kotedia, Noam Chen
					                	</small>
				                        </div>
					                	
					                	<p>
											Il tema scelto è “East”, l’Est, un punto cardinale verso il quale religioni e filosofie hanno sempre guardato con interesse e ammirazione e che, quest’anno, dovrà anche ispirare i partecipanti alla Design Week. L’Est ha anche un valore molto forte per gli ebrei, costretti a vivere per secoli lontani dalla loro terra d’origine. Poiché molti di questi si erano rifugiati in Europa, guardare verso Oriente significava guardare verso Israele, la loro casa. I lavori presentati verranno organizzati in sei diversi capitoli che costruiranno, in tempi e luoghi diversi, un’unica grande narrazione. L’inaugurazione si terrà la sera del 13 luglio alla Hansen House, dove, oltre a un’anteprima su alcune mostre, gli ospiti troveranno anche musica e performance dal vivo. Il 20 giugno, come da tradizione, la settimana si chiuderà con un grande concerto a sorpresa.
					                	</p>
					                	<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/50/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Omkaar Kotedia, Noam Chen
					                	</small>
				                        </div>
					                	
					                	<p>
											La Jerusalem Design Week è un’iniziativa promossa dal Ministry of Jerusalem and Heritage Affair e dalla Jerusalem Development Authority, in collaborazione con la Jerusalem Foundation.
					                	</p>
					                	<p>
					                		Maggiori informazioni sulla Jerusalem Design Week e sulle precedenti edizioni sono disponibili al sito web ufficiale: <a href="https://www.jdw.co.il/en/" target="_blank">https://www.jdw.co.il/en/</a> 
					                	</p>
							
				           `,
      };
    },
  },
  {
    id: "Wine_Festival_It",
    bgImage: "/posts/bank/51/1.jpg",
    mobBgImage: "/posts/bank/51/M.jpg",
    title: "Wine Festival",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                       
				                        <h3>
					                    	Con Wine&Plenty alla scoperta dei vini israeliani
					                	</h3>
					                	<p>
											Forse non tutti sanno che tra i prodotti tipici israeliani figuri anche il vino, eppure questo è oggi tra le produzioni locali più apprezzate anche all’estero. La storia del vino in Israele in realtà è molto antica, anche se le esportazioni hanno preso piede solo quando, dopo il 1970, sono stati introdotti i vitigni più popolari (con il Cabernet Sauvignon a fare da capofila). Qui la vite veniva già coltivata 6 millenni fa, un dato che ha trovato numerosi riscontri nel ricco patrimonio archeologico del Paese. 
					                	</p>
					                 	<p>
											Oggi in Israele i vigneti prosperano un po’ dappertutto, dal verde e rigoglioso nord fino al deserto del Negev, passando anche per il centro e per la zona di Gerusalemme. La loro fama crescente ha reso possibile la nascita di un festival del vino, il Wine & Plenty, dedicato interamente alle uve locali.  
					                	</p>
										 <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/51/1.jpg"} class="img-responsive" />
				                        </div>
					                	<p>
											L’edizione di quest’anno si svolgerà il 3 e 4 luglio 2019 e per la quarta volta avrà come sfondo gli splenditi giardini di Ramat Hanadiv, dove troveranno spazio oltre 30 espositori. Ci saranno i produttori più rinomati – tra i quali figurano Hanadiv Valley, Mt. Carmel ed Emek Hefer – ma non mancheranno altre prelibatezze tipicamente israeliane, come l’olio d’oliva e tanti altri assaggi provenienti dalle fattorie circostanti. 
					                	</p>
					                	 <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/51/2.jpg"} class="img-responsive" />
				                        </div>
					                	<p>
											I visitatori potranno provare i numerosi vini locali immersi nella splendida natura del parco di Ramat Hanadiv, incontrando di persona i produttori e venendo costantemente accompagnati da musica dal vivo e tanti altri intrattenimenti. Il parco che li ospiterà è una struttura nata circa 60 anni per ricordare il Barone Edmond de Rotschild (fondatore della prima cantina vinicola israeliana nel lontano 1882), preservare la fauna locale e sensibilizzare alla tutela del patrimonio ambientale. Oltre a essere sempre più al centro del crescente “turismo del vino”, infatti, il nord di Israele è anche un vero e proprio paradiso naturale: l’unione di queste due caratteristiche non farà altro che rendere i due giorni del festival ancora più speciali, soprattutto per chi viene da fuori.   
					                	</p>
					                	<p>
											A poca distanza dai giardini Ramat Hanadiv si trova Zichron Yaakov, la città che, quasi 150 anni fa, diede il via a questa splendida tradizione enologica in Israele: potete leggere la sua storia nell’approfondimento dedicato! Una tappa veramente imperdibile per gli amanti del vino.
					                	</p>
					                	<p>
					                		LeChaim! (Alla salute!)
					                	</p>
					                	<p>
					                		La lista completa degli espositori e il programma del festival sono disponibili qui: <a href="https://www.wine-ramathanadiv.co.il/en/" target="_blank">https://www.wine-ramathanadiv.co.il/en/</a>
					                	</p>
					                	 <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/51/3.jpg"} class="img-responsive" />
				                        </div>
							
				           `,
      };
    },
  },
  {
    id: "Zichron_Yakov_It",
    bgImage: "/posts/bank/52/1.jpg",
    mobBgImage: "/posts/bank/52/M.jpg",
    title: "Zichron Ya’akov",
    smltitle: "",
    isVid: false,
    ctg: "north",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	Zichron Ya’akov, alla scoperta della città tra vino e natura
					                	</h3>
					                	<p>
											Con quasi 140 anni di storia, Zichron Ya’akov, città 35km a sud di Haifa, entra di diritto tra gli insediamenti più antichi di Israele. Fondata nel 1882, durante la prima ondata migratoria in Terra Santa, da un gruppo di ebrei di origine rumena che le diede il nome di Zammarin, la città crebbe in dimensioni e popolarità soprattutto grazie a un’intuizione del barone Edmond James de Rothschild. Il nobile francese, tra i più accesi sostenitori della causa sionista, venne qui in visita e notò un terreno decisamente favorevole alla crescita della vite, fatto che lo spinse a fondare la cantina Carmel Winery. A lui è dovuto il nome della città: Zichron Ya’akov che in ebraico significa infatti “in memoria di Yaakov”, nome ebraico di suo padre. 
					                	</p>
					                 	<p>
											A rendere celebre il nome di Zichron Ya’akov ha contribuito anche la famiglia Aaronsohn, nota per aver formato il NILI, una rete di spie che collaborò con l’Impero britannico contro gli Ottomani durante la Prima guerra mondiale. La giovane Sarah, una delle fondatrici del gruppo, arrivò a sacrificare la sua vita per la causa di Israele a soli 27 anni ed è tutt’oggi ricordata come un’eroina nazionale. La loro casa è oggi un museo che ne racconta l’incredibile storia. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/52/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Omer Ziv, THE FIRST ALIYAH MUSEUM
					                	</small> 
				                        </div>
					                	              	
					                	<p>
											Oggi, a distanza di quasi un secolo e mezzo dalla sua nascita, la città è ancora un interessante polo turistico, grazie al suo caratteristico centro pedonale e ai suoi vicoli pieni di storia, testimoni diretti della prima Aliyah (l’ondata migratoria che portò in Israele migliaia di ebrei europei). La via principale, Midrahov Derech Hayain (“via del vino”), è rinomata per i suoi negozietti e caffè tipici ed è tutt’oggi una delle attrazioni principali, dato che è stata restaurata per apparire esattamente com’era nel XIX secolo. Qui si trova anche il museo della Prima Aliyah, che ripercorre le vicende della città dal difficile inizio del 1882 al suo successivo splendore. 
					                	</p>
					                	<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/52/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Omer Ziv, THE FIRST ALIYAH MUSEUM
					                	</small>   
				                        </div>
					                	             	
					                	<p>
											La sua posizione estremamente favorevole, inoltre, permette di godere di una fantastica vista sul Mar Mediterraneo e sul verdeggiante Monte Carmel, aggiungendo alla sua ricca storia anche un non trascurabile fattore paesaggistico. Di qui è anche passato il Giro d’Italia 2018, le cui prime tappe si sono corse in Israele. 
					                	</p>
					                	<p>
											Guardando verso il mare è anche possibile imbattersi nell’Elma Hotel Arts Complex, custode di un’interessantissima collezione di arte contemporanea e sede di molte importanti mostre. 
					                	</p>
					                	<p>
											Poco a sud della città si trova lo splendido Ramat Hanadiv, il giardino dedicato al barone de Rothschild, che offre viste mozzafiato sulla natura circostante e un museo che ne racconta la storia. Il sito è tutt’oggi mantenuto dalla famiglia Rothschild, dunque le visite sono gratuite. Qui vengono organizzati, per tutta l’estate, concerti e attività gratuiti per tutta la famiglia. A 20 anni dalla morte, avvenuta nel 1934, le spoglie del barone e della moglie furono portate qui, dove tutt’ora riposano. 
					                	</p>
					                	<p>
											Anche la Carmel Winery, che si è affermata come una delle cantine più rinomate di Israele, è rimasta una delle grandi attrattive della città, soprattutto in un periodo in cui il turismo del vino sembra andare sempre più di moda. La cantina è aperta alle visite e ospita anche un centro che ne ripercorre l’incredibile storia. Poco distanti si possono trovare anche le cantine di Tishbi, Binyamina e altre cantine boutique che insieme alla Carmel formano una vera e propria “via del vino”, itinerario imperdibile per chi vuole conoscere più da vicino il mondo dei vini israeliani.
					                	</p>
							
				           `,
      };
    },
  },
  {
    id: "Avventure_In_Israele_It",
    bgImage: "/posts/bank/53/1.jpg",
    mobBgImage: "/posts/bank/53/M.jpg",
    title: "Avventure in Israele",
    smltitle: "",
    isVid: false,
    ctg: "eilat",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	Avventura in Israele: per una vacanza all’insegna dello sport
					                	</h3>
					                	<p>
											C’è chi viene in Israele per la sua storia millenaria, chi per la sua natura incontaminata e chi per le sue lunghe e soleggiate spiagge. Ma c’è anche chi non sa riesce proprio a staccare la spina e, anche in vacanza, ha bisogno di una bella carica di adrenalina. Nessun problema, perché in Israele le proposte pensate per i turisti più impavidi non mancano certo, dal paracadutismo al diving fino a un entusiasmante giro in mountain bike sulle rupi del deserto.
					                	</p>
					                 	<p>
											Ecco quindi qualche idee per una vacanza di pura emozione, spesa andando alla scoperta (con la giusta dose di coraggio) degli angoli più suggestivi di Israele. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/53/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Omer Ziv, THE FIRST ALIYAH MUSEUM
					                	</small> 
				                        </div>
					                	             


					                    <h3>
					                    	Un’immersione a Eilat
					                	</h3>
					                	<p>
											Non c’è posto migliore di Eilat per cimentarsi in un’immersione, fosse anche una delle prime esperienze sott’acqua. Grazie alla sua splendida barriera corallina e alle sue acque trasparenti, Eilat è un vero e proprio paradiso per sub, con appassionati di diving e snorkeling che vengono qui da tutto il mondo per vedere da vicino la sua ricca fauna sottomarina. Questa è composta da quasi 300 specie diverse di coralli, tartarughe, ricci di mare, anemoni, granchi e molti altri animali: nuotare a pochi metri di distanza da una simile meraviglia è sicuramente un’esperienza da non perdere.
					                	</p>

					                    <h3>
					                    	Rafting nel Giordano
					                	</h3>
					                	<p>
											Per gli amanti dell’acqua che però non osano spingersi in profondità, un inedito giro in canoa sul fiume Giordano può essere un ottimo suggerimento. Il Giordano attraversa una grande varietà di paesaggi (dalla montagna alla pianura) e ha diversi punti in cui la corrente si fa un po’ più forte del normale: questa caratteristica lo rende adatto ai canottieri più rilassati tanto quanto agli amanti del rafting estremo. Basta scegliere con cautela la posizione di partenza e la stagione! Solitamente le acque sono più tranquille da marzo a ottobre, mentre nelle parti più montuose non c’è stagione che tenga: la discesa sarà sempre col brivido. 
					                	</p>

					                    <h3>
					                    	Paracadute a Habonim Beach
					                	</h3>
					                	<p>
											Una bella spiaggia di sabbia bianca bagnata dall’acqua cristallina è ancora più bella se la si guarda…dall’alto! Ecco perché ad Habonim Beach l’associazione Paradive organizza sessioni di skydive e di paracadutismo, aperte anche ai principianti accompagnati da un istruttore professionista. È richiesta una quantità di coraggio non indifferente, ma vedere il mare bagnare la costa mentre si è in caduta libera è un’esperienza che non può non conquistare.
					                	</p>

					                    <h3>
					                    	Watersports al Kinneret (lago di Galilea)
					                	</h3>
					                	<p>
											Surf, windsurf e kitesurf sono attività che si possono praticare ovunque in Israele: a Tel Aviv, Herzliya, Caesarea, Beit Yannay, fra Netanya e Caesarea, e ad Haifa. Pochi sanno che il Kinneret, il lago di Tiberiade che spesso nel nostro immaginario colleghiamo ancora ai Vangeli, offre anche la possibilità di surfare… Israele sorprende sempre!
					                	</p>

					                    <h3>
					                    	SUP Yoga a Tel Aviv
					                	</h3>
					                	<p>
											Non solo surf! E non solo SUP! Oltre alle due attività “tradizionali” su tavola, infatti, a Tel Aviv si può praticare Yoga sulle tavole da surf. L’attività non solo costituisce un modo alternativo di fare Yoga ma rende gli esercizi anche più complessi vista la forza necessaria per mantenersi in equilibrio sull’acqua. Allora, vi è venuta voglia di provarlo? 
					                	</p>

					                    <h3>
					                    	MTB nel Negev 
					                	</h3>
					                	<p>
											Andare alla scoperta dei più bei trails nel deserto del Negev stando in sella alla propria MTB. I panorami unici e i good riding hanno il potere di rendere un viaggio in sella alla mountain bike il modo migliore per scoprire il paesaggio aspro e mozzafiato che regala il Negev: un’esperienza che ci sentiamo caldamente di consigliare a chi sia alla ricerca di luoghi esotici e inusuali da vivere in sella!
					                	</p>
							
				           `,
      };
    },
  },
  {
    id: "Grandi_Concerti_It",
    bgImage: "/posts/bank/54/1.jpg",
    mobBgImage: "/posts/bank/54/M.jpg",
    title: "Grandi concerti a Tel Aviv",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	A Tel Aviv un’estate all’insegna della grande musica internazionale
					                	</h3>
					                	<p>
											Quella tra Tel Aviv e la grande musica internazionale è una storia che va avanti da ormai diversi anni, con artisti del calibro di Bob Dylan, Paul McCartney, Rolling Stones, Madonna, Dire Straits e molti altri che sono passati di qui. Quest’anno non sarà da meno, grazie a una programmazione estiva che vedrà esibirsi numerose star internazionali e che attirerà decine di migliaia di persone ad ogni evento. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/54/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Noam Galai  Stringer, Getty Images
					                	</small>  
				                        </div>
					                	            
					                 	<p>
											Una nuova gioia per gli amanti della musica rock arriverà il 25 luglio, grazie all’attesissimo concerto dei Bon Jovi a Yarkon Park. La band americana è impegnata nel tour estivo per la promozione del suo ultimo album, This House Is Not For Sale, e ritorna in Israele 4 anni dopo il suo ultimo concerto. Nel 2015 i Bon Jovi si erano già esibiti a Yarkon Park, davanti a una folla di oltre 50.000 fan in festa. 
					                	</p>
					                	<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/54/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Noam Galai  Stringer, Getty Images
					                	</small> 
				                        </div>
					                	 
					                	<p>
											A riportare il grande pop in auge dopo un luglio rock’n’roll, ci penserà Jennifer Lopez, il cui concerto è previsto per il 1° agosto allo Yarkon Park. J-Lo, che appare ciclicamente in vetta alle grandi classifiche internazionali, porterà a Tel Aviv una delle tappe del suo “It’s My Party” tour. Per lei si tratta della prima esibizione in Israele e, anche per questo motivo, ci si attende una partecipazione da record. 
					                	</p>
					                	<p>
											In mezzo a questa parata di stelle, anche l’Italia ha saputo ritagliarsi uno spazio importante. Questo grazie a Eros Ramazzotti, una delle voci italiane più famose che ha sempre goduto di grande popolarità anche fuori dai confini nazionali. Il cantante romano sarà alla Yad-Eliyahu Arena il prossimo 9 novembre. 
					                	</p>
							
				           `,
      };
    },
  },
  {
    id: "International_Arts_It",
    bgImage: "/posts/bank/55/1.jpg",
    mobBgImage: "/posts/bank/55/M.jpg",
    title: "International arts & crafts fair",
    smltitle: "",
    isVid: false,
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	Gerusalemme alla scoperta dell’artigianato con l’International arts and crafts fair
					                	</h3>
					                	<p>
											Come ogni estate, Gerusalemme torna a ospitare la tradizionale International Arts and Crafts Fair, nota tra gli israeliani con il nome di “Hutzot HaYotzer”. Dalla gioielleria fino alle arti pittoriche, passando per pelletteria e giocattoli, la fiera è un’occasione unica per vedere da vicino il meglio dell’artigianato israeliano e internazionale. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/55/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: David Saad
					                	</small>  
				                        </div>
					                	            
					                 	<p>
											L’edizione 2019 si terrà dal 15 al 27 agosto e andrà ad aggiungersi ai numerosi intrattenimenti della calda estate israeliana. Centinaia di artisti da tutto il mondo si ritroveranno per mettere in mostra le loro creazioni, ma non saranno l’unica attrazione dell’evento. Ogni sera a partire dalle 21 importanti musicisti israeliani si esibiranno dal vivo sul palco posto davanti alla Piscina del Sultano, mentre durante il giorno, per tutta la settimana, si susseguiranno laboratori, workshop e attività per bambini.
					                	</p>
					                	<p>
											Nel padiglione israeliano, dedicato agli artisti “di casa”, ci saranno circa 200 artigiani all’opera. Nel padiglione internazionale, dedicato ai prodotti dell’artigianato estero, ci saranno oltre 30 paesi stranieri, con prodotti in esposizione che spaziano dai cesti di vimini fino alle marionette, includendo anche tessuti, vetro lavorato, sculture in legno e molto altro. In particolare, sarà possibile ammirare lavori provenienti da: Argentina, Armenia, Bolivia, Chile, Cina, Colombia, Corea del Sud, Ecuador, El Salvador, Germania, Ghana, Guatemala, India, Kenya, Kighizistan, Macedonia, Madagascar, Messico, Perù, Repubblica Ceca, Romania, Russia, Sud Africa, Sri Lanka, Tagikistan, Turkmenistan, Ucraina, Ungheria, Uruguay, Uzbekistan e Zimbabwe.
					                	</p>
					                	<p>
											Per maggiori informazioni e per consultare il programma completo della mostra:<br/>
											<a href="https://artfair.jerusalem.muni.il/Pages/English.aspx#title4" target="_blank">https://artfair.jerusalem.muni.il/</a>
					                	</p>
					                	<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/55/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: David Saad
					                	</small>
				                        </div>
					                	
							
				           `,
      };
    },
  },
  {
    id: "Jerusalem_Film_Festival_It",
    bgImage: "/posts/bank/56/1.jpg",
    mobBgImage: "/posts/bank/56/M.jpg",
    title: "Jerusalem Film Festival",
    smltitle: "",
    isVid: false,
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					                    	Il grande cinema arriva in Israele con il Jerusalem Film FEstival
					                	</h3>
					                	<p>
											Torna, per il 36esimo anno, il Jerusalem Film Festival, il concorso cinematografico più popolare di Israele. L’edizione di quest’anno si terrà dal 25 luglio al 4 agosto 2019 e metterà in mostra il meglio delle ultime uscite in sala, siano grandi produzioni internazionali oppure piccoli lavori indipendenti. 
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/56/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit: Jerusalem Cinematheque & Film Festival
					                	</small>  
				                        </div>
					                	            
					                 	<p>
											La rassegna cinematografica israeliana, inaugurata nel maggio 1984 con Ballando Ballando di Ettore Scola, è oggi diventata uno degli appuntamenti internazionali più importanti per quando riguarda l’industria del grande schermo, con attori come Robert de Niro, Marcello Mastroianni, Roberto Benigni, John Malkovich e tanti altri che sono passati sul suo tappeto rosso. 
					                	</p>
					                	<p>
											Oggi il festival, che va in scena ogni mese di luglio, si distribuisce su oltre 10 giorni di eventi, con oltre 200 proiezioni e numerose sezioni, competitive e non. Parallelamente al festival va anche in scena il meeting della Jerusalem Pitch Point, il cui obiettivo è quello di far incontrare i membri dell’industria cinematografica israeliana con le grandi case di produzione che ogni anno popolano il festival. Nonostante il suo ampio respiro internazionale, infatti, il festival è sempre rimasto molto radicato alla tradizione e al cinema israeliano, diventando un vero e proprio faro per il suo rilancio e la sua distribuzione fuori dai confini nazionali. 
					                	</p>
					                	<p>
											L’evento di quest’anno sarà una festa anche per tutti coloro che si trovano già a Gerusalemme. In vari punti della città, infatti, oltre alle consuete proiezioni, ci saranno anche workshop, masterclass, feste e incontri con professionisti del settore. <br/>
											<a href="https://www.jff.org.il/en/article/2404" target="_blank">https://www.jff.org.il/</a>
					                	</p>
					                	<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/56/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit: Jerusalem Cinematheque & Film Festival
					                	</small>
				                        </div>
					                	
							
				           `,
      };
    },
  },
  {
    id: "Mostre_Estive_In_Israele_It",
    bgImage: "/posts/bank/57/1.jpg",
    mobBgImage: "/posts/bank/57/M.jpg",
    title: "Mostre estive in Israele",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <p>
											Con l’arrivo dell’estate e l’aumentare delle temperature, sono migliaia i turisti che scelgono Israele per le spiagge, gli sport acquatici e per un bel bagno di sole. Ma c’è anche chi, attirato dal ricco patrimonio culturale del Paese e dai suoi oltre 200 musei, decidere di spendere l’estate girovagando di mostra in mostra, godendosi da vicino le opere di grandi artisti internazionali e una buona dose di aria condizionata.
					                	</p>
					                 	<p>
											Quest’ultima categoria non resterà certo delusa, dato che anche quest’anno il calendario delle esposizioni artistiche in Israele è decisamente ricco. Ecco una selezione delle mostre estive più interessanti, imperdibili per un vero appassionato. 
					                	</p>
					                	<h3>
					                		The Conversation Show – Design Museum, Holon
					                	</h3>
					                	<p>
											Curata dall’artista Maria Cristina Didaro, questa mostra raccoglie al suo interno cinque installazioni dedicate al design, firmate da rinomati professionisti del settore che hanno lavorato in coppia per completarle. Fornisce un interessante sguardo sulle diverse tappe del processo creativo e sulle relazioni che si instaurano durante la nascita di un’opera. La mostra resterà aperta fino al 26 ottobre 2019 ed è anche un’occasione per visitare la città di Holon, a pochissima distanza dalla più centrale Tel Aviv.
					                	</p>
										<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/57/1.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Elad Sarig, Quique Kierszenbaum
					                	</small> 
				                        </div>
					                	             
					                	<h3>
											Peter and Pan: From Ancient Greece To Neverland – The Israel Museum, Jerusalem
					                	</h3>
					                	<p>
					                		Ancora una volta l’Israel Museum mira a stupire, per mezzo di un abbinamento audace e inaspettato, i propri visitatori. Questa volta nelle stesse sale sono finite la favola di Peter Pan e le effigi del dio greco-romano Pan, unendo la loro storia lungo un unico filo temporale che passa attraverso statue, affreschi, illustrazioni e anche edizioni storiche del celebre libro di James Matthew Barrie, poi diventato un classico Disney. La mostra, inaugurata lo scorso mese, resterà aperta fino all’11 dicembre 2019.
					                	</p>
					                	<h3>
											Jewelry Making: Past and Present – The Museum of Islamic Art, Jerusalem
					                	</h3>
					                	<p>
											Il Museo di Arte Islamica di Gerusalemme mette in mostra, direttamente dalla sua collezione permanente, una serie di gioielli fatti a mano che aiuti a ripercorrere e a capire meglio il rapporto tra le tre grandi religioni monoteiste della città. Fino al 16 novembre sarà possibile ammirare monili risalenti addirittura al VII secolo a.C., cercando di ricostruire attraverso semplici oggetti il rapporto tra religione, vita sociale e convivenza che ha sempre contraddistinto Israele. 
					                	</p>
					                	<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/57/2.jpg"} class="img-responsive" />
				                          <small>
					                		Credit foto: Elad Sarig, Quique Kierszenbaum
					                	</small>
				                        </div>
					                	
					                	<h3>
											The Lod Mosaic – The National Maritime Museum, Haifa
					                	</h3>
					                	<p>
											Una bella notizia per tutti gli appassionati di archeologia: dopo un giro del mondo durato anni e passato per Parigi, New York e Chicago, il mosaico di Lod torna finalmente a casa, in Israele. Scoperto nel 1996 durante degli scavi di routine nella cittadina che gli ha dato il nome, il mosaico misura 180 metri quadri ed è uno dei meglio conservati al mondo. Si ritiene fosse il pavimento di una villa romana del III-IV secolo<br/>
											Touch Me by Sigal Miller – Abraham Hostel, Tel Aviv<br/>
											Veiled Women of The Holyland – Israel Museum, Jerusalem<br/>
											<a href="https://nocamels.com/2019/06/museum-exhibits-summer-israel/" target="_blank">https://nocamels.com/2019/06/museum-exhibits-summer-israel/</a>
					                	</p>
							
				           `,
      };
    },
  },
  {
    id: "Red_Sea_Jazz_Festival_It",
    bgImage: "/posts/bank/58/1.jpg",
    mobBgImage: "/posts/bank/58/M.jpg",
    title: "Red Sea Jazz Festival",
    smltitle: "",
    isVid: false,
    ctg: "eilat",
    html: function() {
      return {
        __html: `
				                       
				                        <p>
											Torna anche quest’anno uno degli eventi più attesi dagli amanti della musica: il Red Sea Jazz Festival. La rassegna nata nel lontano 1987 andrà in scena dal 25 al 27 agosto 2019 e porterà, come ogni anno, i più interessanti jazzisti internazionali sulle rive del Mar Rosso. 
					                	</p>
					                 	<p>
											Il festival, che vuole essere un momento per unire persone e culture a ritmo di musica jazz, sarà ancora una volta organizzato al porto di Eilat, rendendolo anche un ottimo pretesto per passare dal Mar Rosso e scoprire una delle località più divertenti di Israele. 
					                	</p>
					                	<p>
											Il programma dell’evento, che anche quest’anno include grandi musicisti israeliani e non, rappresentando un po’ tutte le principali correnti del jazz (ce ne sono a centinaia!), non deluderà certo gli amanti della musica. Aprirà le danze il contrabbassista israeliano Avishai Cohen, che lascerà poi spazio alla voce di Buika e alla musica del gruppo israeliano “The Jerusalem Yellow Submarine’s Non Standard Project”.
					                	</p>
					                	<p>
											Tra i nomi più importanti possiamo citare il trombettista italiano Enrico Rava, la band di Danny Rosenfeld al gran completo (8 elementi), il sassofonista Kenny Garrett, il tributo a Django Reinhardt a cura del Richard Manetti Quartet e Donny McCaslin, il sassofonista che ha collaborato con David Bowie per la stesura del suo ultimo album Blackstar.
					                	</p>
					                	<p>
											Oltre ai “big” del palcoscenico, ci sarà anche la possibilità di assistere e partecipare alla consueta jam session finale, per chiudere il festival in bellezza e rendere quei giorni ad Eilat ancora più speciali. 
					                	</p>
					                	<p>
											Per maggiori informazioni e per il programma completo:<br/>
											<a href="https://en.redseajazz.co.il/schedule/" target="_blank">https://en.redseajazz.co.il/schedule/</a>
					                	</p>
							
				           `,
      };
    },
  },
  {
    id: "Tisha_Beav_It",
    bgImage: "/posts/bank/59/1.jpg",
    mobBgImage: "/posts/bank/59/M.jpg",
    title: "Tisha b'av",
    smltitle: "",
    isVid: false,
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
				                            Tisha b’Av, il popolo ebraico si ferma
				                        </h3>
				                        <p>
											Dalla sera del 10 di agosto fino alla sera dell’11, in Israele cadrà la ricorrenza di Tisha b’Av, probabilmente una delle più tristi della storia ebraica. In questo giorno, infatti, si celebrano diversi momenti di ricordo e di lutto: la distruzione del Primo Tempio di Gerusalemme per opera dei Babilonesi, la distruzione del Secondo Tempio per opera dell’Imperatore romano Tito, la sconfitta degli insorti di Bar Kochba sempre contro i romani e la conseguente distruzione di Gerusalemme, che tradizionalmente segna l’inizio della diaspora del popolo ebraico. 
					                	</p>
					                 	<p>
											A queste tragedie dell’età antica ne sono seguite altre più moderne, come la cacciata degli ebrei dall’Inghilterra prima e dalla Spagna poi. In epoca talmudica i rabbini avevano individuato in questo giorno una sorta di punizione divina, fatta cadere ciclicamente sul popolo ebraico per punire la sua mancanza di fede durante l’Esodo. 
					                	</p>
					                	<p>
											Durante il giorno, di fatto, la vita è come sospesa: non è consentito festeggiare, mangiare, lavarsi ed esprimere manifestazioni di affetto, tutto questo in segno di rispetto per le tragedie passate che vengono così onorate. Non è neanche possibile studiare la Torah, poiché la sua lettura porterebbe gioia, se non scegliendo brani tragici o legati alla distruzione del tempio.
					                	</p>
							
				           `,
      };
    },
  },
  //TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES FROM HADAR CORRECTIONS LISHKA
  // {
  // 	    id:"DLD_Innovation_Festival_It",
  //         bgImage : "/posts/bank/60/1.jpg",
  //         mobBgImage : "/posts/bank/60/M.jpg",
  //         title : "DLD Innovation Festival",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "telaviv",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         <p>Grazie alla presenza di quasi 1000 start-up, la città di Tel Aviv è la “capitale tecnologica” di Israele. Proprio qui si terrà uno dei più importanti festival dedicati all’innovazione e al mondo digitale, il DLD Tel Aviv Innovation Festival, in programma dal 16 al 19 settembre 2019. </p>
  // 	                      <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/60/1.jpg"} class="img-responsive" />
  //                         </div>
  // 	                     <p>Arriveranno in città migliaia di professionisti e imprenditori del mondo hi-tech, pronti a scambiarsi idee, consigli e obiettivi, cercando al tempo stesso nuovi investitori per i loro progetti più ambiziosi. L’intera rassegna si basa su diversi appuntamenti (ai quali prendono parte ogni anno esponenti di grandi multinazionali) che trattano, attraverso le esperienze dirette dei protagonisti del settore, di innovazione, digital media, scienza e cultura.</p>

  // 	                     <p>I numeri di quest’anno includono 110 delegazioni da tutto il mondo, oltre 4.000 partecipanti e più di 100 start-up pronte a mettersi in mostra davanti a una platea potenzialmente senza confini. </p>
  // 	                      <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/60/2.jpg"} class="img-responsive" />
  //                         </div>
  // 	                     <p>Il momento più importante del DLD si avrà i giorni 18 e 19 settembre, quando si terrà la DLD Digital Conference presso l’Hatachana Compound. Questo evento, la punta di diamante del vasto calendario dedicato al mondo delle imprese digitali, metterà in diretto contatto imprese e investitori e creerà, per un weekend, uno dei più grandi e variegati incubatori di tecnologie al mondo. L’applicazione del futuro o la prossima svolta nelle bio-tecnologie potrebbero prendere forma proprio qui a Tel Aviv, tra i numerosi appuntamenti del DLD.</p>

  // 	                     <p>Tra le grandi imprese che parteciperanno quest’anno, sia in veste di oratori che di osservatori, troviamo Alibaba, Amazon, Cisco, Facebook, Google, IKEA, Intel, Microsoft, Nasdaq, Nissan, PepsiCo, World Economic Forum e tanti ospiti di livello internazionale. </p>

  // 	                     <p>Il programma completo e altre informazioni sul DLD Tel Aviv Innovation Festival sono disponibili al sito web: <a href="https://www.dldtelaviv.com/2019/index.php" target="_blank">www.dldtelaviv.com</a></p>

  // 	                     <p>Credit foto: DLD Tel Aviv Innovation Festival</p>

  //            `
  //     }
  //   }
  // },
  // end TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES FROM HADAR CORRECTIONS LISHKA

  //TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES FROM HADAR CORRECTIONS LISHKA
  // {
  // 	    id:"Mekudeshet_Festival_It",
  //         bgImage : "/posts/bank/61/1.jpg",
  //         mobBgImage : "/posts/bank/61/M.jpg",
  //         title : "Mekudeshet Festival",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "jerusalem",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         <p>Dal 4 al 21 settembre 2019 la Città Vecchia di Gerusalemme ospita il Mekudeshet Festival (il cui nome significa “sacro”), una rassegna artistica sperimentale che unisce musica, danza e numerose esperienze culturali. </p>
  // 		                <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/61/1.jpg"} class="img-responsive" />
  //                         </div>
  // 		                <p>Gerusalemme, città multiculturale dalle mille contaminazioni, è indubbiamente il luogo giusto per godersi un festival che abbraccia l’arte a 360°. Gli highlight del festival includono concerti di musica classica, reggae e tradizionale, che si alternano con esibizioni più insolite e votate soprattutto alle arti visive, dalle tradizionali mostre fino alle più moderne esperienze interattive di video-mapping. </p>
  // 		                <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/61/2.jpg"} class="img-responsive" />
  //                         </div>
  // 		                <p>Il Mekudeshet vuole anche essere un messaggio di speranza, pace e tolleranza rivolto alle tante anime differenti che compongono il tessuto sociale di Gerusalemme. Per questo motivo “prende” dalla città (con numerose opere ispirate proprio da questa) e contemporaneamente alla città restituisce, attraverso opere dal sicuro impatto visivo e dal significato profondo. Per un turista, non c’è modo migliore per scoprire il lato più artistico e sperimentale di Gerusalemme, il melting pot culturale per eccellenza. </p>
  // 		                <p>Maggiori informazioni sulla storia del festival e il programma completo delle esibizioni sono disponibili al sito web:<a href="https://en.mekudeshet.com/" target="_blank">en.mekudeshet.com</a> </p>
  // 		                <p>Credit foto: Daniel Hanoch</p>

  //            `
  //     }
  //   }
  // },

  // {
  // 	    id:"Open_House_Tel_Aviv_It",
  //         bgImage : "/posts/bank/62/1.jpg",
  //         mobBgImage : "/posts/bank/62/M.jpg",
  //         title : "Open House Tel Aviv",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "telaviv",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         <h3>
  // 			                    Alla scoperta degli edifici più iconici di Tel Aviv
  // 			                    con la nuova edizione dell’Open House

  // 			            </h3>
  // 			                        <p>La tradizione degli Open Days, il festival nato in Francia nel 1984 che apre al pubblico edifici di interesse storico ma normalmente inaccessibili, ha contagiato anche Tel Aviv. Nella città israeliana andrà in scena, dal 19 al 21 settembre, una nuova edizione dell’“Open House Tel Aviv”, con numerosi edifici che apriranno le loro porte in via eccezionale a residenti e turisti.</p>
  // 			                        <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/62/1.jpg"} class="img-responsive" />
  //                         </div>
  // 			                        <p>L’Open House Tel Aviv si svolge ogni anno dal 2007 e rappresenta un’occasione per scoprire da vicino l’architettura Bauhaus della “Città Bianca”. Ma non solo: il festival offre anche un importante palcoscenico a giovani architetti e designer locali, da sempre attenti a sorprendere i visitatori senza trascurare gli aspetti eco-friendly.</p>
  // 			                        <p>Tra i luoghi più interessanti da visitare, il grattacielo Meier on Rothschild con i suoi 42 piani, la residenza dell’ambasciatore francese a Jaffa, la casa natale del poeta ebraico Hayyim Nahman Bialik, oggi trasformata in un vero e proprio museo. Tra i diversi tour disponibili, da non perdere ad esempio quello dedicato alla street art nel quartiere di Florentin. </p>
  // 			                       <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/62/2.jpg"} class="img-responsive" />
  //                         </div>
  // 			                        <p>E per tutti gli appassionati di architettura, le sorprese di Tel Aviv non finiscono certo qui. Quest’anno cade infatti il centesimo anniversario dalla fondazione della scuola Bauhaus, e il Bauhaus Center, l’associazione che custodisce e promuove il retaggio urbanistico della città, propone tour e mostre a tema per tutto l’anno. </p>
  // 			                        <p>La lista completa degli edifici aperta al pubblico in occasione dell’Open House è disponibile al sito: <a href="//www.batim-il.org/ToursEng.aspx?batim=" target="_blank">www.batim-il.org.</a> In alcuni casi potrebbe essere necessario prenotare la propria visita in anticipo. </p>

  // 			                        <p>Credit foto: Dana Friedlander<p>

  //            `
  //     }
  //   }
  // },
  // end TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES FROM HADAR CORRECTIONS LISHKA

  {
    id: "Alture_del_Golan_It",
    bgImage: "/posts/bank/63/1.jpg",
    mobBgImage: "/posts/bank/63/M.jpg",
    title: "Alture del Golan",
    smltitle: "",
    isVid: false,
    ctg: "north",
    html: function() {
      return {
        __html: `
				                        
				                        <p>Alla scoperta delle Alture del Golan tra natura, archeologia e del buon vino
					                     <p>C’è un posto, nel nord-est di Israele, che è un vero e proprio paradiso per gli amanti della natura e dei grandi panorami: sono le alture del Golan. Questa regione, che si estende dal Mar di Galilea fino al confine con il Libano, è da tutt’altra parte rispetto alle grandi città del centro del Paese, ma non per questo è meno ricca di attrazioni e avventure. </p>
					                     <p>A differenza del sud di Israele, desertico e selvaggio, le alture del Golan sono caratterizzate da ampie aree verdi e rigogliose, grazie alla grande presenza di acqua nella regione. Proprio l’acqua offre una delle principali attrazioni del luogo: le maestose cascate Saar. Queste, alimentate dalle nevi delle montagne sovrastanti, raggiungono il Massimo.
 </p>
					                     <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/63/1.jpg"} class="img-responsive" />
				                         </div>
					                     <p>Un altro luogo da non perdere è la riserva naturale di Gamla, dove aquile e avvoltoi vengono a nidificare e da dove si gode di una splendida vista su tutte le alture. Per una pausa all’insegna del relax, invece, conviene fermarsi a Hamat Gader, con le sue fonti termali già note ai romani oltre 2.000 anni fa.</p>
					                     <p>C’è spazio anche per i più avventurosi che potranno dedicarsi ad escursioni in fuoristrada, rafting nel fiume Giordano, trekking lungo il Golan Trail e tour in quad alla scoperta del lato più selvaggio del Golan. In inverno qui si può addirittura sciare, dato che il monte Hermon è abbastanza alto da offrire ogni anno almeno 50 giorni di neve. Anche senza sci ai piedi, o in mesi più caldi, la vista sulla Galilea dalla sua vetta (2.814m) vale una visita.</p>
					                     <p>Non mancano poi importanti siti di importanza storica. Uno di questi è la Fortezza di Nimrod, il più grande edificio di epoca crociata in Israele. La struttura del XIII secolo, in buono stato di conservazione, è oggi aperta al pubblico e offre un viaggio nel tempo fino al Medioevo, con visite guidate alle torri, al fossato e ai molteplici passaggi segreti tra le antiche stanze di pietra. I tour, aperti ai gruppi e ai turisti in solitaria, vengono organizzati anche la sera, accompagnati dalla suggestiva luce delle lanterne. </p>
					                     <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/63/2.jpg"} class="img-responsive" />
				                         </div>
					                     <p>Lungo le mura sono inoltre presenti numerosi punti di osservazione sulle alture circostanti, un tempo usati per scorgere l’avanzata dei nemici e diventati oggi un’occasione per godere di uno splendido panorama sul Golan. Un altro luogo da non perdere per gli passionati di archeologia è Rujm el-Hiri, la “Stonehenge israeliana”: una costruzione megalitica risalente a circa 3.000 anni fa.</p>
					                     <p>Qui si trova anche uno dei consorzi di produttori di vino più rinomati di Israele, la Golan Heights Winery. L’azienda agricola coltiva sedici vitigni autoctoni, impiega oltre 100 lavoratori e utilizza tecniche all’avanguardia per la produzione del proprio vino, tanto da aver ottenuto, nel corso della sua storia, decine di riconoscimenti. Nel 2011, in particolare, ha ottenuto il Gran Vinitaly Special Award, assegnato ogni anno in Italia.</p>
					                     <p>Poiché Israele è un Paese relativamente piccolo, tutte queste meraviglie si trovano a poco più di due ore di auto da Tel Aviv e Gerusalemme. Questo rende molto semplice l’aggiunta di un giro last-minute sul Golan al proprio itinerario: basterà noleggiare una macchina o unirsi a uno dei tanti tour settimanali della regione, con partenza proprio dalle grandi città. </p>

					                     <p>Credit foto: Itamar Grinberg</p>
							
				           `,
      };
    },
  },

  //TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES FROM HADAR CORRECTIONS LISHKA
  // {
  // 	    id:"Rosh_HaShana_It",
  //         bgImage : "/posts/bank/64/1.jpg",
  //         mobBgImage : "/posts/bank/64/M.jpg",
  //         title : "Rosh haShana",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "jerusalem",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         <p>Dalla sera del 29 settembre alla sera del 1° ottobre in Israele si festeggerà Rosh Hashana, una delle ricorrenze più importanti e sentite per il popolo ebraico. La festività cade il primo e il secondo giorno di Tishrì, il primo mese del calendario ebraico, ed è per questo motivo considerata alla stregua del nostro Capodanno (Rosh haShana significa proprio “capo dell’anno”). </p>
  // 		                <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/64/1.jpg"} class="img-responsive" />
  //                         </div>
  // 		                   <p>La tradizione vuole che durante questa festa venga suonato lo Shofar, un tipico strumento a fiato il cui suono, che rappresenta un richiamo verso Dio, mira a far emergere la volontà di pentimento (teshuva). Proprio il pentimento è il sentimento chiave di Rosh haShana: con questa ricorrenza, infatti, cominciano i dieci giorni penitenziali (Yamim Noraim) che portano verso la festa dello Yom Kippur (8-9 ottobre 2019), il giorno dell’espiazione e del giudizio divino.</p>
  // 		                   <p>Una delle azioni compiute dai fedeli durante i festeggiamenti è il tashlich, il lancio di oggetti negli specchi d’acqua (laghi o fontane) che vuole simboleggiare l’allontanamento dagli atti impuri e dai peccati residui. Si è anche soliti piantare qualche seme di grano o di granturco, per iniziare l’anno con un auspicio di prosperità.</p>

  // 		                   <p>A tavola, durante il Seder di Rosh haShana, si è soliti consumare qualcosa di dolce: spesso si opta per una mela intinta nel miele, per augurarsi un anno pieno di dolcezza. Anche il melograno è un frutto molto popolare sulle tavole delle famiglie ebree, poiché simboleggia la molteplicità e l’abbondanza. Una particolare forma di pane intrecciato (chiamata challa) rappresenta invece la circolarità dell’anno, la cui fine e il cui inizio vengono celebrati proprio in quei giorni.</p>

  //            `
  //     }
  //   }
  // },

  // {
  // 	    id:"Solar_Guerrilla_Exhibition_It",
  //         bgImage : "/posts/bank/65/1.jpg",
  //         mobBgImage : "/posts/bank/65/M.jpg",
  //         title : "Solar Guerrilla Exhibition",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "telaviv",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         <p>Tra progetti futuristici e opere già realizzate, la lotta al cambiamento climatico passa anche attraverso un drastico ripensamento del profilo urbanistico delle città. Il TAM, Tel Aviv Museum of Art, ha deciso di raccogliere in un’unica mostra tutti i progetti più innovativi ed eco-friendly attualmente in cantiere per contrastare il riscaldamento globale e le altre disastrose conseguenze che l’azione dell’uomo sta avendo sul pianeta Terra. </p>
  // 	                    <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/65/1.jpg"} class="img-responsive" />
  //                         </div>
  // 	                    <p>Tra i progetti in mostra ci saranno le soluzioni adottate da grandi città come Chicago, Hong Kong, Londra, Copenaghen, Shanghai e la stessa Tel Aviv, oltre ad altre importanti capitali mondiali. Quella verso un’urbanistica green sembra essere una tendenza internazionale che non ha lasciato indifferente nemmeno l’Italia, dato che nei corridori del museo israeliano si parlerà di alcuni progetti in atto a Venezia e del Bosco Verticale, l’innovativo grattacielo di Stefano Boeri che da Milano sta rapidamente facendo il giro del mondo. </p>
  // 	                    <p>La mostra, curata da Maya Vinitsky, è stata ufficialmente inaugurata lo scorso 18 luglio ma resterà aperta fino a novembre 2019. Il Tel Aviv Museum of Art, oltre a numerose esposizioni di artisti israeliani e non, offre anche un’interessante collezione permanente di arte moderna e contemporanea. Aperto nel 1932, il museo è ancora oggi uno dei più importanti poli culturali di Israele.</p>
  // 	                    <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/65/2.jpg"} class="img-responsive" />
  //                         </div>
  // 	                    <p>Informazioni sulla mostra e alcune anteprime sono disponibili al sito: <a href="//www.tamuseum.org.il/about-the-exhibition/solar-guerrilla-constructive-responses-to-climate-change" target="_blank"> http://www.tamuseum.org.il</p>

  //            `
  //     }
  //   }
  // },
  // end TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES FROM HADAR CORRECTIONS LISHKA
  {
    id: "Israeli_Innovation_It",
    bgImage: "/posts/bank/66/1.jpg",
    mobBgImage: "/posts/bank/66/M.jpg",
    title: "Israeli innovation peres center",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>
					           				L’Israeli Innovation Center di Tel Aviv mette in mostra la Start-Up Nation
					              		</h3>
					              		<p>
										Da qualche tempo a Tel Aviv c’è una nuova struttura capace di raccontare la storia di Israele e delle numerose innovazioni sviluppate in questa vera e propria “Start-up Nation”. Si tratta dell’Israeli Innovation Center, situato all’interno del Peres Center for Peace and Innovation.
										</p>
										<p>
										Questa struttura è dedicata a Shimon Peres, uno dei politici più longevi di Israele che per primo, nel 1996, volle aprire un centro di questo tipo, con l’ambizioso obiettivo di unire persone da tutto il Paese (e non solo) sotto il segno dell’innovazione, dell’imprenditoria, dell’educazione e di tanti altri importanti valori. 
										</p>
					                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/66/1.jpg"} class="img-responsive" />
				                        </div>
										<p>
										La struttura è stata progettata dall’architetto Massimiliano Fuksas in collaborazione con l’architetto locale Yoav Messer ed è presto diventata un punto di riferimento per il mondo della ricerca e dell’innovazione. Grazie al supporto del Ministero dell’Economia Israeliano e di importanti partners privati, l’Israeli Innovation Center è oggi al centro di un importante network dedicato alla ricerca e al commercio.
										</p>
										<p>
										Il centro, che si trova ad Ahuzat Bayit St 2, è naturalmente aperto al pubblico e offre numerose attrazioni per scoprire più da vicino la storia dell’innovazione in Israele. Tra maxi-schermi, ologrammi, realtà virtuale e mostre permanenti, sarà possibile fare un viaggio nel tempo, scoprendo che cosa ha ispirato e motivato generazioni di pionieri tecnologici israeliani. Tra le attrazioni c’è anche una ricostruzione dello studio di Shimon Peres, dove è possibile vedere il Premio Nobel per la pace vinto nel 1994.
										</p>
										<p>
										Maggiori informazioni su orari, biglietti ed eventi sono disponibili al link: <a href="https://www.peres-center.org/en/the-israeli-innovation-center/explore/" target="_blank">www.peres-center.org</a>
										</p>
							
				           `,
      };
    },
  },

  //ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  // {
  // 	    id:"Le_Maratone_It",
  //         bgImage : "/posts/bank/67/1.jpg",
  //         mobBgImage : "/posts/bank/67/M.jpg",
  //         title : "Le maratone",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "telaviv",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                           <h3>
  // 			              	Israele…di corsa! Le maratone in programma da novembre 2019 a dicembre 2020
  // 			              </h3>
  // 			              <p>
  // 							L’arrivo dell’inverno israeliano porta con sé anche una grande stagione di eventi sportivi, adatti a tutti gli appassionati di natura e aria aperta. Chi non resterà sicuramente deluso, in particolare, sono gli amanti delle maratone, visto che il calendario da qui alla primavera prossima include almeno 6 grandi appuntamenti internazionali dedicati alle corse sulle lunghe distanze.
  // 							</p>
  // 							<p>
  // 							Vediamo quali sono gli eventi più gettonati dei prossimi mesi, che saranno anche un’occasione ideale per scoprire un Paese ricco di storia e natura come Israele attraverso l’attività sportiva.
  // 							</p>
  // 			                <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/67/1.jpg"} class="img-responsive" />
  //                         </div>
  // 							<h3>
  // 								<a href="https://www.ultramanisrael.com/" target="_blank" style="color:#000;text-decoration: underline;">
  // 									Ultraman Israel – 19-21 novembre 2019
  // 								</a>
  // 							</h3>
  // 							<p>
  // 							Già a novembre avremo il primo grande evento sportivo della stagione: la Ultraman Israel. Questo appuntamento, dedicato agli appassionati di triathlon, permetterà ai partecipanti di attraversare il Paese da nord a sud, con la prima prova (il nuoto) svolta nel Mar di Galilea e l’arrivo della corsa finale previsto a Eilat, sul Mar Rosso. In mezzo anche l’altro mare israeliano, il Mar Morto, avrà il suo momento di gloria: lungo le sue coste, infatti, si svolgerà la prova di ciclismo.
  // 							</p>
  // 			                <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/67/2.jpg"} class="img-responsive" />
  //                         </div>
  // 							<h3>
  // 								<a href="https://www.marathonisrael.co.il/en/event/tiberias-marathon/" target="_blank" style="color:#000;text-decoration: underline;">
  // 									Sea of Galilee Tiberias International Marathon – 3 gennaio 2020
  // 								</a>
  // 							</h3>
  // 							<p>
  // 							Il primo appuntamento dell’anno nuovo sarà la 43esima edizione della maratona di Tiberiade, una delle più basse del mondo (corsa a 200m sotto il livello del mare). Il tracciato segue la costa del Mar di Galilea e ripercorre, nel corso dei suoi 42.195m, gli splendidi paesaggi della Valle del Giordano. La Kinneret Urban Association penserà agli eventi collaterali, dando anche a chi non parteciperà in prima persona alla corsa l’occasione di divertirsi.
  // 							</p>
  // 							<h3>
  // 								<a href="https://www.israman.co.il/?lang=en" target="_blank" style="color:#000;text-decoration: underline;">
  // 									Israman Ironman Garmin Race Eilat – 29 gennaio 2020
  // 								</a>
  // 							</h3>
  // 							<p>
  // 							Torna anche quest’anno un appuntamento per veri duri: la Ironman di Eilat, una sfida sportiva ai limiti dell’estremo composta da 3,8km di nuoto, 180 di bicicletta e 42 di corsa. L’evento richiede una preparazione non indifferente, ma se si vogliono provare le emozioni di una corsa Ironman senza pagarne troppo le conseguenze, è anche possibile partecipare alla Half Israman: le distanze sono dimezzate, ma l’adrenalina è la stessa!
  // 							</p>
  // 							<h3>
  // 								<a href="https://deadsea.run/en/" target="_blank" style="color:#000;text-decoration: underline;">
  // 									Dead Sea Marathon – 7 febbraio 2020
  // 								</a>
  // 							</h3>
  // 							<p>
  // 							Dopo il successo dello scorso anno, ritroviamo anche la Dead Sea Marathon, un’esperienza unica che porterà i runner a correre intorno alle saline del Mar Morto vicine al confine giordano. Queste si trovano a circa 400 metri sotto il livello del mare e offrono un clima particolarmente adatto all’attività sportiva, oltre che a stupendi panorami desertici.
  // 							</p>
  // 			                <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/67/3.jpg"} class="img-responsive" />
  //                         </div>
  // 							<h3>
  // 								<a href="https://www.tlvmarathon.co.il/MenuDefault_en.aspx?id=6607" target="_blank" style="color:#000;text-decoration: underline;">
  // 									Tel Aviv Samsung Marathon – 28 febbraio 2020
  // 								</a>
  // 							</h3>
  // 							<p>
  // 							Oltre 40.000 corridori sono attesi alla maratona di Tel Aviv, uno degli eventi più attesi della città. Il percorso si snoda attraverso alcune delle strade e nei luoghi più iconici: dal lungomare passando per Dizengoff Street, Rothschild Avenue, the Azrieli Towers e Rabin Square, dove ammirare  gli edifici in stile Bauhaus della Città Bianca. Non sono molte le maratone che possono vantare un tracciato urbano così!
  // 							</p>
  // 							<h3>
  // 								<a href="https://jerusalem-marathon.com/" target="_blank" style="color:#000;text-decoration: underline;">
  // 									Jerusalem Winner Marathon – 20 marzo 2020
  // 								</a>
  // 							</h3>
  // 							<p>
  // 							L’ultimo appuntamento da segnare in rosso sul calendario è la maratona di Gerusalemme, una corsa che l’anno scorso è stata capace di radunare 20.000 corridori da 50 Paesi. È possibile iscriversi a percorsi di diversa lunghezza (da 4 a 42km), in base al proprio livello di allenamento. Il percorso completo si articola tra i luoghi più famosi della città; la Knesset, la torre di David, il Monte Sion, il Monte degli Ulivi e molti altri ancora. In una città ricca di storia come Gerusalemme, però, anche il più breve dei tracciati sarà in grado di offrire ai partecipanti degli scorci incantevoli.
  // 							</p>

  //            `
  //     }
  //   }
  // },
  //eND ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA

  //ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  // {
  // 	    id:"Inverno_A_Eilat_It",
  //         bgImage : "/posts/bank/68/1.jpg",
  //         mobBgImage : "/posts/bank/68/M.jpg",
  //         title : "Inverno a Eilat",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "eilat",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         <h3>
  // 			              	Inverno a Eilat
  // 			              </h3>
  // 			              <p>
  // 							Eilat, la città più a sud di Israele, è ogni anno una delle mete più gettonate per le vacanze invernali, con tanti turisti europei che abbandonano il freddo dei loro Paesi per cercare un po’ di tepore sulle rive del Mar Rosso. La città è in effetti il luogo ideale per un break fuori stagione, grazie alla sua fauna marina, alla sua barriera corallina, allo splendido deserto che si stende per migliaia di km appena fuori dalla città e alle temperature che, anche nel più rigido degli inverni, difficilmente scendono sotto i 21 gradi.
  // 							</p>
  // 							<p>
  // 							Tra le attività più gettonate in città ci sono lo shopping e lo snorkeling, ma non mancano certo le alternative per i più sportivi. Il Timna Park, a pochi km di distanza dalla città, è il luogo ideale per un’escursione in bicicletta, mentre gli amanti del trekking potranno esplorare le ripide pareti del Red Canyon.
  // 							</p>
  // 							<div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/68/1.jpg"} class="img-responsive" />
  //                         </div>
  // 							<p>
  // 							Questa stagione ci sarà un motivo in più per passare da Eilat: un calendario di eventi veramente interessante tra novembre e marzo, con un susseguirsi di festival internazionali che sapranno attirare ancora più turisti in fuga dal freddo. Ce ne saranno ben 35 e i temi saranno i più disparati: musica, cibo, sport e altro ancora. Tra le proposte più popolari troviamo:
  // 							</p>
  // 							<p>
  // 							<strong>•	Desert Ashram:</strong> la 9° edizione dell’International Yoga Festival, in programma tra il 31 ottobre e il 2 novembre nella suggestiva località di Hevel Eilot, sarà l’occasione per ritrovarsi tra appassionati e praticare yoga in un contesto selvaggio e impareggiabile
  // 							</p>
  // 							<p>
  // 							<strong>•	International Desert Marathon:</strong> una corsa divisa in 5 tappe che, nel weekend tra il 29 e 30 novembre, partirà dal deserto per arrivare fino in riva al mare. In mezzo, oltre alle montagne, i partecipanti troveranno tanti panorami mozzafiato.
  // 							</p>
  // 							<p>
  // 							<strong>•	Wine Festival:</strong> un festival per andare alla scoperta dei vini del deserto, una delle specialità israeliane che più di tutte attirano la curiosità degli appassionati. Parteciperanno anche rinomati chef locali, a caccia dell’abbinamento perfetto, oltre a sommelier, esperti e produttori. L’appuntamento è dal 13 al 15 febbraio 2020.
  // 							</p>
  // 							<p>
  // 							<strong>•	Electronic Music Festival:</strong> Tre giorni di musica elettronica in tutte le sue varianti, con diversi palchi sparsi sul lungomare per animare la città di giorno e di notte. L’ingresso a tutti gli eventi è libero e sarà, per Eilat, una grande occasione per fare festa. L’appuntamento è per marzo 2020!
  // 							</p>
  // 							<p>
  // 							•	… e tante altre proposte per tutti i gusti.
  // 							</p>
  // 							<p>
  // 							Al sito ufficiale della città, <a href="https://eilat.city/en" target="_blank">https://eilat.city/en</a>, è possibile consultare il programma completo e trovare l’evento che fa al caso proprio.
  // 							</p>
  // 			                <div class="img-wrapper">
  //                           <img src=${getImgUrl() +  "/posts/68/2.jpg"} class="img-responsive" />
  //                         </div>

  //            `
  //     }
  //   }
  // },
  //eND ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  {
    id: "TLV_Time_Out_It",
    bgImage: "/posts/bank/69/1.jpg",
    mobBgImage: "/posts/bank/69/M.jpg",
    title: "TLV Time Out",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                       
				                            <h3>
							              	Tel Aviv entra due volte nella classifica di Time Out sui 50 quartieri più belli al mondo
							                </h3>
											<p>
											Il quartiere yemenita (Kerem Hateimanim) e il Carmel Market sono i due quartieri di Tel Aviv entrati ufficialmente a far parte della classifica “50 Coolest Neighborhoods in the World” stilata ogni anno dalla redazione di Time Out con la collaborazione di oltre 27.000 lettori in tutto il mondo. Questa particolare classifica, che può ora contare su due new-entry israeliane, aiuta i lettori del magazine a scoprire i luoghi più caratteristici e autentici delle città, offrendo valide alternative alle solite attrazioni turistiche. 
											</p>
											 <div class="img-wrapper">
											                          <img src=${getImgUrl() +
                                                  "/posts/69/1.jpg"} class="img-responsive" />
											                        </div>
											<p>
											I due quartieri di Tel Aviv sono stati scelti non solo per la loro offerta culinaria, artistica e culturale, ma soprattutto per la loro capacità di attirare i residenti e regalare tanto divertimento “made in Tel Aviv”. Kerem Hatemanim è stato descritto come un perfetto ritrovo foodie, immerso in un’atmosfera che ha saputo mantenersi autentica nonostante la vocazione residenziale del quartiere. Anche Carmel Market deve ai foodies gran parte della sua fama, poiché è all’interno di questo mercato che si trovano le migliori prelibatezze di Tel Aviv. 
											</p>
											<p>
											Entrambi i luoghi sono due punti di ritrovo per i locali e rappresentano il modo migliore per immedesimarsi tra i residenti, svestendo i panni del turista e assaporando l’autentico clima israeliano. Tra le attrazioni da non perdere, Time Out ha menzionato i ristoranti HaBasta e Ha Minzar e il mercato degli artisti di Nachalat Binyamin, dove artigianato ed esibizioni di artisti la fanno da padrone.
											</p>
											<p>
											Ecco quindi due suggerimenti in più per andare alla scoperta di una città che, oltre a questi due splendidi posti, ha anche molto altro da offrire! 
											</p>
											<p>
											La classifica integrale di Time Out è visibile al link: <a href="https://www.timeout.com/coolest-neighbourhoods-in-the-world" target="_blank">www.timeout.com<a/>
											</p>

							
				           `,
      };
    },
  },

  //TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES from HADAR
  // {
  // 	    id:"Chanukkah_It",
  //         bgImage : "/posts/bank/70/1.jpg",
  //         mobBgImage : "/posts/bank/70/M.jpg",
  //         title : "Chanukkah",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "jerusalem",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 			<p>Questo dicembre in Israele si celebrerà una delle festività più sentite, vale a dire Chanukkah (o Hannukkah, a seconda della trascrizione dall’ebraico). Questa ricorrenza ricorda la nuova consacrazione del Tempio di Gerusalemme al termine dell’occupazione ellenistica e viene festeggiata, secondo il calendario ebraico; a cavallo dei mesi di kislev e tevet: quest’anno tale data cadrà tra il 22 e il 30 dicembre. </p>
  //                          <p>La festa trae origine dal cosiddetto miracolo dell’olio: la tradizione vuole, infatti, che le lanterne del Tempio rimasero accese per otto giorni consecutivi senza che l’olio combustibile che le alimentava venisse meno. Questo fatto venne interpretato come una chiara vicinanza di Dio al popolo di Israele e da allora il suo ricordo è diventato una delle feste più importanti della religione ebraica. </p>
  //                          <p>Grazie all’immagine delle lanterne inesauribili, Chanukkah è conosciuta anche come la Festa delle Luci, luci anche simboliche capaci di liberare dall’oscurità e dall’oppressione. Dopo la riconsacrazione del Tempio e la cacciata dell’invasore, infatti, gli ebrei furono liberi di professare la loro religione senza più bisogno di nascondersi.</p>
  //                          <p>Una delle tradizioni più radicate è quella di accendere, ogni sera di festa, uno dei bracci della Menorah, il simbolico candeliere a nove bracci. Ce n’è uno in ogni casa, sinagoga ed edificio pubblico di Israele e spesso vengono messi vicino a porte e finestre, per uno spettacolo di luci veramente suggestivo. </p>
  //                          <p>Un altro simbolo di Chanukkah sono i cibi fritti, poiché la loro preparazione richiama ancora una volta il miracolo dell’olio. In particolare, impossibile non citare i Sufganiot, deliziosa ciambelle farcite di marmellata e servite rigorosamente dopo una bella frittura. </p>

  //            `
  //     }
  //   }
  // },

  // {
  // 	    id:"Run_The_City_It",
  //         bgImage : "/posts/bank/71/1.jpg",
  //         mobBgImage : "/posts/bank/71/M.jpg",
  //         title : "Run the City",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "telaviv",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                         <p>Un nuovo grande evento sportivo sta per animare le strade di Tel Aviv: si tratta della Run The City, una grande corsa non competitiva in programma per il prossimo 20 dicembre. </p>
  //                         <p>La corsa, aperta a tutti, è in realtà un semplice pretesto per andare alla scoperta della città in maniera nuova e divertente: sarà possibile partire quando si preferisce, fermarsi lungo il percorso per ammirare il panorama o fare uno snack, oppure semplicemente perdersi tra le tante attrazioni messe lungo il percorso dagli organizzatori. </p>
  //                         <p>I partecipanti potranno scegliere tra due percorsi: uno di 10 e uno di 15km, entrambi tracciati tenendo conto della posizione dei grandi punti di interesse della città. Non mancheranno dunque, lungo il percorso, passaggi attraverso Rabin Square, Zidingeroff Square, l’Habima Tehater, Bialik Street, il Nahalat Binyamin Market e tanti altri luoghi iconici della città. Se l’obiettivo principale della corsa era quello di promuovere la città e i suoi monumenti, con percorsi del genere ha sicuramente centrato l’obiettivo. </p>
  //                         <p>Anche le famiglie sono benvenute! Per loro infatti è stato pensato un apposito percorso da 3km che, pur semplificando il percorso originale, non trascura le principali attrazioni che Tel Aviv ha da offrire ai suoi numerosi turisti. </p>
  //                         <p>La partenza sarà alle 8 del mattino al porto di Tel Aviv, che sarà già animato a partire dalle 7. L’arrivo è invece previsto al vecchio porto di Giaffa, dove in tarda mattinata avrà inizio una grande festa per tutti i partecipanti, con musica dal vivo e stand di cibo e bevande. </p>
  //                         <p>Per maggiori informazioni sull’evento, per iscriversi o per consultare in anteprima i tre tracciati scelti dagli organizzatori, è possibile consultare il sito web ufficiale dell’evento: <a href="https://runthecity.gold-fish.co.il/goldfish/content/15038" target="_blank" https://runthecity.gold-fish.co.il/goldfish/content/15038</a></p>

  //            `
  //     }
  //   }
  // },
  //END TO BE PUBLISHED AGAIN CLOSE TO THE EVENT WITH NEW DATES from HADAR

  //HADAR ASKED TO DELETE THIS POST THE CORRECTIONS FROM LISHKA THAT SHE SENT
  // {
  // 	    id:"Tel_Aviv_Museum_It",
  //         bgImage : "/posts/bank/72/1.jpg",
  //         mobBgImage : "/posts/bank/72/M.jpg",
  //         title : "Tel Aviv Museum",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "telaviv",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                         <p>Al Tel Aviv Museum of Art, uno dei musei di arte contemporanea più interessanti e prestigiosi di Israele, sono state di recente inaugurate due mostre personali di grandi artisti internazionali: si tratta della scozzese Rachel Maclean e dell’americano Raymond Pettibon.</p>
  //                       <p>Rachel Maclean, che porta per la prima volta i suoi lavori in Israele, ha deciso di portare la sua video-installazione Spite Your Face, un cortometraggio di 37 minuti redatto in occasione della Biennale di Venezia del 2017 e ora portato nei migliori musei del mondo. Racconta la storia di Pic, una sorta di Pinocchio moderno (come il nome suggerisce), che scala le gerarchie della società contemporanea salvo poi ritrovarsi isolato e deluso. La particolarità dell’opera è che l’artista ha interpretato lei stessa tutti i personaggi del racconto, grazie a un sapiente utilizzo dei costumi e dell’editing digitale. L’opera viene presentata al Tel Aviv Museum of Art con le stesse proporzioni della Chiesa di Santa Caterina, luogo dove venne mostrata per la prima volta nel 2017, per mantenerne l’impatto monumentale e solenne anche nelle moderne sale di un museo israeliano. Spite Your Face resterà aperta fino al 9 maggio 2020. </p>
  //                       <p>Raymond Pettibon è invece un artista più convenzionale, dato che oltre a tre lavori video ha portato con sé oltre cento disegni e stampe. Anche l’americano si trova per la prima volta in Israele e per il suo debutto ha scelto di portare un’ampia selezione di lavori che affrontano, con occhio critico, i grandi problemi di oggi. Fortemente influenzato dal contesto americano, Pettibon è però stato in grado di sfornare opere universalmente comprensibili e che, in un modo o nell’altro, finiscono per coinvolgere tutti indistintamente. La mostra resterà aperta fino al 25 aprile 2020</p>
  //                       <p>Immagini delle due mostre sono disponibili ai seguenti link:</p>

  //                       <p>Tutti gli altri eventi del Tel Aviv Museum of Art e le collezioni permanenti sono invece consultabili al link: <a href="//www.tamuseum.org.il/" target="_blank">tamuseum.org.il</a></p>

  //            `
  //     }
  //   }
  // },
  //end HADAR ASKED TO DELETE THIS POST THE CORRECTIONS FROM LISHKA THAT SHE SENT
  {
    id: "Timna_Park_It",
    bgImage: "/posts/bank/73/1.jpg",
    mobBgImage: "/posts/bank/73/M.jpg",
    title: "Timna Park",
    smltitle: "",
    isVid: false,
    ctg: "eilat",
    html: function() {
      return {
        __html: `
				                        <p>C’è un luogo, all’interno del vasto deserto del Negev, dove trovare formazioni geologiche uniche e un antichissimo patrimonio archeologico: si tratta del Timna Park, una vallata di 15.000 ettari poco a nord di Eilat circondata dai ripidi crateri del Negev.</p>
                          <p>Divenuto celebre per il suo fungo di roccia scavato dal vento e per le imponenti pareti ad arco, il parco ospita anche alcune tra le più antiche miniere di rame al mondo. Vi sono resti risalenti addirittura al decimo secolo avanti Cristo e gli archeologici stanno ancora studiando l’area per capire quanti popoli, dai Nabatei ai Romani, passando per gli Arabi e gli Egizi, siano effettivamente passati da questa terra, all’apparenza arida ma custode di un vero e proprio tesoro sotterraneo. Le attività minerarie sono state ufficialmente sospese nel 2002, quando l’intera area è stata dichiarata riserva naturale. </p>
                          <p>Oggi è uno dei luoghi più affascinanti e selvaggi di Israele, famoso tanto per la sua storia millenaria quando per il caratteristico colore rosso delle sue rocce. Ospita inoltre diversi eventi di grande rilievo: ogni anno, per citarne uno, gli appassionati di meditazione si ritrovano qui, all’ombra delle sue suggestive formazioni rocciose, per lo Yoga Arava, uno dei più rinomati festival internazionali dedicati alle discipline orientali. </p>
                          <p>Il parco è anche un ottimo luogo per un po’ di azione. È infatti possibile esplorarlo in sella a una mountain bike grazie a una serie di tracciati adatti sia alle famiglie di cicloturisti che ai professionisti delle due ruote a caccia di adrenalina. I percorsi sono tutti ben segnalati e si estendono per oltre 20 chilometri: l’ideale per andare, in maniera slow ed ecologica, alla scoperta di questa meraviglia della natura.</p>
                          <p>Per vivere un’esperienza veramente indimenticabile, è poi possibile esplorare il parco una volta tramontato il sole: vi sono numerose aree illuminate, mentre uno show di proiezioni e immagini appena fuori dalle miniere di Salomone racconta il lontanissimo retaggio egizio di questa regione. </p>

							
				           `,
      };
    },
  },
  //ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  // {
  // 	    id:"A_Ritmo_Di_Musica_It",
  //         bgImage : "/posts/bank/74/1.jpg",
  //         mobBgImage : "/posts/bank/74/M.jpg",
  //         title : "Gerusalemme a ritmo di musica",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "jerusalem",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                         <p>Dal 6 al 19 dicembre Gerusalemme si animerà con una nuova edizione, l’ottava, della Jerusalem International Dance Week. </p>
  //                       <p>Questa importante rassegna dedicata alla danza vede partecipare ogni anno decine di artisti israeliani e stranieri, per una serie di eventi di grande rilievo e spessore artistico. L’evento è organizzato dalla Machol Shalem Dance House di Gerusalemme, in collaborazione con il Ministero degli Affari Esteri. </p>
  //                       <p>La Machol Shalem Dance House è attiva da 17 anni ed è un punto di riferimento per gli artisti della danza a Gerusalemme. È da sempre impegnata in numerose attività culturali, incontri e laboratori per promuovere quest’arte, e ha trovato nella Dance Week un evento nel quale esprimere al meglio tutta l’energia dei tanti ballerini che raccoglie.</p>
  //                       <p>Il programma di quest’anno si preannuncia particolarmente ricco. Ci saranno grandi competizioni internazionali, eventi dedicati alla danza israeliana e ai suoi massimi esponenti e momenti di workshop e condivisione per far emergere le idee più originali del momento nel panorama artistico globale.</p>
  //                       <p>In particolare, sarà possibile assistere a:</p>
  //                       <ul>
  //                            <li>	International Choreography Competition, una competizione tra artisti provenienti da Stati Uniti, Italia, Spagna, Cina, Lituania, Russia, Germania e naturalmente Israele.</li>

  //                            <li>	The Jerusalem Dance Showcase: un’esibizione dedicata agli artisti israeliani e alle nuove tendenze della danza locale</li>

  //                            <li>	Pitching Event: una novità di quest’anno. Si tratta di un momento in cui gli artisti israeliani potranno esporre le loro idee più originali a rinomati esperti internazionali, per dar loro la possibilità di esportare le tendenze più valide. </li>

  //                            <li>	Machol Shalem Festival: la presentazione ufficiale dei nuovi lavori della Machol Shalem Dance House e dei suoi artisti.</li>

  //                            <li>	E molti altri eventi ancora.</li>
  //                       <ul>

  //                       <p>Il programma completo è disponibile al link:<a href="//danceweek.org.il/about-jerusalem-international-dance-week/?lang=en" target="_blank">danceweek.org.il</a> </p>

  //            `
  //     }
  //   }
  // },
  //end ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA

  //ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  // {
  // 	    id:"Il_Mar_Di_Galilea_It",
  //         bgImage : "/posts/bank/75/1.jpg",
  //         mobBgImage : "/posts/bank/75/M.jpg",
  //         title : "Il Mar di Galilea",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "north",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                         <p>Per il 43esimo anno, Tiberiade e il Mar di Galilea si preparano ad ospitare la tradizionale “Winner Marathon”, una maratona ricca di panorami da sogno e resa particolarmente attraente anche dal suo fondo estremamente pianeggiante.</p>
  //                       <p>La prima edizione del 1977, tenutasi quando ancora le maratone sembravano un’impresa riservata esclusivamente ai grandi dello sport, raccolse 99 persone da 7 Paesi diversi, fu vinta da un’atleta tedesca con un corridore britannico poco dietro di lei. Da allora sono cambiate parecchie cose: nelle successive 41 edizioni sono passati oltre 7.000 corridori e sono stati registrati tempi di percorrenza sempre più vicini a quelli dei grandi campioni. </p>
  //                       <p>Al di là dell’aspetto agonistico della corsa, vale la pena concentrarsi su quello che è il suo patrimonio paesaggistico. Come già detto la manifestazione si svolge tutta su un terreno pianeggiante, circondato però da verdi alture e dall’acqua del Mar di Galilea: le condizioni ottimali non solo per andare a caccia di un grande risultato, ma anche per godersi una piacevole giornata di sport all’aria aperta nel mite inverno israeliano. </p>
  //                       <p>Ovviamente, come tutti i grandi eventi sportivi di Israele, anche la maratona di Tiberiade è aperta a tutti, professionisti e semplici amatori della corsa. Per far sì che l’evento sia veramente alla portata di tutti, sono stati tracciati tre percorsi differenti: quello principale è lungo 42,2km come da tradizione ed è seguito da una mezza maratona da 21,1km e da un percorso più semplice, ma altrettanto suggestivo, di 10km.</p>

  //                       <p>Maggiori informazioni sul programma e sul tracciato sono disponibili al sito ufficiale della maratona:<a href="https://www.tiberiasmarathon.com/en/" target="_blank">www.tiberiasmarathon.com</a> </p>

  //            `
  //     }
  //   }
  // },
  //end ARTICLE TO BE ERASED HADAR ASKED - CORRECTION FROM HALISHKA
  {
    id: "50_Best_Discovery_It",
    bgImage: "/posts/bank/76/1.jpg",
    mobBgImage: "/posts/bank/76/M.jpg",
    title: "8 RISTORANTI E BAR DI ISRAELE NELLA LISTA 50 BEST DISCOVERY",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <p>Otto ristoranti e bar di Tel Aviv e Gerusalemme sono stati inseriti nella lista 50 Best Discovery, stilata dal celebre brand 50 Best. I quattro ristoranti di Tel Aviv da “scoprire” secondo la classifica sono HaBasta, un piccolo locale che propone prodotti farm-to-table nel quartiere di Nachalat Binyamin, vicino al Carmel Market; M25, piccolo ristorante e macelleria che serve carne di alta qualità preparata su griglia a carbone; Milgo & Milbar, un ristorante di pesce in una residenza in stile Bauhaus in Rothshild Boulevard; e Pastel, il ristorante situato all’interno del Tel Aviv Museum of Art, con un menu di cucina israeliana contemporanea. </p>
					                      <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/76/1.jpg"} class="img-responsive" />
				                        </div>
					                      <p>I tre bar di Tel Aviv inclusi nella 50 Best Discovery sono Imperial Craft Cocktail Bar, la famosa cocktail lounge dell’Imperial Hotel; Bell Boy, un divertente hotel bar che propone cocktail e ostriche; e Butler, soprannominato la matrioska degli speakeasy, situato nell’Hotel B Berdichevsky. </p>
					                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/76/2.jpg"} class="img-responsive" />
				                        </div>
					                      <p>Gerusalemme è rappresentata con un ristorante, il Machneyuda: fondato dal celebrity chef Assaf Granit insieme a Yossy Elad e Uri Navon nel 2009 propone una cucina mediterranea e mediorientale realizzata con ingredienti acquistati nel vicino Mahane Yehuda Market. </p>

							
				           `,
      };
    },
  },

  {
    id: "50_Destinations_To_Visit",
    bgImage: "/posts/bank/destinations/1.jpg",
    mobBgImage: "/posts/bank/destinations/M.jpg",
    title: "TEL AVIV TRA LE 50 DESTINAZIONI DA VISITARE NEL 2018",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        
					                      
							
							<p>La città di Tel Aviv è stata recentemente inserita nella lista delle “50 migliori destinazioni da visitare nel 2018” della celebre rivista americana di viaggi Travel + Leisure.</p>
							
							<p>Il magazine riporta che <em>“Tel Aviv continua ad attirare l’attenzione su di sé e a distinguersi per la sua nightlife e la sua scena culinaria creativa. Ultimamente il centro di gravità si è spostato a sud, nell’antica città portuale di Jaffa (anch’essa parte di Tel Aviv). Questo mese, il Setai apre all’interno di una vecchia prigione ottomana mentre un nuovo W Hotel sarà inaugurato a marzo 2018 in un ex-convento e ospizio per pellegrini del 19° secolo. La lista di hotel di alto livello, ristoranti e boutique è in costante crescita nelle stradine di quello che un tempo era un villaggio di pescatori. Il mercato delle pulci di Jaffa oggi è popolato da un gran numero di antiquari esclusivi, vicino ai quali sorgono bar e caffè, molti dei quali propongono serate di musica dal vivo. &nbsp;Da non perdere Maskit, una casa di moda storica di Israele, celebre per i suoi tessuti ricamati, che è recentemente rinata dopo la sua chiusura negli anni ’90. Numerosi chef interessanti hanno aperto nuovi indirizzi tra le chiese, le moschee e i siti archeologici di Jaffa. Da provare, ad esempio, Beit Kandinof, un ristorante situato in un edificio del 17° secolo, dove si possono gustare piatti creativi come la bruschetta con pesto e asparagi, e allo stesso tempo ammirare mostre di arte locale.</em>”</p>
							<p>La lista delle “50 migliori destinazioni da visitare nel 2018” di Travel + Leisure è stata creata sulla base dei suggerimenti dei giornalisti esperti di viaggio che collaborano con il giornale, che hanno scelto le destinazioni più alla moda e che sono sulla bocca di tutti, per nuovi hotel, musei o grandi eventi internazionali.</p>
							<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/destinations/1.jpg"} class="img-responsive" />
				                        </div>
							<p>L’articolo completo è disponibile a questo link:</p>
							<p><span><a href="//www.travelandleisure.com/trip-ideas/best-places-to-travel-in-2018" target="_blank"><strong><span>http://www.travelandleisure.com/trip-ideas/best-places-to-travel-in-2018</span></strong></a></span></p>
											           `,
      };
    },
  },
  {
    id: "Forbes_It",
    bgImage: "/posts/bank/77/1.jpg",
    mobBgImage: "/posts/bank/77/M.jpg",
    title: "DESTINAZIONE TOP PER IL 2020",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <p>Si è concluso al meglio il 2019 per Tel Aviv che ha ricevuto due importanti riconoscimenti da parte di Forbes, BBC e HappyCow, che confermano come la città israeliana sia tra le destinazioni più interessanti al mondo, riconosciuta a livello internazionale per le sue eccellenze. </p>
                    
						                <h3>Tel Aviv è tra le Top 20 destinazioni del 2020 secondo Forbes.com</h3>
						                <p>Tel Aviv appare al secondo posto nella classifica stilata da Forbes.com dedicata alle migliori destinazioni da visitare nel 2020. La lista, curata dai redattori della Forbes Travel Guide, ha tenuto in considerazione diversi elementi tra cui eventi sportivi, anniversari importanti e ingenti investimenti nel settore alberghiero.  Nella classifica, insieme a Tel Aviv compaiono destinazioni come Las Vegas, Nashville, Dubai, Tokyo e Edimburgo. </p>
						                <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/77/1.jpg"} class="img-responsive" />
				                        </div>
						                <p>Il commento di Forbes: “Storia antica e vita moderna si incontrano in questa vivace città lungo la costa mediterranea di Israele. Oltre alle leggendarie spiagge (visitate ad esempio The Setai, Tel Aviv per un posto in prima fila al mare), dedicate un po’ di tempo al nuovo White City Center appena inaugurato. In occasione del centenario del Bauhaus, il museo mette in risalto l’unicità della Città Bianca, patrimonio dell'UNESCO, che ospita più di 4.000 edifici in stile Bauhaus, la più grande collezione del genere al mondo”.</p>
					                    <p>La lista completa è disponibile su: 
					                    <a href="https://www.forbes.com/sites/forbestravelguide/2019/12/13/forbes-travel-guide-20-top-destinations-for-2020/#23f3e05773df" target="_blank">www.forbes.com</a></p>


					                    <h3>Tel Aviv è tra le “Top 10 Destinations for Foodies”<br/> per il 2020 secondo BBC.</h3> 
					                    <p>BBC ha incluso Tel Aviv nella sua Top 10 delle destinazioni più apprezzate dai food lover, insieme a mete culinarie d’eccellenza come Galway, Lione, Los Cabos, Paesi Bassi, Malta, Marrakech, Scozia, Porto e Cadice. </p>
					                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/77/2.jpg"} class="img-responsive" />
				                        </div>
					                    <p>Il commento di BBC: "La cucina vegana è al centro della tradizione culinaria di Tel Aviv, da sempre apprezzata dagli amanti del cibo vegetale che potranno trovare verdure sempre fresche coltivate nei terreni che circondano questa città di mare. Negli ultimi anni, Tel Aviv ha alzato la posta in gioco diventando la capitale vegana del mondo, con eleganti caffetterie vegane e catene locali come Domino's che propongono pizza senza prodotti animali. Questa città giovane e LGBT-friendly è ricca di boutique hotel in stile Bauhaus, cocktail bar e ristoranti alla moda, anche la sua vera forza è data dal cibo di strada a buon prezzo. Non c'è niente come l'hummus, il falafel e lo shakshuka di Tel Aviv, serviti nei locali, nelle bancarelle di strada e nei mercati, come lo Shuk Hacarmel".</p>
					                    <p>La lista completa è disponibile su:
					                    <a href="https://www.bbcgoodfood.com/howto/guide/top-10-destinations-foodies-2020" target="_blank">www.bbcgoodfood.com</a></p>

					                    <h3>Tel Aviv è nella Top 10 delle città vegan-friendly di HappyCow</h3>
					                    <p>Il sito “HappyCow” che recensisce i ristoranti vegetariani e vegani di tutto il mondo ha incluso Tel Aviv nella sua top 10 delle città più vegan-friendly. La lista è stata stilata sulla base di 4 fattori principali: numero di ristoranti vegani in un raggio di 5 miglia nell’area a maggiore densità di ristoranti vegani; numero di ristoranti con opzioni vegane/vegetariane nella stessa area, disponibilità di ristoranti vegani sulla base della densità della popolazione e impressioni generali su quanto la città sia vegan-friendly (es. festival a tema, incontri e comunità).  Insieme a Tel Aviv, la lista comprende altre destinazioni come Londra, New York, Berlino, Los Angeles, Toronto, portland, Varsavia, Bangkok e Praga. </p>
					                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/77/3.jpg"} class="img-responsive" />
				                        </div>
					                    <p>Il commento di HappyCow: “Israele vanta la più alta percentuale di vegani a livello globale: si stima infatti che il 5-8% dell’intera popolazione del Paese segua una dieta vegana, pari a 400.000 persone, molte delle quali vivono a Tel Aviv.  La maggior parte dei 36 ristoranti completamente vegani di Tel Aviv servono una combinazione di cucina israeliana, mediorientale e mediterranea con una certa influenza occidentale. Il primo caffè vegano di Tel Aviv, Anastasia, ha ottimi piatti principali e dessert raw. Four One Six, un bar e ristorante all-vegan moderno in stile newyorkese, prepara la propria "bistecca" vegana e propone favolosi dessert. Aperti quest'anno, Hativonit J17 e Vivida stanno rapidamente diventando tra gli indirizzi preferiti a Tel Aviv.</p>
					                    <p>Zakaim Vegan Boutique è considerato uno dei migliori locali vegani della città con la sua raffinata cucina persiana e mediorientale. Se siete in vena di cibo raw gourmet, date un'occhiata al Neroli Organic Juice Bar e al Rawfood Diner. Hatool HaYarok offre alcune delle migliori pizze vegane della città, condite con formaggio di anacardi fatto in casa.</p>
					                    <p>Il Meshek Barzilay Deli propone insalate e piatti caldi, torte vegane, succhi di frutta, prodotti biologici e altro ancora. Accanto c'è il ristorante Meshek Barzilay, che serve soprattutto piatti vegani.
					                    <p>Per un boccone veloce, da provare il fast food vegetariano e ristorante in stile diner Goodness, o ancora Falafel Mevorach per kebab vegani, shawarma, schnitzel e burger. Per i fast-food vegani senza fritti, date un'occhiata a Nature Boys, Jars and Bowls per insalate, bowl di legumi e frullati, mentre Alegria è la scelta migliore per insalate, formaggi vegani e panini. HaSabzia è un piccolo e accogliente ristorante vegano di ispirazione persiana con un servizio eccellente e cibo raffinato. La città ha anche 2 negozi di alimentari vegani, Taam L'Chaim - Taste For Life e Makolet Teva, un negozio di abbigliamento maschile vegano (Taddeo), un negozio di scarpe/borse vegane (Vegan Mind), e uno degli unici negozi di cioccolato vegani al mondo (COCO Vegan Chocolate).</p>

					                    <p>HappyCow Tel Aviv include 40 ristoranti vegani, 44 vegetariani e 171 ristoranti con opzioni veg, la maggior parte dei quali è concentrata nel raggio di un miglio dal centro città. Israele ha il maggior numero di vegani per capita e le opzioni vegane a Tel Aviv sono incredibili”. </p>
					                    <p>La lista completa è disponibile su: 
					                       <a href="https://www.happycow.net/vegtopics/travel/top-vegan-friendly-cities" target="_blank">www.happycow.net</a>
					                    </p>
							
				           `,
      };
    },
  },
  {
    id: "2000_Year_Old_Wine_And_Fish_It",
    bgImage: "/posts/bank/78/1.jpg",
    mobBgImage: "/posts/bank/78/M.jpg",
    title: "VINI E SALSE DI PESCE ANTICHE 2000 ANNI",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        
				                        <h3>Vini e una salsa a base di pesce: le preferenze culinarie dei romani rivelate da un ritrovamento archeologico di 2000 anni fa ad Ashkelon</h3>
	                                   <p>Gli scavi archeologici condotti dall'Autorità israeliana per le antichità a sud di Ashkelon prima dell'istituzione di un Eco-Sport Park hanno scoperto un'antica area industriale che rivela viticoltori e impianti raramente scoperti per la produzione di una salsa di pesce che era molto popolare e la cui preparazione ha comportato forti esalazioni.</p>
	                                   <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/78/1.jpg"} class="img-responsive" />
				                        </div>
	                                   <p>Queste vasche utilizzate per la produzione di salsa di pesce (garum) sono tra le poche conosciute nel Mediterraneo orientale. Lo scavo ha rivelato prove delle preferenze culinarie romane e bizantine di 2000 anni fa.</p>

	                                   <p> Secondo il dott. Tali Erickson-Gini dell'Autorità israeliana per le antichità, “Molto prima della pasta e della pizza, l'antica dieta romana si basava in gran parte sulla salsa di pesce. Fonti storiche si riferiscono alla produzione di salsa di pesce speciale, che è stata utilizzata come condimento di base per il cibo nelle epoche romana e bizantina in tutto il bacino del Mediterraneo. Riferiscono che i forti odori che l'accompagnavano durante la sua produzione richiedevano che fosse distanziato dalle aree urbane e questo è risultato essere il caso poiché gli impianti sono stati scoperti a circa 2 km dall'antica Ashkelon. "</p>
	                                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/78/2.jpg"} class="img-responsive" />
				                        </div>
	                                   <p> Il dott. Erickson-Gini aggiunge: “Questa è una scoperta rara nella nostra regione e pochissime installazioni di questo tipo sono state trovate nel Mediterraneo orientale. Fonti antiche fanno persino riferimento alla produzione di garum ebraico. La scoperta di questo tipo di installazione ad Ashkelon dimostra che i gusti romani che si diffusero in tutto l'impero non si limitarono al vestiario, ma includevano anche abitudini alimentari”.</p>

	                                   <p> Il sito romano fu infine abbandonato ma le condizioni che favorirono la viticoltura rimasero e nel periodo bizantino nel V sec. una comunità monastica cominciò a prosperare lì, guadagnandosi da vivere con la produzione di vino: furono costruiti tre viticoltori accanto a una chiesa riccamente decorata. Poco della chiesa è sopravvissuto, ma frammenti architettonici trovati nel sito mostrano che era decorato con impressionanti marmi e mosaici. Nelle vicinanze si trovava un grande complesso di fornaci che produceva vasetti di vino. Questi sembrano essere stati usati per esportare vino, che era il reddito principale per il monastero.</p>

	                                   <p> Conclude Erickson-Gini: “Il sito, che ha servito come area industriale per diversi periodi, è stato nuovamente abbandonato qualche tempo dopo la conquista islamica della regione nel 7° secolo. e successivamente le famiglie nomadi, probabilmente residenti in tende, hanno smantellato le strutture e venduto le diverse parti per materiale da costruzione altrove”. La prova di questa attività è stata trovata nelle vasche dei tini da vino, che sono state trasformate in fosse di rifiuti contenenti le ossa di grandi pacchi animali, come asini e cammelli. </p>
	                                   <ol class="ac-2000yeas-old-post">
	                                       1. Veduta aerea del sito. Asaf Peretz, Autorità israeliana per le antichità.<br/>
	                                        2.Installazioni di Garum, Asaf Peretz, Israel Antiquities Authority.<br/>
	                                        3.I forni bizantini che producono vasetti di vino, Asaf Peretz, Israel Antiquities Authority.<br/>
	                                        4.I viticoltori bizantini, Asaf Peretz, Israel Antiquities Authority.<br/>
	                                        5.Lavori nello scavo di Ashkelon, Anat Rasiuk, Autorità israeliana per le antichità.<br/>
	                                        6.Archeologi IAA che esaminano un vassoio di marmo dall'altare della chiesa bizantina. Anat Rasiuk, Autorità israeliana per le antichità.<br/>
	                                        7.Pavimentazione a mosaico della chiesa bizantina, Anat Rasiuk, Autorità israeliana delle antichità.<br/>
	                                       8. 8-9. Frammenti di marmo dalla decorazione della chiesa bizantina, Anat Rasiuk, Israel Antiquities Authority.<br/>
	                                       9. 10. Videoclip dello scavo, Emil Alajem, Israel Antiquities Authority.
	                                    </ol>
							
				           `,
      };
    },
  },
  {
    id: "Arte_Di_Telaviv_It",
    bgImage: "/posts/bank/79/1.jpg",
    mobBgImage: "/posts/bank/79/M.jpg",
    title: "DUE NUOVE MOSTRE APERTE AL MUSEO DELL'ARTE di TEL AVIV",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				                        <br/>
				                        <p>Rachel Maclean,<em><strong> Spite Your Face</strong></em><br/>
		                                   Raymond Pettibon:<em><strong> And What is Drawing For?</strong></em><br/>
		                                   Rachel Maclean,<em><strong> Spite Your Face</strong></em></p>

		                               <p> Il Tel Aviv Museum of Art è orgoglioso di annunciare la prima mostra in Israele dell'artista scozzese Rachel Maclean. La mostra al Tel Aviv Museum of Art comprende un'installazione video intitolata Spite Your Face (2017, 37 min.), che è stata esposta per la prima volta alla Biennale di Venezia nel 2017, dove Rachel Maclean ha rappresentato la Scozia. </p>
		                               <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/79/1.jpg"} class="img-responsive" />
				                        </div>
		                               <p> Il protagonista del film, Pic, è una figura simile a Pinocchio, che sale dalle grondaie fino alle altezze della società, godendo i frutti della fama e della fortuna. Aprendosi la strada con bugie, il suo naso, un naso da Pinocchio dorato, diventa sempre più lungo. Il titolo è preso in prestito dal proverbio inglese "tagliati il naso per far dispetto al tuo viso", che di solito viene pronunciato come un avvertimento. La facciata in stile Disney del film non è che un dispositivo che serve a camuffare la sua vera essenza: è solo presumibilmente una storia per bambini.</p>
		                               <p> Dipinto di blu e oro, Spite Your Face ritrae una realtà di avidità, opportunismo e adorazione del glamour esterno e superficiale. Una storia oscura alla Dickens, grottesca e terrificante, costruita come una favola dolce-amara sulla vita. Risponde a cambiamenti significativi nel clima politico nel corso del 2016-17, con la Brexit nel Regno Unito e le elezioni presidenziali negli Stati Uniti. </p>
		                               <p> Tutti i personaggi del film, sia ammirevoli che spregevoli, sono interpretati dall'artista stessa, con un impressionante virtuosismo, aiutati da parrucche, costumi, trucco e manipolazione digitale. </p>
		                               <p> Scritto, diretto e interpretato da Rachel Maclean, Spite Your Face è stato mostrato per la prima volta nel 2017 nella chiesa di Santa Caterina a Venezia, situata alla fine della lunga navata della chiesa. Al Tel Aviv Museum of Art, l'installazione replica le proporzioni allungate e verticali della chiesa, permettendo allo spettatore di essere immerso dallo schermo verticale monumentale. Il timore reverenziale dello spazio della chiesa è sostituito dall'aura museale. Dati gli exploit di Pic, sia la chiesa che il museo migliorano le relazioni di potere e il divario di status che Pic, invano, sta cercando di ristabilire.</p>
		                               <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/79/2.jpg"} class="img-responsive" />
				                        </div>
		                               <p> "Spite Your Face" è stato commissionato da Alchemy Film & Arts for Scotland + Venice alla 57a Esposizione Internazionale d'Arte, La Biennale di Venezia 2017. È stato prodotto da Ciara Barry e Rosie Crerar. La mostra Scotland + Venice è stata curata da Alchemy Film & Arts in collaborazione con Talbot Rice Gallery e l'Università di Edimburgo. La presenza della mostra al Museo dell'arte di Tel Aviv è stata resa possibile grazie al supporto generale di Outset, BFAMI e Marc Worth. L'acquisizione di Spite Your Face nella collezione del Museo dell'arte di Tel Aviv è stata resa possibile grazie a BFAMI e Outset.</p>
		                               <p> Curatore: Ruth Direktor<br/>
		                                Chiusura della mostra: 9 maggio 2020<br/>


		                               Raymond Pettibon:<em><strong> And What is Drawing For?</strong></em></p>
		                        
		                               <p> Raymond Pettibon (1957, Tucson, Arizona) è stato una figura chiave nell'arte americana dagli anni '90. Con circa 100 disegni e tre opere video, la mostra presenta, per la prima volta in Israele, un concentrato e sostanziale corpus di opere dell'ampia opera di Pettibon. Grappoli di motivi identificati con il suo lavoro (ad es. Surfisti, giocatori di baseball e Charles Manson) e dei temi principali che affronta (tra cui il capitalismo, il governo americano e la guerra in Iraq) sono intrecciati nella mostra lungo un asse di disegni relativi all'arte stessa e che interagiscono con lo stato sociale e la condizione umana dell'artista.</p>
		                               <p> Nei suoi disegni unici, Pettibon approfondisce l'America e i suoi strati culturali e storici, dall'etica formativa dello spirito americano alle sottoculture ai suoi margini. Lo specchio proposto da Pettibon riflette una realtà complessa che distanzia lo sguardo dal secolo precedente, parlando la lingua di ogni strato sociale di cui parla. </p>
		                               <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/79/3.jpg"} class="img-responsive" />
				                        </div>
		                               <p> Il nucleo di ogni disegno, tuttavia, è la relazione dinamica tra immagine e testo, che apre uno spazio di riflessione sui modelli comportamentali e sul condizionamento culturale. Da questo spazio, il lavoro di Pettibon affina le intuizioni sul momento culturale in cui viviamo, non solo in America.</p>
		                               <p> Curatore: Irith Hadar</p>
		                               <p> Chiusura della mostra: 25 aprile 2020</p>
							
				           `,
      };
    },
  },
  {
    id: "Mar_Morto_It",
    bgImage: "/posts/bank/80/1.jpg",
    mobBgImage: "/posts/bank/80/M.jpg",
    title: "MAR MORTO",
    smltitle: "",
    isVid: false,
    ctg: "deadsea",
    html: function() {
      return {
        __html: `
				                        
				                        <p><em>Il Ministero del Turismo di Israele e Israel Land Authority hanno annunciato i vincitori della gara d'appalto per la costruzione di quattro nuovi hotel sul Mar Morto, per un totale di 1.000 nuove camere disponibili. Il progetto comprenderà anche un nuovo centro commerciale e un centro conferenze.</em> </p>

                              <p><em>Il Ministro del turismo, Yariv Levin, ha dichiarato: "Stiamo continuando la rivoluzione del turismo nel Mar Morto proponendola come una destinazione turistica moderna e attraente. Dato il notevole aumento del numero di turisti in Israele, accolgo con favore l'inizio del processo di costruzione di 1000 nuove stanze nel Mar Morto. Si tratta di un grande passo avanti sulla strada del cambiamento nella regione".</em></p>
                              <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/80/1.jpg"} class="img-responsive" />
				                        </div>
                              <p><em>Adiel Shomron, direttore dell'autorità della terra israeliana, ha dichiarato: “Dopo quasi 20 anni in cui non sono stati costruiti nuovi hotel nell'area, è arrivato un nuovo slancio per costruire hotel, un'area commerciale e un'ampia area per conferenze. In questa gara d'appalto, è stato costruito un modello speciale in cui il prezzo del terreno era minimo e fisso e la concorrenza fosse focalizzata sui costi di sviluppo, in modo che il sussidio statale, tramite la società di governo di conservazione del Mar Morto, fosse speso in modo efficace e senza sprechi di risorse pubbliche ".</em></p>
 
                              <p><em>Shimon (Shimi) Daniel, CEO della società governativa per la conservazione del Mar Morto, aggiunge: "Si tratta di un evento formativo che crea un cambiamento nella regione con il completamento del lavoro infrastrutturale e dopo i numerosi investimenti che abbiamo fatto nella regione, stiamo per iniziare la fase di costruire un complesso alberghiero innovativo che cambierà l'area e trasformerà il Mar Morto in un'area attraente su scala internazionale”.</em></p>
 
                              <p> Africa Israel si è aggiudicato il lotto nella rinomata area Hamei Zohar area dove sorgerà un hotel da 220 camere. Fattal Hotels realizzerà nella nuova area tra Ein Bokek e Hamei Zohar un albergo da 198 camere. </p>

                              <p>Elad Hotels si è aggiudicato due lotti situati nella nuova area tra Bokek e Hamei Zohar, dove costruirà due hotel, rispettivamente 253 e 330 camere. Quest’ultimo sarà un complesso di lusso sull’acqua comprensivo di Spa. </p>
                              <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/80/2.jpg"} class="img-responsive" />
				                        </div>
                              <p>Sono incluse due aree aggiuntive: una per il commercio e l'altra per un centro conferenze regionale. Barclays Israel, proprietario del Dead Sea Mall di 12.000 mq inaugurato lo scorso anno, ha vinto la gara d'appalto. La nuova area commerciale coprirà 26.579 metri quadrati e sarà costruita tra Ein Bokek e Hamei Zohar. Elad Hotels Ltd. ha vinto il bando di gara per la costruzione di un centro conferenze unico per un'area di 11.539 metri quadrati. </p>
  
                              <p>Di recente, il Ministero del Turismo, guidato dal direttore generale Amir Halevi, ha promosso il prodotto turistico nel Negev. Dopo il successo di portare decine di voli europei verso Eilat durante la stagione invernale, il ministero sta lavorando per creare contenuti per questi turisti per prolungare il loro soggiorno nel sud di Israele in particolare e in Israele in generale. Lo sviluppo della regione del Mar Morto rappresenta parte della strategia del ministero che pone l'accento sul prodotto turistico, che è il futuro economico per il Negev e l'Arava.</p>
 
                              <p>Il Ministero del Turismo sta investendo gli sforzi per aumentare il volume del turismo nella regione del Mar Morto, che gode della più alta occupazione media annua di hotel in Israele. Negli ultimi anni il ministero ha inaugurato nuove spiagge accessibili, libere dal pubblico, nell'area alberghiera del Mar Morto, tra Ein Bokek e Hamei Zohar. Tramite la sua filiale, la Dead Government Preservation Government Company, il Ministero del Turismo israeliano ha anche istituito una nuova passeggiata di 4 chilometri lungo la riva del mare e il lavoro e lo sviluppo delle infrastrutture con un investimento di circa mezzo miliardo di shekel.</p>

							
				           `,
      };
    },
  },
  {
    id: "Cesarea2_It",
    bgImage: "/posts/bank/81/1.jpg",
    mobBgImage: "/posts/bank/81/M.jpg",
    title: "Cesarea",
    smltitle: "",
    isVid: false,
    ctg: "north",
    html: function() {
      return {
        __html: `
				                        <h3>Cesarea, storia millenaria e acque cristalline: per T+L nei top 50 places to see</h3>
				                        <p>Un porto risalente a migliaia di anni fa e splendide spiagge frequentate ancora oggi: sono i due elementi che rendono Cesarea una meta imperdibile durante un viaggio in Israele. Questa località marittima si trova a metà strada tra Haifa e Tel Aviv, dista poco più di un’ora di auto da entrambe le città e ha decisamente molto da scoprire!.</p>
			                            <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/81/1.jpg"} class="img-responsive" />
				                        </div>
			                               <p>Travel + Leisure ha appena pubblicato l'elenco dei 50 migliori posti in cui viaggiare nel 2020 e tra i primi 50 c'è la città costiera di Cesarea. Il sito ha esaminato le statistiche del turismo, verificato i principali eventi, preso in considerazione nuove rotte di volo, nonché nuove aperture di hotel e ristoranti, e utilizzato la loro vasta rete di esperti di viaggio tra cui consulenti di viaggio, scrittori e altri professionisti del settore al fine di elaborare il loro elenco definitivo. Ecco la recensione di Travel + Leisure di Cesarea:</p>
			                               <p>“Il felice connubio tra antichità e modernità sta attirando più visitatori a Cesarea, una città costiera e un parco nazionale nel nord di Israele, sul sito di un porto romano di 2000 anni fa. Il nuovo Centro Visitatori di Re Erode (chiamato così dato che il monarca fu fondatore del porto e costruito nelle enormi volte arcuate che un tempo sorgevano sotto un tempio) mostra reperti archeologici recenti, come mosaici colorati e monete d'oro recuperate dai relitti di navi. Come scoprirla? Ammira l'antico porto da un tavolo al ristorante Helena, un locale raffinato che offre ingredienti locali e vini israeliani, quindi passeggia tra le rovine di stabilimenti balneari o esplora frangiflutti, colonne e carichi romani sommersi lungo i percorsi di snorkeling e immersioni subacquee a il vecchio centro immersioni di Cesarea. Trascorri la notte nel Dan Caesarea, recentemente rinnovato, un elegante resort di metà del secolo costruito dal rampicante bancario francese Baron Edmond de Rothschild".</p>
			                            <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/81/2.jpg"} class="img-responsive" />
				                        </div>
			                               <p>La storia delle origini di Cesarea risale addirittura al I secolo a.C., quando Erode il Grande fece costruire un grande porto attorno al quale si sviluppò presto una vivace cittadina. Il centro rimase amministrato dall’Impero Romano prima e Bizantino poi, salvo venire distrutto e abbandonato nel XIII secolo. La Cesarea moderna sorge a poca distanza dal nucleo originale e, grazie a importanti scavi archeologici svolti a partire dal 1950, numerosi reperti (soprattutto architettonici) sono stati riportati alla luce. Oggi fanno tutti parte del Caesarea National Park, aperto al pubblico tutto l’anno e fra archeologici più popolari di Israele. </p>
			                               <p>Cesarea è anche la casa di un museo subacqueo unico al mondo: poiché alcune rovine del porto si trovano oggi sott’acqua, è possibile armarsi di muta e bombole e seguire una guida esperta del Caesarea Dive Club e andare alla scoperta di queste meraviglie sottomarine.</p>
			                               <p>Ma non c’è solo archeologia a Cesarea! La città vanta infatti una delle spiagge più belle di Israele: la Acquaduct Beach. Questa spiaggia, attraversata da un acquedotto di epoca romana, non ha nulla da invidiare alle popolari spiagge del sud del Paese, ma si distingue per un’atmosfera decisamente più tranquilla e meno mondana, con splendide viste sulla campagna circostante. </p>

							
				           `,
      };
    },
  },

  {
    id: "Tu_Bishvat_It",
    bgImage: "/posts/bank/82/1.jpg",
    mobBgImage: "/posts/bank/82/M.jpg",
    title: "TU BISHVAT, IL CAPODANNO DEGLI ALBERI",
    smltitle: "",
    isVid: false,
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `
				                       
				                        <p>I prossimi 9 e 10 febbraio in Israele si festeggia Tu Bishvat, una ricorrenza conosciuta anche come il “Capodanno degli Alberi”. Questa festa ha origini molto antiche e è fortemente ispirata dall’antico retaggio agricolo delle prime civiltà israeliane. Un tempo infatti, il giorno di Tu Bishvat (che secondo il calendario ebraico cade sempre il 15esimo giorno del mese di Shevat), divideva i raccolti in due anni “fiscali” distinti: ciò che veniva raccolto prima di quel giorno rientrava nelle imposte dell’anno precedente, altrimenti si aggiungeva a quelle dell’anno in corso. </p>

									<p>La ricorrenza è presto diventata una convenzione per dare agli alberi un’età esatta: questo permetteva di rispettare la Torah (che impone di non cogliere frutti di alberi con meno di tre anni), e ha dato alla celebrazione il suo caratteristico nome di “Capodanno degli Alberi”.</p>
                                    <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/82/1.jpg"} class="img-responsive" />
				                        </div>
									<p>Pur essendo una festività secondaria e non venendo celebrata con il rigore tipico dello Shabbat o di altre giornate sacre agli ebrei, Tu Bishvat è comunque un momento molto speciale all’interno del calendario ebraico. Durante questa festa si è soliti consumare un pasto a base dei sette frutti tipici della tradizione israeliana (grano, orzo, uva, fichi, melograni, olive e datteri, stando a quanto tramandato dal Deuteronomio) ed è proibita qualsiasi manifestazione di tristezza. </p>

									<p>Per ribadire l’origine agricola della festa e l’importanza degli alberi, ogni giorno di Tu Bishvat i bambini israeliani si ritrovano per piantare decine di nuovi alberi nel verde pubblico delle loro città. Un gesto che è sicuramente un tributo alla figura dell’albero, centrale nella tradizione e nella storia israeliana, ma che porta con sé anche un messaggio positivo di ecologia e speranza. </p>

			                          
							
				           `,
      };
    },
  },

  {
    id: "Darom_Adom_It",
    bgImage: "/posts/bank/83/1.jpg",
    mobBgImage: "/posts/bank/83/M.jpg",
    title: "Darom Adom la magia del deserto in fiore",
    smltitle: "",
    isVid: false,
    ctg: "eilat",
    html: function() {
      return {
        __html: `
				                       
				                        <p>Può sembrare un miraggio, o addirittura un miracolo, ma è una splendida realtà: ogni anno, tra gennaio e febbraio, il Negev settentrionale “smette” di essere un deserto e comincia a fiorire. Succede al termine della stagione delle piogge, quando la terra (non più) arida del deserto si apre e lascia spazio a migliaia di anemoni rossi.</p>
									<p>L’anemone è un fiore molto comune nel resto di Israele, ma è naturale che vederlo in questa regione sia un’esperienza molto più affascinante. La fioritura del deserto è però una bellezza fragile, dato che, una volta raggiunto il suo massimo splendore, raramente dura più di una settimana. </p>
									<div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/83/1.jpg"} class="img-responsive" />
				                        </div>
									<p>Questo spettacolo della natura viene celebrato con un festival che quest’anno occuperà tutti i fine settimana di febbraio, il cuore della stagione degli anemoni rossi. Il festival, che coinvolge i vari centri della regione di Eshkol, è nato nel 2007 per dare risalto non solo al deserto fiorito, ma anche ai centri abitati e alle attività che hanno la fortuna di ospitare questo straordinario fenomeno. </p>
									<p>Il festival si chiama Darom Adom (dall’ebraico Sud Rosso) e ogni fine settimana propone tante attività per famiglie, turisti ed escursionisti. Nel programma di quest’anno sono incluse anche attività in mountain bike e diversi spettacoli di musica dal vivo, per accontentare tutti i visitatori e rendere ancora più magico il Negev in fiore. </p>
									<p>Una delle attività più gettonate tra i tanti turisti che vengono ad assistere a questo spettacolo è sicuramente il classico pic-nic, l’ideale per sfruttare al meglio il mite inverno israeliano e al tempo stesso godersi lo splendido paesaggio circostante. Sono diverse le posizioni gettonate tra gli amanti di questo genere di esperienza: le più popolari sono a Re’im o nei kibbutz Kissufim e Ruhama.</p>
									<p>Il programma completo con tutte le attività in programma è consultabile, in inglese, al link:<a href="https://www.habsor.co.il/?lang=en" target="_blank"> www.habsor.co.il</a></p>

			                             
							
				           `,
      };
    },
  },
  {
    id: "La_Cucina_A_TelAviv",
    bgImage: "/posts/bank/la-cucina/1.jpg",
    mobBgImage: "/posts/bank/la-cucina/M.jpg",
    title: "LA CUCINA A TEL AVIV",
    smltitle: "",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    ctg: "culinarytelaviv",
    html: function() {
      return {
        __html: `
								        <div class="ac-cradit" style="margin-top:-13px"><small>
                  		                  A film by VIA TOLILA
                  	                  </small></div>
                  	                  <br/>
				                       <h3>Tel Aviv rappresenta una destinazione di viaggio per i buongustai grazie alle migliaia di ristoranti e bar di alta qualità</h3>
				                    



				                        <p>Tel Aviv rappresenta una destinazione di viaggio che offre sole, divertimento, spiagge, storia, una cultura unica … e dell’ottimo cibo. Tel Aviv è di recente stata inclusa nella lista compilata a cura della rivista di gastronomia Sauver &nbsp;<a href="//www.saveur.com/content/culinary-travel-awards-2014-all-winners" target="_blank">Outstanding Culinary Destinations</a>&nbsp;(notevoli destinazioni culinarie) nei loro riconoscimenti annuali per i viaggi culinari (Culinary Travel Awards). Tel Aviv è stata definita “notevole” anche nella categoria dei migliori mercati e negozi (Best Markets and Shops). La Pastel Brasserie di Tel Aviv è stata votata il più bel ristorante del mondo <a href="//nocamels.com/2015/01/pastel-brasserie-designed-by-bk-wins-international-award/" target="_blank">Most Beautiful Restaurant in the World</a>&nbsp;nel 2014 International Space Design Awards.</p>                
                                        <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/la-cucina/3.jpg"} class="img-responsive" />
				                        </div>
					                      <p>Israele è una terra di immigrati, dove ogni comunità etnica porta con se la propria specifica cultura culinaria, e tutte insieme hanno contribuito a creare l’esperienza gastronomica di &nbsp;Tel Aviv. Qui potrete provare la cucina etiope, rumena, georgiana, russa, indiana, yemenita, irachena, iraniana ed altro ancora, con un tocco israelo-mediterraneo. La città ha eleganti ristoranti di chef, come <a href="//mizlala.co.il/en" target="_blank">Mizlala</a>, di Mir Adoni, <a href="https://topolopompo.co.il/" target="_blank">Topolpompo</a>, di Avi Conforti, e North Abraxas, del celeberrimo chef Eyal Shani. Ma ci sono anche intimi ristorantini di quartiere, come Abdu Hadayag, e non dimenticate il cibo dei chioschi di strada a Tel Aviv, che è stato classificato come il più salutare fast-food del mondo e sempre servito con fresca insalata araba.<br>
                                        </p>

					                      <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/la-cucina/4.jpg"} class="img-responsive" />
				                        </div>

					                      <h3>
						                     I bar di Tel Aviv
					                      </h3>

					                      <p>E se ci spostiamo dal cibo, troveremo che anche il panorama dei bar di Tel Aviv è assolutamente superlativo. Drinks International Magazine include Tel Aviv nella propria lista dei 50 migliori bar del mondo (&nbsp;<a href="//www.drinksint.com/news/categoryfront.php/id/185/The_World_s_50_Best_Bars.html" target="_blank">World’s 50 Best Bars Awards</a>.) Imperial Craft Cocktail Bar a Tel Aviv e stato eletto il migliore in Africa e Medio Oriente. L’Imperial si distingue per i propri cocktail su ordinazione, e Tel Aviv in generale ha cominciato ad entrare nella tendenza della “mixologia”. La citta presenta un brulicante panorama di ristorazione, dato che conta circa 4.500 posti per mangiare e bere, che significa una media di un ristorante ogni 1.000 abitanti. Time Out Israel ha recentemente definito le migliori aree di bar della città: Lilienblum Street, il porto, il lungomare, Ben Yehuda Street e Dizengoff Street. Tra i locali piu amati di Tel Aviv il Lima Lima Bar, collocato al primo posto da Trip Advisor, il classico Abraxas, l’intimo Ozen Bar ed il bar sulla spiaggia LaLa Land.</p>
                                         <div class="img-wrapper">
				                          <img src=${getImgUrl() +
                                    "/posts/la-cucina/2.jpg"} class="img-responsive" />
				                        </div>
									
			                             
							
				           `,
      };
    },
  },

  // 		{
  // 		id:"EILAT1",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId: "ZdnNT-GDJv4",
  //         title : "EILAT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                       <p>Eilat is a port that is Israel’s outlet to India, eastern Asia and Africa. Six decades ago it was a shanty-style frontier town, but Eilat has developed into one of Israel’s major resorts whose Red Sea beaches and dozens of hotels attract Israelis and tourists from 100 countries. Eilat is devoted to vacationing. Resorts line the promenade and lagoon, along with a giant shopping mall, restaurants and a variety of attractions for visitors young and old. Eilat is also an entrée to one of the world’s most magnificent coral reefs: the Eilat Underwater Observatory is a must for every visitor, as is the dolphin reef where tourists swim with the dolphins.</p>
  //                       <div class="img-wrapper">
  // 						    <img src=${getImgUrl()+ "/posts/eilat1/1.jpg"} class="img-responsive">
  // 					    </div>
  //                       <p>Eilat is a 4/5-hour drive from Tel Aviv and Jerusalem – or a one-hour flight into Eilat Airport which sits in the heart of town. A 15-minute drive south from Eilat brings visitors to the crossing point to Egypt. And 10-minutes to the north, tourists cross to Jordan and the neighboring port city of Aqaba. Many visitors to Eilat take day trips to Petra in Jordan.</p>

  //                        <div class="img-wrapper">
  // 						    <img src=${getImgUrl()+ "/posts/eilat1/2.jpg"} class="img-responsive">
  // 					    </div>
  //                       <h3>Take a deep at the Red Sea</h3>
  //                       <p>An amazing attraction in itself, Eilat’s gorgeous Red Sea and the 10 kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide.<br> With their clean, clear and unexpectedly cool water allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
  //                       <p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the southern and northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>
  //                       <h3>Feel the vibe</h3>
  //                       <p>When evening comes and the hot desert sun sets on Eilat and the pools and beaches close, that is just the time to shower, change and hit the town’s fantastic nightlife scene. Eilat holds a unique record – the city with the most clubs, bars and other entertainment venues per capita in Israel, so there is no shortage of hotspots to make your night as fun-filled as your day.</p>
  //                       <h3>A desert adventure</h3>
  //                       <p>North of the city lies the southern Arava, a region of breathtaking desert vistas, and one of the most recommended areas to visit in the country, where you can feel the vast expanses and hike steep cliffs, valleys, streams and more.</p>
  //                       <p>The colorful and stunning mountains of the Eilat area, besides contributing to the city's breathtaking view, will provide all nature lovers with an unforgettable experience. There are a variety of routes and sites to visit and enjoy by hiking, bicycling, driving, camel riding and even rock climbing or rappelling down cliffs for the extreme sports enthusiasts.</p>
  //                       <p>Don't wait up. Visit Eilat. Escape to the sun.</p>
  // 				 `
  //     }
  //   }
  // },
  // {
  // 		id:"Welcome_To_Eilat",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"ZdnNT-GDJv4",
  //         title : "WELCOME TO EILAT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                 <h3>A city of sun and fun!</h3>
  // 							<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
  // 							<p>Whether you come to stay in Eilat as a family, a couple or even by yourself, you will find loads to see and do here. Accommodations are abundant, ranging from youth hostels to the r luxury resorts, offering visitors an unforgettable 5 star experience, with everything from the finest restaurants to beach side service.</p>
  // 							<p></p>
  // 							<div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/welcome-to-eilat/1.jpg"} class="img-responsive">
  // 							</div>
  // 							<p>With a whopping 360 Sunny days a year, a visit to Eilat is a fun-filled experience, where you get to relax, recharge and get energized all at the same time. This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
  // 							<h3>The Red Sea</strong><br> An amazing attraction, Eilat’s gorgeous Red Sea and the 10-kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide. With their clean, clear and unexpectedly cool water, allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
  // 							<p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the Southern and Northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>
  // 							<p></p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "The_Ultimate_Holiday",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "THE ULTIMATE HOLIDAY DESTINATION",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                 

                                 
							   <p><strong">Eilat,&nbsp;</strong>the southernmost town in Israel, has all you need for a perfect vacation. Whether you're looking for a romantic gateway, family vacation, action-packed adventure or partying with your friends, this bustling resort town on the shores of the Red Sea is the place for you. Mediterranean Sun, crystal clear water, soothing Spas, vibrant night life, Tax free shopping, and endless list of attractions – that's Eilat.</p>
							   <p><strong">Soak up the sun.&nbsp;</strong>With summer sun that shines throughout the year, the best time to visit Eilat is…anytime! Even in the middle of a freezing European winter Eilat offers an escape from the cold. Just hop on a plane and in few short hours you'll stop shivering and feel revived.</p>
							   <p><strong">Choose your vacation home. &nbsp;</strong>Hostels and on the budget inns or luxury world-class and boutique hotels. Family and groups oriented resorts or secluded, peaceful and romantic ones - Eilat offers a large variety of accommodations to fit every budget and need.</p>
							   <p><strong">Jump into the water.</strong>&nbsp;With over 7 kilometers of breathtaking Rad Sea coastline, Eilat has plenty to offer when it comes to water activities. From snorkeling and scuba-diving to wind- surfing, kite-surfing, sailing and so much more – this city got you covered.</p>
							   <p>Experience the&nbsp;<strong">Dolphin's reef</strong>, a family friendly ecological beach with a gorgeous botanical garden, relaxation pools and the main attraction – an opportunity to watch, touch, swim and dive with Dolphins. &nbsp;(<em>Don't worry, all interaction with these beautiful creatures is based solely on the Dolphin's free will</em>).</p>
							  
                               <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-ultimate-holiday/1.jpg"} class="img-responsive">
									</div>
							   <p>Visit the&nbsp;<strong">Underwater Observatory</strong>, one of Eilat's most popular attractions that allows you and your family to view and learn about the Red Sea unique Marine life. Through the huge glass windows you'll see sharks, turtles, stings rays and multicolored Red Sea fishes. Through sailing on a glass ship, you'll feel a part of this magical underwater kingdom.</p>
							   <p>Don't miss the world famous<strong">&nbsp;Coral Beach Nature Reserve&nbsp;</strong>and its stunning coral reef<strong">.&nbsp;</strong>Go snorkeling and scuba diving to see the colorful fish and extraordinary water plants in this rare delicate natural habitat.</p>
							   <p><strong">Go on a desert adventure.&nbsp;</strong>The Negev desert offers some of the most spectacular scenic routes in Israel.&nbsp; Hike, mount bike or take a Jeep tour to explore and marvel at the beauty that surrounds you.</p>
							   <p>Only 25 kilometers north of Eilat you'll find the&nbsp;<strong">Timna Park Valley</strong>. Go on a tour, explore the gorgeous scenery and special antiquities of the world's first copper mine and enjoy the many attractions it offers for families and adventurers among you.</p>
							   <p>Want to expand your adventure? The city is easily accessible to the rest of the country. Take a day trip to the Dead Sea or Jerusalem.</p>
							   <p><strong">Allow yourself to relax.&nbsp;</strong>Eilat is a laid back town where you can truly slow down and rest. True to its nature, it's also filled with fantastic Spa facilities that offers lots of different treatments from traditional messages to water therapy.&nbsp;<em>Trust us, it's worth it!</em></p>
							   <p><strong">Buy, eat, drink and party.&nbsp;</strong>Shop in the city's promenade's Bazaar, Luxurious shopping Boulevard and numerous malls<strong">&nbsp;–&nbsp;</strong>it's all TAX free<strong">!&nbsp;</h3>
							   <p><strong">Go out to a night on the town.</strong>&nbsp;Get entertained a see the amazing colorful audiovisual show of the musical fountain; prepare to be wowed with the Broadway style Wow show that combines dancing, acrobatics light effects, great soundtrack and many more surprises.</p>
							   <p>Dine in one of the many restaurants and bars in town and then go hit the dancefloor in a club.</p>
							   <p>It doesn't get better than this.</p>
							  


		                        `,
      };
    },
  },
  {
    id: "Eilat_Calling",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat2/1.jpg",
    mobBgImage: "/posts/bank/eilat2/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "UNA SENSAZIONE DI VACANZA ESTIVA SENZA FINE",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  
									<p>Capitale del Mar Rosso, Eilat è la città turistica più famosa di Israele, che attrae quasi 2,8 milioni di visitatori l’anno, i quali trascorrono le vacanze sulle spiagge dello stupendo Mar Rosso.</p>
									<p>La città più a sud di Israele, Eilat, è famosa per la sua spettacolare combinazione di paesaggio desertico, la sua stupenda baia e il sole estivo che splende tutto l’anno.&nbsp;<br><br>Sia che visiti Eilat in famiglia, in coppia o da soli, qui troverai tantissime cose da vedere e fare. Le possibilità di alloggio sono innumerevoli e vanno dai raffinati hotel di lusso a 5 stelle alle comode soluzioni di Airbnb, fino agli ostelli della gioventù.&nbsp;</p>
									<p>Eilat gode di ben 360 giorni di sole l’anno, il che l’ha resa una destinazione molto amata dai turisti provenienti da ogni dove, desiderosi di scappare dal loro rigido clima invernale.&nbsp;<br>Una visita a Eilat è un’esperienza molto divertente, grazie alla quale potrai rilassarti, ricaricarti e fare il pieno di energia. Questa vivace città turistica offre un gran numero di attività e attrazioni durante tutto l’arco dell’anno: ottimi ristoranti e caffè, centri commerciali e bar e club alla moda.<br>La parte migliore? A Eilat tutto è sempre accessibile a pochi passi dalla spiaggia.</p>
									<h3Fai un tuffo nel Mar Rosso</h3>
									<p>Lo stupendo Mar Rosso e il litorale di 10 km che circonda la città di Eilat costituiscono le principali attrazioni sia per i turisti locali che per quelli che vengono da lontano.<br>Le acque pulite, chiare e inaspettatamente fresche offrono un gradito refrigerio agli abitanti della città, caratterizzata da temperature elevate e aria secca, mentre la grande varietà di strutture turistiche e attrazioni disponibili sulle spiagge di Eilat offre il contesto ideale per prendere il sole, riposarsi e rilassarsi.</p>
									<p>Agli appassionati di sport estremi piaceranno le decine di club di sport acquatici diffusi lungo le coste meridionali e settentrionali di Eilat e attività come sci nautico, banana da traino, tubing (discesa di un fiume a bordo di una grossa camera d’aria), kayak e molto altro ancora.</p>
									<h3>Assapora l’atmosfera </h3>
									<p>Quando cala la sera e il forte sole del deserto tramonta su Eilat e le piscine e le spiagge chiudono, giunge il momento di fare la doccia, cambiarsi e godersi la stupenda vita notturna della città.&nbsp; Eilat detiene un record unico: è la città israeliana con il maggior numero di club, bar e strutture di intrattenimento pro capite. Di conseguenza, non mancano i locali notturni in cui divertirsi tanto quanto il giorno.</p>
									<h3>Un’avventura nel deserto</h3>
									<p>A nord della città si estende il deserto dell’Arava, che offre panorami desertici mozzafiato ed è una delle zone da non perdere del Paese, dove potrai ammirare spazi sconfinati e irte scogliere, valli, ruscelli e altro ancora.</p>
									<p>Le montagne variopinte e spettacolari della zona di Eilat, oltre a contribuire al panorama mozzafiato della città, consentono agli amanti della natura di fare un’esperienza indimenticabile. Esistono numerosi percorsi e siti da visitare e nei quali dedicarsi a escursioni, gite in bicicletta, cavalcate a dorso di cammello e - per gli appassionati di sport estremi - addirittura alpinismo e discesa a corda doppia lungo le scogliere.</p>
									<p>Non rimandare. Visitat Eilat. Corri verso il sole.</p>

											                        `,
      };
    },
  },
  {
    id: "Eilat_Doolphin_Reef",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    // vidId:"3Cvz8GoxNzA",
    vidId: "EPAPO5zU--4",
    title: "LA SPIAGGIA DEI DELFINI DI EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
							    <h3>Un incontro stravagante con la flora e la fauna</h3>
							    <h3>Socializza con i delfini presso l’esclusiva attrazione balneare di Eilat</h3>
								<p>La Spiaggia dei delfini di Eilat è un’oasi naturalistica sulle spiagge del Mar Rosso, dove le avventure ricche di azione vanno di pari passo con la natura e il relax. Sulla spiaggia i visitatori entrano in contatto con un sito magico, interagiscono con i delfini nel loro habitat naturale: una spiaggia incredibile dove la vita vegetale conosce la sua massima espressione e la vista è mozzafiato.</p>
								<p>La lunga banchina offre un punto di osservazione ideale per guardare i delfini “tursiopi” che se ne vanno in giro per svolgere le loro attività quotidiane: mangiare, cacciare, accoppiarsi e socializzare, talvolta anche con i visitatori umani. I visitatori alla ricerca di un’esperienza più pratica possono provare a interagire con i delfini attraverso una delle numerose attività aperte al pubblico.</p>
								<p>Un’esperienza davvero magica consiste nel guardare i delfini durante i pasti, a orari programmati, ma pur sempre ammalianti. C’è qualcosa di entusiasmante nel gioco fanciullesco e brioso dei delfini nei confronti dei loro addestratori, nell’attesa di ricevere il cibo. La gioia pura che provano quando finalmente afferrano il cibo provoca quasi istintivamente uno scroscio di applausi da parte di tutti gli spettatori. Sembra quasi che i visitatori si sentano esaltati e soddisfatti come se fossero loro a mangiare.</p>
								<p>La bellezza della Spiaggia dei delfini è che i visitatori non devono tenersi a distanza, ma possono tuffarsi e nuotare insieme ai delfini, osservarli nel loro ecosistema unico, scendere fino a sei metri di profondità e vivere la vita magnifica e segreta come essa si svolge nelle profondità del mare. Oppure, possono scegliere di nuotare sott'acqua con il respiratore insieme ai delfini, leggermente più vicino al pelo dell’acqua, galleggiando accanto ai delfini e interagendo con essi.</p>
								<p>Le “piscine di rilassamento” consentono ai visitatori di liberarsi dalle loro preoccupazioni e di galleggiare ascoltando musica rilassante. I ristoranti presenti sul posto fanno sentire i visitatori accuditi e coccolati, senza doversene andare dal piccolo santuario di bellezze naturali.</p>
										                      
		                        `,
      };
    },
  },
  {
    id: "Action_Packed_Eilat",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "ACTION PACKED EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               <p>So, you’ve heard about the fabulous beaches, the awesome nightlife and fantastic atmosphere of year round sunny Eilat, but aren’t you wondering, amongst all the leisure, what to do with the excess energy? Well wonder no more. Here are just some of the amazing ways to have some action-packed fun in the sun:</p>
		                       
                                   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/action-packed-eilat/1.jpg"} class="img-responsive">
									</div>
								   <p>Eilat’s stunning red sea offers loads of fantastic adventures. For one, its gorgeous underwater environment is known as a world-famous <b>scuba diving destination</b>. Not a pro? No problem. There are short courses that run for 1-2 days.</p>
								   <p>Atop the waves, you’ll find, <b>windsurfing</b>, <b>kitesurfing</b>, and <b>stand-up paddle boarding</b> options for which it’s always an ideal time in Eilat, with its pristine beaches, calm waters, and perfect sunny weather almost year-round. By the way, don’t worry about equipment or experience, as there are plenty of options for rentals and individual or group lessons for all ages as well as all-inclusive packages. You’ll be flying across the sea in no time!</p>
								   <p>Looking to flex a few more muscles? Eilat’s nearby desert area offers <b>fantastic hikes</b> in stunning trails where you can <b>walk or bike</b> through breathtaking desert scenery.<span class="Apple-converted-space">&nbsp; </span>Feeling adventurous? Check out the huge array of unique action attractions from unforgettable camel rides to <b>adrenaline charged ATV rides</b> to thrilling off cliff <b>paragliding,</b> guaranteed to get the heart racing.</p>
								   <p>If your holidays are all about breathtaking adventures, Eilat is definitely the place for you!</p>
								 


		                        `,
      };
    },
  },
  {
    id: "Eilat_Ultimate_Beachside",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    // vidId:"ZdnNT-GDJv4",
    vidId: "u0TAD8TFpO8",
    title: "LASCIATI ANDARE",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               
								   
								   <h3>Vivi l’esperienza unica del mondo di attrazioni acquatiche di Eilat</h3>
								   
									<h3>Goditi le attrazioni acquatiche che fanno di Eilat la migliore destinazione balneare</h3>
									<p>Circondata dall’acqua, Eilat, la città più meridionale di Israele, è un punto di incontro per gli sporti acquatici e le avventure naturalistiche. Eilat offre spiagge stupende, sport acquatici, attività e attrazioni varie, aperte tutto l’anno grazie al clima caldo.</p>
									
									<p>Immergete i piedi nelle acque pulite e azzurre delle spiagge di Eilat, che si estendono per oltre dodici chilometri di sabbia, passerelle, hotel e attrazioni commerciali. Rilassatevi su una delle spiagge meridionali più appartate e silenziose e nuotate attorno alle barriere coralline, oppure godetevi una delle spiagge settentrionali, dove grazie agli hotel, ristoranti e negozi, il piacere e la soddisfazione sono garantiti. Oppure, potete divertirvi a bordo di uno yacht e solcare le acque, prendere il sole, rilassarvi e socializzare.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/eilat-ultimate-beachside/1.jpg"} class="img-responsive">
									</div>
									<p>Scoprite lo stupendo habitat, unico nel suo genere, della riserva naturale della spiaggia di corallo di Eilat. Indossate l’attrezzatura da snorkeling e osservate e interagite con le creature marine che vi nuotano intorno.</p>
									<p>Eilat è il cuore delle avventure marine estreme di Israele. Sentite il vento tra i capelli e il sole sulle guance mentre vi dedicate a sci d’acqua, moto d’acqua, banana da traino, surf o escursioni in barca con fondo di vetro, sfrecciando sulle acque a velocità esilarante. Preferite restare in superficie? Scegliete una veduta dall’aereo delle acque e dei paracadute ascensionali al di sopra della baia di Eilat.</p>
									<p>Vi piace la flora e la fauna? Nuotate in superficie o sott’acqua insieme ai delfini della Spiaggia dei delfini di Eilat. Questo sito naturalistico unico nel suo genere, in mezzo a una spiaggia magica, consente ai visitatori di osservare da vicino le vite dei delfini e costituisce un’entusiasmante avventura all’aria aperta. Volete fare un’esperienza in immersione senza bagnarvi? Visitate l’Osservatorio sottomarino di Eilat per gettare uno sguardo accattivante sulla vita sotto il livello del mare, dove potrete dedicarvi anche ad attività interattive e visitare mostre speciali.</p>

		                        `,
      };
    },
  },
  {
    id: "One_Day_In_Eilat",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "ONE DAY IN EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
								   <h3>Suggestions for an awesome day in the sun</h3>
								   <p>Whether you’re staying in one of the city’s 5 star hotels, a hostel or have opted for the cool camping alternative, we recommend to start your day with a delicious breakfast and make your way to the <b>Dolphin Reef</b>. This is one of the most popular attractions in Eilat, where you can touch, swim and dive with these beautiful creatures. Watch the dolphins in their natural habitat, visit the underwater photo center, or take part in either scuba diving or snorkeling. Check out also <b>Coral Beach</b>, the natural underwater reserve that extends for 1,200 meters along the coast and gives you the opportunity to go snorkeling with an extraordinary variety of tropical fish in a beautiful coral reef.</p>
								   <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/one-day-in-eilat/1.jpg"} class="img-responsive">
									</div>
								
								   <p>Once you’ve dried off, head to the stunning <b>Botanical Gardens</b> within Eilat. You’ll find there more than 1,000 types of trees and plants from all around the world, streams, waterfalls, a rainforest and bird sanctuaries.</p>
								   <p>To end of your day with something slightly different, head just outside of Eilat to the <b>Red Canyon,</b> where you can track through the riverbed and between the red Nubian sandstone walls that have been sculpted over the centuries by wind and water.</p>
								   <p>When evening comes, make your way to the buzzing Eilat promenade ,stroll by the shops and market stands which are open until late. You can treat yourself to a meal in any of the dozens of the excellent restaurants and cafés or a drink in any of the lively seaside pubs and bars.</p>
								  
		                        `,
      };
    },
  },
  // {
  // 		id:"Majestic_Desert",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "NEGEV – ISRAEL’S MAJESTIC DESERT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                  <div class="responisve-iframe">
  // 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/yXzhH92kREg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 				           </div>
  // 						   <h3>Where Adventure and Inspiration Await</h3>
  // 						   <p>An ideal destination for travelers who love adventure in the great outdoors. The south of Israel is sparsely populated, but packed with fascinating sites and activities.</p>
  // 						   <p>With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset. A desert but definitely not deserted, there is so much to see and do here – there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert. Simply put, this majestic Southern region is one of the country’s greatest assets and an absolute must on the itinerary.</p>
  // 						   <h3>Sde Boker</h3>
  // 						   <p>A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50’s. Sde Boker is renowned as the home of David Ben Gurion, Israel’s first Prime Minister whose home is now a museum open to the public.</p>
  // 						   <h3>Vidor Center</h3>
  // 						   <p>A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.</p>
  // 						   <h3>Nevatim</h3>
  // 						   <p>A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world. The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.</p>
  // 						   <h3>MidBurn Festival</h3>
  // 						   <p>Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.</p>
  // 						   <h3>Negev - Where Adventure and Inspiration Await</h3>
  // 						   <div class="responisve-iframe">
  // 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/QL3BGy2p77g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 				           </div>
  // 				           <h3>The Bedouin Experience</h3>
  //                                   <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging. A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.</p>
  //                            <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/majestic-desert/1.jpg"} class="img-responsive">
  // 										Credit: Daphna Tal
  // 							</div>

  // 						   <h3>The Culinary Queens of Yeruham</h3>
  // 						   <p>For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham – a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors. Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.</p>
  // 						   <h3>The Old City of Be'er Sheva</h3>
  // 						   <p>Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.</p>
  // 						   <h3>Carasso Science Park</h3>
  // 						   <p>New in the Old City of Be’er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel. Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.</p>
  // 						   <h3>Arad</h3>
  // 						   <p>Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style. With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.</p>
  // 						   <h3>Yotvata Hai-Bar</h3>
  // 						   <p>The Yotvata Hai-Bar Nature Reserve is the area’s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators’ center with its live predators and small desert animals, a Nocturnal animal’s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.</p>

  //                                  <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/majestic-desert/2.jpg"} class="img-responsive">
  // 							</div>
  // 							<h3>Extreme Adventures</h3>
  //                                   <p>The south of Israel is a total dream destination for adventure-hungry travelers. Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.</p>
  //                                     <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/majestic-desert/3.jpg"} class="img-responsive">
  // 										Credit: Daphna Tal
  // 							</div>
  // 							<h3>Camel rides</h3>
  //                                   <p>A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.</p>
  //                                   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/majestic-desert/4.jpg"} class="img-responsive">
  // 										Credit: Daphna Tal
  // 							</div>

  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"Negev1",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"yXzhH92kREg",
  //         title : "NEGEV",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                              <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
  // 					   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
  // 					   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
  // 					   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/negev/1.jpg"} class="img-responsive">
  // 							</div>

  // 					   <h3>The Israeli desert is special for the following reasons:</h3>
  // 					   <ul>
  // 					      <li><strong>The desert is very near:</strong>&nbsp;just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half). Starting from November, there will be direct flights from Europe and Russia to Ovda airport including&nbsp;Ryanair, Wizzair, and SAS.</li>
  // 					      <li><strong>Easy to Hike and Bike:</strong>&nbsp;There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert.</li>
  // 					      <li><strong>Cordial local population:</strong>&nbsp;The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
  // 					      <li><strong>Tourists Activities:</strong>&nbsp;Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
  // 					      <li>
  // 					         <strong>Magnificent landscapes:</strong>&nbsp;Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety
  // 					         <ul>
  // 					            <li>There are spectacular sand dunes in the north.</li>
  // 					            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
  // 					            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
  // 					            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
  // 					         </ul>
  // 					         <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers. Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
  // 					      </li>
  // 					      <li><strong>The Negev is very safe to travel.</strong>&nbsp;In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
  // 					   </ul>
  // 					   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/negev/2.jpg"} class="img-responsive">
  // 							</div>

  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"Location_And_Approach",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"5AAqIhkq_tQ",
  //         title : "NEGEV – LOCATION AND APPROACH",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 						   <p>Landing at the airports of Ovda or Eilat with the onward journey to Mitzpe Ramon or Sde Boker:</p>
  // 						   <h3>Public means of transportation:</h3>
  // 						   <p>Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.</p>
  // 						   <p>Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.</p>
  // 						   <p>Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.</p>
  // 						   <h3>Car rental in Eilat, Mitzpe Ramon and Be'erSheva:</h3>
  // 						   <p>There a multiple option in renting a car in these cities. There is a choice of international and Israeli companies.</p>
  // 						   <p>Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon</p>
  // 						   <h3>Public means of transportation:</h3>
  // 						   <p>Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.Train from Ben Gurion or Tel Aviv to Be'erSheva.</p>
  // 						   <p>From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes). Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.</p>
  // 						   <h3>NEGEV ROAD DISTANCES</h3>
  // 						   <table>
  // 						      <tbody>
  // 						         <tr>
  // 						            <th></th>
  // 						            <th>Tel Aviv</th>
  // 						            <th>Jerusalem</th>
  // 						            <th>Bee'r Sheva</th>
  // 						            <th>Eilat</th>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Old Town&nbsp;Beer Sheva</strong></td>
  // 						            <td>113 Km</td>
  // 						            <td>122 Km</td>
  // 						            <td></td>
  // 						            <td>232 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Tel Arad</strong></td>
  // 						            <td>134 Km</td>
  // 						            <td>144 Km</td>
  // 						            <td>40 Km</td>
  // 						            <td>229 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Ben-Gurion's House&nbsp;in Sde Boker</strong></td>
  // 						            <td>162 Km</td>
  // 						            <td>171 Km</td>
  // 						            <td>49 Km</td>
  // 						            <td>185 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Ramon Crater</strong></td>
  // 						            <td>210 Km</td>
  // 						            <td>192 Km</td>
  // 						            <td>97 Km</td>
  // 						            <td>141 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Hai Bar Wildlife&nbsp;reserve Yotvata</strong></td>
  // 						            <td>323 Km</td>
  // 						            <td>288 Km</td>
  // 						            <td>202 Km</td>
  // 						            <td>35 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Timna Park</strong></td>
  // 						            <td>330 Km</td>
  // 						            <td>294 Km</td>
  // 						            <td>208 Km</td>
  // 						            <td>30 Km</td>
  // 						         </tr>
  // 						      </tbody>
  // 						   </table>
  // 						   <h3>NEGEV DESERT - DON'T MISS</h3>
  // 						   <h3>Ramon Crater</h3>
  //                                  <p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve. Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon. The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
  //                                   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/1.jpg"} class="img-responsive">
  // 										Credit: Daphna Tal
  // 							</div>
  // 							<h3>Timna Park</h3>
  //                                   <p>15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions. With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.</p>
  //                             <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/2.jpg"} class="img-responsive">
  // 										Credit: Daphna Tal
  // 							</div>
  // 							<h3>Timna Park - An Exhilarating Desert Adventure</h3>
  // 							<div class="responisve-iframe">
  // 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/i_4QKtXIeto" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 				           </div>
  // 				           <h3>Sandboarding in the desert</h3>
  //                                  <p>An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?</p>
  //                                   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/3.jpg"} class="img-responsive">
  // 							</div>
  // 							<div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/4.jpg"} class="img-responsive">
  // 							</div>
  // 							<h3>Negev at night</h3>

  //                                   <p>The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.</p>
  //                            <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/5.jpg"} class="img-responsive">
  // 							</div>
  // 							<h3>Sunrise at Masada</h3>

  //                                   <p>Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Stay_In_The_Negev",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: false,
    title: "SISTEMAZIONI NEL NEGEV",
    smltitle: "",
    html: function() {
      return {
        __html: `
									<p>Un viaggio nel Negev offre molto più di grandi panorami e paesaggi tranquilli di quanto non evochi la parola “deserto”. Anche se il Negev offre comunque tutte le bellezze naturali, la calma e i luoghi meravigliosi di cui è alla ricerca il turista del deserto, esso è anche estremamente interessante, ricco di attività e avventure e offre addirittura tutti i comfort di una vacanza moderna.</p>
									<p>Il Negev mette a disposizione un’enorme varietà di alloggi. Molto più di un semplice luogo in cui riposarsi, il tipo di alloggio scelto ti darà l’opportunità di abituarti alla gemma indiscussa del Negev: la sua comunità locale. Dai residenti del Kibbutz a quelli delle fattorie solitarie, fino ai beduini, scoprirai che gli abitanti del Negev sono calorosi, ospitali e sempre disponibili a dare una mano. Ecco alcuni esempi di ospitalità che si riscontrano nel Negev:</p>
									<p>Hotel: il Negev offre innumerevoli possibilità di scelta, che vanno dagli hotel economici a 5 stelle fino ai premiati hotel di lusso internazionali a 5 stelle, presso i quali puoi rilassarti durante la pausa nel deserto.</p>
									<p>Ostelli: una sistemazione economica rivolta soprattutto ai viaggiatori giovani. Qui molti turisti hanno la possibilità di incontrarsi e conoscere altri viaggiatori con una mentalità simile e provenienti da tutto il mondo e di trascorrere le serate a socializzare, stabilendo spesso delle amicizie durature.</p>
									<div class="img-wrapper">
																					<img src=${getImgUrl() +
                                            "/posts/stay-in-the-negev/1.jpg"} class="img-responsive">
																	  </div>
									<p>Zimmer: si tratta della versione israeliana del Bed and Breakfast, di solito separata dalla casa in cui abitano i proprietari e spesso costituita da alloggi a se stanti e accoglienti, ideali per i viaggiatori alla ricerca di un’atmosfera romantica e tranquilla.&nbsp;</p>
									<p>Tende beduine per gli ospiti: l’esperienza da non perdere nel Negev. Si tratta di una forma di ospitalità unica e autentica, che ti consente di provare il modo di vita della comunità beduina del posto e offre l’opportunità eccezionale di partecipare alle tradizioni beduine nel loro ambiente naturale: altamente consigliata.</p>
									<p>Khan: un’esclusiva del Negev, i Kahn sono molto diffusi e consistono in grandi complessi all’aperto comprendenti casupole e aree comuni, oltre a tutte le altre strutture di base. Se da un lato i kahn costituiscono una forma di alloggio più spartana e rustica, sono ottimi per provare l’atmosfera rilassata del posto, fare la conoscenza di altri viaggiatori e abitanti del posto ed entrare a far parte dell’ambiente naturale del deserto.</p>
									<p>Fattorie isolate: forma di alloggio sviluppatasi di recente, le fattorie isolate sono di fatto delle camere degli ospiti all’interno di fattorie a gestione familiare ubicate in luoghi remoti nel Negev.&nbsp; Grazie alla tranquillità dei luoghi e alle comodità domestiche, le fattorie solitarie garantiscono privacy, panorami incredibili e un modo autentico di sperimentare la stupenda atmosfera del deserto del Negev.</p>
									<p>kibbutz:&nbsp;forma di insediamento comune e collettivo tipica di Israele, i kibbutz offrono una possibilità di alloggio con un buon rapporto qualità/prezzo. Tuttavia, il vero motivo di interesse del kibbutz è senza dubbio l’atmosfera particolare e lo spirito di comunità e il calore umano dei residenti, la loro mentalità aperta e accogliente, che garantiscono un soggiorno gradevole e indimenticabile.</p>
											                      
		                        `,
      };
    },
  },
  {
    id: "Pure_Desert_Magic",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "IL DESERTO DEL NEGEV: PURA MAGIA",
    smltitle: "",
    html: function() {
      return {
        __html: `
						                
								       <p>Il deserto israeliano, con il suo paesaggio mozzafiato e le numerose attrazioni è il luogo ideale per una vacanza. Il Negev invita i visitatori a fare un viaggio entusiasmante e ricco di opportunità.</p>
										<p>Israele è un piccolo Paese, con il 62% della superficie totale occupato dal deserto del Negev. Il terreno desertico, rossastro e lucente, è caratterizzato da numerose e notevoli formazioni rocciose. Qui i visitatori possono godere di una vista esclusiva di un’immensità immacolata, silenziosa e maestosa.</p>
										<p>Vi sono tracce delle civiltà del passato e della loro agricoltura, oltre ai siti archeologici. Il Negev offre un’ambientazione inconfondibile per incontrare le tribù di beduini, gli abitanti del deserto.</p>
										<h3>Il deserto israeliano è speciale per i seguenti motivi</strong>:</p>
										<ul>
										<li>
										<strong>Il deserto è molto vicino:</strong> appena 4 ore di volo dall’Europa. Israele ha due aeroporti internazionali: Ben Gurion e Ovda, i quali garantiscono un breve viaggio nel deserto a tutti i viaggiatori (da mezz’ora a un’ora e mezza).</li>
										</ul>
										<p>A partire da novembre ci saranno dei voli diretti da Europa e Russia per l’aeroporto di Ovda, organizzati da compagnie aeree tra cui <strong>Monarch</strong>, <strong>Ryanair</strong>, <strong>Wizzair</strong> e <strong>SAS</strong>.</p>
										<p>Per ulteriori informazioni, visitare il sito seguente: <a href="//www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx" target="_blank">http://www.iaa.gov.il</a></p>
										<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/pure-desert-magic/1.jpg"} class="img-responsive">
								       </div> 
										<ul>
										<li>
										<strong>Escursioni agevoli a piedi e in bicicletta</strong>: sono disponibili molti percorsi con segnaletica. Israele offre i percorsi escursionistici più imponenti del mondo e centinaia di percorsi sicuri attraverso il deserto israeliano. Nei seguenti siti Web sono elencati alcuni dei percorsi: <a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a> ; <a href="//www.en.aravaway.co.il" target="_blank">www.en.aravaway.co.il</a>
										</li>
										<li>
										<strong>Popolazione locale cordiale</strong>: gli abitanti del deserto sono amichevoli e ospitali e rendono l’esperienza del deserto sia piacevole che entusiasmante per i visitatori.</li>
										<li>
										<strong>Attività turistiche:</strong> oltre alle numerose possibilità di alloggio, la notevole offerta di attività turistiche ha trasformato di recente il Negev in una destinazione popolare, interessante, versatile e creativa.</li>
										<li>
										<strong>Paesaggi magnifici:</strong> oggi molti turisti apprezzano il fascino del Negev, con i suoi paesaggi variegati
										<ul>
										<li>A nord sono presenti spettacolari dune di sabbia.</li>
										<li>Il cratere Ramon si trova al centro del deserto, con le sue ripide scogliere e le sorgenti d’acqua stagionali.</li>
										<li>A est si può visitare il deserto africano, con ampie savane e alberi di acacia.</li>
										<li>Il paesaggio a sud è caratterizzato da granito rosso e nero, che contrasta con i rilievi di arenaria dal colore forte e gradevole.</li>
										</ul>
										</li>
										</ul>
										<p style="margin-left:36.0pt;">Durante un viaggio nel deserto di circa 3 ore potrete imparare a conoscere l’intera gamma del paesaggio desertico e apprezzarne la varietà, la quale, spesso, in altri deserti, può essere ammirata solo grazie a un lungo viaggio di diversi chilometri.</p>
										<p style="margin-left:36.0pt;">Molti turisti decidono di restare per 2 o 3 giorni in ciascuna regione del Negev.</p>
										<ul>
										<li>
										<strong>Viaggiare nel Negev è molto sicuro</strong>. In caso di emergenza, le unità di soccorso che operano in zona sono tra le meglio addestrate al mondo e si trovano sempre nelle vicinanze. Qualora qualcuno avesse bisogno di assistenza medica, Israele offre servizi medici specialistici di prim’ordine.</li>
										</ul>
										<h3>Ulteriori informazioni e suggerimenti per l’alloggio e consigli:</h3>
										<p><a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a></p>
								                              
											                        `,
      };
    },
  },
  {
    id: "Action_Fun_In_The_Desert",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "yXzhH92kREg",
    title: "DIVERTIMENTO E AZIONE NEL DESERTO ISRAELIANO",
    smltitle: "",
    html: function() {
      return {
        __html: `

						             
								    <p>Il deserto israeliano è ricco di panorami stupendi e siti storici e consente di dedicarsi a moltissime e divertenti attività che dimostrano che nel deserto non accade mai nulla.</p>
									<h3>L’unicità del deserto</h3>
									<p>Resterete attoniti davanti alle bellezze naturali delle quattro principali aree desertiche di Israele; il Mar Morto, la catena montuosa di Eilat, il deserto del Negev e della Giudea. I turisti possono esplorare i paesaggi dai colori e dalle formazioni rocciose uniche nel loro genere del cratere Ramon e le tonalità forti del parco di Timna nei dintorni di Eilat. Scendere a corda doppia lungo le scogliere multicolori o mettersi alla prova con un’escursione lungo strade polverose è ancora più bello se alla fine ci si può immergere e rinfrescarsi in un’oasi del deserto come quella di Ein Gedi, vicino al Mar Morto. Se trascorrerete la notte accampati in prossimità di uno dei numerosi campeggi che offrono servizi completi potrete vedere più stelle di quante possiate immaginarne. Potreste addirittura incontrare alcuni dei timidi animali notturni che vivono nel deserto!</p>
									<p>Primavera, autunno e inverno sono i periodi migliori per approfittare del clima secco e accogliente del deserto israeliano. Fate un salto indietro nel tempo visitando la famosa fortezza di Masada, per riscoprire il destino degli ultimi ebrei che combatterono contro i romani e ammirare la maestosità del palazzo di Erode. Esplorate le rovine bizantine e scoprite l’incredibile cultura degli antichi insediamenti dei nabatei, scavati nella roccia del deserto e che attendono solo una vostra visita.</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/action-fun-in-the-desert/1.jpg"} class="img-responsive">
								    </div>
									<h3>Divertimento e azione nel deserto</h3>
									<p>Il deserto israeliano è pieno di attività divertenti. Un viaggio entusiasmante in jeep vi farà sobbalzare sul terreno unico nel suo genere del Negev oppure potete noleggiare un mountain bike per mettervi alla prova nella bellezza soprannaturale delle rocce colorate del parco di Timna o attraverso i sentieri del deserto. Concedetevi una rilassante passeggiata a dorso di cammello con familiari o amici nel deserto della Giudea o sulle montagne di Eilat oppure sorseggiate un tè alla menta e mangiate datteri mentre approfittate dell’autentica ospitalità beduina nel Negev. Potete addirittura viaggiare a dorso di cammello per sentirvi come un vero antico israelita!</p>
									<p>Potreste cospargervi il corpo di fango minerale terapeutico sulle spiagge del Mar Morto ammirando le maestose montagne e l’acqua azzurra accanto a voi. Gli amanti degli sport estremi possono cimentarsi nel sandsurfing lungo le ampie dune sabbiose del Negev, provando l’ebrezza di gareggiare su ettari e ettari di sabbia.</p>
									<p>I deserti di Israele offrono molto più divertimento di quanto possiate immaginare.</p>                         
		                        `,
      };
    },
  },
  {
    id: "The_Incense_Route",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    title: "LA VIA DELL’INCENSO",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						           <h3>Una storia di successo commerciale vecchia di 2.000 anni</h3>
						           <p>La mitica via dell’incenso è una storia di successo commerciale vecchia di 2.000 anni.</p>
									<p>All’epoca, senza trasporti, strade e mappe, lunghe carovane di cammelli percorrevano sentieri difficili tra ladri, predoni, ostacoli e governanti ostili. Lungo il percorso transitavano beni preziosi, che partivano dallo Yemen e, procedendo verso est, attraversavano l’Arabia Saudita e la Giordania per poi arrivare in Israele, nel porto di Gaza, dove venivano caricati su navi mercantili dirette in Europa. Le donne dell’impero romano potevano quindi apprezzare i profumi di incenso e mirra, i sapori delle spezie orientali e i sali per cucinare e conservare gli alimenti.</p>
									<p>Per percorrere i 2.400 chilometri della via dell’incenso occorreva un viaggio di sei mesi. Le carovane di cammelli, tra cui migliaia di persone, si spostavano lentamente, facendo 56 fermate in occasione delle quali si riposavano, si prendevano cura degli animali e recuperavano le forze per il giorno successivo.</p>
									<div class="img-wrapper">
																					<img src=${getImgUrl() +
                                            "/posts/the-incense-route/1.jpg"} class="img-responsive">
																	       </div> 
									<p>Il tratto israeliano della via dell’incenso copriva circa 150 chilometri. Nel deserto del Negev sopravvivono ancora alcune rovine lungo l’antica via, che molti viaggiatori percorrono ancora oggi per esplorare il deserto e provare lo stile di vita dei maestri del deserto. Molte delle aree di sosta sono ancora visibili, a cominciare da Moa, nell’Arava, al confine con la Giordania, dove sono presenti le rovine di un’antica taverna, un posto di guardia, terreni agricoli, caverne, magazzini e un acquedotto. Da qui, il percorso continua in direzione nord-ovest verso Mamshit, un grande città le cui impressionanti rovine includono una taverna, alcune chiese, uno stabilimento balneare, vasche di raccolta dell’acqua piovana e altre strutture.</p>
									<p>La fermata successiva era la città di Ovdat, ubicata alla sommità di una collina. Anche qui sono presenti le rovine di una fortezza, chiese, un torchio per l’olio, un laboratorio di ceramica, abitazioni, uno stabilimento balneare e addirittura delle caverne per la sepoltura.</p>
									<p>La carovana continuava da Ovdat a Shivta, una cittadina con un sistema idrico ben sviluppato, vasche di raccolta dell’acqua piovana, torchi per l’olio e alcune chiese. La penultima fermata, quella più a nord, era Halutsa, della quale restano le rovine di un teatro e della chiesa e dalla quale le carovane procedevano dritte alla volta di Gaza. Lungo il tragitto furono aggiunte alcune stazioni minori – Kasra, Nekarot, Makhmal e Grafon – nonché una taverna aggiuntiva, Ein-Saharonim, della quale esiste ancora un cortile circondato da laboratori e un bagno.</p>
									<p>Lungo il percorso sono presenti serbatoi, torri di guardia, siti rituali, bagni e pietre miliari che indicavano la strada.</p>
									<p>Moa, Mamshit, Ovdat, Shivta e Haluza, come pure Ein-Saharonim, sono tutte accessibili con qualsiasi veicolo. Nel deserto, la via è percorribile esclusivamente a bordo di jeep, pur essendo fruibile anche da ciclisti e pedoni che desiderano ammirare l’affascinante sentiero. Nel 2005, la via dell’incenso è stata dichiarata Patrimonio mondiale dell’UNESCO e Israele vi invita a visitare il Negev e l’Arava per seguire le orme dei nomadi e a rivivere e ripercorrere la storia eccezionale di un testimone silenzioso in un’epoca irrequieta.</p>
															            
								       
										                        `,
      };
    },
  },
  {
    id: "Mount_Karkom",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "MOUNT KARKOM",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  <p>In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.</p>
								   <p>Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.</p>
								   <p>Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/mount-karkom/1.jpg"} class="img-responsive">
								       </div>	
								       <p>Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.</p>
                                    <p>To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.</p>                      

										                        `,
      };
    },
  },
  // {
  // 		id:"Machtesh_Ramon",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "MACHTESH RAMON",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                               <p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater, also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an elongated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.</p>
  //                         <div class="img-wrapper">
  // 							<img src=${getImgUrl()+ "/posts/machtes-ramon/1.jpg"} class="img-responsive">
  // 						</div>
  // 						<p>Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock, and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.</p>
  // 						<p>The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
  // 						<p>A visit to Machtesh Ramon offers a range of exciting experiences and attractions specifically geared towards tourists and world travelers:</p>
  // 						<h3>Ramon Crater Visitor Center</strong>&nbsp;–&nbsp; Built on the crater’s edge, the visitor center overlooks the awesome views from the Machtesh and offers an opportunity to learn about its unique natural phenomena, and also about the life and work of Ilan Ramon, the first Israeli astronaut.</p>
  // 						<h3>Hai Ramon</strong>&nbsp;- Raising awareness to the local animal population, The Hai Ramon animal park offers a fascinating encounter with the often obscure and unseen small animals of the desert, The site features about 40 species of animals: lizards, snakes, turtles, spurs, hedgehogs, falcons, pheasants and more.</p>
  // 						<h3>Kahn Saharonim</strong>&nbsp;– a short walk from this once station on the Nabatean Spice Route, is Ein Saharonim, a beautiful spring (dry in the summer) which features rich vegetation and the footprints of the many animals that come to enjoy its waters.</p>
  // 						<h3>The Carpentry</strong>&nbsp;– a fascinating geological phenomenon, The Carpentry is a concentration of elongated stones in the form of prisms formed when the sandstone was "baked" at the high temperature created by a hot lava flow from the depths of the earth. During its cooling, the rock formed into thousands of ribbed columns, and the fragments of the columns act as the prisms.</p>
  // 						<h3>The Ammonite Wall</strong>&nbsp;- a rock wall featuring fossils of ammonites - marine animals that lived millions of years ago in the sea which then covered the entire Negev area.</p>
  // 						<p>A trip to Machtesh Ramon is a fascinating experience, one guaranteed to create a strong impression and a lasting memory.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Epic_Masada",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    // vidId:"XxWa_MNm5x8",
    vidId: "xH9m5hfimNQ",
    title: "SCOPRI MASADA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <h3>La “vetta del coraggio” nel cuore del deserto della Giudea</h3>
                                   <h3>Rivivi la storia epica in cima alla gloriosa fortificazione nel deserto della Giudea</h3>
									<p>Vivi l’emozione di un &nbsp;viaggio nel parco nazionale di Masada, dove si erge l’antica fortificazione, solitaria e isolata sulla vetta di un dirupo, nel deserto della Giudea, affacciata sulla vicina oasi del Mar Morto. Sali lungo il sentiero tortuoso o la scala romana partendo dalla base della fortificazione, oppure entra nel centro di accoglienza per i visitatori e sali fino alla vetta del sito prendendo la funivia e inizia a respirare la storia antica, come se fosse ancora in corso.</p>

									<h3>Esplora le rovine regali e sentiti parte della storia</h3>
									<p>Entra in quelli che una volta erano dei lussuosi castelli che costituivano l’ultima fortezza abitata dai combattenti per la libertà, i quali ebbero il coraggio di dichiarare guerra all’Impero romano a seguito della distruzione del Secondo tempio. Un sito così ricco di storia che le fresche pareti di pietra quasi trasudano le lacrime delle anime coraggiose che scelsero la morte piuttosto che la schiavitù sotto il regime nemico.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/epic-masada/1.jpg"} class="img-responsive">
																	   </div>
									<h3>Dove cultura e religioni raggiungono nuovi traguardi</h3>
									<p>Passeggia tra le rovine dei castelli e scopri stanze e strutture, reperti archeologici che testimoniano la vita a Masada durante l’assedio romano. Entra nel castello sul lato nord, che era il palazzo-fortezza privato del re Erode. Sussurra una preghiera nell’antica sinagoga, dove gli ebrei si riunivano tre volte al giorno per pregare per la loro salvezza. Rendi omaggio ai combattenti morti per la libertà che tiravano a sorte nella “stanza della lotteria” per stabilire l’ordine con il quale andare a morire, fino all’ultimo uomo rimasto che poneva fine alla sua stessa vita.</p>
									<p>Ammira i resti della chiesa bizantina e dei suoi mosaici, probabilmente frequentata per secoli dai monaci cristiani fuggiti all’inizio del I secolo, per un periodo di circa 600 anni.</p>
									<p>Visita Masada, uno dei siti dichiarati patrimonio mondiale dell’UNESCO, fatti accompagnare dai suoni e dalla luce del tramonto alla base della fortificazione, che rievocano la vita e le battaglie di secoli e secoli fa.</p>
									                                   
								   
							    `,
      };
    },
  },
  // {
  // 		id:"The_Bedouin_Experience",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "THE BEDOUIN EXPERIENCE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 				           <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.</p>
  //                                  <p>A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality.</p>
  //                                  <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/the-bedouin-experience/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a long-forgotten way of life.</p>
  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"The_Israel_National_Trail",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "THE ISRAEL NATIONAL TRAIL",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                <p>The Israel National Trail (“Shvil Israel”) is a national project, paving a marked and safe hiking route across the country. Over 900km long, the route is one of the most rewarding ways to experience the nature and community in Israel.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/the-israel-national-trail/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>The Israel Bike Trail (Part of The Israel National Trail Project) is a national initiative to create mountain biking trail that crosses the country from north to south, connecting Mt. Hermon at one end with Eilat at the other. Perfectly suited for bicycle tourism, the trail passes through national sites and amazing landscapes, allowing riders to experience Israel's diversity of culture and types of communities along the way.The trail is one of the longest demarcated trails in the world suited to, and with appropriate signage for, mountain biking.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Timna_Treasures",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    // vidId:"i_4QKtXIeto",
    vidId: "oiA-nj-Kpzo",
    title: "PARCO DI TIMNA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   
                                   <h3>Una stimolante avventura nel deserto</h3>

                                   
                                    
								    

								   <h3>Esplora le bellezze naturali e le entusiasmanti attrazioni che il parco di Timna ha da offrire </h3>
									<p>Il parco di Timna è un’esperienza unica nel suo genere. Situato a circa 20 minuti da Eilat, nel cuore del deserto incantato israeliano e nascosto tra un paesaggio naturale mozzafiato. Con attrazioni e attività che combinano natura, antichità storiche e avventura, i vasti territori fanno spazio a stupore e incanto, che lasceranno il segno sui visitatori di tutte le età e con qualsiasi tipo di interesse.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/1.jpg"} class="img-responsive">
								   </div>
									<h3>Ammira fenomeni naturali impressionanti</h3>
									<p>Cammina nel parco e ammira le <strong><b>formazioni rocciose uniche</b></strong><strong> </strong>nel loro genere, con nomi particolari e forme rare e che potrai toccare a mani nude: “Il fungo”, “Il fungo e mezzo”, “Il canyon rosa”, “Gli archi”, “I pilastri di Salomone” e “La valle dei disegni sulla roccia”. Le rocce sono testimoni di un’era passata e per i visitatori rappresentano uno spettacolo unico.</p>
									
									<h3>Faiun’escursione</h3>
									<p>Cammina lungo uno dei 20 <strong><b>percorsi escursionistici</b></strong> del parco, ben segnalati e con un livello di difficoltà variabile, scelti in base alle esigenze e alle capacità di persone singole o gruppi di persone. Fai trekking lungo i sentieri spettacolari e importanti dal punto di vista geologico e archeologico oppure prendetela comoda e gironzola lungo il <strong><b>lago di Timna</b></strong> ombreggiato e il vicino campeggio. Presso il ristorante King Solomon’s Khan potrai dedicarti all’artigianato del deserto, come la realizzazione di bottiglie di sabbia colorata, oppure potrai fare un giro in pedalò.</p>
									<p>Ti piacciono gli <strong><b>sport estremi</b></strong>? Nel parco potrai provare la discesa a corda doppia, la “zip line” e i giri in bicicletta, attività che tempreranno il tuo fisico e ti faranno provare un senso di appagamento.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/2.jpg"} class="img-responsive">
								    </div>
									<h3>Faioggi l’esperienza dell’antichità</h3>
									<p>Scopri la storia biblica nel deserto, partecipando a una visita guidata del <strong><b>tabernacolo</b></strong><b> </b>ricostruito, completo di una copia dell’altare, del Santo dei santi e dell’arca. Osserva il timore reverenziale dei più giovani che ammirano la riproduzione della struttura sacra che Dio ordinò agli ebrei di costruire nel deserto, mentre i visitatori più maturi esamineranno la ricostruzione dal punto di vista della precisione storica, imparando cose nuove.</p>
									<p>Parco di Timna. Dove la storia incontra l’avventura, nel profondo del deserto di Israele.</p>
								  
		                        `,
      };
    },
  },
  {
    id: "Negev_Desert_Dont_Miss",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "DESERTO DEL NEGEV - NON LASCIARTELO SFUGGIRE",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  
                                   <h3>Sandboarding nel deserto</h3>
												<p>Un'esperienza unica nel deserto. Le morbide dune sabbiose del deserto del Negev consentono di scivolare giù seduti o in piedi, a una velocità esilarante. Bisogna avere un'abilità molto speciale che, una volta appresa (è davvero molto facile), vi consentirà di diventare surfisti della sabbia provetti. Che ne dite?</p>
												
												<h3>Il Negev di notte</h3>
												<p>Il cielo notturno del Negev è una vista incantevole. Scrutate il cielo nell'oscurità e sarete immediatamente colpiti dallo splendore di milioni di stelle scintillanti, che brillano nell'oscurità blu-nera, emettendo un bagliore visibile solo nel deserto.</p>
												<h3>Escursioni a dorso di cammello</h3>
												<p>Con un tuffo nel passato, questo è il modo più autentico di esplorare il meraviglioso deserto circostante. Viaggiare a dorso di cammello è un'attività che è possibile svolgere presso numerosi allevamenti di cammelli nella zona del Negev, per un'esperienza indimenticabile.</p>
												<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/negev-desert-dont-miss/1.jpg"} class="img-responsive">
								   </div>
											
												<h3>Festival del MidBurn</h3>
												<p>È la versione israeliana del famoso festival dell'“uomo bruciato”, nel corso del quale, per 6 giorni, nel deserto del Negev viene preparata una città temporanea, creando un ambiente che consente uno stile di vita comune, creatività, arte e libera espressione di se stessi.</p>
												<h3>Alba a Masada</h3>
												<p>Disponibile solo per coloro che hanno abbastanza coraggio per salire sulla vetta a piedi nudi, guardare il tramonto a Masada è indubbiamente una delle esperienze più indimenticabili da fare in Israele. Il lento sorgere del sole sulle montagne di Moab, in Giordania, e il Mar Morto, con la luce che illumina i panorami desertici circostanti, è un vero e proprio spettacolo della natura, indimenticabile.</p>


		                        `,
      };
    },
  },
  {
    id: "Ha_Arava",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: false,
    title: "L’ARAVA: LASCIATEVI SORPRENDERE!",
    smltitle: "",
    html: function() {
      return {
        __html: `

						        
								
								<p>Tra l’incrocio con Menucha, nel nord, e la prima rotatoria che si incontra entrando ad Eilat, circondato da Har haNegev e dalle montagne di Eilat a ovest e dalle montagne di Edom a est, si estende l’Aravá, una striscia stretta e magnifica nella quale potrete <em>sentire</em> il deserto, con tutto ciò che esso offre, sia che siate una coppia, una famiglia o un gruppo. I visitatori hanno la possibilità di ammirare l’Arava in molti modi: a piedi, in bicicletta, in auto o in autobus. Le possibilità di alloggio possono essere lussuose oppure di tipo “glamping”. Potete addirittura dormire sotto le stelle. Ecco alcune cose da vedere e da fare.</p>
								<h3>Parco nazionale di Timna</h3>
								<p>Il nostro centro visitatori, aperto di recente, nei pressi dell’ingresso del parco, vi accoglie con un’introduzione all’incredibile paesaggio di Timna, una combinazione di arenaria rossa scolpita dalla natura e abbinata a ciottoli bianchi e neri, che creano uno scenario drammatico. Il parco di Timna, a forma di U, svela i tesori di vari periodi storici e racconta la storia delle antiche miniere di rame egiziane che ancora oggi restituiscono il prezioso metallo, grazie a reliquie e altre scoperte.</p>
								<p>Timna offre oltre 25 percorsi per escursioni, ciclismo (tra cui una singola pista) e automobilismo, tra cui il <strong>fungo</strong>, gli <strong>archi</strong>, i <strong>pilastri di Salomone</strong>, il <strong>canyon rosa</strong>, il <strong>cavatappi</strong> e le <strong>facce</strong>. E non è tutto: il Tabernacolo, una replica esatta di quello biblico realizzato dagli israeliti nel loro girovagare nel Sinai, un lago con pedalò, bottiglie contenenti sabbia colorata e altri prodotti dell’artigianato locale, noleggio di moto, un campeggio sorvegliato e la taverna del re Salomone, presso la quale potete rifocillarvi con i prodotti del deserto e acquistare souvenir.</p>
								<div class="img-wrapper">
											   <img src=${getImgUrl() + "/posts/ha-arava/1.jpg"} class="img-responsive">
								</div>
								<h3>Santuario naturalistico di Hai-Bar</h3>
								<p>L’obiettivo di Hai-Bar è reintrodurre nella natura gli animali citati nella Bibbia. Nel frattempo, gli animali sono protetti e curati nei loro habitat, aperti al contatto con i visitatori. Sono disponibili dei circuiti per chi si sposta a bordo di un veicolo motorizzato, grazie ai quali si potrà partecipare a un safari e ammirare le orici, le antilopi dalle corna a vite e gli struzzi in mezzo alla flora del deserto, tra cui l’acacia biblica. Presso il negozio si possono acquistare dei CD in varie lingue che vi faranno da guida. Le visite guidate si svolgono di sabato, alle ore 11:00, quando gli animali sono intenti a fare il “brunch”! È disponibile un campeggio con animazione.</p>
								
								<h3>Fattoria delle spezie di Eilat</h3>
								<p>La fattoria, dedita alla ricerca nel campo della maricoltura, si trova nei pressi di un antico incrocio tra la via delle spezie e la via del mare, davanti alle montagne di Edom. Alghe, molluschi, gamberetti artemia e pseudochromis fridmani (che in ebraico vengono chiamati “pesci di Friedman”, dal nome del proprietario della fattoria, che lo scoprì) sono tutti allevati qui.</p>
								<p>Il centro visitatori della fattoria è un delizia per i sensi: appena entrati ci si trova immersi nelle fragranze di decine di spezie, miscele e infusi sia per cucinare che per curare malattie; inoltre, è disponibile una serie di pentole e utensili speciali, di cui il nostro staff sarà lieto di spiegare le modalità d’uso.</p>
								<div class="img-wrapper">
											   <img src=${getImgUrl() + "/posts/ha-arava/2.jpg"} class="img-responsive">
								</div>
								<h3>Passate al biologico a Neót Smadár</h3>
								<p>Fate un giro autoguidato nella nostra comunità, che dispone di uno stupendo centro artistico la cui costruzione ha richiesto 13 anni, attraversate i nostri terreni, che riflettono la nostra attenzione ai dettagli e il nostro carattere rustico, visitate il nostro vigneto biologico e l’azienda vinicola più a sud di Israele!</p>
								<p>Presso il nostro <u>centro artistico</u> sono presenti i laboratori dei nostri artigiani, oltre a una galleria presso la quale vengono esposte e vendute le loro opere. Il centro della struttura, noto per la caratteristica torre, è un idrante che raffredda l’intero edificio, sostituendo il tradizionale impianto di condizionamento dell’acqua. Tutto il centro, sia all’interno che all’esterno è ricoperto di legno ornamentale, lavorato dai membri della nostra comunità.</p>
								<h3>Arava al calar della sera</h3>
								<p>Dopo il tramonto, il paesaggio cambia: dalle montagne di Edom fino alle tonalità più scure rosse e viola della notte stellata, al chiaro di luna. È ora di andare a dormire… vi aiuteremo a scegliere gli alloggi più adatti e comodi. Telefonateci al numero fisso +972 (8) 661.6976!</p>
																
								    
															                               
		                        `,
      };
    },
  },
  // {
  // 		id:"Negev_Charms",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"3UddwPEzDXo",
  //         title : "ESCAPE TO THE NEVEG",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                 <p>A desert holiday is unlike any other - the tranquility, the awe inspiring grand vistas, the clear star-studded night skies, all come together to create a truly mesmerizing and exotic experience most of us do not to partake in during our day to day lives.</p>
  //                                 <p>The Negev is so much more than just a Desert. While it still offers all the natural beauty, calmness and wonderous sites which the desert tourist is looking for, it is also extremely westernized and packed with activities and adventures while offering all the comforts of a holiday. This is exactly what makes a trip to the Negev the perfect destination for travelers from all over the world. Another gem of the Negev is undoubtedly its local community, from the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, the people of the Negev are warm, hospitable and always ready to lend a hand. The Negev is rich in geological and archeological treasures and offers loads of exciting activities for the more adventurous travelers.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/negev-charms/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>At the same time, visitors looking for relaxation are sure to find it in the tranquil surroundings, and for some urban excitement, the nearby cities provide a wide range of city fun from culinary treats to exciting nightlife.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Galilee",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"5Ep3GgxELag",
  //         title : "GALILEE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				          <p>Most of northern Israel is generically known as The Galilee (Galil in Hebrew). It stretches virtually from the Mediterranean to the harp-shaped Sea Of Galilee and River Jordan on whose shores vast history has been made. Here is Mount Gilboa where King Saul and his son, Jonathan, died in battle against the Phillistines. Here is Hazor, where Deborah killed Sisera. Here, at Mount Meron, is the grave of Rabbi Hillel. Here in Tzippori, Hamat Tveriya and Bet Alpha, gorgeous 1,800-year-old synagogue mosaics have been discovered. Here is Armageddon (Megiddo) where Solomon built giant stables. Here is the lakeshore city of Tiberias, one of the “Four Holy Cities of Judaism” (another is Galilee’s Safed), which reached fame 2,000 years ago as one of the chief locations in which the Talmud was written.</p>
  //                                 <h3 >Galilee</h3>
  //                                 <div class="responisve-iframe">
  // 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/lzYzxyvnfng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 				           </div>
  // 				           <p>The restoration of the Jewish homeland in the period beginning in the 1880’s was largely centered in the Galilee, and in the ensuing 130 years a much neglected landscape of not much more than olive trees has been transformed into one of the most fertile areas in the world. Here are dozens of kibbutzim and independently owned farms – whose produce feeds not only Israelis but is also flown daily to the grocery stores and flower markets of Europe. Here are some of Israel’s 300+ vineyards producing award winning wines. And here are pretty villages, towns and cities including Nazareth and Carmiel.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/galilee/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>In addition to hotels and very comfortable kibbutz guest houses, the Galilee is filled with dozens of country bed-and-breakfast accommodations, known as zimmerim. Many offer luxurious accommodations, including pools, and make a delightful base for relaxing and touring.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Caesarea",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"eLZ433_S6HI",
  //         title : "CAESAREA",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>The Roman port city of Caesarea is one of Israel’s wonders, combining ancient structures, archeology and a picture-perfect harbor, and adapting them for modern use.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/caesarea/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>Built by Rome’s Judean Governor, Pontius Pilate, two millennia ago, Caesarea was one of the largest and most magnificent ports in the Mediterranean, with giant piers stretching out into the sea to accommodate dozens of ships. The city of Caesarea contained a giant hippodrome, aqueduct and theater; a thousand years later the Crusaders arrived and built a giant fortress, and then came the Ottomans, who turned it into a seaside town. Today, the Roman theatre is a venue for concerts, the Crusader fortress is thrilling to visit and the Ottoman harbor and beach are full of cafes, restaurants and a visitors’ center. Caesarea is 45 minutes’ drive from Tel Aviv, 20 from Haifa.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Acre",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    // vidID:"KlXXyToCmCM",
    vidId: "J0MjPKAmQRg",
    title: "ACRI VIAGGIO SULLE ORME DEI CROCIATI",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						          
								   

								   <h3>Un’antica città cinta da mura si è trasformata in un crocevia culturale nel nord di Israele</h3>
									<p>Acri è una delle località più straordinarie di Israele. Città marinara circondata da antiche mura di pietra, Acri custodisce innumerevoli tesori storici e culinari e trasuda un’atmosfera sublime come nessun’altra città del Paese.</p>
									
									<h3>Scopriun patrimonio storico affascinante</h3>
									<p>Preparati a conoscere luoghi e attrazioni stupendi che rivelano le vite e le abitudini dei crociati che una volta avevano il controllo su Acri. Ammira le imponenti e antiche <strong><b>mura</b></strong> che circondano la Città vecchia e che protessero i residenti di Acri durante l’assedio napoleonico. Visita il <strong><b>porto di Acri</b></strong>, dove potete chiudere gli occhi, respirare la fresca aria marina e immaginarlo come un crocevia delle attività marinare, dove furono stabiliti i collegamenti via mare con l’ovest e i pellegrini scoprirono l’ingresso principale nella terra di Israele.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/acre/1.jpg"} class="img-responsive">
																	   </div>
									<p>Scopri lo spettacolare sito sotterraneo noto come il <strong><b>tunnel dei templari</b></strong>. Una volta collegava una fortezza strategica al porto di Acri e aiutava i pellegrini a visitare Israele, mentre oggi il passaggio in pietra naturale costituisce una metafora di cooperazione e perseveranza e percorrerlo suscita&nbsp; ancora oggi un senso di stupore. Prosegui fino alla <strong><b>fortezza Hospitaller</b></strong> (Knights’ Halls), fatta costruire dal re Riccardo Cuor di Leone durante la terza crociata. Le rovine di quello che in passato era il cortile centrale del forte, circondato da archi, testimonia i profondi legami della città in un’epoca difficile.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/acre/2.jpg"} class="img-responsive">
																	   </div>
									<h3>Un raro connubio di autenticità e culture</h3>
									<p>Tra i luoghi storici e le attrazioni spicca il <strong>mercato</strong> di Acri, che esemplifica l’intreccio di culture orientali e occidentali sul quale la città di mare fu fondata e continua a prosperare. Il mercato è ricco di sapori e odori e gli abitanti originari dei quattro angoli del mondo si mescolano con i visitatori, appagando sia lo spirito che lo stomaco con tesori culturali e specialità gastronomiche, come i dolci orientali, le spezie preparate sul posto, i prodotti freschi e il pesce appena pescato. Percorri il mercato in direzione sud e visitate la sinagoga Ramchal e la casa dell’artista Chaim Parchi, due luoghi che aggiungono originalità, tradizione e vivacità a un crocevia culturale già effervescente.</p>						   
											                        
		                        `,
      };
    },
  },

  {
    id: "Haifa",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    // vidId:"3ahATaKkhBk",
    vidId: "DAM1o7WW8ck",
    title: "HAIFA LA PORTA PER IL NORD DI ISRAELE",
    smltitle: "",
    html: function() {
      return {
        __html: `  

                                    <p>Haifa, la vivace “Capitale del nord”, è la terza città di Israele in ordine di grandezza e di gran lunga la più entusiasmante.</p>
									<p>Una visita in primavera o estate offre un’ottima opportunità per farsi una nuotata o sdraiarsi su una delle sue spiagge più belle: oltre a ciò, &nbsp;Haifa è piena di cose da fare e vedere tutto l’anno.</p>
									<p>La posizione fantastica di Haifa, alle pendici dell’impressionante monte Carmelo (anch’esso un’attrazione turistica) è valsa alla città l’appellativo di “la San Francisco di Israele” e, in linea con la sua reputazione, è ricca di bellissime spiagge, panorami affascinanti, vivace vita notturna e buona musica.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/haifa/1.jpg"} class="img-responsive">
								   </div>
									<h3><b>Giardini Bahá’í - Bellezza, grandezza e fantasia&nbsp; </b></h3>
									<p>Nel luglio del 2008, i giardini Bahá’í furono dichiarati patrimonio mondiale dell’UNESCO, come riconoscimento del loro “grande valore universale” come luogo sacro di pellegrinaggio per i seguaci della fede Bahá’í.</p>
									<p>Il santuario e i giardini Bahá’í sono una creazione fantastica ispirata a bellezza, grandezza e stile raffinato, avvolta in un’atmosfera particolare e tranquilla senza eguali. I giardini Bahá’í sono anche una delle attrazioni più popolari del paese e ogni anno attraggono oltre un milione di visitatori.</p>
									 <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/haifa/2.jpg"} class="img-responsive">
								   </div>
									<h3><b>Monte Carmelo - La montagna sempre verde vicino alle spiagge del Mediterraneo</b></h3>
									<p>Una delle principali attrazioni è costituita dal monte Carmelo, simbolo di bellezza e splendore e destinazione ideale per escursioni e picnic in famiglia. Non è necessario affaticarsi troppo per ammirare i panorami spettacolari dalla cima del monte Carmelo, in quanto una comoda metropolitana - la Carmelit - consente di andare su e giù per la montagna.</p>
									<h3><b>Arte e cultura</b></h3>
									<p>Haifa è una città creativa e vivace e, in quanto tale, in ogni angolo fioriscono iniziative artistiche e culturali. Tra le numerose offerte culturali di alto valore figurano il Museo della scienza e della tecnologia Madatech, il Museo nazionale della scienza di Israele, il Museo delle arti di Haifa e lo zoo didattico di Haifa, ubicato sul monte Carmel.</p>
									<p>Haifa offre anche numerosi eventi culturali, come l’Holiday of Holidays Festival, che celebra i festival ebraico, cristiano e musulmano che si svolgono in dicembre. Inoltre, non lasciarti sfuggire il festival internazionale del cinema di Haifa, un evento che dura un’intera settimana, che si tiene ogni settembre e che trasforma l’intera città in un’attrazione cinematografica, con la proiezione di centinaia di film di ogni genere<span dir="RTL">.</span></p>
					               
								  
								   
		                        `,
      };
    },
  },

  // {
  // 		id:"Safed",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"i3_ihL51bHo",
  //         title : "SAFED – WHERE MYSTICAL MEETS THE WORLDLY",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>With endless views that extend into distant horizons and pristine mountain air, Safed will instantly captivate you the moment you arrive. Known as the capital of Jewish mysticism past and present, this breathtaking ancient hilltop city is the highest in the Galilee and all of Israel – geologically and spiritually. One of the four sacred cities in Judaism, Safed offers a palpably mystical journey that will leave you in awe of its profound energy.</p>
  //                                 <p>A short drive from the revered Sea of Galilee, Safed welcomes you with quaint cobblestone alleys and numinous architecture. Listen as the many souls of history share their secrets through an old fortress erected by the Crusaders, the Mamluk, Ottoman and British influences, the War of Independence Monument, as well as a deep sacred history embodied by extraordinary synagogues and ancient tombs.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/safed/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						    <h3>The Eternal Kabbalah Capital</h3>
  // 						   <p>From Rabbi Shimon Bar-Yohai, the 2nd&nbsp;century author of the foundational work on the Kabbalah known as the Zohar, to Ari HaKadosh, the father of contemporary Kabbalah, Safed has been home to Judaism’s highest mystics and their devout students. It was 16th&nbsp;century when Ari HaKadosh “democratized” Kabbalistic teachings by bringing in a new understanding – one that allowed Kabbalah to reach the laymen.</p>
  // 						   <p>As you walk from one synagogue to the next, you’ll feel just how Safed became the unchanging home for such a long lineage of spiritual aspirants, regardless of all that history threw their way. The Abuhav Synanogue whose architectural elements embody numerical mysticism, the Ari Ashkenazi Synagogue dedicated to Ari HaKadosh, and the Yosef Caro Synagogue will all transport you through time and into mysticism’s upper worlds.</p>
  // 						   <h3>An Inspirational Old City &nbsp;</h3>
  // 						   <p>Add more unforgettable moments to your trip by walking the winding cobblestone alleys in the Old City, viewing unique stone buildings and continuing on to the Artists’ Colony. Home to quality galleries that will introduce you to the exquisite works of local artists, including a wide variety of Judaica, this part of the Old City is for lovers of all things art. The Doll Museum and the Museum of Printing Art are special must-see for the culture-hungry.</p>
  // 						   <p>Safed can be as nourishing for your body as it is for your soul – the Old City’s eclectic food offerings promise to please every taste and budget. From Yemenite pancakes and street food to unexpected delicacies at sit-down restaurants, you’ll find all that you’re looking for and more in this gracious city of deep traditions.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"The_Bahai_Gardens",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"JV_AmfRULOo",
  //         title : "THE STUNNING BAHA’I GARDENS",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				          <h3>Visit the Baha’i Gardens</h3>
  //                                 <p>Picture yourself standing on the nineteenth terrace which is the very top of this breath taking monument where you can see the rolling hills of the Galilee, the city of Haifa, Akko and the Mediterranean Sea.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/bahai-gardens/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>Beauty, grandeur, and inspired design combined with the meticulous gardening by generations of dedicated gardeners and a variety of cultures create the unique atmosphere of the Baha’i shrine and gardens in Haifa. While each garden offers a different experience they all share the same theme of gravelling paths, unique hedges and flourishing flower beds. A picture so perfect you must see it with your own eyes to believe the precision and symmetry.</p>
  // 						   <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/bahai-gardens/2.jpg"} class="img-responsive">
  // 						   </div>
  // 						     <p>This mystical iconic is site where members of the Baha’i faith have established their shrine and world centre because of its significance to their faith.</p>
  //                                  <p>The Baha’i faith had its origins from Iran. Its founder Baha'u'llah, was exiled from his homeland at the end of the 19th century, and came to Akko (Acre) and Haifa after suffering persecution in neighbouring countries.&nbsp; He was impressed with the beauty of Mount Carmel and expressed the desire that the Bab (one of the central figures of the Baha’i faith) would be buried there. About 20 years later the bones of the Bab were laid to rest in Haifa on the site that then developed into the centre of The Baha’i faith which is visited by half a million people every year.</p>
  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"The_Sea_Of_Galilee",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"haG-t3wwuMc",
  //         title : "THE SEA OF GALILEE (KINNERET )",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Rosh_Pina",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"_qKbHL5-qrQ",
  //         title : "ROSH PINA",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				           <h3>Turn back the clock in the authentically picturesque Galilee village</h3>
  //                                <p>Known as the Princess of the Galilee, Rosh Pina is home to the perfect mix of natural, cultural, historic and entertainment hotspots. A beautifully restored, serene northern village where aged olive trees and quaint homes are surrounded by lush golden fields, Rosh Pina is just the place for a leisurely and relaxing vacation, where visitors can relive village life as it was, over a century ago.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/rosh-pina/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <h3>Where magical silence is broken only by chirping birds</h3>
  // 						   <p>In search of a serene nature-filled location, reminiscent of Italy’s Tuscany or France’s Provence? Head north to Rosh Pina, where breathtaking rural landscapes are unhindered by the village’s attractions and you will feel as if transported to an era long ago. Choose from the many available guest houses, outfitted to provide maximum hospitality and interspersed throughout the village’s romantic alleyways, unadulterated by the bustle of the big city and breathing new life into the bewitchingly quaint and hospitable community.</p>
  // 						   <p>Take advantage of the local natural beauty and traipse through stunning green&nbsp;hiking pathsaround Rosh Pina’s river or about the&nbsp;Baron de Rothschild’s Gardens, reportedly modeled to resemble the grand gardens at Versailles. Breathe in the fresh air and enjoy the sheer natural beauty as you stroll, becoming one with nature and recharging your batteries.</p>
  // 						   <h3>A vacation colony with a unique, artistic charm</h3>
  // 						   <p>Stroll about the village’s cobblestone streets, reminiscent of old European towns, and you will encounter a delightful cultural and artistic atmosphere surrounded by magnificent Galilee mountains. A place of trendy coffee shops, gourmet restaurants, art galleries, museums, festivals, historical sites and a shopping center, the city is teeming with antiquity, culture, nature and culinary delights, together recounting the history of the first “Galilee Moshava” (town) and the establishment of Jewish communities in Israel.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Nazareth",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    // vidId:"1M7N5BcmjFM",
    vidId: "nVJe3bBdMn4",
    title: "NAZARETH - LA CULLA DEL CRISTIANESIMO",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						           <h3>Una città antica ricca di storia, archeologia affascinante, cultura moderna e fascino mediorientale</h3>

                                
								    <p>Nazareth, o Natsrat secondo la pronuncia ebraica, è la culla del cristianesimo, la città in cui, secondo la tradizione, l’angelo Gabriele disse a Maria che avrebbe concepito grazie al potere dello Spirito Santo e il luogo in cui Gesù trascorse la sua infanzia e giovinezza. Nazareth, nella Galilea inferiore, si trova nel cuore di una valle circondata da montagne che abbracciano la maggior parte dei siti cristiani più importanti del mondo. Si tratta di una città di religione e fede, di spiritualità e santità, ma anche una città con una storia ricca, archeologia affascinante, cultura moderna e fascino mediorientale.</p>
									<h3><b>La culla del cristianesimo</b></h3>
									<p>Nazareth, che 2.000 anni fa era un piccolo villaggio, nel periodo bizantino, alcuni secoli dopo, divenne una roccaforte del cristianesimo. Durante quel periodo, il nome di Nazareth si diffuse in lungo e in largo e il desiderio di visitare i luoghi in cui vissero la Vergine Maria e Gesù Cristo trasformarono la città in un luogo di pellegrinaggio molto famoso. Queste visite portarono alla costruzione della prima chiesa della città: la Chiesa dell’Annunciazione sul luogo in cui sorgeva la casa di Giuseppe e Maria. Nella città furono costruite molte altre chiese, alcune delle quali furono distrutte e ricostruite in seguito all’alternarsi del dominio musulmano e cristiano nel corso dei secoli. Nel XIX secolo Nazareth suscitò un rinnovato interesse e i cristiani tornarono a vivere in questa città e ricostruirono chiese e monasteri. Oggi Nazareth è la più grande città araba di Israele e ha circa 30 chiese e monasteri, oltre a moschee e antiche sinagoghe.</p>
									<h3><b>La Città vecchia </b></h3>
									
									<p>Fare un’escursione a Nazareth è come riviverne i vari periodi storici. Ogni epoca storica si lasciava dietro un patrimonio che nell’era moderna ha trasformato la città in un sito turistico stupendo e apprezzato dai visitatori. La maggior parte dei siti è concentrata nella Città vecchia, costruita a metà del XIX secolo in un affascinante sito architettonico mediorientale. Una passeggiata tra vie strette e case pittoresche costituisce un’esperienza incredibile e per apprezzarne la bellezza l’ideale è camminare lentamente.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/nazareth/1.jpg"} class="img-responsive">
								   </div>
									<p>Nella Città vecchia sono presenti molte chiese antiche, con la Chiesa dell’Annunciazione in cima alla lista. La chiesa ricostruita ha conservato parti delle chiese precedenti, dai periodi delle Crociate a quelli bizantini. Inoltre, la chiesa ospita una stupenda collezione di dipinti.</p>
									<p>Accanto a questa chiesa si trova la Chiesa di San Giuseppe, costruita sulle rovine degli edifici agricoli dove, secondo la tradizione, Giuseppe, il marito di Maria, aveva la sua falegnameria. Mentre la Chiesa dell’Annunciazione fu costruita sul luogo in cui sorgeva la casa di Maria, la Chiesa greco-ortodossa dell’Annunciazione è costruita sul Pozzo di Maria, dal quale secondo la tradizione bevve la madre di Gesù. Si tratta di una struttura del periodo delle crociate al cui interno si trovano alcuni affreschi interessanti. Accanto al Pozzo di Maria si trova la Chiesa greco-ortodossa dell’Annunciazione, all’interno di una sala crociata. Secondo la tradizione, questo è il luogo della sinagoga in cui pregava Gesù.</p>
									<p>Tra le molte altre chiese di Nazareth c’è la chiesa Mensa&#8203; Christi, la chiesa maronita, la chiesa di San Gabriele e la chiesa salesiana. Inoltre, nella Città vecchia sorgono importanti edifici del periodo ottomano, tra cui la Saraya, o Palazzo del Governo, costruita da Daher el Omar, il governatore della Galilea nel XVIII secolo, e la Moschea bianca, che oggi è usata come casa di preghiera e centro didattico e culturale. La Moschea bianca ospita anche un museo che ripercorre la storia di Nazareth.</p>
									<p>Nessuna visita alla Città vecchia di Nazareth sarebbe completa senza una visita al mercato locale, che è diventato un’attrazione popolare e famosa grazie alle bancarelle colorate e alla varietà delle merci esposte. Al mercato è possibile ammirare l’esplosione di colori dei tessuti alla moda, degustare le spezie e le specialità locali e acquistare opere d’arte e souvenir. Tutti i suoni, le cose da vedere, i profumi e i gusti promettono un’autentica esperienza del Medio Oriente.</p>
									<h3><b>Uno sguardo al fascino del Medio Oriente</b></h3>
									<p>Nazareth è piena di angoli affascinanti e graziosi che vi apriranno il cuore alla bellezza. Un altro luogo che vale la pena visitare è il cammino lungo la dorsale Nabi Sain, per ammirare il meraviglioso panorama della Galilea. Puoi visitare l’antico bagno turco scoperto durante i lavori di restauro di uno dei negozi della città, dare un’occhiata a una bella casa padronale dove sono esposte le ricchezze e gli indumenti dell’alta borghesia ottomana del XIX secolo, compresi alcuni stupendi affreschi. Una visita la merita anche la casa del vescovo greco-ortodosso, dove potrai percorrere una serie di passaggi sotterranei scoperti nel cortile. Un altro sito interessante è l’ostello recintato costruito dai russi per ospitare i pellegrini.</p>
									<p dir="LTR">Nazareth, che per secoli ha accolto i pellegrini, dispone di ostelli e hotel cristiani in grado di garantire il comfort ai turisti che affollano questo luogo così importante, specialmente nel periodo natalizio. Decine di ristoranti servono pietanze squisite a base di alimenti aromatici buonissimi che richiamano i visitatori tutto l’anno. Nazareth è bellissima durante le festività natalizie, quando la città viene addobbata e i suoi colori e l’atmosfera di entusiasmo si uniscono alla sacralità e ai suoni delle preghiere che fuoriescono dalle chiese<span dir="RTL">.</span></p>							   
											                        
		                        `,
      };
    },
  },

  // {
  // 		id:"Cheers_To_Israel",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"Cxii1yKqKwI",
  //         title : "GREAT WITH WHITE OR RED",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Over the past decade, Israeli wine-making has become a vital and thriving industry.</p>
  //                                  <p>The fertile land of the area has been recognized worldwide as an excellent setting for burgeoning vineyards, and the local scene is trendy and opulent.</p>
  //                                  <p>In the north, the general atmosphere reminiscent of French or Italian wine regions while the south&nbsp;has become renowned for its burgeoning&nbsp;wine scene, thanks to pioneering farmers and their use of computerized drip irrigation.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/cheers-to-israel/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						    <p><span style="font-family: arial,sans-serif;">The Israeli wine scene allows visitors a fantastic experience combining delectable wine tastings with the stunning vistas and energy this has to offer.</span></p>
  // 						   <p>So come get a taste of Israel’s wine country through its many fantastic tours of the vineyards and boutique wineries, the fantastic wine and music festivals and year-round wine-themed events.</p>
  // 						   <p>FYI, a visit to Israel goes great with white or red.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"A_Galilean_Treat",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"kF808ENuuTQ",
  //         title : "CULINARY JOYS TO SUIT EVERY PALATE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				          <p>A visit to the Galilee brings tastes and flavors unlike any you’ve ever experienced before. From regional cheeses handmade in artisanal dairies to world-class wines from boutique vineyards, from gourmet family-run restaurants to freshly-picked fruits and vegetables bursting with flavor, the Galilee is a foodie’s paradise.</p>
  // 						   <p><strong">A Region Flowing with Milk and Wine</h3>
  // 						   <p>Visit an artisanal dairy to discover the richness of Galilee cheeses and take part in the rhythm of cheese-making. Let an expert cheese-maker guide you as you taste some of the area’s many unique soft, hard and semi-hard cheeses, such as&nbsp;<em>lebane</em>, a creamy yoghurt-like soft cheese made from sheep or goat’s milk that is often served mixed with local herbs like za’atar, or&nbsp;<em>zefatit</em>, a salted sheep’s curd cheese that is molded into a basket and named for the area of&nbsp;<em>Zefat</em>, or Safed, where it was first made.</p>
  // 						   <p>If you’d like some wine to accompany your cheese, you’ll be in for a treat. Each wine is better than the last. A recent revolution in wine-making caused boutique wineries to spring up across the Galilee’s highly varied terroir, every vineyard raising grapes with a flavor that is specific to the soil in which they grow. Gaze out over hills covered in vines while you savor deep, fruity reds and fresh white wines with the guidance of Israel’s top wine-makers. Explore the grape blends that produced wines earning top honors at the world’s wine fairs, many of which are not available for sale outside of Israel.</p>
  // 						   <p><strong">Taste the Harvest</h3>
  // 						   <p>Visit pick-your-own orchards to revel in berries, apples, cherries, peaches, plums and even sabra-fruit that are plump, juicy and bursting with flavor. Tour spice farms to smell and taste an ever-changing range of herbs and spices, both those that are familiar to you and those that you’ve never encountered before. Discover the Galilee’s native flavors and create your own herbal teas and spice blends.</p>
  // 						   <p>Another of the Galilee’s important harvests, olive oil, also awaits you. If you thought that all olive oil tastes the same, a visit to a family-run olive oil farm in the Galilee will change your mind. Sample olive oils to learn what makes each oil taste different and join the fun of picking olives and pressing them the old-fashioned way to make your own extra-virgin olive oil.</p>

  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/galilean-treat/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p><strong">Markets and Restaurants</h3>
  // 						   <p>The Galilee’s ancient towns boast a plethora of markets where you can buy the best local produce and artisanal products, often sold by the experts who made them. Amble the markets tasting and testing to discover delights around every corner, or join a knowledgeable foodie guide who will lead you to the best stalls and finest treats.</p>
  // 						   <p>As you wander the Galilee following your taste buds you’ll encounter gourmet restaurants tucked away in the unlikeliest corners. Some of the country’s best cooking is served in unassuming Galilee eateries perched on the edge of magnificent views. Many are family-run, serving dishes made with love from ingredients that were grown or raised within just a few miles. But to really plumb the depths of the Galilee’s produce, take part in a cooking workshop. They are led by local chefs who know the land inside and out and are eager to share the best way to choose, prepare and enjoy the tastiest local produce. Often you’ll pick your ingredients before you prepare them, making dishes that taste better than anything you’ve ever cooked before.</p>
  // 						   <p><strong">The Unique Experience of the Galilee</h3>
  // 						   <p>The Galilee is much more than a series of delicious flavors. Visit ruined fortresses and biblical sites where Jesus preached and battles were fought. Climb up mountains, thrill with white-water rafting and hike alongside bubbling streams as part of your dream vacation in the Galilee.</p>
  // 									<p>photo credit:Itamar Grinberg		</p>
  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Galilee_Action",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidID:"5Ep3GgxELag",
  //         title : "GALILEE ACTION",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>The Galilee’s multitude of rivers, lakes and coastline are the source of plenty of fun for all ages. Thrill-seekers can feel the spray on their faces while they race their friends on whitewater kayaking, or families or couples can relax together floating past the cool green banks of one of the Galilee’s many rivers. You can cool off with exciting water fun like water-skiing, tubing or kite surfing on the Sea of Galilee. Along the coast, tourists love hanging out on the Galilee’s hot sandy beaches or visit the eerie glowing beauty of the Rosh Hanikra grottoes.</p>
  //                                  <p>Extreme sports can be found on land and in the air as well as on water. Active tourists can enjoy adrenaline-packed activities like sky-jumping, jeeping over rough mountain tracks or rappelling down challenging cliffs. In winter, take the sports to the snow at the Hermon mountain range with skiing and snowboarding on easy or challenging pistes.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/galilee-action/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <h3>The Breathtaking Natural Bounty of the Galilee</h3>

  // 						   <p>The Galilee is overflowing with areas of natural beauty where families, lovers and groups of friends can hike, glimpse wildlife, or just enjoy a picnic in the calming embrace of nature. Clopping along quiet paths on horseback or following the well-marked trails on foot or on a bicycle rewards you with beauty, fun and excitement wherever you go. See nature in a more relaxed way by going bird and wildlife spotting at the Hula Valley Nature Reserve, or experience the magic of the whole patchwork of forest, field and river unfolding below you as you rise in a hot-air balloon in the Gilboa. Add to the experience by immersing yourself in spirituality in sites holy to Christians, Jews and the Baha’i.</p>
  // 						   <p>The Galilee’s many hiking trails are a magnet for hikers of all ages, all year round. Whether you prefer a shady strolls alongside gentle brooks, the thrill of mountain climbing and rappelling, or enjoy the achievement of reaching the amazing view at the top of a challenging hill, you’ll find the perfect path waiting for you. In the Galilee all the options are open.</p>
  // 						   <p>photo credit:</p>
  // 						   <p>Itamar Grinberg</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Bet_Shean",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "BET SHE’AN",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>South of the Sea of Galilee are the remains of one of the largest cities in the Roman-Byzantine Empire, Bet She’an. One of ten ancient cities (hence “Decapolis”) that included Philadelphia (present day Amman in Jordan) and Jerash, Scythopolis ((Bet She’an) was the only decapolis city west of the Jordan river.  It was very grand, with a giant theater, streets of tall columns, shops, bathhouses a hippodrome and hundreds of homes.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/bet-shean/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>However, the splendid city was toppled in 749 by a massive earthquake, and never rebuilt. Over the centuries the ruins were overgrown – and it was not until the mid-20th century that Israeli archeologists pulled Bet She’an out of the murk, discovering (and restoring) the theater, the Cardo, the columns and much more.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Zichron_Yaakov",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "ZICHRON YA’AKOV",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: ` <p>Zichron Ya’akov is a wonderful town for tourists, both local and foreign. This picturesque moshava semi-cooperative farming community built at the tip of the Carmel mountain range is the first moshava ever built in Israel and is a main tourism and vacation site in this region.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/zichron-yaakov/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						    <p>Anyone who visits&nbsp;<strong>Zichron&nbsp;Ya’akov&nbsp;</strong>goes straight to Ha-Nadiv Street, and Ha-Meyasdim Street in the town center, which has become a very popular pedestrian mall, thanks to the special atmosphere in this place. The streets are paved with stones and pass between the moshava’s original houses (some of which have been reconstructed), which are bustling with activity.</p>
  // 						   <p>There are many quaint and charming restaurants and coffee shops, interspersed between beautifully designed stores that sell local art works and lovely souvenirs. There are art galleries, unique artists' studios and workshops. New, modern buildings stand alongside old ones, such as the synagogue and the administration building, an old courtyard with a display of antique agricultural implements.</p>
  // 						   <p>From its early days,&nbsp;<strong>Zichron Ya’akov</strong>&nbsp;had two main characteristics: wine and tranquility. The moshava’s founding farmers cultivated vineyards and the large winery built here in 1889 became the area’s most important industry. During the British Mandate period (1917-1948), the moshava became a holiday resort and rural vacations site, and to this day has hotels, spas and guesthouses.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Discover_The_Wine_Routes",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"Cxii1yKqKwI",
  //         title : "DISCOVER THE WINE ROUTES",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Discover a different Israel through it's wineries and vineyards, through the passion of the people who are crafting award winning wines from home grown grapes.</p>
  //                                  <p>Enjoy vintage wines, gourmet foods, and gorgeous scenery. Spend time experiencing Israel as you never have before, as a Wine Connoisseur! The beauty of these routes in Israel is of course the authentic wine but also the incredible landscapes that surround the wineries. Many of the wineries are situated near ‘Zimmers’ which are little spa complexes that are dotted around northern Israel. They have little cabins with Jacuzzis that face out to the magnificent views of the rolling green hills. You can relax in your personal cabin with a splendid glass of wine from the local winery.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/discover-the-wine-routes/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <div class="wpb_wrapper"><p>The Middle East &amp; Eastern Mediterranean was the cradle of wine production, and the ancient land of Canaan is in fact one of the earliest countries to cultivate wine over 2,000 years before the vine came to Europe.</p><p>There are currently over 25 commercial wineries and over 150 boutique wineries in Israel where wine making has become a personal obsession with wine makers striving to produce world class wines.</p><p>Israel like other 'long' countries such as Chile or Italy enjoys a variety of microclimates. While the northern region gets much rain and even snow in the winter, just a few hours away Israel's southern region is very arid with desert conditions. This range in microclimates supports many grape varieties, which can grow on several different types of soil, yielding excellent results.</p><p>As always in matters of taste, you must visit Israel’s wineries and vineyards and decide for yourself which is your favourite!</p><p></p></div>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Birdtastic_Hula_Lake",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidID:"ImobrsxsKl8",
  //         title : "BIRDTASTIC HULA LAKE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Hula Valley The Hula valley is located in a drained swampland by an attractive large lake, and is one of the area’s top places for friendly hiking and biking excursions. The Hula Valley is the country’s primary migration route for birds, making bird watching a very popular and fascinating experience.&nbsp;<strong>In 2009, the BBC Nature Magazine named the Hula Valley as one of the top nature watching places in the world.</h3>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/birdtastic-hula-lake/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <h3>Discover One of the World's Top Birdwatching Sites</h3>
  //                                  <p>In the heart of the picturesque Hula Valley in Upper Galilee, only two hours drive north from Tel-Aviv, between two majestic mountain ranges, lays a place of extraordinary beauty - the Hula Lake. One of the most important birdwatching sites in the world, this ecological internationally acclaimed wetland reserve, is an oasis for birds and nature lovers everywhere. Offering a rare and unique opportunity to experience nature without barriers or partitions, it's an invitation for an experience of a lifetime.</p>
  // 						    <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/birdtastic-hula-lake/2.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <h3>Follow the Birds and Marvel Nature</h3>
  // 						   <p>During every migration season (spring and fall) over 500 million birds and close to 400 species travel through the Hula Lake. This wetland paradise is the perfect stopover for small waterfalls, cormorants, heron, pelicans, raptors, strokes and cranes.</p>
  // 						   <p>Declared by the BBC Wildlife as one of the world's top ten birdwatching sites, Hula Lake or as it called in Hebrew Agamon Hula, naturally attracts birdwatchers from all around the world. Join the international Hula bird festival every year in the fall and enjoy a truly not-to-be missed-experience.</p>
  // 						   <p>There are several ways to witness this dazzling humbling phenomenon. All you need is simply choose your adventure.</p>
  // 						   <h3>Explore the Trails</strong>. Tour the park's magical trails. You can walk, bike or use club carts to drive around. You'll pass through fruit groves waterway and get a glimpse of the wetland wildlife.</p>
  // 						   <h3>Drive a Tractor</strong>. Join a guided tour in a Tractor-Drawn "Safari Wagon" that takes you deep into the Agamon's premises. The wagon "hides" you from the birds and therefore enables a rare up close and personal encounter with these beautiful creatures.</p>
  // 						   <h3>Sunrise and Night tours</strong>. For the more adventurers, there are 2 special tour experiences. One is the 'Sunrise Tour' that offers unbeatable birdwatching and photography opportunities. Alternatively, the 'Night Owl Tour' offers a completely different look on the reserve. With campfire and star-gazing you'll peek into the lives of wild cats, nocturnal raptors and fruit bats.</p>
  // 						   <h3>Uplift the Spirit and Witness Nature Preservation at Work</strong><br> Agamon Hula gained world acclaim for being model for a sustainable ecological system balancing between nature, tourism and agriculture.<br> Visit the ringing center in the park and watch the work done to preserve nature. Go to the "bird Island tour" and maybe you'll even get a chance to help release a bird back to nature. It doesn't get much better than this.<br> With so many different types of animals and tireless work to preserve nature in creative ecological ways, Hula Lake offers more than a fun trip with beautiful scenery but a true feel good experience that opens the heart and mind.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"The_Kibbutz_Experience",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "THE INCOMPARABLE KIBBUTZ EXPERIENCE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				           <p>Predominantly based amongst beautiful landscape settings dotted around the country the Kibbutz life is a modern day phenomenon and a totally unique way of living. The movement which started in 1905 is a collective community way of living traditionally based on agriculture. Each kibbutz would sell its own produce.  The people living on them would all collectively work together to preserve it and work the land.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/kibbutz-experience/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						    <p>The word ‘Kibbutz’ in Hebrew means group.&nbsp;The point being it is a voluntary democratic community where people live and work together to generate economically. It is founded on the principles of communal ownership of property and social equality.</p>
  //                                  <p>Some would describe the beautiful settings and a life of equality a utopia and why not experience it for yourself?&nbsp; Many of the Kibbutzim are open to visitors whether you would like to stay a few hours or a few months learning what this life is all about.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"National_Parks",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "NATIONAL PARKS",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 				          <p>Despite Israel being small its scenery varies immensely! You will find new cities and old, beaches and lakes, deserts and green mountains. Israel’s National parks and nature reserves make all this possible for you to experience the wondrous landscapes.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/national-parks/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>In the south of the country you will find the expanse of the golden and orange plains of the desert. The Negev, Arava and Eilat are the fiery beautiful landscapes of the south that home the Dead Sea, Mitzpe Ramon and the beautiful desert oasis of En gedi not mention some wonderful hiking and cycling trails. When the sun sets the south turns in to a red illuminous sea of magic and when dark the sky turns in to a blanket of sparkles as the vast scenery makes it possible to see every star.</p>
  //                                  <p>In the North of the country you are welcomed with Luscious green hills and mountains including the snow-capped Mount Hermon.&nbsp; The Golan Heights home to magnificent mountainous scenery and an array of cultures.&nbsp; There are endless forest trails and water fall hikes for all the family to enjoy. The view from the mountain tops is breath taking as your eyes take you all the way out to the Mediterranean. Below the mountains you will find the green slopes of the Galilee home to the famous Kinneret, wineries and some wonderful relaxation spa’s. It really is a wonderland.</p>
  // 						   <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/national-parks/2.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>The national parks offer exciting cultural and natural adventures. You have the opportunity to visit magnificent historical sites and follow wonderful nature trails while searching for some of the countries species i.e. The desert ibex and leopards, Eagles in the Golan. The impressive diversity of natural wonders, encounters with unspoiled nature and with plants.</p>
  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Tiberias",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "TIBERIAS (TVERYA)",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				           <p>Located at the shores of the Sea of Galilee, Tiberias, the capital of the Galilee, was established in the early Roman period and has served as a religious, administrative and culture center of the Jewish people for many years.</p>
  //                                 <p>In addition to its rich history and significance, modern day Tiberias is synonymous with holiday in Israel. Here one can enjoy a variety of activities the city has to offer, and experience a wonderful mix of relaxation, nature and history, along with contemporary attractions, active water sports, pilgrimage sites and unique tourist attractions</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/tiberias/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>A visit to Tiberias is not complete without a visit to its surrounding area, which features many must-see sights, including The city Bet Shean, one of the oldest cities in the world, and one of the country’s largest archaeological sites; Magdala (Migdal) the ancient town on the Sea of Galilee which was home to many of Jesus’s disciples and is said to have been the home of Mary Magdalene; Megiddo, a beautiful and impressive national park and one of the most important archeological sites in Israel from the time of the Bible. Once an ancient city of critical strategic importance, Megiddo is a UNESCO World Heritage Site, and an inspiring location for lovers of history and archeology.</p>

  //                         `
  //     }
  //   }
  // },
];



// WEBPACK FOOTER //
// ./src/Posts/PostsData.js